import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: number;
};

export type AIAction = {
  __typename?: 'AIAction';
  CreatedAt: Scalars['Timestamp'];
  DefaultModel?: Maybe<Scalars['String']>;
  DefaultModelID?: Maybe<Scalars['Int']>;
  DefaultPrompt?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type AIModel = {
  __typename?: 'AIModel';
  AIModelTypeID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  DriverClass?: Maybe<Scalars['String']>;
  DriverImportPath?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  Vendor?: Maybe<Scalars['String']>;
};

export type AIModelAction = {
  __typename?: 'AIModelAction';
  AIAction: Scalars['String'];
  AIActionID: Scalars['Int'];
  AIModel: Scalars['String'];
  AIModelID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  UpdatedAt: Scalars['Timestamp'];
};

export type AIModelType = {
  __typename?: 'AIModelType';
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

/** Organizations that are prospects, customers, or prior customers of any/multiple Blue Cypress companies */
export type Account = {
  __typename?: 'Account';
  AccountCompanyIntegrations: Array<AccountCompanyIntegration>;
  /** Financials */
  AccountingFees?: Maybe<Scalars['Float']>;
  /** Optional - Acronym for the organization */
  Acronym?: Maybe<Scalars['String']>;
  Activities: Array<Activity>;
  /** Total # of activities, across all subs in BC Family */
  ActivityCount: Scalars['Int'];
  AddressLine1?: Maybe<Scalars['String']>;
  AddressLine2?: Maybe<Scalars['String']>;
  AddressLine3?: Maybe<Scalars['String']>;
  /** Financials */
  AdvertisingExpense?: Maybe<Scalars['Float']>;
  /** Blue Cypress Master ID */
  BCMID: Scalars['String'];
  City?: Maybe<Scalars['String']>;
  Companies: Array<Company>;
  Contacts: Array<Contact>;
  Country?: Maybe<Scalars['String']>;
  /** . */
  CreatedAt: Scalars['Timestamp'];
  Deals: Array<Deal>;
  Description?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
  /** The domain for the account, for example, bluecypress.io - not www.bluecypress.io */
  Domain?: Maybe<Scalars['String']>;
  EarliestActivityDate?: Maybe<Scalars['Timestamp']>;
  /** Company Page on Facebook */
  Facebook?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  ISOCountryCode?: Maybe<Scalars['String']>;
  /** Financials */
  InformationTechnologyExpense?: Maybe<Scalars['Float']>;
  Invoices: Array<Invoice>;
  LastReviewedDate?: Maybe<Scalars['Timestamp']>;
  /** Financials */
  Latest990ID?: Maybe<Scalars['Int']>;
  /** Most recent activity date, across all companies in BC Family */
  LatestActivityDate?: Maybe<Scalars['Timestamp']>;
  LeadershipPageURL?: Maybe<Scalars['String']>;
  /** Financials */
  LegalFees?: Maybe<Scalars['Float']>;
  /** Company Page on LinkedIn */
  LinkedIn?: Maybe<Scalars['String']>;
  Logo?: Maybe<Scalars['String']>;
  LogoURL?: Maybe<Scalars['String']>;
  /** Financials */
  ManagementFees?: Maybe<Scalars['Float']>;
  Name: Scalars['String'];
  NumberEmployees?: Maybe<Scalars['Int']>;
  OperatingName?: Maybe<Scalars['String']>;
  /** Phone (including Country + Area Code) */
  PhoneNumber?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  /** Financials */
  ProgramServiceRevenueA?: Maybe<Scalars['Float']>;
  /** Financials */
  ProgramServiceRevenueB?: Maybe<Scalars['Float']>;
  /** Financials */
  ProgramServiceRevenueC?: Maybe<Scalars['Float']>;
  /** Financials */
  ProgramServiceRevenueD?: Maybe<Scalars['Float']>;
  /** Financials */
  ProgramServiceRevenueE?: Maybe<Scalars['Float']>;
  /** Financials */
  ProgramServiceRevenueNameA?: Maybe<Scalars['String']>;
  /** Financials */
  ProgramServiceRevenueNameB?: Maybe<Scalars['String']>;
  /** Financials */
  ProgramServiceRevenueNameC?: Maybe<Scalars['String']>;
  /** Financials */
  ProgramServiceRevenueNameD?: Maybe<Scalars['String']>;
  /** Financials */
  ProgramServiceRevenueNameE?: Maybe<Scalars['String']>;
  StateProvince?: Maybe<Scalars['String']>;
  /** Financials */
  Subsection?: Maybe<Scalars['Int']>;
  /** Tax ID from taxing authority where organization is based */
  TaxID?: Maybe<Scalars['String']>;
  /** Financials */
  TaxMonth?: Maybe<Scalars['Int']>;
  /** Financials */
  TaxYear?: Maybe<Scalars['Int']>;
  /** Financials */
  TotalAssets?: Maybe<Scalars['Float']>;
  /** Financials */
  TotalRevenue?: Maybe<Scalars['Float']>;
  UpdatedAt: Scalars['Timestamp'];
  Website?: Maybe<Scalars['String']>;
  _990Full: Array<_990Full>;
};

/** Join table between Companies and Accounts entities, this is used to determine which Accounts are linked to which Companies */
export type AccountCompanyIntegration = {
  __typename?: 'AccountCompanyIntegration';
  Account: Scalars['String'];
  AccountID: Scalars['Int'];
  AccountType: Scalars['String'];
  AccountTypeID?: Maybe<Scalars['Int']>;
  CompanyID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  CompanyName: Scalars['String'];
  CreatedAt: Scalars['Timestamp'];
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
};

export type AccountType = {
  __typename?: 'AccountType';
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type Activity = {
  __typename?: 'Activity';
  Account?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Int']>;
  AccountWebsite?: Maybe<Scalars['String']>;
  ActivityDate?: Maybe<Scalars['Timestamp']>;
  Attachment?: Maybe<Scalars['String']>;
  AttachmentID?: Maybe<Scalars['Int']>;
  BCMID: Scalars['String'];
  Company: Scalars['String'];
  CompanyID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  ContactEmail?: Maybe<Scalars['String']>;
  ContactFirstName?: Maybe<Scalars['String']>;
  ContactID?: Maybe<Scalars['Int']>;
  ContactLastName?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  Deal?: Maybe<Scalars['String']>;
  DealID?: Maybe<Scalars['Int']>;
  Description?: Maybe<Scalars['String']>;
  EmployeeEmail?: Maybe<Scalars['String']>;
  EmployeeFirstName?: Maybe<Scalars['String']>;
  EmployeeID?: Maybe<Scalars['Int']>;
  EmployeeLastName?: Maybe<Scalars['String']>;
  EmployeeSupervisor?: Maybe<Scalars['Int']>;
  EmployeeSupervisorEmail?: Maybe<Scalars['String']>;
  EmployeeSupervisorFirstName?: Maybe<Scalars['String']>;
  EmployeeSupervisorLastName?: Maybe<Scalars['String']>;
  ExternalSystemRecordID?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Integration: Scalars['String'];
  IsActive?: Maybe<Scalars['Boolean']>;
  IsBounced?: Maybe<Scalars['Boolean']>;
  IsOpened?: Maybe<Scalars['Boolean']>;
  IsReplied?: Maybe<Scalars['Boolean']>;
  Summary?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type ActivityAttachment = {
  __typename?: 'ActivityAttachment';
  Attachments?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
};

export type Application = {
  __typename?: 'Application';
  ApplicationEntities: Array<ApplicationEntity>;
  ApplicationPermissions: Array<ApplicationPermission>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type ApplicationEntity = {
  __typename?: 'ApplicationEntity';
  Application: Scalars['String'];
  ApplicationID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  DefaultForNewUser: Scalars['Boolean'];
  Entity: Scalars['String'];
  EntityBaseTable: Scalars['String'];
  EntityBaseTableCodeName: Scalars['String'];
  EntityClassName: Scalars['String'];
  EntityCodeName?: Maybe<Scalars['String']>;
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
};

export type ApplicationPermission = {
  __typename?: 'ApplicationPermission';
  Application: Scalars['String'];
  ApplicationID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  Role: Scalars['String'];
  RoleID: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
};

export type AskSkipResultType = {
  __typename?: 'AskSkipResultType';
  Result: Scalars['String'];
  Status: Scalars['String'];
  Success: Scalars['Boolean'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  AuditLogType: Scalars['String'];
  AuditLogTypeID: Scalars['Int'];
  AuthorizationID?: Maybe<Scalars['Int']>;
  CreatedAt: Scalars['Timestamp'];
  Details?: Maybe<Scalars['String']>;
  Entity?: Maybe<Scalars['String']>;
  EntityID?: Maybe<Scalars['Int']>;
  ID: Scalars['Int'];
  RecordID?: Maybe<Scalars['Int']>;
  Status: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  User: Scalars['String'];
  UserID: Scalars['Int'];
};

export type AuditLogType = {
  __typename?: 'AuditLogType';
  AuthorizationID?: Maybe<Scalars['Int']>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  Parent?: Maybe<Scalars['String']>;
  ParentID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type Authorization = {
  __typename?: 'Authorization';
  AuthorizationRoles: Array<AuthorizationRole>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  ParentID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
  UseAuditLog: Scalars['Boolean'];
};

export type AuthorizationRole = {
  __typename?: 'AuthorizationRole';
  AuthorizationID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  Role: Scalars['String'];
  RoleID: Scalars['Int'];
  Type: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type Campaign = {
  __typename?: 'Campaign';
  BCMID: Scalars['String'];
  CompanyIntegrationID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  Employee?: Maybe<Scalars['String']>;
  EmployeeID?: Maybe<Scalars['Int']>;
  ExternalSystemCreatedAt?: Maybe<Scalars['Timestamp']>;
  ExternalSystemRecordID?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  StatusID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type CampaignStep = {
  __typename?: 'CampaignStep';
  Body?: Maybe<Scalars['String']>;
  CampaignID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  ExternalSystemRecordID?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  Subject?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
};

/** List of companies within the Blue Cypress Family */
export type Company = {
  __typename?: 'Company';
  AccountCompanyIntegrations: Array<AccountCompanyIntegration>;
  Accounts: Array<Account>;
  Contacts: Array<Contact>;
  CreatedAt: Scalars['Timestamp'];
  Deals: Array<Deal>;
  Description: Scalars['String'];
  Domain?: Maybe<Scalars['String']>;
  Employees: Array<Employee>;
  ID: Scalars['Int'];
  Invoices: Array<Invoice>;
  LogoURL?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  Website?: Maybe<Scalars['String']>;
};

export type CompanyIntegration = {
  __typename?: 'CompanyIntegration';
  APIKey?: Maybe<Scalars['String']>;
  AccessToken?: Maybe<Scalars['String']>;
  ClientID?: Maybe<Scalars['String']>;
  ClientSecret?: Maybe<Scalars['String']>;
  Company: Scalars['String'];
  CompanyID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  CustomAttribute1?: Maybe<Scalars['String']>;
  DriverClassName?: Maybe<Scalars['String']>;
  DriverImportPath?: Maybe<Scalars['String']>;
  ExternalSystemID?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Integration: Scalars['String'];
  IntegrationID: Scalars['Int'];
  IsActive?: Maybe<Scalars['Boolean']>;
  IsExternalSystemReadOnly: Scalars['Boolean'];
  LastRunEndedAt?: Maybe<Scalars['Timestamp']>;
  LastRunID?: Maybe<Scalars['Int']>;
  LastRunStartedAt?: Maybe<Scalars['Timestamp']>;
  RefreshToken?: Maybe<Scalars['String']>;
  TokenExpirationDate?: Maybe<Scalars['Timestamp']>;
  UpdatedAt: Scalars['Timestamp'];
};

/** Individuals who are prospects, customers, former customers, etc, across all companies in the Blue Cypress family. */
export type Contact = {
  __typename?: 'Contact';
  Account?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Int']>;
  Activities: Array<Activity>;
  ActivityCount: Scalars['Int'];
  /** Blue Cypress Master ID */
  BCMID: Scalars['String'];
  Companies: Array<Company>;
  ContactAccounts: Array<ContactAccount>;
  ContactEmails: Array<ContactEmail>;
  ContactTopics: Array<ContactTopic>;
  CreatedAt: Scalars['Timestamp'];
  Deals: Array<Deal>;
  Domain?: Maybe<Scalars['String']>;
  EarliestActivityDate?: Maybe<Scalars['Timestamp']>;
  Email1?: Maybe<Scalars['String']>;
  Email2?: Maybe<Scalars['String']>;
  EmailDomain?: Maybe<Scalars['String']>;
  EmailSource?: Maybe<Scalars['String']>;
  EmailStatus?: Maybe<Scalars['String']>;
  /** Individual's FB Page URL */
  Facebook?: Maybe<Scalars['String']>;
  FirstLast?: Maybe<Scalars['String']>;
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  Instagram?: Maybe<Scalars['String']>;
  Invoices: Array<Invoice>;
  LastName: Scalars['String'];
  LastReviewedDate?: Maybe<Scalars['Timestamp']>;
  LatestActivityDate?: Maybe<Scalars['Timestamp']>;
  /** Structured Level */
  Level?: Maybe<Scalars['String']>;
  LevelID?: Maybe<Scalars['Int']>;
  /** Individual's LinkedIn Page URL */
  LinkedIn?: Maybe<Scalars['String']>;
  NickName?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Prefix?: Maybe<Scalars['String']>;
  ProfilePictureURL?: Maybe<Scalars['String']>;
  /** Structured Role */
  Role?: Maybe<Scalars['String']>;
  RoleID?: Maybe<Scalars['Int']>;
  Status?: Maybe<Scalars['String']>;
  Suffix?: Maybe<Scalars['String']>;
  Tags?: Maybe<Scalars['String']>;
  /** Actual title the individual uses */
  Title?: Maybe<Scalars['String']>;
  Twitter?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
  Website?: Maybe<Scalars['String']>;
};

/** Accounts linked to a contact */
export type ContactAccount = {
  __typename?: 'ContactAccount';
  Account: Scalars['String'];
  AccountID: Scalars['Int'];
  Contact?: Maybe<Scalars['String']>;
  ContactID: Scalars['Int'];
  EndedAt?: Maybe<Scalars['Timestamp']>;
  ID: Scalars['Int'];
  IsPrimary: Scalars['Boolean'];
  Sequence: Scalars['Int'];
  StartedAt: Scalars['Timestamp'];
};

/** Join table between Companies and Contacts entities, this is used to determine which Contacts are linked to which Companies */
export type ContactCompanyIntegration = {
  __typename?: 'ContactCompanyIntegration';
  CompanyID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  CompanyName: Scalars['String'];
  ContactID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
};

/** Emails belonging to a contact */
export type ContactEmail = {
  __typename?: 'ContactEmail';
  Account?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Int']>;
  Contact?: Maybe<Scalars['String']>;
  ContactID: Scalars['Int'];
  Email: Scalars['String'];
  EmailDomain?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
};

export type ContactLevel = {
  __typename?: 'ContactLevel';
  Description?: Maybe<Scalars['String']>;
  ExcludeKeywords?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Keywords?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  Rank: Scalars['Int'];
};

export type ContactRole = {
  __typename?: 'ContactRole';
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Keywords?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
};

/** Topics that each contact has engaged with/expressed interest in, over time */
export type ContactTopic = {
  __typename?: 'ContactTopic';
  Account?: Maybe<Scalars['String']>;
  Contact?: Maybe<Scalars['String']>;
  ContactID: Scalars['Int'];
  Domain?: Maybe<Scalars['String']>;
  EarliestDate: Scalars['Timestamp'];
  ID: Scalars['Int'];
  LatestDate: Scalars['Timestamp'];
  Topic: Scalars['String'];
  TotalCount: Scalars['Int'];
  Website?: Maybe<Scalars['String']>;
};

export type CreateAccountInput = {
  Acronym?: InputMaybe<Scalars['String']>;
  AddressLine1?: InputMaybe<Scalars['String']>;
  AddressLine2?: InputMaybe<Scalars['String']>;
  AddressLine3?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DisplayName?: InputMaybe<Scalars['String']>;
  Domain?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  ISOCountryCode?: InputMaybe<Scalars['String']>;
  LeadershipPageURL?: InputMaybe<Scalars['String']>;
  LinkedIn?: InputMaybe<Scalars['String']>;
  Logo?: InputMaybe<Scalars['String']>;
  LogoURL?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  OperatingName?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  StateProvince?: InputMaybe<Scalars['String']>;
  TaxID?: InputMaybe<Scalars['String']>;
  Website?: InputMaybe<Scalars['String']>;
};

export type CreateApplicationEntityInput = {
  ApplicationID: Scalars['Int'];
  DefaultForNewUser: Scalars['Boolean'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
};

export type CreateAuditLogInput = {
  AuditLogTypeID: Scalars['Int'];
  AuthorizationID?: InputMaybe<Scalars['Int']>;
  Details?: InputMaybe<Scalars['String']>;
  EntityID?: InputMaybe<Scalars['Int']>;
  RecordID?: InputMaybe<Scalars['Int']>;
  Status: Scalars['String'];
  UserID: Scalars['Int'];
};

export type CreateCompanyInput = {
  Description: Scalars['String'];
  Domain?: InputMaybe<Scalars['String']>;
  LogoURL?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  Website?: InputMaybe<Scalars['String']>;
};

export type CreateContactInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  ActivityCount: Scalars['Int'];
  EarliestActivityDate?: InputMaybe<Scalars['Timestamp']>;
  Email1?: InputMaybe<Scalars['String']>;
  Email2?: InputMaybe<Scalars['String']>;
  EmailSource?: InputMaybe<Scalars['String']>;
  EmailStatus?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  FirstName: Scalars['String'];
  Instagram?: InputMaybe<Scalars['String']>;
  LastName: Scalars['String'];
  LastReviewedDate?: InputMaybe<Scalars['Timestamp']>;
  LatestActivityDate?: InputMaybe<Scalars['Timestamp']>;
  LevelID?: InputMaybe<Scalars['Int']>;
  LinkedIn?: InputMaybe<Scalars['String']>;
  NickName?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  Prefix?: InputMaybe<Scalars['String']>;
  ProfilePictureURL?: InputMaybe<Scalars['String']>;
  RoleID?: InputMaybe<Scalars['Int']>;
  Status?: InputMaybe<Scalars['String']>;
  Suffix?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  Twitter?: InputMaybe<Scalars['String']>;
};

export type CreateDealInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  CloseDate?: InputMaybe<Scalars['Timestamp']>;
  CompanyIntegrationID: Scalars['Int'];
  ContactID?: InputMaybe<Scalars['Int']>;
  ContractTermMonths: Scalars['Int'];
  DealForecastCategoryID?: InputMaybe<Scalars['Int']>;
  DealStageID?: InputMaybe<Scalars['Int']>;
  DealTypeID?: InputMaybe<Scalars['Int']>;
  Description?: InputMaybe<Scalars['String']>;
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ExternalSystemCreatedAt?: InputMaybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ExternalSystemUpdatedAt?: InputMaybe<Scalars['Timestamp']>;
  ForecastNotes?: InputMaybe<Scalars['String']>;
  IncludeInForecast?: InputMaybe<Scalars['Boolean']>;
  LeadSource?: InputMaybe<Scalars['String']>;
  LeadSourceDetail?: InputMaybe<Scalars['String']>;
  MRR: Scalars['Float'];
  OneTimeFees: Scalars['Float'];
  Pipeline?: InputMaybe<Scalars['String']>;
  Probability?: InputMaybe<Scalars['Float']>;
  Title?: InputMaybe<Scalars['String']>;
  Value?: InputMaybe<Scalars['Float']>;
};

export type CreateEmployeeInput = {
  Active: Scalars['Boolean'];
  CompanyID: Scalars['Int'];
  Email: Scalars['String'];
  FirstName: Scalars['String'];
  LastName: Scalars['String'];
  Phone?: InputMaybe<Scalars['String']>;
  SupervisorID?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['String']>;
};

export type CreateEntityFieldInput = {
  AllowUpdateAPI: Scalars['Boolean'];
  AllowUpdateInView: Scalars['Boolean'];
  Category?: InputMaybe<Scalars['String']>;
  DefaultColumnWidth?: InputMaybe<Scalars['Int']>;
  DefaultInView: Scalars['Boolean'];
  Description?: InputMaybe<Scalars['String']>;
  DisplayName?: InputMaybe<Scalars['String']>;
  ExtendedType?: InputMaybe<Scalars['String']>;
  GeneratedFormSection: Scalars['String'];
  IncludeInGeneratedForm: Scalars['Boolean'];
  IncludeInUserSearchAPI: Scalars['Boolean'];
  IncludeRelatedEntityNameFieldInBaseView: Scalars['Boolean'];
  IsNameField: Scalars['Boolean'];
  RelatedEntityFieldName?: InputMaybe<Scalars['String']>;
  RelatedEntityID?: InputMaybe<Scalars['Int']>;
  RelatedEntityNameFieldMap?: InputMaybe<Scalars['String']>;
  UserSearchParamFormatAPI?: InputMaybe<Scalars['String']>;
  ValueListType: Scalars['String'];
  ViewCellTemplate?: InputMaybe<Scalars['String']>;
};

export type CreateEntityInput = {
  AllowAllRowsAPI: Scalars['Boolean'];
  AllowCreateAPI: Scalars['Boolean'];
  AllowDeleteAPI: Scalars['Boolean'];
  AllowUpdateAPI: Scalars['Boolean'];
  AllowUserSearchAPI: Scalars['Boolean'];
  AuditRecordAccess: Scalars['Boolean'];
  AuditViewRuns: Scalars['Boolean'];
  BaseView: Scalars['String'];
  BaseViewGenerated: Scalars['Boolean'];
  CustomResolverAPI: Scalars['Boolean'];
  Description?: InputMaybe<Scalars['String']>;
  EntityObjectSubclassImportPath?: InputMaybe<Scalars['String']>;
  EntityObjectSubclassName?: InputMaybe<Scalars['String']>;
  IncludeInAPI: Scalars['Boolean'];
  Name: Scalars['String'];
  ParentID?: InputMaybe<Scalars['Int']>;
  TrackRecordChanges: Scalars['Boolean'];
  UserFormClassName?: InputMaybe<Scalars['String']>;
  UserFormGenerated: Scalars['Boolean'];
  UserFormImportPath?: InputMaybe<Scalars['String']>;
  UserViewMaxRows?: InputMaybe<Scalars['Int']>;
  spCreate?: InputMaybe<Scalars['String']>;
  spCreateGenerated: Scalars['Boolean'];
  spDelete?: InputMaybe<Scalars['String']>;
  spDeleteGenerated: Scalars['Boolean'];
  spUpdate?: InputMaybe<Scalars['String']>;
  spUpdateGenerated: Scalars['Boolean'];
};

export type CreateEntityPermissionInput = {
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanRead: Scalars['Boolean'];
  CanUpdate: Scalars['Boolean'];
  CreateRLSFilterID?: InputMaybe<Scalars['Int']>;
  DeleteRLSFilterID?: InputMaybe<Scalars['Int']>;
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  ReadRLSFilterID?: InputMaybe<Scalars['Int']>;
  RoleID: Scalars['Int'];
  UpdateRLSFilterID?: InputMaybe<Scalars['Int']>;
};

export type CreateEntityRelationshipInput = {
  BundleInAPI: Scalars['Boolean'];
  DisplayInForm: Scalars['Boolean'];
  DisplayName?: InputMaybe<Scalars['String']>;
  DisplayUserViewID?: InputMaybe<Scalars['Int']>;
  EntityID: Scalars['Int'];
  EntityKeyField?: InputMaybe<Scalars['String']>;
  IncludeInParentAllQuery: Scalars['Boolean'];
  JoinEntityInverseJoinField?: InputMaybe<Scalars['String']>;
  JoinEntityJoinField?: InputMaybe<Scalars['String']>;
  JoinView?: InputMaybe<Scalars['String']>;
  RelatedEntityID: Scalars['Int'];
  RelatedEntityJoinField: Scalars['String'];
  Type: Scalars['String'];
};

export type CreateListDetailInput = {
  ID: Scalars['Int'];
  ListID: Scalars['Int'];
  RecordID: Scalars['Int'];
  Sequence: Scalars['Int'];
};

export type CreateListInput = {
  Description?: InputMaybe<Scalars['String']>;
  EntityID?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UserID: Scalars['Int'];
};

export type CreateRecordChangeInput = {
  ChangedAt: Scalars['Timestamp'];
  ChangesDescription: Scalars['String'];
  ChangesJSON: Scalars['String'];
  Comments?: InputMaybe<Scalars['String']>;
  EntityID: Scalars['Int'];
  FullRecordJSON: Scalars['String'];
  RecordID: Scalars['Int'];
  Status: Scalars['String'];
  UserID: Scalars['Int'];
};

export type CreateTaxReturnCompensationInput = {
  AnnualizedTotalCompensation?: InputMaybe<Scalars['Float']>;
  AverageHoursPerWeek?: InputMaybe<Scalars['Int']>;
  Compensation: Scalars['Float'];
  ContactID?: InputMaybe<Scalars['Int']>;
  EndDate?: InputMaybe<Scalars['Timestamp']>;
  IsOfficer: Scalars['Boolean'];
  OtherCompensation?: InputMaybe<Scalars['Float']>;
  PartialYear: Scalars['Boolean'];
  PersonName: Scalars['String'];
  RelatedOrgCompensation?: InputMaybe<Scalars['Float']>;
  StartDate?: InputMaybe<Scalars['Timestamp']>;
  TaxReturnID: Scalars['Int'];
  Title?: InputMaybe<Scalars['String']>;
  TotalCompensation?: InputMaybe<Scalars['Float']>;
};

export type CreateTaxReturnContractorInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  AddressLine1?: InputMaybe<Scalars['String']>;
  Amount: Scalars['Float'];
  City?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  PostalCode?: InputMaybe<Scalars['String']>;
  StateProvince?: InputMaybe<Scalars['String']>;
  TaxReturnID: Scalars['Int'];
  Type: Scalars['String'];
};

export type CreateTaxReturnDetailInput = {
  Code?: InputMaybe<Scalars['String']>;
  EndingAmount: Scalars['Float'];
  Name: Scalars['String'];
  StartingAmount?: InputMaybe<Scalars['Float']>;
  TaxReturnID: Scalars['Int'];
  Type: Scalars['String'];
};

export type CreateTaxReturnInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  AccountingFees?: InputMaybe<Scalars['Float']>;
  AccountsPayable?: InputMaybe<Scalars['Float']>;
  AccountsReceivable?: InputMaybe<Scalars['Float']>;
  ActivityDescription?: InputMaybe<Scalars['String']>;
  AddressLine1?: InputMaybe<Scalars['String']>;
  AddressLine2?: InputMaybe<Scalars['String']>;
  AdvertisingExpense?: InputMaybe<Scalars['Float']>;
  AffiliatePaymentExpense?: InputMaybe<Scalars['Float']>;
  Affiliation?: InputMaybe<Scalars['Int']>;
  BODVotingMembers?: InputMaybe<Scalars['Int']>;
  CapitalStockPrincipal?: InputMaybe<Scalars['Float']>;
  Cash?: InputMaybe<Scalars['Float']>;
  City?: InputMaybe<Scalars['String']>;
  ConferenceExpense?: InputMaybe<Scalars['Float']>;
  CostBasisSecurities?: InputMaybe<Scalars['Float']>;
  DeferredRevenue?: InputMaybe<Scalars['Float']>;
  DepreciationExpense?: InputMaybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: InputMaybe<Scalars['Float']>;
  EscrowAccountLiability?: InputMaybe<Scalars['Float']>;
  FinancialStrength?: InputMaybe<Scalars['String']>;
  FundraisingExpenses?: InputMaybe<Scalars['Float']>;
  FundraisingNetIncome?: InputMaybe<Scalars['Float']>;
  GrantsPayable?: InputMaybe<Scalars['Float']>;
  GrantsToIndividuals?: InputMaybe<Scalars['Int']>;
  GrantsToOrgs?: InputMaybe<Scalars['Int']>;
  GrossFundraisingReceipts?: InputMaybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: InputMaybe<Scalars['Float']>;
  GrossSalesSecurities?: InputMaybe<Scalars['Float']>;
  HasForeignBankAcct?: InputMaybe<Scalars['Boolean']>;
  HasInvestmentIncome?: InputMaybe<Scalars['Boolean']>;
  InformationTechnologyExpense?: InputMaybe<Scalars['Float']>;
  InsuranceExpense?: InputMaybe<Scalars['Float']>;
  IntangibleAssetValue?: InputMaybe<Scalars['Float']>;
  InterestExpense?: InputMaybe<Scalars['Float']>;
  InventoryAssetValue?: InputMaybe<Scalars['Float']>;
  InvestmentManagementFees?: InputMaybe<Scalars['Float']>;
  IsHospital?: InputMaybe<Scalars['Boolean']>;
  LegalFees?: InputMaybe<Scalars['Float']>;
  LobbyingFees?: InputMaybe<Scalars['Float']>;
  ManagementFees?: InputMaybe<Scalars['Float']>;
  MissionDescription?: InputMaybe<Scalars['String']>;
  MortgagesNotesPayable?: InputMaybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: InputMaybe<Scalars['Float']>;
  NetRentRealEstate?: InputMaybe<Scalars['Float']>;
  NotesReceivable?: InputMaybe<Scalars['Float']>;
  NumberEmployees?: InputMaybe<Scalars['Int']>;
  NumberVolunteers?: InputMaybe<Scalars['Int']>;
  OccupancyExpense?: InputMaybe<Scalars['Float']>;
  OfficeExpense?: InputMaybe<Scalars['Float']>;
  OfficerCompensation?: InputMaybe<Scalars['Float']>;
  OtherAssets?: InputMaybe<Scalars['Float']>;
  OtherEmployeeBenefits?: InputMaybe<Scalars['Float']>;
  OtherFees?: InputMaybe<Scalars['Float']>;
  OtherLiabilities?: InputMaybe<Scalars['Float']>;
  OtherSalaries?: InputMaybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  PaidInCapitalSurplus?: InputMaybe<Scalars['Float']>;
  PayablesToOfficers?: InputMaybe<Scalars['Float']>;
  PayrollTaxes?: InputMaybe<Scalars['Float']>;
  PensionContributions?: InputMaybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  PledgesGrantsReceivable?: InputMaybe<Scalars['Float']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: InputMaybe<Scalars['Float']>;
  PreparerFirm?: InputMaybe<Scalars['String']>;
  PreparerFirmAddressLine1?: InputMaybe<Scalars['String']>;
  PreparerFirmAddressLine2?: InputMaybe<Scalars['String']>;
  PreparerFirmCity?: InputMaybe<Scalars['String']>;
  PreparerFirmPostalCode?: InputMaybe<Scalars['String']>;
  PreparerFirmStateProvince?: InputMaybe<Scalars['String']>;
  PreparerFirmTaxID?: InputMaybe<Scalars['String']>;
  PreparerPerson?: InputMaybe<Scalars['String']>;
  PreparerPersonPhone?: InputMaybe<Scalars['String']>;
  PreparerPersonTaxID?: InputMaybe<Scalars['String']>;
  ProfessionalFundraisingFees?: InputMaybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: InputMaybe<Scalars['Float']>;
  PublicSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  RealEstateAssetValue?: InputMaybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: InputMaybe<Scalars['Float']>;
  ReceivablesFromOfficers?: InputMaybe<Scalars['Float']>;
  RentalExpenseRealEstate?: InputMaybe<Scalars['Float']>;
  RetainedEarnings?: InputMaybe<Scalars['Float']>;
  ReturnType?: InputMaybe<Scalars['String']>;
  RoyaltyExpense?: InputMaybe<Scalars['Float']>;
  Savings?: InputMaybe<Scalars['Float']>;
  SourceJSON?: InputMaybe<Scalars['String']>;
  StateProvince?: InputMaybe<Scalars['String']>;
  Subsection?: InputMaybe<Scalars['String']>;
  SummaryText?: InputMaybe<Scalars['String']>;
  TaxExemptBondLiability?: InputMaybe<Scalars['Float']>;
  TaxID: Scalars['String'];
  TaxMonth?: InputMaybe<Scalars['Int']>;
  TaxPeriodEnd: Scalars['Timestamp'];
  TaxPeriodStart: Scalars['Timestamp'];
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  TotalAssets?: InputMaybe<Scalars['Float']>;
  TotalGrossReceipts?: InputMaybe<Scalars['Float']>;
  TotalInvestmentIncome?: InputMaybe<Scalars['Float']>;
  TotalLiabilities?: InputMaybe<Scalars['Float']>;
  TotalMemberIncome?: InputMaybe<Scalars['Float']>;
  TotalNetAssets?: InputMaybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: InputMaybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: InputMaybe<Scalars['Float']>;
  TotalRevenue?: InputMaybe<Scalars['Float']>;
  TravelExpense?: InputMaybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: InputMaybe<Scalars['Float']>;
  UnrestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  UnsecuredNotesPayable?: InputMaybe<Scalars['Float']>;
  Website?: InputMaybe<Scalars['String']>;
  YearFormed?: InputMaybe<Scalars['Int']>;
};

export type CreateUserApplicationEntityInput = {
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  UserApplicationID: Scalars['Int'];
};

export type CreateUserFavoriteInput = {
  EntityID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UserID: Scalars['Int'];
};

export type CreateUserViewInput = {
  CustomFilterState: Scalars['Boolean'];
  CustomWhereClause: Scalars['Boolean'];
  Description?: InputMaybe<Scalars['String']>;
  EntityID: Scalars['Int'];
  FilterState?: InputMaybe<Scalars['String']>;
  GridState?: InputMaybe<Scalars['String']>;
  IsDefault: Scalars['Boolean'];
  IsShared: Scalars['Boolean'];
  Name: Scalars['String'];
  UserID: Scalars['Int'];
  WhereClause?: InputMaybe<Scalars['String']>;
};

export type CreateUserViewRunDetailInput = {
  ID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UserViewRunID: Scalars['Int'];
};

export type CreateUserViewRunInput = {
  ID: Scalars['Int'];
  RunAt: Scalars['Timestamp'];
  RunByUserID: Scalars['Int'];
  UserViewID: Scalars['Int'];
};

/** Deals active and historical from all Blue Cypress companies aggregated into a single entity */
export type Deal = {
  __typename?: 'Deal';
  Account?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Int']>;
  Activities: Array<Activity>;
  /** Blue Cypress Master ID. */
  BCMID: Scalars['String'];
  /** Expected Close Date */
  CloseDate?: Maybe<Scalars['Timestamp']>;
  Company: Scalars['String'];
  CompanyID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  CompanyLogoURL?: Maybe<Scalars['String']>;
  ContactEmail1?: Maybe<Scalars['String']>;
  ContactFirstName?: Maybe<Scalars['String']>;
  ContactID?: Maybe<Scalars['Int']>;
  ContactLastName?: Maybe<Scalars['String']>;
  ContactPhoneNumber?: Maybe<Scalars['String']>;
  ContactTitle?: Maybe<Scalars['String']>;
  ContractTermMonths: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  DealForecastCategoryID?: Maybe<Scalars['Int']>;
  DealStageID?: Maybe<Scalars['Int']>;
  DealTypeID?: Maybe<Scalars['Int']>;
  Description?: Maybe<Scalars['String']>;
  EmployeeEmail?: Maybe<Scalars['String']>;
  EmployeeFirstName?: Maybe<Scalars['String']>;
  EmployeeID?: Maybe<Scalars['Int']>;
  EmployeeLastName?: Maybe<Scalars['String']>;
  EmployeeSupervisor?: Maybe<Scalars['String']>;
  EmployeeSupervisorEmail?: Maybe<Scalars['String']>;
  EmployeeTitle?: Maybe<Scalars['String']>;
  ExternalSystemCreatedAt?: Maybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ExternalSystemUpdatedAt?: Maybe<Scalars['Timestamp']>;
  ForecastNotes?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  /** Include this deal in the sales forecast or not */
  IncludeInForecast?: Maybe<Scalars['Boolean']>;
  LeadSource?: Maybe<Scalars['String']>;
  LeadSourceDetail?: Maybe<Scalars['String']>;
  MRR: Scalars['Float'];
  OneTimeFees: Scalars['Float'];
  Pipeline?: Maybe<Scalars['String']>;
  /** Probability of winning the deal */
  Probability?: Maybe<Scalars['Float']>;
  Title?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
  Value?: Maybe<Scalars['Float']>;
};

export type DealStage = {
  __typename?: 'DealStage';
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type DealType = {
  __typename?: 'DealType';
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  DisplayName?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type EmailServiceProviders = {
  __typename?: 'EmailServiceProviders';
  Domain: Scalars['String'];
  ID: Scalars['Int'];
};

/** Employees of the Blue Cypress Family of Companies */
export type Employee = {
  __typename?: 'Employee';
  Active: Scalars['Boolean'];
  BCMID: Scalars['String'];
  CompanyID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  /** 5 */
  Email: Scalars['String'];
  Employees: Array<Employee>;
  FirstLast?: Maybe<Scalars['String']>;
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  LastName: Scalars['String'];
  Phone?: Maybe<Scalars['String']>;
  Supervisor?: Maybe<Scalars['String']>;
  SupervisorEmail?: Maybe<Scalars['String']>;
  SupervisorFirstName?: Maybe<Scalars['String']>;
  SupervisorID?: Maybe<Scalars['Int']>;
  SupervisorLastName?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
};

/** Metadata about all of the entities in the system. This information is managed by CodeGen, don't modify the parts that come from SQL Server */
export type Entity = {
  __typename?: 'Entity';
  AllowAllRowsAPI: Scalars['Boolean'];
  AllowCreateAPI: Scalars['Boolean'];
  AllowDeleteAPI: Scalars['Boolean'];
  /** If set to 1, allows updates to occur via API. Role based permissions are required in addition to turning this bit on. */
  AllowUpdateAPI: Scalars['Boolean'];
  /** If set to 1, allows an end user to add their own search string when running a user view or searching without saving a view */
  AllowUserSearchAPI: Scalars['Boolean'];
  AuditRecordAccess: Scalars['Boolean'];
  AuditViewRuns: Scalars['Boolean'];
  BaseTable: Scalars['String'];
  BaseTableCodeName: Scalars['String'];
  BaseView: Scalars['String'];
  BaseViewGenerated: Scalars['Boolean'];
  ClassName: Scalars['String'];
  CodeName?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  CustomResolverAPI: Scalars['Boolean'];
  Description?: Maybe<Scalars['String']>;
  EntityAIActions: Array<EntityAIAction>;
  EntityFields: Array<EntityField>;
  EntityObjectSubclassImportPath?: Maybe<Scalars['String']>;
  EntityObjectSubclassName?: Maybe<Scalars['String']>;
  EntityPermissions: Array<EntityPermission>;
  EntityRelationships: Array<EntityRelationship>;
  ID: Scalars['Int'];
  /** Master switch to control if the field is included in the API or not */
  IncludeInAPI: Scalars['Boolean'];
  Name: Scalars['String'];
  ParentBaseTable?: Maybe<Scalars['String']>;
  ParentBaseView?: Maybe<Scalars['String']>;
  ParentEntity?: Maybe<Scalars['String']>;
  /** Reserved for future use */
  ParentID?: Maybe<Scalars['Int']>;
  /** Database Schema Name */
  SchemaName: Scalars['String'];
  TrackRecordChanges: Scalars['Boolean'];
  UpdatedAt: Scalars['Timestamp'];
  UserFormClassName?: Maybe<Scalars['String']>;
  UserFormGenerated: Scalars['Boolean'];
  UserFormImportPath?: Maybe<Scalars['String']>;
  UserViewMaxRows?: Maybe<Scalars['Int']>;
  spCreate?: Maybe<Scalars['String']>;
  spCreateGenerated: Scalars['Boolean'];
  spDelete?: Maybe<Scalars['String']>;
  spDeleteGenerated: Scalars['Boolean'];
  spUpdate?: Maybe<Scalars['String']>;
  spUpdateGenerated: Scalars['Boolean'];
};

export type EntityAIAction = {
  __typename?: 'EntityAIAction';
  AIAction: Scalars['String'];
  AIActionID: Scalars['Int'];
  AIModel?: Maybe<Scalars['String']>;
  AIModelID?: Maybe<Scalars['Int']>;
  Comments?: Maybe<Scalars['String']>;
  Entity: Scalars['String'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  OutputEntity?: Maybe<Scalars['String']>;
  OutputEntityID?: Maybe<Scalars['Int']>;
  OutputField?: Maybe<Scalars['String']>;
  OutputType: Scalars['String'];
  Prompt?: Maybe<Scalars['String']>;
  SkipIfOutputFieldNotEmpty: Scalars['Boolean'];
  TriggerEvent: Scalars['String'];
  UserMessage: Scalars['String'];
};

export type EntityField = {
  __typename?: 'EntityField';
  AllowUpdateAPI: Scalars['Boolean'];
  AllowUpdateInView: Scalars['Boolean'];
  AllowsNull: Scalars['Boolean'];
  AutoIncrement: Scalars['Boolean'];
  BaseTable: Scalars['String'];
  BaseView: Scalars['String'];
  Category?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  DefaultColumnWidth?: Maybe<Scalars['Int']>;
  DefaultInView: Scalars['Boolean'];
  DefaultValue?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
  Entity: Scalars['String'];
  EntityClassName: Scalars['String'];
  EntityCodeName?: Maybe<Scalars['String']>;
  EntityFieldValues: Array<EntityFieldValue>;
  EntityID: Scalars['Int'];
  ExtendedType?: Maybe<Scalars['String']>;
  GeneratedFormSection: Scalars['String'];
  ID: Scalars['Int'];
  IncludeInGeneratedForm: Scalars['Boolean'];
  IncludeInUserSearchAPI: Scalars['Boolean'];
  IncludeRelatedEntityNameFieldInBaseView: Scalars['Boolean'];
  IsNameField: Scalars['Boolean'];
  IsVirtual: Scalars['Boolean'];
  Length?: Maybe<Scalars['Int']>;
  Name: Scalars['String'];
  Precision?: Maybe<Scalars['Int']>;
  RelatedEntity?: Maybe<Scalars['String']>;
  RelatedEntityBaseTable?: Maybe<Scalars['String']>;
  RelatedEntityBaseView?: Maybe<Scalars['String']>;
  RelatedEntityClassName?: Maybe<Scalars['String']>;
  RelatedEntityCodeName?: Maybe<Scalars['String']>;
  RelatedEntityFieldName?: Maybe<Scalars['String']>;
  RelatedEntityID?: Maybe<Scalars['Int']>;
  RelatedEntityNameFieldMap?: Maybe<Scalars['String']>;
  RelatedEntitySchemaName?: Maybe<Scalars['String']>;
  Scale?: Maybe<Scalars['Int']>;
  SchemaName: Scalars['String'];
  Sequence: Scalars['Int'];
  Type: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  UserSearchParamFormatAPI?: Maybe<Scalars['String']>;
  ValueListType: Scalars['String'];
  ViewCellTemplate?: Maybe<Scalars['String']>;
};

export type EntityFieldValue = {
  __typename?: 'EntityFieldValue';
  Code?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  EntityField: Scalars['String'];
  EntityFieldID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
  Value: Scalars['String'];
};

export type EntityPermission = {
  __typename?: 'EntityPermission';
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanRead: Scalars['Boolean'];
  CanUpdate: Scalars['Boolean'];
  CreateRLSFilter?: Maybe<Scalars['String']>;
  CreateRLSFilterID?: Maybe<Scalars['Int']>;
  CreatedAt: Scalars['Timestamp'];
  DeleteRLSFilter?: Maybe<Scalars['String']>;
  DeleteRLSFilterID?: Maybe<Scalars['Int']>;
  Entity: Scalars['String'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  ReadRLSFilter?: Maybe<Scalars['String']>;
  ReadRLSFilterID?: Maybe<Scalars['Int']>;
  Role: Scalars['String'];
  RoleID: Scalars['Int'];
  RoleSQLName: Scalars['String'];
  UpdateRLSFilter?: Maybe<Scalars['String']>;
  UpdateRLSFilterID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type EntityRelationship = {
  __typename?: 'EntityRelationship';
  BundleInAPI: Scalars['Boolean'];
  CreatedAt: Scalars['Timestamp'];
  DisplayInForm: Scalars['Boolean'];
  DisplayName?: Maybe<Scalars['String']>;
  DisplayUserViewID?: Maybe<Scalars['Int']>;
  Entity: Scalars['String'];
  EntityBaseTable: Scalars['String'];
  EntityBaseView: Scalars['String'];
  EntityID: Scalars['Int'];
  EntityKeyField?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncludeInParentAllQuery: Scalars['Boolean'];
  JoinEntityInverseJoinField?: Maybe<Scalars['String']>;
  JoinEntityJoinField?: Maybe<Scalars['String']>;
  JoinView?: Maybe<Scalars['String']>;
  RelatedEntity: Scalars['String'];
  RelatedEntityBaseTable: Scalars['String'];
  RelatedEntityBaseTableCodeName: Scalars['String'];
  RelatedEntityBaseView: Scalars['String'];
  RelatedEntityClassName: Scalars['String'];
  RelatedEntityCodeName?: Maybe<Scalars['String']>;
  RelatedEntityID: Scalars['Int'];
  RelatedEntityJoinField: Scalars['String'];
  Type: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

/** List of integrations that can be executed using the MemberJunction integration architecture. */
export type Integration = {
  __typename?: 'Integration';
  BatchMaxRequestCount: Scalars['Int'];
  BatchRequestWaitTime: Scalars['Int'];
  ClassName?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  ImportPath?: Maybe<Scalars['String']>;
  IntegrationURLFormats: Array<IntegrationURLFormat>;
  Name: Scalars['String'];
  NavigationBaseURL?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type IntegrationURLFormat = {
  __typename?: 'IntegrationURLFormat';
  EntityID: Scalars['Int'];
  FullURLFormat?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IntegrationID: Scalars['Int'];
  NavigationBaseURL?: Maybe<Scalars['String']>;
  URLFormat: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  Account: Scalars['String'];
  AccountID: Scalars['Int'];
  AccountWebsite?: Maybe<Scalars['String']>;
  BCMID: Scalars['String'];
  Company: Scalars['String'];
  CompanyID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  Contact?: Maybe<Scalars['String']>;
  ContactEmail?: Maybe<Scalars['String']>;
  ContactID?: Maybe<Scalars['Int']>;
  CreatedAt: Scalars['Timestamp'];
  DueDate?: Maybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  InvoiceDate: Scalars['Timestamp'];
  InvoiceNumber: Scalars['String'];
  PaymentTermsID?: Maybe<Scalars['Int']>;
  Payments: Array<Payment>;
  PostingDate?: Maybe<Scalars['Timestamp']>;
  StatusID: Scalars['Int'];
  SubTotal: Scalars['Float'];
  Tax: Scalars['Float'];
  Total: Scalars['Float'];
  UpdatedAt: Scalars['Timestamp'];
};

export type LifecycleStage = {
  __typename?: 'LifecycleStage';
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type List = {
  __typename?: 'List';
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  Entity?: Maybe<Scalars['String']>;
  EntityID?: Maybe<Scalars['Int']>;
  ID: Scalars['Int'];
  ListDetails: Array<ListDetail>;
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  User: Scalars['String'];
  UserID: Scalars['Int'];
};

export type ListDetail = {
  __typename?: 'ListDetail';
  ID: Scalars['Int'];
  ListID: Scalars['Int'];
  RecordID: Scalars['Int'];
  Sequence: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AddUserFavorite: UserFavorite;
  CreateAccount: Account;
  CreateApplicationEntity: ApplicationEntity;
  CreateAuditLog: AuditLog;
  CreateCompany: Company;
  CreateContact: Contact;
  CreateDeal: Deal;
  CreateEmployee: Employee;
  CreateEntity: Entity;
  CreateEntityField: EntityField;
  CreateEntityPermission: EntityPermission;
  CreateEntityRelationship: EntityRelationship;
  CreateList: List;
  CreateListDetail: ListDetail;
  CreateRecordChange: RecordChange;
  CreateTaxReturn: TaxReturn;
  CreateTaxReturnCompensation: TaxReturnCompensation;
  CreateTaxReturnContractor: TaxReturnContractor;
  CreateTaxReturnDetail: TaxReturnDetail;
  CreateUserApplicationEntity: UserApplicationEntity;
  CreateUserFavorite: UserFavorite;
  CreateUserView: UserView;
  CreateUserViewRun: UserViewRun;
  CreateUserViewRunDetail: UserViewRunDetail;
  DeleteAccount: Scalars['Int'];
  DeleteApplicationEntity: Scalars['Int'];
  DeleteCompany: Scalars['Int'];
  DeleteContact: Scalars['Int'];
  DeleteDeal: Scalars['Int'];
  DeleteEmployee: Scalars['Int'];
  DeleteEntity: Scalars['Int'];
  DeleteEntityField: Scalars['Int'];
  DeleteEntityPermission: Scalars['Int'];
  DeleteEntityRelationship: Scalars['Int'];
  DeleteList: Scalars['Int'];
  DeleteListDetail: Scalars['Int'];
  DeleteUserApplicationEntity: Scalars['Int'];
  DeleteUserFavorite: Scalars['Int'];
  DeleteUserView: Scalars['Int'];
  SetRecordFavoriteStatus: UserFavoriteResult;
  UpdateAIAction: AIAction;
  UpdateAIModel: AIModel;
  UpdateAIModelAction: AIModelAction;
  UpdateAIModelType: AIModelType;
  UpdateAccount: Account;
  UpdateAccountCompanyIntegration: AccountCompanyIntegration;
  UpdateAccountType: AccountType;
  UpdateActivity: Activity;
  UpdateActivityAttachment: ActivityAttachment;
  UpdateApplication: Application;
  UpdateApplicationEntity: ApplicationEntity;
  UpdateApplicationPermission: ApplicationPermission;
  UpdateAuditLog: AuditLog;
  UpdateCampaign: Campaign;
  UpdateCampaignStep: CampaignStep;
  UpdateCompany: Company;
  UpdateCompanyIntegration: CompanyIntegration;
  UpdateContact: Contact;
  UpdateContactAccount: ContactAccount;
  UpdateContactCompanyIntegration: ContactCompanyIntegration;
  UpdateContactEmail: ContactEmail;
  UpdateContactTopic: ContactTopic;
  UpdateDeal: Deal;
  UpdateDealStage: DealStage;
  UpdateDealType: DealType;
  UpdateEmailServiceProviders: EmailServiceProviders;
  UpdateEmployee: Employee;
  UpdateEntity: Entity;
  UpdateEntityAIAction: EntityAIAction;
  UpdateEntityField: EntityField;
  UpdateEntityPermission: EntityPermission;
  UpdateEntityRelationship: EntityRelationship;
  UpdateIntegration: Integration;
  UpdateIntegrationURLFormat: IntegrationURLFormat;
  UpdateInvoice: Invoice;
  UpdateLifecycleStage: LifecycleStage;
  UpdateList: List;
  UpdateListDetail: ListDetail;
  UpdatePayment: Payment;
  UpdateProject: Project;
  UpdateProjectBillingType: ProjectBillingType;
  UpdateProjectRateType: ProjectRateType;
  UpdateProjectStatusType: ProjectStatusType;
  UpdateRole: Role;
  UpdateTask: Task;
  UpdateTaskType: TaskType;
  UpdateTaxReturn: TaxReturn;
  UpdateTimeEntry: TimeEntry;
  UpdateUser: User;
  UpdateUserApplication: UserApplication;
  UpdateUserApplicationEntity: UserApplicationEntity;
  UpdateUserFavorite: UserFavorite;
  UpdateUserRecordLog: UserRecordLog;
  UpdateUserView: UserView;
  UpdateUserViewRun: UserViewRun;
  UpdateUserViewRunDetail: UserViewRunDetail;
  UpdateWorkflow: Workflow;
  UpdateWorkflowEngine: WorkflowEngine;
  UpdateWorkflowRun: WorkflowRun;
  Update_990Full: _990Full;
  Update_990Latest: _990Latest;
};


export type MutationAddUserFavoriteArgs = {
  input: UserFavoriteSearchParams;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateApplicationEntityArgs = {
  input: CreateApplicationEntityInput;
};


export type MutationCreateAuditLogArgs = {
  input: CreateAuditLogInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateDealArgs = {
  input: CreateDealInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};


export type MutationCreateEntityFieldArgs = {
  input: CreateEntityFieldInput;
};


export type MutationCreateEntityPermissionArgs = {
  input: CreateEntityPermissionInput;
};


export type MutationCreateEntityRelationshipArgs = {
  input: CreateEntityRelationshipInput;
};


export type MutationCreateListArgs = {
  input: CreateListInput;
};


export type MutationCreateListDetailArgs = {
  input: CreateListDetailInput;
};


export type MutationCreateRecordChangeArgs = {
  input: CreateRecordChangeInput;
};


export type MutationCreateTaxReturnArgs = {
  input: CreateTaxReturnInput;
};


export type MutationCreateTaxReturnCompensationArgs = {
  input: CreateTaxReturnCompensationInput;
};


export type MutationCreateTaxReturnContractorArgs = {
  input: CreateTaxReturnContractorInput;
};


export type MutationCreateTaxReturnDetailArgs = {
  input: CreateTaxReturnDetailInput;
};


export type MutationCreateUserApplicationEntityArgs = {
  input: CreateUserApplicationEntityInput;
};


export type MutationCreateUserFavoriteArgs = {
  input: CreateUserFavoriteInput;
};


export type MutationCreateUserViewArgs = {
  input: CreateUserViewInput;
};


export type MutationCreateUserViewRunArgs = {
  input: CreateUserViewRunInput;
};


export type MutationCreateUserViewRunDetailArgs = {
  input: CreateUserViewRunDetailInput;
};


export type MutationDeleteAccountArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteApplicationEntityArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteCompanyArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteContactArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteDealArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteEmployeeArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteEntityArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteEntityFieldArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteEntityPermissionArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteEntityRelationshipArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteListArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteListDetailArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteUserApplicationEntityArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteUserFavoriteArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteUserViewArgs = {
  ID: Scalars['Int'];
};


export type MutationSetRecordFavoriteStatusArgs = {
  params: UserFavoriteSetParams;
};


export type MutationUpdateAIActionArgs = {
  input: UpdateAIActionInput;
};


export type MutationUpdateAIModelArgs = {
  input: UpdateAIModelInput;
};


export type MutationUpdateAIModelActionArgs = {
  input: UpdateAIModelActionInput;
};


export type MutationUpdateAIModelTypeArgs = {
  input: UpdateAIModelTypeInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountCompanyIntegrationArgs = {
  input: UpdateAccountCompanyIntegrationInput;
};


export type MutationUpdateAccountTypeArgs = {
  input: UpdateAccountTypeInput;
};


export type MutationUpdateActivityArgs = {
  input: UpdateActivityInput;
};


export type MutationUpdateActivityAttachmentArgs = {
  input: UpdateActivityAttachmentInput;
};


export type MutationUpdateApplicationArgs = {
  input: UpdateApplicationInput;
};


export type MutationUpdateApplicationEntityArgs = {
  input: UpdateApplicationEntityInput;
};


export type MutationUpdateApplicationPermissionArgs = {
  input: UpdateApplicationPermissionInput;
};


export type MutationUpdateAuditLogArgs = {
  input: UpdateAuditLogInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignStepArgs = {
  input: UpdateCampaignStepInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyIntegrationArgs = {
  input: UpdateCompanyIntegrationInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateContactAccountArgs = {
  input: UpdateContactAccountInput;
};


export type MutationUpdateContactCompanyIntegrationArgs = {
  input: UpdateContactCompanyIntegrationInput;
};


export type MutationUpdateContactEmailArgs = {
  input: UpdateContactEmailInput;
};


export type MutationUpdateContactTopicArgs = {
  input: UpdateContactTopicInput;
};


export type MutationUpdateDealArgs = {
  input: UpdateDealInput;
};


export type MutationUpdateDealStageArgs = {
  input: UpdateDealStageInput;
};


export type MutationUpdateDealTypeArgs = {
  input: UpdateDealTypeInput;
};


export type MutationUpdateEmailServiceProvidersArgs = {
  input: UpdateEmailServiceProvidersInput;
};


export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};


export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};


export type MutationUpdateEntityAIActionArgs = {
  input: UpdateEntityAIActionInput;
};


export type MutationUpdateEntityFieldArgs = {
  input: UpdateEntityFieldInput;
};


export type MutationUpdateEntityPermissionArgs = {
  input: UpdateEntityPermissionInput;
};


export type MutationUpdateEntityRelationshipArgs = {
  input: UpdateEntityRelationshipInput;
};


export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationInput;
};


export type MutationUpdateIntegrationURLFormatArgs = {
  input: UpdateIntegrationURLFormatInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateLifecycleStageArgs = {
  input: UpdateLifecycleStageInput;
};


export type MutationUpdateListArgs = {
  input: UpdateListInput;
};


export type MutationUpdateListDetailArgs = {
  input: UpdateListDetailInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectBillingTypeArgs = {
  input: UpdateProjectBillingTypeInput;
};


export type MutationUpdateProjectRateTypeArgs = {
  input: UpdateProjectRateTypeInput;
};


export type MutationUpdateProjectStatusTypeArgs = {
  input: UpdateProjectStatusTypeInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskTypeArgs = {
  input: UpdateTaskTypeInput;
};


export type MutationUpdateTaxReturnArgs = {
  input: UpdateTaxReturnInput;
};


export type MutationUpdateTimeEntryArgs = {
  input: UpdateTimeEntryInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserApplicationArgs = {
  input: UpdateUserApplicationInput;
};


export type MutationUpdateUserApplicationEntityArgs = {
  input: UpdateUserApplicationEntityInput;
};


export type MutationUpdateUserFavoriteArgs = {
  input: UpdateUserFavoriteInput;
};


export type MutationUpdateUserRecordLogArgs = {
  input: UpdateUserRecordLogInput;
};


export type MutationUpdateUserViewArgs = {
  input: UpdateUserViewInput;
};


export type MutationUpdateUserViewRunArgs = {
  input: UpdateUserViewRunInput;
};


export type MutationUpdateUserViewRunDetailArgs = {
  input: UpdateUserViewRunDetailInput;
};


export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


export type MutationUpdateWorkflowEngineArgs = {
  input: UpdateWorkflowEngineInput;
};


export type MutationUpdateWorkflowRunArgs = {
  input: UpdateWorkflowRunInput;
};


export type MutationUpdate_990FullArgs = {
  input: Update_990FullInput;
};


export type MutationUpdate_990LatestArgs = {
  input: Update_990LatestInput;
};

/** NAICS Reference Data */
export type NAICS = {
  __typename?: 'NAICS';
  Code: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  Account: Scalars['String'];
  AccountID?: Maybe<Scalars['Int']>;
  AccountWebsite?: Maybe<Scalars['String']>;
  Amount: Scalars['Float'];
  BCMID: Scalars['String'];
  Comments?: Maybe<Scalars['String']>;
  Company: Scalars['String'];
  CompanyID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  Contact?: Maybe<Scalars['String']>;
  ContactEmail?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  DocumentNumber?: Maybe<Scalars['String']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  InvoiceID: Scalars['Int'];
  PaymentDate: Scalars['Timestamp'];
  UpdatedAt: Scalars['Timestamp'];
};

export type Project = {
  __typename?: 'Project';
  AccountID?: Maybe<Scalars['Int']>;
  BillingType?: Maybe<Scalars['String']>;
  BillingTypeID?: Maybe<Scalars['Int']>;
  BudgetAmount?: Maybe<Scalars['Float']>;
  CompanyIntegrationID?: Maybe<Scalars['Int']>;
  CreatedAt: Scalars['Timestamp'];
  DueDate?: Maybe<Scalars['Timestamp']>;
  Employee?: Maybe<Scalars['String']>;
  EmployeeID?: Maybe<Scalars['Int']>;
  ExternalSystemRecordID?: Maybe<Scalars['String']>;
  FixedFee?: Maybe<Scalars['Float']>;
  ID: Scalars['Int'];
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  ProjectRate?: Maybe<Scalars['Float']>;
  RateType?: Maybe<Scalars['String']>;
  RateTypeID?: Maybe<Scalars['Int']>;
  StartDate?: Maybe<Scalars['Timestamp']>;
  Status?: Maybe<Scalars['String']>;
  StatusID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type ProjectBillingType = {
  __typename?: 'ProjectBillingType';
  Code: Scalars['String'];
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type ProjectRateType = {
  __typename?: 'ProjectRateType';
  Code: Scalars['String'];
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type ProjectStatusType = {
  __typename?: 'ProjectStatusType';
  Code: Scalars['String'];
  CreatedAt: Scalars['Timestamp'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  IsClosed: Scalars['Boolean'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type Query = {
  __typename?: 'Query';
  AIAction?: Maybe<AIAction>;
  AIModel?: Maybe<AIModel>;
  AIModelAction?: Maybe<AIModelAction>;
  AIModelType?: Maybe<AIModelType>;
  Account?: Maybe<Account>;
  AccountCompanyIntegration?: Maybe<AccountCompanyIntegration>;
  AccountType?: Maybe<AccountType>;
  Activity?: Maybe<Activity>;
  ActivityAttachment?: Maybe<ActivityAttachment>;
  AllAIActions: Array<AIAction>;
  AllAIModelActions: Array<AIModelAction>;
  AllAIModelTypes: Array<AIModelType>;
  AllAIModels: Array<AIModel>;
  AllAccountTypes: Array<AccountType>;
  AllApplications: Array<Application>;
  AllAuditLogTypes: Array<AuditLogType>;
  AllAuthorizationRoles: Array<AuthorizationRole>;
  AllAuthorizations: Array<Authorization>;
  AllCompanies: Array<Company>;
  AllDealStages: Array<DealStage>;
  AllDealTypes: Array<DealType>;
  AllDeals: Array<Deal>;
  AllEmailServiceProviders: Array<EmailServiceProviders>;
  AllEmployees: Array<Employee>;
  AllEntities: Array<Entity>;
  AllEntityFields: Array<EntityField>;
  AllEntityPermissions: Array<EntityPermission>;
  AllIntegrationURLFormats: Array<IntegrationURLFormat>;
  AllIntegrations: Array<Integration>;
  AllLatestMetadataUpdates: Array<Team>;
  AllLifecycleStages: Array<LifecycleStage>;
  AllRoles: Array<Role>;
  AllRowLevelSecurityFilters: Array<RowLevelSecurityFilter>;
  AllSkills: Array<Skill>;
  AllTaskTypes: Array<TaskType>;
  AllUserRoles: Array<UserRole>;
  AllUserViews: Array<UserView>;
  AllUsers: Array<User>;
  Application?: Maybe<Application>;
  ApplicationEntity?: Maybe<ApplicationEntity>;
  ApplicationPermission?: Maybe<ApplicationPermission>;
  AuditLog?: Maybe<AuditLog>;
  AuditLogType?: Maybe<AuditLogType>;
  Authorization?: Maybe<Authorization>;
  AuthorizationRole?: Maybe<AuthorizationRole>;
  Campaign?: Maybe<Campaign>;
  CampaignStep?: Maybe<CampaignStep>;
  Company?: Maybe<Company>;
  CompanyIntegration?: Maybe<CompanyIntegration>;
  Contact?: Maybe<Contact>;
  ContactAccount?: Maybe<ContactAccount>;
  ContactCompanyIntegration?: Maybe<ContactCompanyIntegration>;
  ContactEmail?: Maybe<ContactEmail>;
  ContactLevel?: Maybe<ContactLevel>;
  ContactRole?: Maybe<ContactRole>;
  ContactTopic?: Maybe<ContactTopic>;
  CurrentUser: User;
  CurrentUserDefaultViewByEntityID: Array<UserView>;
  CurrentUserUserViewsByEntityID: Array<UserView>;
  Deal?: Maybe<Deal>;
  DealStage?: Maybe<DealStage>;
  DealType?: Maybe<DealType>;
  DefaultViewByUserAndEntity: Array<UserView>;
  EmailServiceProviders?: Maybe<EmailServiceProviders>;
  Employee?: Maybe<Employee>;
  Entity?: Maybe<Entity>;
  EntityAIAction?: Maybe<EntityAIAction>;
  EntityField?: Maybe<EntityField>;
  EntityFieldValue?: Maybe<EntityFieldValue>;
  EntityPermission?: Maybe<EntityPermission>;
  EntityRelationship?: Maybe<EntityRelationship>;
  ExecuteAskSkipQuery: AskSkipResultType;
  GetEntityRecordName: UtilityResultType;
  GetRecordFavoriteStatus: UserFavoriteResult;
  Integration?: Maybe<Integration>;
  IntegrationURLFormat?: Maybe<IntegrationURLFormat>;
  Invoice?: Maybe<Invoice>;
  LifecycleStage?: Maybe<LifecycleStage>;
  List?: Maybe<List>;
  ListDetail?: Maybe<ListDetail>;
  Payment?: Maybe<Payment>;
  Project?: Maybe<Project>;
  ProjectBillingType?: Maybe<ProjectBillingType>;
  ProjectRateType?: Maybe<ProjectRateType>;
  ProjectStatusType?: Maybe<ProjectStatusType>;
  Queue?: Maybe<Queue>;
  QueueTask?: Maybe<QueueTask>;
  QueueType?: Maybe<QueueType>;
  RecordChange?: Maybe<RecordChange>;
  Role?: Maybe<Role>;
  RowLevelSecurityFilter?: Maybe<RowLevelSecurityFilter>;
  RunAIActionUnsavedView: RunAIActionViewResult;
  RunAIActionViewByID: RunAIActionViewResult;
  RunAIActionViewByName: RunAIActionViewResult;
  RunAIModelActionUnsavedView: RunAIModelActionViewResult;
  RunAIModelActionViewByID: RunAIModelActionViewResult;
  RunAIModelActionViewByName: RunAIModelActionViewResult;
  RunAIModelTypeUnsavedView: RunAIModelTypeViewResult;
  RunAIModelTypeViewByID: RunAIModelTypeViewResult;
  RunAIModelTypeViewByName: RunAIModelTypeViewResult;
  RunAIModelUnsavedView: RunAIModelViewResult;
  RunAIModelViewByID: RunAIModelViewResult;
  RunAIModelViewByName: RunAIModelViewResult;
  RunAccountCompanyIntegrationUnsavedView: RunAccountCompanyIntegrationViewResult;
  RunAccountCompanyIntegrationViewByID: RunAccountCompanyIntegrationViewResult;
  RunAccountCompanyIntegrationViewByName: RunAccountCompanyIntegrationViewResult;
  RunAccountTypeUnsavedView: RunAccountTypeViewResult;
  RunAccountTypeViewByID: RunAccountTypeViewResult;
  RunAccountTypeViewByName: RunAccountTypeViewResult;
  RunAccountUnsavedView: RunAccountViewResult;
  RunAccountViewByID: RunAccountViewResult;
  RunAccountViewByName: RunAccountViewResult;
  RunActivityAttachmentUnsavedView: RunActivityAttachmentViewResult;
  RunActivityAttachmentViewByID: RunActivityAttachmentViewResult;
  RunActivityAttachmentViewByName: RunActivityAttachmentViewResult;
  RunActivityUnsavedView: RunActivityViewResult;
  RunActivityViewByID: RunActivityViewResult;
  RunActivityViewByName: RunActivityViewResult;
  RunApplicationEntityUnsavedView: RunApplicationEntityViewResult;
  RunApplicationEntityViewByID: RunApplicationEntityViewResult;
  RunApplicationEntityViewByName: RunApplicationEntityViewResult;
  RunApplicationPermissionUnsavedView: RunApplicationPermissionViewResult;
  RunApplicationPermissionViewByID: RunApplicationPermissionViewResult;
  RunApplicationPermissionViewByName: RunApplicationPermissionViewResult;
  RunApplicationUnsavedView: RunApplicationViewResult;
  RunApplicationViewByID: RunApplicationViewResult;
  RunApplicationViewByName: RunApplicationViewResult;
  RunAuditLogTypeUnsavedView: RunAuditLogTypeViewResult;
  RunAuditLogTypeViewByID: RunAuditLogTypeViewResult;
  RunAuditLogTypeViewByName: RunAuditLogTypeViewResult;
  RunAuditLogUnsavedView: RunAuditLogViewResult;
  RunAuditLogViewByID: RunAuditLogViewResult;
  RunAuditLogViewByName: RunAuditLogViewResult;
  RunAuthorizationRoleUnsavedView: RunAuthorizationRoleViewResult;
  RunAuthorizationRoleViewByID: RunAuthorizationRoleViewResult;
  RunAuthorizationRoleViewByName: RunAuthorizationRoleViewResult;
  RunAuthorizationUnsavedView: RunAuthorizationViewResult;
  RunAuthorizationViewByID: RunAuthorizationViewResult;
  RunAuthorizationViewByName: RunAuthorizationViewResult;
  RunCampaignStepUnsavedView: RunCampaignStepViewResult;
  RunCampaignStepViewByID: RunCampaignStepViewResult;
  RunCampaignStepViewByName: RunCampaignStepViewResult;
  RunCampaignUnsavedView: RunCampaignViewResult;
  RunCampaignViewByID: RunCampaignViewResult;
  RunCampaignViewByName: RunCampaignViewResult;
  RunCompanyIntegrationUnsavedView: RunCompanyIntegrationViewResult;
  RunCompanyIntegrationViewByID: RunCompanyIntegrationViewResult;
  RunCompanyIntegrationViewByName: RunCompanyIntegrationViewResult;
  RunCompanyUnsavedView: RunCompanyViewResult;
  RunCompanyViewByID: RunCompanyViewResult;
  RunCompanyViewByName: RunCompanyViewResult;
  RunContactAccountUnsavedView: RunContactAccountViewResult;
  RunContactAccountViewByID: RunContactAccountViewResult;
  RunContactAccountViewByName: RunContactAccountViewResult;
  RunContactCompanyIntegrationUnsavedView: RunContactCompanyIntegrationViewResult;
  RunContactCompanyIntegrationViewByID: RunContactCompanyIntegrationViewResult;
  RunContactCompanyIntegrationViewByName: RunContactCompanyIntegrationViewResult;
  RunContactEmailUnsavedView: RunContactEmailViewResult;
  RunContactEmailViewByID: RunContactEmailViewResult;
  RunContactEmailViewByName: RunContactEmailViewResult;
  RunContactLevelUnsavedView: RunContactLevelViewResult;
  RunContactLevelViewByID: RunContactLevelViewResult;
  RunContactLevelViewByName: RunContactLevelViewResult;
  RunContactRoleUnsavedView: RunContactRoleViewResult;
  RunContactRoleViewByID: RunContactRoleViewResult;
  RunContactRoleViewByName: RunContactRoleViewResult;
  RunContactTopicUnsavedView: RunContactTopicViewResult;
  RunContactTopicViewByID: RunContactTopicViewResult;
  RunContactTopicViewByName: RunContactTopicViewResult;
  RunContactUnsavedView: RunContactViewResult;
  RunContactViewByID: RunContactViewResult;
  RunContactViewByName: RunContactViewResult;
  RunDealStageUnsavedView: RunDealStageViewResult;
  RunDealStageViewByID: RunDealStageViewResult;
  RunDealStageViewByName: RunDealStageViewResult;
  RunDealTypeUnsavedView: RunDealTypeViewResult;
  RunDealTypeViewByID: RunDealTypeViewResult;
  RunDealTypeViewByName: RunDealTypeViewResult;
  RunDealUnsavedView: RunDealViewResult;
  RunDealViewByID: RunDealViewResult;
  RunDealViewByName: RunDealViewResult;
  RunEmailServiceProvidersUnsavedView: RunEmailServiceProvidersViewResult;
  RunEmailServiceProvidersViewByID: RunEmailServiceProvidersViewResult;
  RunEmailServiceProvidersViewByName: RunEmailServiceProvidersViewResult;
  RunEmployeeUnsavedView: RunEmployeeViewResult;
  RunEmployeeViewByID: RunEmployeeViewResult;
  RunEmployeeViewByName: RunEmployeeViewResult;
  RunEntityAIActionUnsavedView: RunEntityAIActionViewResult;
  RunEntityAIActionViewByID: RunEntityAIActionViewResult;
  RunEntityAIActionViewByName: RunEntityAIActionViewResult;
  RunEntityFieldUnsavedView: RunEntityFieldViewResult;
  RunEntityFieldValueUnsavedView: RunEntityFieldValueViewResult;
  RunEntityFieldValueViewByID: RunEntityFieldValueViewResult;
  RunEntityFieldValueViewByName: RunEntityFieldValueViewResult;
  RunEntityFieldViewByID: RunEntityFieldViewResult;
  RunEntityFieldViewByName: RunEntityFieldViewResult;
  RunEntityPermissionUnsavedView: RunEntityPermissionViewResult;
  RunEntityPermissionViewByID: RunEntityPermissionViewResult;
  RunEntityPermissionViewByName: RunEntityPermissionViewResult;
  RunEntityRelationshipUnsavedView: RunEntityRelationshipViewResult;
  RunEntityRelationshipViewByID: RunEntityRelationshipViewResult;
  RunEntityRelationshipViewByName: RunEntityRelationshipViewResult;
  RunEntityUnsavedView: RunEntityViewResult;
  RunEntityViewByID: RunEntityViewResult;
  RunEntityViewByName: RunEntityViewResult;
  RunIntegrationURLFormatUnsavedView: RunIntegrationURLFormatViewResult;
  RunIntegrationURLFormatViewByID: RunIntegrationURLFormatViewResult;
  RunIntegrationURLFormatViewByName: RunIntegrationURLFormatViewResult;
  RunIntegrationUnsavedView: RunIntegrationViewResult;
  RunIntegrationViewByID: RunIntegrationViewResult;
  RunIntegrationViewByName: RunIntegrationViewResult;
  RunInvoiceUnsavedView: RunInvoiceViewResult;
  RunInvoiceViewByID: RunInvoiceViewResult;
  RunInvoiceViewByName: RunInvoiceViewResult;
  RunLifecycleStageUnsavedView: RunLifecycleStageViewResult;
  RunLifecycleStageViewByID: RunLifecycleStageViewResult;
  RunLifecycleStageViewByName: RunLifecycleStageViewResult;
  RunListDetailUnsavedView: RunListDetailViewResult;
  RunListDetailViewByID: RunListDetailViewResult;
  RunListDetailViewByName: RunListDetailViewResult;
  RunListUnsavedView: RunListViewResult;
  RunListViewByID: RunListViewResult;
  RunListViewByName: RunListViewResult;
  RunPaymentUnsavedView: RunPaymentViewResult;
  RunPaymentViewByID: RunPaymentViewResult;
  RunPaymentViewByName: RunPaymentViewResult;
  RunProjectBillingTypeUnsavedView: RunProjectBillingTypeViewResult;
  RunProjectBillingTypeViewByID: RunProjectBillingTypeViewResult;
  RunProjectBillingTypeViewByName: RunProjectBillingTypeViewResult;
  RunProjectRateTypeUnsavedView: RunProjectRateTypeViewResult;
  RunProjectRateTypeViewByID: RunProjectRateTypeViewResult;
  RunProjectRateTypeViewByName: RunProjectRateTypeViewResult;
  RunProjectStatusTypeUnsavedView: RunProjectStatusTypeViewResult;
  RunProjectStatusTypeViewByID: RunProjectStatusTypeViewResult;
  RunProjectStatusTypeViewByName: RunProjectStatusTypeViewResult;
  RunProjectUnsavedView: RunProjectViewResult;
  RunProjectViewByID: RunProjectViewResult;
  RunProjectViewByName: RunProjectViewResult;
  RunQueueTaskUnsavedView: RunQueueTaskViewResult;
  RunQueueTaskViewByID: RunQueueTaskViewResult;
  RunQueueTaskViewByName: RunQueueTaskViewResult;
  RunQueueTypeUnsavedView: RunQueueTypeViewResult;
  RunQueueTypeViewByID: RunQueueTypeViewResult;
  RunQueueTypeViewByName: RunQueueTypeViewResult;
  RunQueueUnsavedView: RunQueueViewResult;
  RunQueueViewByID: RunQueueViewResult;
  RunQueueViewByName: RunQueueViewResult;
  RunRecordChangeUnsavedView: RunRecordChangeViewResult;
  RunRecordChangeViewByID: RunRecordChangeViewResult;
  RunRecordChangeViewByName: RunRecordChangeViewResult;
  RunRoleUnsavedView: RunRoleViewResult;
  RunRoleViewByID: RunRoleViewResult;
  RunRoleViewByName: RunRoleViewResult;
  RunRowLevelSecurityFilterUnsavedView: RunRowLevelSecurityFilterViewResult;
  RunRowLevelSecurityFilterViewByID: RunRowLevelSecurityFilterViewResult;
  RunRowLevelSecurityFilterViewByName: RunRowLevelSecurityFilterViewResult;
  RunSkillUnsavedView: RunSkillViewResult;
  RunSkillViewByID: RunSkillViewResult;
  RunSkillViewByName: RunSkillViewResult;
  RunTaskTypeUnsavedView: RunTaskTypeViewResult;
  RunTaskTypeViewByID: RunTaskTypeViewResult;
  RunTaskTypeViewByName: RunTaskTypeViewResult;
  RunTaskUnsavedView: RunTaskViewResult;
  RunTaskViewByID: RunTaskViewResult;
  RunTaskViewByName: RunTaskViewResult;
  RunTaxReturnCompensationUnsavedView: RunTaxReturnCompensationViewResult;
  RunTaxReturnCompensationViewByID: RunTaxReturnCompensationViewResult;
  RunTaxReturnCompensationViewByName: RunTaxReturnCompensationViewResult;
  RunTaxReturnContractorUnsavedView: RunTaxReturnContractorViewResult;
  RunTaxReturnContractorViewByID: RunTaxReturnContractorViewResult;
  RunTaxReturnContractorViewByName: RunTaxReturnContractorViewResult;
  RunTaxReturnDetailUnsavedView: RunTaxReturnDetailViewResult;
  RunTaxReturnDetailViewByID: RunTaxReturnDetailViewResult;
  RunTaxReturnDetailViewByName: RunTaxReturnDetailViewResult;
  RunTaxReturnUnsavedView: RunTaxReturnViewResult;
  RunTaxReturnViewByID: RunTaxReturnViewResult;
  RunTaxReturnViewByName: RunTaxReturnViewResult;
  RunTeamUnsavedView: RunTeamViewResult;
  RunTeamViewByID: RunTeamViewResult;
  RunTeamViewByName: RunTeamViewResult;
  RunTimeEntryUnsavedView: RunTimeEntryViewResult;
  RunTimeEntryViewByID: RunTimeEntryViewResult;
  RunTimeEntryViewByName: RunTimeEntryViewResult;
  RunUnsavedView: RunViewResult;
  RunUserApplicationEntityUnsavedView: RunUserApplicationEntityViewResult;
  RunUserApplicationEntityViewByID: RunUserApplicationEntityViewResult;
  RunUserApplicationEntityViewByName: RunUserApplicationEntityViewResult;
  RunUserApplicationUnsavedView: RunUserApplicationViewResult;
  RunUserApplicationViewByID: RunUserApplicationViewResult;
  RunUserApplicationViewByName: RunUserApplicationViewResult;
  RunUserFavoriteUnsavedView: RunUserFavoriteViewResult;
  RunUserFavoriteViewByID: RunUserFavoriteViewResult;
  RunUserFavoriteViewByName: RunUserFavoriteViewResult;
  RunUserRecordLogUnsavedView: RunUserRecordLogViewResult;
  RunUserRecordLogViewByID: RunUserRecordLogViewResult;
  RunUserRecordLogViewByName: RunUserRecordLogViewResult;
  RunUserRoleUnsavedView: RunUserRoleViewResult;
  RunUserRoleViewByID: RunUserRoleViewResult;
  RunUserRoleViewByName: RunUserRoleViewResult;
  RunUserUnsavedView: RunUserViewResult;
  RunUserViewByID: RunUserViewResult;
  RunUserViewByName: RunUserViewResult;
  RunUserViewRunDetailUnsavedView: RunUserViewRunDetailViewResult;
  RunUserViewRunDetailViewByID: RunUserViewRunDetailViewResult;
  RunUserViewRunDetailViewByName: RunUserViewRunDetailViewResult;
  RunUserViewRunUnsavedView: RunUserViewRunViewResult;
  RunUserViewRunViewByID: RunUserViewRunViewResult;
  RunUserViewRunViewByName: RunUserViewRunViewResult;
  RunUserViewUnsavedView: RunUserViewViewResult;
  RunUserViewViewByID: RunUserViewViewResult;
  RunUserViewViewByName: RunUserViewViewResult;
  RunViewByID: RunViewResult;
  RunViewByName: RunViewResult;
  RunWorkflowEngineUnsavedView: RunWorkflowEngineViewResult;
  RunWorkflowEngineViewByID: RunWorkflowEngineViewResult;
  RunWorkflowEngineViewByName: RunWorkflowEngineViewResult;
  RunWorkflowRunUnsavedView: RunWorkflowRunViewResult;
  RunWorkflowRunViewByID: RunWorkflowRunViewResult;
  RunWorkflowRunViewByName: RunWorkflowRunViewResult;
  RunWorkflowUnsavedView: RunWorkflowViewResult;
  RunWorkflowViewByID: RunWorkflowViewResult;
  RunWorkflowViewByName: RunWorkflowViewResult;
  Run_990FullUnsavedView: Run_990FullViewResult;
  Run_990FullViewByID: Run_990FullViewResult;
  Run_990FullViewByName: Run_990FullViewResult;
  Run_990LatestUnsavedView: Run_990LatestViewResult;
  Run_990LatestViewByID: Run_990LatestViewResult;
  Run_990LatestViewByName: Run_990LatestViewResult;
  Skill?: Maybe<Skill>;
  Task?: Maybe<Task>;
  TaskType?: Maybe<TaskType>;
  TaxReturn?: Maybe<TaxReturn>;
  TaxReturnCompensation?: Maybe<TaxReturnCompensation>;
  TaxReturnContractor?: Maybe<TaxReturnContractor>;
  TaxReturnDetail?: Maybe<TaxReturnDetail>;
  Team?: Maybe<Team>;
  TimeEntry?: Maybe<TimeEntry>;
  UpdateWhereClause: Array<UserView>;
  User?: Maybe<User>;
  UserApplication?: Maybe<UserApplication>;
  UserApplicationEntity?: Maybe<UserApplicationEntity>;
  UserByEmail: User;
  UserByEmployeeID: User;
  UserByID: User;
  UserFavorite?: Maybe<UserFavorite>;
  UserFavoriteSearchByParams: Array<UserFavorite>;
  UserFavoritesByUserID: Array<UserFavorite>;
  UserRecordLog?: Maybe<UserRecordLog>;
  UserRole?: Maybe<UserRole>;
  UserView?: Maybe<UserView>;
  UserViewRun?: Maybe<UserViewRun>;
  UserViewRunDetail?: Maybe<UserViewRunDetail>;
  UserViewsByUserID: Array<UserView>;
  Workflow?: Maybe<Workflow>;
  WorkflowEngine?: Maybe<WorkflowEngine>;
  WorkflowRun?: Maybe<WorkflowRun>;
  _990Full?: Maybe<_990Full>;
  _990Latest?: Maybe<_990Latest>;
};


export type QueryAIActionArgs = {
  ID: Scalars['Int'];
};


export type QueryAIModelArgs = {
  ID: Scalars['Int'];
};


export type QueryAIModelActionArgs = {
  ID: Scalars['Int'];
};


export type QueryAIModelTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryAccountArgs = {
  ID: Scalars['Int'];
};


export type QueryAccountCompanyIntegrationArgs = {
  ID: Scalars['Int'];
};


export type QueryAccountTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryActivityArgs = {
  ID: Scalars['Int'];
};


export type QueryActivityAttachmentArgs = {
  ID: Scalars['Int'];
};


export type QueryApplicationArgs = {
  ID: Scalars['Int'];
};


export type QueryApplicationEntityArgs = {
  ID: Scalars['Int'];
};


export type QueryApplicationPermissionArgs = {
  ID: Scalars['Int'];
};


export type QueryAuditLogArgs = {
  ID: Scalars['Int'];
};


export type QueryAuditLogTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryAuthorizationArgs = {
  ID: Scalars['Int'];
};


export type QueryAuthorizationRoleArgs = {
  ID: Scalars['Int'];
};


export type QueryCampaignArgs = {
  ID: Scalars['Int'];
};


export type QueryCampaignStepArgs = {
  ID: Scalars['Int'];
};


export type QueryCompanyArgs = {
  ID: Scalars['Int'];
};


export type QueryCompanyIntegrationArgs = {
  ID: Scalars['Int'];
};


export type QueryContactArgs = {
  ID: Scalars['Int'];
};


export type QueryContactAccountArgs = {
  ID: Scalars['Int'];
};


export type QueryContactCompanyIntegrationArgs = {
  ID: Scalars['Int'];
};


export type QueryContactEmailArgs = {
  ID: Scalars['Int'];
};


export type QueryContactLevelArgs = {
  ID: Scalars['Int'];
};


export type QueryContactRoleArgs = {
  ID: Scalars['Int'];
};


export type QueryContactTopicArgs = {
  ID: Scalars['Int'];
};


export type QueryCurrentUserDefaultViewByEntityIDArgs = {
  EntityID: Scalars['Int'];
};


export type QueryCurrentUserUserViewsByEntityIDArgs = {
  EntityID: Scalars['Int'];
};


export type QueryDealArgs = {
  ID: Scalars['Int'];
};


export type QueryDealStageArgs = {
  ID: Scalars['Int'];
};


export type QueryDealTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryDefaultViewByUserAndEntityArgs = {
  EntityID: Scalars['Int'];
  UserID: Scalars['Int'];
};


export type QueryEmailServiceProvidersArgs = {
  ID: Scalars['Int'];
};


export type QueryEmployeeArgs = {
  ID: Scalars['Int'];
};


export type QueryEntityArgs = {
  ID: Scalars['Int'];
};


export type QueryEntityAIActionArgs = {
  ID: Scalars['Int'];
};


export type QueryEntityFieldArgs = {
  ID: Scalars['Int'];
};


export type QueryEntityFieldValueArgs = {
  ID: Scalars['Int'];
};


export type QueryEntityPermissionArgs = {
  ID: Scalars['Int'];
};


export type QueryEntityRelationshipArgs = {
  ID: Scalars['Int'];
};


export type QueryExecuteAskSkipQueryArgs = {
  UserQuestion: Scalars['String'];
};


export type QueryGetEntityRecordNameArgs = {
  EntityName: Scalars['String'];
  RecordID: Scalars['Int'];
};


export type QueryGetRecordFavoriteStatusArgs = {
  params: UserFavoriteSearchParams;
};


export type QueryIntegrationArgs = {
  ID: Scalars['Int'];
};


export type QueryIntegrationURLFormatArgs = {
  ID: Scalars['Int'];
};


export type QueryInvoiceArgs = {
  ID: Scalars['Int'];
};


export type QueryLifecycleStageArgs = {
  ID: Scalars['Int'];
};


export type QueryListArgs = {
  ID: Scalars['Int'];
};


export type QueryListDetailArgs = {
  ID: Scalars['Int'];
};


export type QueryPaymentArgs = {
  ID: Scalars['Int'];
};


export type QueryProjectArgs = {
  ID: Scalars['Int'];
};


export type QueryProjectBillingTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryProjectRateTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryProjectStatusTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryQueueArgs = {
  ID: Scalars['Int'];
};


export type QueryQueueTaskArgs = {
  ID: Scalars['Int'];
};


export type QueryQueueTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryRecordChangeArgs = {
  ID: Scalars['Int'];
};


export type QueryRoleArgs = {
  ID: Scalars['Int'];
};


export type QueryRowLevelSecurityFilterArgs = {
  ID: Scalars['Int'];
};


export type QueryRunAIActionUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAIActionViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAIActionViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAIModelActionUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAIModelActionViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAIModelActionViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAIModelTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAIModelTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAIModelTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAIModelUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAIModelViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAIModelViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAccountCompanyIntegrationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAccountCompanyIntegrationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAccountCompanyIntegrationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAccountTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAccountTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAccountTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAccountUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAccountViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAccountViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunActivityAttachmentUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunActivityAttachmentViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunActivityAttachmentViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunActivityUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunActivityViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunActivityViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunApplicationEntityUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunApplicationEntityViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunApplicationEntityViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunApplicationPermissionUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunApplicationPermissionViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunApplicationPermissionViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunApplicationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunApplicationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunApplicationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAuditLogTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAuditLogTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAuditLogTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAuditLogUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAuditLogViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAuditLogViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAuthorizationRoleUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAuthorizationRoleViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAuthorizationRoleViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunAuthorizationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunAuthorizationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunAuthorizationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunCampaignStepUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunCampaignStepViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunCampaignStepViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunCampaignUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunCampaignViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunCampaignViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunCompanyIntegrationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunCompanyIntegrationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunCompanyIntegrationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunCompanyUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunCompanyViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunCompanyViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactAccountUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactAccountViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactAccountViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactCompanyIntegrationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactCompanyIntegrationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactCompanyIntegrationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactEmailUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactEmailViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactEmailViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactLevelUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactLevelViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactLevelViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactRoleUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactRoleViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactRoleViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactTopicUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactTopicViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactTopicViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunContactUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunContactViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunContactViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunDealStageUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunDealStageViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunDealStageViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunDealTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunDealTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunDealTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunDealUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunDealViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunDealViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEmailServiceProvidersUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEmailServiceProvidersViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEmailServiceProvidersViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEmployeeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEmployeeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEmployeeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEntityAIActionUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEntityAIActionViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEntityAIActionViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEntityFieldUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEntityFieldValueUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEntityFieldValueViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEntityFieldValueViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEntityFieldViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEntityFieldViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEntityPermissionUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEntityPermissionViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEntityPermissionViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEntityRelationshipUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEntityRelationshipViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEntityRelationshipViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunEntityUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunEntityViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunEntityViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunIntegrationURLFormatUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunIntegrationURLFormatViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunIntegrationURLFormatViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunIntegrationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunIntegrationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunIntegrationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunInvoiceUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunInvoiceViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunInvoiceViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunLifecycleStageUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunLifecycleStageViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunLifecycleStageViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunListDetailUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunListDetailViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunListDetailViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunListUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunListViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunListViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunPaymentUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunPaymentViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunPaymentViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunProjectBillingTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunProjectBillingTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunProjectBillingTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunProjectRateTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunProjectRateTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunProjectRateTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunProjectStatusTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunProjectStatusTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunProjectStatusTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunProjectUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunProjectViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunProjectViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunQueueTaskUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunQueueTaskViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunQueueTaskViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunQueueTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunQueueTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunQueueTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunQueueUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunQueueViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunQueueViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunRecordChangeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunRecordChangeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunRecordChangeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunRoleUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunRoleViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunRoleViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunRowLevelSecurityFilterUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunRowLevelSecurityFilterViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunRowLevelSecurityFilterViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunSkillUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunSkillViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunSkillViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTaskTypeUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTaskTypeViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTaskTypeViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTaskUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTaskViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTaskViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTaxReturnCompensationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTaxReturnCompensationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTaxReturnCompensationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTaxReturnContractorUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTaxReturnContractorViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTaxReturnContractorViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTaxReturnDetailUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTaxReturnDetailViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTaxReturnDetailViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTaxReturnUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTaxReturnViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTaxReturnViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTeamUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTeamViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTeamViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunTimeEntryUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunTimeEntryViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunTimeEntryViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserApplicationEntityUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserApplicationEntityViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserApplicationEntityViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserApplicationUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserApplicationViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserApplicationViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserFavoriteUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserFavoriteViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserFavoriteViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserRecordLogUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserRecordLogViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserRecordLogViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserRoleUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserRoleViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserRoleViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserViewRunDetailUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserViewRunDetailViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserViewRunDetailViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserViewRunUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserViewRunViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserViewRunViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunUserViewUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunUserViewViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunUserViewViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunWorkflowEngineUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunWorkflowEngineViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunWorkflowEngineViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunWorkflowRunUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunWorkflowRunViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunWorkflowRunViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRunWorkflowUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRunWorkflowViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRunWorkflowViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRun_990FullUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRun_990FullViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRun_990FullViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QueryRun_990LatestUnsavedViewArgs = {
  input: RunUnsavedViewInput;
};


export type QueryRun_990LatestViewByIDArgs = {
  input: RunViewByIDInput;
};


export type QueryRun_990LatestViewByNameArgs = {
  input: RunViewByNameInput;
};


export type QuerySkillArgs = {
  ID: Scalars['Int'];
};


export type QueryTaskArgs = {
  ID: Scalars['Int'];
};


export type QueryTaskTypeArgs = {
  ID: Scalars['Int'];
};


export type QueryTaxReturnArgs = {
  ID: Scalars['Int'];
};


export type QueryTaxReturnCompensationArgs = {
  ID: Scalars['Int'];
};


export type QueryTaxReturnContractorArgs = {
  ID: Scalars['Int'];
};


export type QueryTaxReturnDetailArgs = {
  ID: Scalars['Int'];
};


export type QueryTeamArgs = {
  ID: Scalars['Int'];
};


export type QueryTimeEntryArgs = {
  ID: Scalars['Int'];
};


export type QueryUpdateWhereClauseArgs = {
  ID: Scalars['Int'];
};


export type QueryUserArgs = {
  ID: Scalars['Int'];
};


export type QueryUserApplicationArgs = {
  ID: Scalars['Int'];
};


export type QueryUserApplicationEntityArgs = {
  ID: Scalars['Int'];
};


export type QueryUserByEmailArgs = {
  Email: Scalars['String'];
};


export type QueryUserByEmployeeIDArgs = {
  EmployeeID: Scalars['Int'];
};


export type QueryUserByIDArgs = {
  ID: Scalars['Int'];
};


export type QueryUserFavoriteArgs = {
  ID: Scalars['Int'];
};


export type QueryUserFavoriteSearchByParamsArgs = {
  params: Scalars['Int'];
};


export type QueryUserFavoritesByUserIDArgs = {
  UserID: Scalars['Int'];
};


export type QueryUserRecordLogArgs = {
  ID: Scalars['Int'];
};


export type QueryUserRoleArgs = {
  ID: Scalars['Int'];
};


export type QueryUserViewArgs = {
  ID: Scalars['Int'];
};


export type QueryUserViewRunArgs = {
  ID: Scalars['Int'];
};


export type QueryUserViewRunDetailArgs = {
  ID: Scalars['Int'];
};


export type QueryUserViewsByUserIDArgs = {
  UserID: Scalars['Int'];
};


export type QueryWorkflowArgs = {
  ID: Scalars['Int'];
};


export type QueryWorkflowEngineArgs = {
  ID: Scalars['Int'];
};


export type QueryWorkflowRunArgs = {
  ID: Scalars['Int'];
};


export type Query_990FullArgs = {
  ID: Scalars['Int'];
};


export type Query_990LatestArgs = {
  ID: Scalars['Int'];
};

export type Queue = {
  __typename?: 'Queue';
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  QueueType: Scalars['String'];
  QueueTypeID: Scalars['Int'];
};

export type QueueTask = {
  __typename?: 'QueueTask';
  Comments?: Maybe<Scalars['String']>;
  EndedAt?: Maybe<Scalars['Timestamp']>;
  ErrorMessage?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Output?: Maybe<Scalars['String']>;
  QueueID: Scalars['Int'];
  StartedAt?: Maybe<Scalars['Timestamp']>;
  Status: Scalars['String'];
};

export type QueueType = {
  __typename?: 'QueueType';
  Description?: Maybe<Scalars['String']>;
  DriverClass: Scalars['String'];
  DriverImportPath?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

/** Tracks history of all pending and complete data changes to records */
export type RecordChange = {
  __typename?: 'RecordChange';
  ChangedAt: Scalars['Timestamp'];
  ChangesDescription: Scalars['String'];
  ChangesJSON: Scalars['String'];
  Comments?: Maybe<Scalars['String']>;
  Entity: Scalars['String'];
  EntityID: Scalars['Int'];
  FullRecordJSON: Scalars['String'];
  ID: Scalars['Int'];
  RecordID: Scalars['Int'];
  Status: Scalars['String'];
  User: Scalars['String'];
  UserID: Scalars['Int'];
};

export type Role = {
  __typename?: 'Role';
  AzureID?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  SQLName: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type RowLevelSecurityFilter = {
  __typename?: 'RowLevelSecurityFilter';
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  FilterText?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type RunAIActionViewResult = {
  __typename?: 'RunAIActionViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AIAction>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAIModelActionViewResult = {
  __typename?: 'RunAIModelActionViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AIModelAction>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAIModelTypeViewResult = {
  __typename?: 'RunAIModelTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AIModelType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAIModelViewResult = {
  __typename?: 'RunAIModelViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AIModel>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAccountCompanyIntegrationViewResult = {
  __typename?: 'RunAccountCompanyIntegrationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AccountCompanyIntegration>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAccountTypeViewResult = {
  __typename?: 'RunAccountTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AccountType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAccountViewResult = {
  __typename?: 'RunAccountViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Account>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunActivityAttachmentViewResult = {
  __typename?: 'RunActivityAttachmentViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ActivityAttachment>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunActivityViewResult = {
  __typename?: 'RunActivityViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Activity>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunApplicationEntityViewResult = {
  __typename?: 'RunApplicationEntityViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ApplicationEntity>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunApplicationPermissionViewResult = {
  __typename?: 'RunApplicationPermissionViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ApplicationPermission>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunApplicationViewResult = {
  __typename?: 'RunApplicationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Application>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAuditLogTypeViewResult = {
  __typename?: 'RunAuditLogTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AuditLogType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAuditLogViewResult = {
  __typename?: 'RunAuditLogViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AuditLog>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAuthorizationRoleViewResult = {
  __typename?: 'RunAuthorizationRoleViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<AuthorizationRole>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunAuthorizationViewResult = {
  __typename?: 'RunAuthorizationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Authorization>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunCampaignStepViewResult = {
  __typename?: 'RunCampaignStepViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<CampaignStep>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunCampaignViewResult = {
  __typename?: 'RunCampaignViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Campaign>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunCompanyIntegrationViewResult = {
  __typename?: 'RunCompanyIntegrationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<CompanyIntegration>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunCompanyViewResult = {
  __typename?: 'RunCompanyViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Company>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactAccountViewResult = {
  __typename?: 'RunContactAccountViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ContactAccount>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactCompanyIntegrationViewResult = {
  __typename?: 'RunContactCompanyIntegrationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ContactCompanyIntegration>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactEmailViewResult = {
  __typename?: 'RunContactEmailViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ContactEmail>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactLevelViewResult = {
  __typename?: 'RunContactLevelViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ContactLevel>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactRoleViewResult = {
  __typename?: 'RunContactRoleViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ContactRole>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactTopicViewResult = {
  __typename?: 'RunContactTopicViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ContactTopic>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunContactViewResult = {
  __typename?: 'RunContactViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Contact>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunDealStageViewResult = {
  __typename?: 'RunDealStageViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<DealStage>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunDealTypeViewResult = {
  __typename?: 'RunDealTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<DealType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunDealViewResult = {
  __typename?: 'RunDealViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Deal>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEmailServiceProvidersViewResult = {
  __typename?: 'RunEmailServiceProvidersViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<EmailServiceProviders>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEmployeeViewResult = {
  __typename?: 'RunEmployeeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Employee>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEntityAIActionViewResult = {
  __typename?: 'RunEntityAIActionViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<EntityAIAction>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEntityFieldValueViewResult = {
  __typename?: 'RunEntityFieldValueViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<EntityFieldValue>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEntityFieldViewResult = {
  __typename?: 'RunEntityFieldViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<EntityField>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEntityPermissionViewResult = {
  __typename?: 'RunEntityPermissionViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<EntityPermission>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEntityRelationshipViewResult = {
  __typename?: 'RunEntityRelationshipViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<EntityRelationship>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunEntityViewResult = {
  __typename?: 'RunEntityViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Entity>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunIntegrationURLFormatViewResult = {
  __typename?: 'RunIntegrationURLFormatViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<IntegrationURLFormat>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunIntegrationViewResult = {
  __typename?: 'RunIntegrationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Integration>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunInvoiceViewResult = {
  __typename?: 'RunInvoiceViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Invoice>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunLifecycleStageViewResult = {
  __typename?: 'RunLifecycleStageViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<LifecycleStage>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunListDetailViewResult = {
  __typename?: 'RunListDetailViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ListDetail>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunListViewResult = {
  __typename?: 'RunListViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<List>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunPaymentViewResult = {
  __typename?: 'RunPaymentViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Payment>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunProjectBillingTypeViewResult = {
  __typename?: 'RunProjectBillingTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ProjectBillingType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunProjectRateTypeViewResult = {
  __typename?: 'RunProjectRateTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ProjectRateType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunProjectStatusTypeViewResult = {
  __typename?: 'RunProjectStatusTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<ProjectStatusType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunProjectViewResult = {
  __typename?: 'RunProjectViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Project>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunQueueTaskViewResult = {
  __typename?: 'RunQueueTaskViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<QueueTask>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunQueueTypeViewResult = {
  __typename?: 'RunQueueTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<QueueType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunQueueViewResult = {
  __typename?: 'RunQueueViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Queue>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunRecordChangeViewResult = {
  __typename?: 'RunRecordChangeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<RecordChange>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunRoleViewResult = {
  __typename?: 'RunRoleViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Role>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunRowLevelSecurityFilterViewResult = {
  __typename?: 'RunRowLevelSecurityFilterViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<RowLevelSecurityFilter>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunSkillViewResult = {
  __typename?: 'RunSkillViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Skill>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTaskTypeViewResult = {
  __typename?: 'RunTaskTypeViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<TaskType>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTaskViewResult = {
  __typename?: 'RunTaskViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Task>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTaxReturnCompensationViewResult = {
  __typename?: 'RunTaxReturnCompensationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<TaxReturnCompensation>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTaxReturnContractorViewResult = {
  __typename?: 'RunTaxReturnContractorViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<TaxReturnContractor>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTaxReturnDetailViewResult = {
  __typename?: 'RunTaxReturnDetailViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<TaxReturnDetail>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTaxReturnViewResult = {
  __typename?: 'RunTaxReturnViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<TaxReturn>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTeamViewResult = {
  __typename?: 'RunTeamViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Team>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunTimeEntryViewResult = {
  __typename?: 'RunTimeEntryViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<TimeEntry>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUnsavedViewInput = {
  EntityName: Scalars['String'];
  /** Pass in a UserViewRun ID value to exclude all records from that run from results */
  ExcludeUserViewRunID?: InputMaybe<Scalars['Int']>;
  ExtraFilter?: InputMaybe<Scalars['String']>;
  /** Pass in a valid condition to append to the view WHERE clause to override the Exclude List. For example, UpdatedAt >= Some Date */
  OverrideExcludeFilter?: InputMaybe<Scalars['String']>;
  UserSearchString?: InputMaybe<Scalars['String']>;
};

export type RunUserApplicationEntityViewResult = {
  __typename?: 'RunUserApplicationEntityViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserApplicationEntity>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserApplicationViewResult = {
  __typename?: 'RunUserApplicationViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserApplication>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserFavoriteViewResult = {
  __typename?: 'RunUserFavoriteViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserFavorite>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserRecordLogViewResult = {
  __typename?: 'RunUserRecordLogViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserRecordLog>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserRoleViewResult = {
  __typename?: 'RunUserRoleViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserRole>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserViewResult = {
  __typename?: 'RunUserViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<User>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserViewRunDetailViewResult = {
  __typename?: 'RunUserViewRunDetailViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserViewRunDetail>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserViewRunViewResult = {
  __typename?: 'RunUserViewRunViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserViewRun>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunUserViewViewResult = {
  __typename?: 'RunUserViewViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<UserView>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunViewByIDInput = {
  /** Pass in a UserViewRun ID value to exclude all records from that run from results */
  ExcludeUserViewRunID?: InputMaybe<Scalars['Int']>;
  ExtraFilter?: InputMaybe<Scalars['String']>;
  /** Pass in a valid condition to append to the view WHERE clause to override the Exclude List. For example, UpdatedAt >= Some Date */
  OverrideExcludeFilter?: InputMaybe<Scalars['String']>;
  /** If set to True, the results of this view are saved into a new UserViewRun record and the UserViewRun.ID is passed back in the results. */
  SaveViewResults?: InputMaybe<Scalars['Boolean']>;
  UserSearchString?: InputMaybe<Scalars['String']>;
  ViewID: Scalars['Int'];
};

export type RunViewByNameInput = {
  /** Pass in a UserViewRun ID value to exclude all records from that run from results */
  ExcludeUserViewRunID?: InputMaybe<Scalars['Int']>;
  ExtraFilter?: InputMaybe<Scalars['String']>;
  /** Pass in a valid condition to append to the view WHERE clause to override the Exclude List. For example, UpdatedAt >= Some Date */
  OverrideExcludeFilter?: InputMaybe<Scalars['String']>;
  /** If set to True, the results of this view are saved into a new UserViewRun record and the UserViewRun.ID is passed back in the results. */
  SaveViewResults?: InputMaybe<Scalars['Boolean']>;
  UserSearchString?: InputMaybe<Scalars['String']>;
  ViewName: Scalars['String'];
};

export type RunViewResult = {
  __typename?: 'RunViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<RunViewResultRow>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunViewResultRow = {
  __typename?: 'RunViewResultRow';
  Data: Scalars['String'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
};

export type RunWorkflowEngineViewResult = {
  __typename?: 'RunWorkflowEngineViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<WorkflowEngine>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunWorkflowRunViewResult = {
  __typename?: 'RunWorkflowRunViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<WorkflowRun>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type RunWorkflowViewResult = {
  __typename?: 'RunWorkflowViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<Workflow>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type Run_990FullViewResult = {
  __typename?: 'Run_990FullViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<_990Full>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type Run_990LatestViewResult = {
  __typename?: 'Run_990LatestViewResult';
  ErrorMessage?: Maybe<Scalars['String']>;
  ExecutionTime?: Maybe<Scalars['Int']>;
  Results: Array<_990Latest>;
  RowCount?: Maybe<Scalars['Int']>;
  Success: Scalars['Boolean'];
  UserViewRunID?: Maybe<Scalars['Int']>;
};

export type Skill = {
  __typename?: 'Skill';
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  ParentID: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type Task = {
  __typename?: 'Task';
  ActualEffort?: Maybe<Scalars['Float']>;
  ActualVariance?: Maybe<Scalars['Float']>;
  AssignedEmployee?: Maybe<Scalars['String']>;
  AssignedEmployeeID?: Maybe<Scalars['Int']>;
  BudgetedEffort?: Maybe<Scalars['Float']>;
  CalculatedActual?: Maybe<Scalars['Float']>;
  CreatedAt: Scalars['Timestamp'];
  EndDate?: Maybe<Scalars['Timestamp']>;
  EstimateToComplete?: Maybe<Scalars['Float']>;
  ExternalSystemRecordID?: Maybe<Scalars['String']>;
  ForecastedEffort?: Maybe<Scalars['Float']>;
  ForecastedVariance?: Maybe<Scalars['Float']>;
  ID: Scalars['Int'];
  IsCompleted?: Maybe<Scalars['Boolean']>;
  IsDeleted?: Maybe<Scalars['Boolean']>;
  Name?: Maybe<Scalars['String']>;
  Parent?: Maybe<Scalars['String']>;
  ParentID?: Maybe<Scalars['Int']>;
  Project?: Maybe<Scalars['String']>;
  ProjectID?: Maybe<Scalars['Int']>;
  Role?: Maybe<Scalars['String']>;
  Section?: Maybe<Scalars['String']>;
  Skills?: Maybe<Scalars['String']>;
  StartDate?: Maybe<Scalars['Timestamp']>;
  Status?: Maybe<Scalars['String']>;
  TaskTypeID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type TaskType = {
  __typename?: 'TaskType';
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  ParentID?: Maybe<Scalars['String']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type TaxReturn = {
  __typename?: 'TaxReturn';
  Account?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Int']>;
  AccountingFees?: Maybe<Scalars['Float']>;
  AccountsPayable?: Maybe<Scalars['Float']>;
  AccountsReceivable?: Maybe<Scalars['Float']>;
  ActivityDescription?: Maybe<Scalars['String']>;
  AddressLine1?: Maybe<Scalars['String']>;
  AddressLine2?: Maybe<Scalars['String']>;
  AdvertisingExpense?: Maybe<Scalars['Float']>;
  AffiliatePaymentExpense?: Maybe<Scalars['Float']>;
  Affiliation?: Maybe<Scalars['Int']>;
  BODVotingMembers?: Maybe<Scalars['Int']>;
  CapitalStockPrincipal?: Maybe<Scalars['Float']>;
  Cash?: Maybe<Scalars['Float']>;
  City?: Maybe<Scalars['String']>;
  ConferenceExpense?: Maybe<Scalars['Float']>;
  CostBasisSecurities?: Maybe<Scalars['Float']>;
  DeferredRevenue?: Maybe<Scalars['Float']>;
  DepreciationExpense?: Maybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: Maybe<Scalars['Float']>;
  EscrowAccountLiability?: Maybe<Scalars['Float']>;
  FinancialStrength?: Maybe<Scalars['String']>;
  FundraisingExpenses?: Maybe<Scalars['Float']>;
  FundraisingNetIncome?: Maybe<Scalars['Float']>;
  GrantsPayable?: Maybe<Scalars['Float']>;
  GrantsToIndividuals?: Maybe<Scalars['Int']>;
  GrantsToOrgs?: Maybe<Scalars['Int']>;
  GrossFundraisingReceipts?: Maybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: Maybe<Scalars['Float']>;
  GrossSalesSecurities?: Maybe<Scalars['Float']>;
  HasForeignBankAcct?: Maybe<Scalars['Boolean']>;
  HasInvestmentIncome?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  InformationTechnologyExpense?: Maybe<Scalars['Float']>;
  InsuranceExpense?: Maybe<Scalars['Float']>;
  IntangibleAssetValue?: Maybe<Scalars['Float']>;
  InterestExpense?: Maybe<Scalars['Float']>;
  InventoryAssetValue?: Maybe<Scalars['Float']>;
  InvestmentManagementFees?: Maybe<Scalars['Float']>;
  IsHospital?: Maybe<Scalars['Boolean']>;
  LegalFees?: Maybe<Scalars['Float']>;
  LobbyingFees?: Maybe<Scalars['Float']>;
  ManagementFees?: Maybe<Scalars['Float']>;
  MissionDescription?: Maybe<Scalars['String']>;
  MortgagesNotesPayable?: Maybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: Maybe<Scalars['Float']>;
  NetRentRealEstate?: Maybe<Scalars['Float']>;
  NotesReceivable?: Maybe<Scalars['Float']>;
  NumberEmployees?: Maybe<Scalars['Int']>;
  NumberVolunteers?: Maybe<Scalars['Int']>;
  OccupancyExpense?: Maybe<Scalars['Float']>;
  OfficeExpense?: Maybe<Scalars['Float']>;
  OfficerCompensation?: Maybe<Scalars['Float']>;
  OtherAssets?: Maybe<Scalars['Float']>;
  OtherEmployeeBenefits?: Maybe<Scalars['Float']>;
  OtherFees?: Maybe<Scalars['Float']>;
  OtherLiabilities?: Maybe<Scalars['Float']>;
  OtherSalaries?: Maybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: Maybe<Scalars['Float']>;
  PaidInCapitalSurplus?: Maybe<Scalars['Float']>;
  PayablesToOfficers?: Maybe<Scalars['Float']>;
  PayrollTaxes?: Maybe<Scalars['Float']>;
  PensionContributions?: Maybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: Maybe<Scalars['Float']>;
  PledgesGrantsReceivable?: Maybe<Scalars['Float']>;
  PostalCode?: Maybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: Maybe<Scalars['Float']>;
  PreparerFirm?: Maybe<Scalars['String']>;
  PreparerFirmAddressLine1?: Maybe<Scalars['String']>;
  PreparerFirmAddressLine2?: Maybe<Scalars['String']>;
  PreparerFirmCity?: Maybe<Scalars['String']>;
  PreparerFirmPostalCode?: Maybe<Scalars['String']>;
  PreparerFirmStateProvince?: Maybe<Scalars['String']>;
  PreparerFirmTaxID?: Maybe<Scalars['String']>;
  PreparerPerson?: Maybe<Scalars['String']>;
  PreparerPersonPhone?: Maybe<Scalars['String']>;
  PreparerPersonTaxID?: Maybe<Scalars['String']>;
  ProfessionalFundraisingFees?: Maybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: Maybe<Scalars['Float']>;
  PublicSecuritiesAssetValue?: Maybe<Scalars['Float']>;
  RealEstateAssetValue?: Maybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: Maybe<Scalars['Float']>;
  ReceivablesFromOfficers?: Maybe<Scalars['Float']>;
  RentalExpenseRealEstate?: Maybe<Scalars['Float']>;
  RetainedEarnings?: Maybe<Scalars['Float']>;
  ReturnType?: Maybe<Scalars['String']>;
  RoyaltyExpense?: Maybe<Scalars['Float']>;
  Savings?: Maybe<Scalars['Float']>;
  SourceJSON?: Maybe<Scalars['String']>;
  StateProvince?: Maybe<Scalars['String']>;
  Subsection?: Maybe<Scalars['String']>;
  SummaryText?: Maybe<Scalars['String']>;
  TaxExemptBondLiability?: Maybe<Scalars['Float']>;
  TaxID: Scalars['String'];
  TaxMonth?: Maybe<Scalars['Int']>;
  TaxPeriodEnd: Scalars['Timestamp'];
  TaxPeriodStart: Scalars['Timestamp'];
  TaxReturnCompensation: Array<TaxReturnCompensation>;
  TaxReturnContractors: Array<TaxReturnContractor>;
  TaxReturnDetails: Array<TaxReturnDetail>;
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: Maybe<Scalars['Float']>;
  TotalAssets?: Maybe<Scalars['Float']>;
  TotalGrossReceipts?: Maybe<Scalars['Float']>;
  TotalInvestmentIncome?: Maybe<Scalars['Float']>;
  TotalLiabilities?: Maybe<Scalars['Float']>;
  TotalMemberIncome?: Maybe<Scalars['Float']>;
  TotalNetAssets?: Maybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: Maybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: Maybe<Scalars['Float']>;
  TotalRevenue?: Maybe<Scalars['Float']>;
  TravelExpense?: Maybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: Maybe<Scalars['Float']>;
  UnrestrictedNetAssets?: Maybe<Scalars['Float']>;
  UnsecuredNotesPayable?: Maybe<Scalars['Float']>;
  Website?: Maybe<Scalars['String']>;
  YearFormed?: Maybe<Scalars['Int']>;
};

export type TaxReturnCompensation = {
  __typename?: 'TaxReturnCompensation';
  AnnualizedTotalCompensation?: Maybe<Scalars['Float']>;
  AverageHoursPerWeek?: Maybe<Scalars['Int']>;
  Compensation: Scalars['Float'];
  Contact?: Maybe<Scalars['String']>;
  ContactID?: Maybe<Scalars['Int']>;
  EndDate?: Maybe<Scalars['Timestamp']>;
  ID: Scalars['Int'];
  IsOfficer: Scalars['Boolean'];
  OtherCompensation?: Maybe<Scalars['Float']>;
  PartialYear: Scalars['Boolean'];
  PersonName: Scalars['String'];
  RelatedOrgCompensation?: Maybe<Scalars['Float']>;
  StartDate?: Maybe<Scalars['Timestamp']>;
  TaxReturnID: Scalars['Int'];
  Title?: Maybe<Scalars['String']>;
  TotalCompensation?: Maybe<Scalars['Float']>;
};

export type TaxReturnContractor = {
  __typename?: 'TaxReturnContractor';
  Account?: Maybe<Scalars['String']>;
  AccountID?: Maybe<Scalars['Int']>;
  AddressLine1?: Maybe<Scalars['String']>;
  Amount: Scalars['Float'];
  City?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  PostalCode?: Maybe<Scalars['String']>;
  StateProvince?: Maybe<Scalars['String']>;
  TaxReturnID: Scalars['Int'];
  Type: Scalars['String'];
};

export type TaxReturnDetail = {
  __typename?: 'TaxReturnDetail';
  Code?: Maybe<Scalars['String']>;
  EndingAmount: Scalars['Float'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  StartingAmount?: Maybe<Scalars['Float']>;
  TaxReturnID: Scalars['Int'];
  Type: Scalars['String'];
};

/** Virtual Entity - returns a list of latest update dates by metadata type */
export type Team = {
  __typename?: 'Team';
  ID: Scalars['Int'];
  Type: Scalars['String'];
  UpdatedAt?: Maybe<Scalars['Timestamp']>;
};

export type TimeEntry = {
  __typename?: 'TimeEntry';
  Comment?: Maybe<Scalars['String']>;
  CreatedAt: Scalars['Timestamp'];
  Date?: Maybe<Scalars['Timestamp']>;
  Effort?: Maybe<Scalars['Float']>;
  Employee?: Maybe<Scalars['String']>;
  EmployeeID?: Maybe<Scalars['Int']>;
  ExternalSystemRecordID?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsDeleted?: Maybe<Scalars['Boolean']>;
  IsInvoiced?: Maybe<Scalars['Boolean']>;
  IsLocked?: Maybe<Scalars['Boolean']>;
  Task?: Maybe<Scalars['String']>;
  TaskID?: Maybe<Scalars['Int']>;
  UpdatedAt: Scalars['Timestamp'];
};

export type UpdateAIActionInput = {
  DefaultModelID?: InputMaybe<Scalars['Int']>;
  DefaultPrompt?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
};

export type UpdateAIModelActionInput = {
  AIActionID: Scalars['Int'];
  AIModelID: Scalars['Int'];
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
};

export type UpdateAIModelInput = {
  AIModelTypeID: Scalars['Int'];
  Description?: InputMaybe<Scalars['String']>;
  DriverClass?: InputMaybe<Scalars['String']>;
  DriverImportPath?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  Vendor?: InputMaybe<Scalars['String']>;
};

export type UpdateAIModelTypeInput = {
  Description?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateAccountCompanyIntegrationInput = {
  AccountID: Scalars['Int'];
  AccountTypeID?: InputMaybe<Scalars['Int']>;
  CompanyIntegrationID: Scalars['Int'];
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
};

export type UpdateAccountInput = {
  Acronym?: InputMaybe<Scalars['String']>;
  AddressLine1?: InputMaybe<Scalars['String']>;
  AddressLine2?: InputMaybe<Scalars['String']>;
  AddressLine3?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DisplayName?: InputMaybe<Scalars['String']>;
  Domain?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  ISOCountryCode?: InputMaybe<Scalars['String']>;
  LeadershipPageURL?: InputMaybe<Scalars['String']>;
  LinkedIn?: InputMaybe<Scalars['String']>;
  Logo?: InputMaybe<Scalars['String']>;
  LogoURL?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  OperatingName?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  StateProvince?: InputMaybe<Scalars['String']>;
  TaxID?: InputMaybe<Scalars['String']>;
  Website?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountTypeInput = {
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateActivityAttachmentInput = {
  Attachments?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
};

export type UpdateActivityInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  ActivityDate?: InputMaybe<Scalars['Timestamp']>;
  Attachment?: InputMaybe<Scalars['String']>;
  AttachmentID?: InputMaybe<Scalars['Int']>;
  CompanyIntegrationID: Scalars['Int'];
  ContactID?: InputMaybe<Scalars['Int']>;
  DealID?: InputMaybe<Scalars['Int']>;
  Description?: InputMaybe<Scalars['String']>;
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ExternalSystemRecordID?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsBounced?: InputMaybe<Scalars['Boolean']>;
  IsOpened?: InputMaybe<Scalars['Boolean']>;
  IsReplied?: InputMaybe<Scalars['Boolean']>;
  Summary?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
};

export type UpdateApplicationEntityInput = {
  ApplicationID: Scalars['Int'];
  DefaultForNewUser: Scalars['Boolean'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
};

export type UpdateApplicationInput = {
  Description?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateApplicationPermissionInput = {
  ApplicationID: Scalars['Int'];
  ID: Scalars['Int'];
  RoleID: Scalars['Int'];
};

export type UpdateAuditLogInput = {
  AuditLogTypeID: Scalars['Int'];
  AuthorizationID?: InputMaybe<Scalars['Int']>;
  Details?: InputMaybe<Scalars['String']>;
  EntityID?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  RecordID?: InputMaybe<Scalars['Int']>;
  Status: Scalars['String'];
  UserID: Scalars['Int'];
};

export type UpdateCampaignInput = {
  CompanyIntegrationID: Scalars['Int'];
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ExternalSystemCreatedAt?: InputMaybe<Scalars['Timestamp']>;
  ExternalSystemRecordID?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  StatusID?: InputMaybe<Scalars['Int']>;
};

export type UpdateCampaignStepInput = {
  Body?: InputMaybe<Scalars['String']>;
  CampaignID: Scalars['Int'];
  ExternalSystemRecordID?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  Subject?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyInput = {
  Description: Scalars['String'];
  Domain?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  LogoURL?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  Website?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyIntegrationInput = {
  APIKey?: InputMaybe<Scalars['String']>;
  AccessToken?: InputMaybe<Scalars['String']>;
  ClientID?: InputMaybe<Scalars['String']>;
  ClientSecret?: InputMaybe<Scalars['String']>;
  CompanyID: Scalars['Int'];
  CustomAttribute1?: InputMaybe<Scalars['String']>;
  ExternalSystemID?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IntegrationID: Scalars['Int'];
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsExternalSystemReadOnly: Scalars['Boolean'];
  RefreshToken?: InputMaybe<Scalars['String']>;
  TokenExpirationDate?: InputMaybe<Scalars['Timestamp']>;
};

export type UpdateContactAccountInput = {
  AccountID: Scalars['Int'];
  ContactID: Scalars['Int'];
  EndedAt?: InputMaybe<Scalars['Timestamp']>;
  ID: Scalars['Int'];
  IsPrimary: Scalars['Boolean'];
  Sequence: Scalars['Int'];
  StartedAt: Scalars['Timestamp'];
};

export type UpdateContactCompanyIntegrationInput = {
  CompanyIntegrationID: Scalars['Int'];
  ContactID: Scalars['Int'];
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
};

export type UpdateContactEmailInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  ContactID: Scalars['Int'];
  Email: Scalars['String'];
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
};

export type UpdateContactInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  ActivityCount: Scalars['Int'];
  EarliestActivityDate?: InputMaybe<Scalars['Timestamp']>;
  Email1?: InputMaybe<Scalars['String']>;
  Email2?: InputMaybe<Scalars['String']>;
  EmailSource?: InputMaybe<Scalars['String']>;
  EmailStatus?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  Instagram?: InputMaybe<Scalars['String']>;
  LastName: Scalars['String'];
  LastReviewedDate?: InputMaybe<Scalars['Timestamp']>;
  LatestActivityDate?: InputMaybe<Scalars['Timestamp']>;
  LevelID?: InputMaybe<Scalars['Int']>;
  LinkedIn?: InputMaybe<Scalars['String']>;
  NickName?: InputMaybe<Scalars['String']>;
  PhoneNumber?: InputMaybe<Scalars['String']>;
  Prefix?: InputMaybe<Scalars['String']>;
  ProfilePictureURL?: InputMaybe<Scalars['String']>;
  RoleID?: InputMaybe<Scalars['Int']>;
  Status?: InputMaybe<Scalars['String']>;
  Suffix?: InputMaybe<Scalars['String']>;
  Tags?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  Twitter?: InputMaybe<Scalars['String']>;
};

export type UpdateContactTopicInput = {
  ContactID: Scalars['Int'];
  EarliestDate: Scalars['Timestamp'];
  ID: Scalars['Int'];
  LatestDate: Scalars['Timestamp'];
  Topic: Scalars['String'];
  TotalCount: Scalars['Int'];
};

export type UpdateDealInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  CloseDate?: InputMaybe<Scalars['Timestamp']>;
  CompanyIntegrationID: Scalars['Int'];
  ContactID?: InputMaybe<Scalars['Int']>;
  ContractTermMonths: Scalars['Int'];
  DealForecastCategoryID?: InputMaybe<Scalars['Int']>;
  DealStageID?: InputMaybe<Scalars['Int']>;
  DealTypeID?: InputMaybe<Scalars['Int']>;
  Description?: InputMaybe<Scalars['String']>;
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ExternalSystemCreatedAt?: InputMaybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ExternalSystemUpdatedAt?: InputMaybe<Scalars['Timestamp']>;
  ForecastNotes?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncludeInForecast?: InputMaybe<Scalars['Boolean']>;
  LeadSource?: InputMaybe<Scalars['String']>;
  LeadSourceDetail?: InputMaybe<Scalars['String']>;
  MRR: Scalars['Float'];
  OneTimeFees: Scalars['Float'];
  Pipeline?: InputMaybe<Scalars['String']>;
  Probability?: InputMaybe<Scalars['Float']>;
  Title?: InputMaybe<Scalars['String']>;
  Value?: InputMaybe<Scalars['Float']>;
};

export type UpdateDealStageInput = {
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateDealTypeInput = {
  Description: Scalars['String'];
  DisplayName?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name?: InputMaybe<Scalars['String']>;
};

export type UpdateEmailServiceProvidersInput = {
  Domain: Scalars['String'];
  ID: Scalars['Int'];
};

export type UpdateEmployeeInput = {
  Active: Scalars['Boolean'];
  CompanyID: Scalars['Int'];
  Email: Scalars['String'];
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  LastName: Scalars['String'];
  Phone?: InputMaybe<Scalars['String']>;
  SupervisorID?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['String']>;
};

export type UpdateEntityAIActionInput = {
  AIActionID: Scalars['Int'];
  AIModelID?: InputMaybe<Scalars['Int']>;
  Comments?: InputMaybe<Scalars['String']>;
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  OutputEntityID?: InputMaybe<Scalars['Int']>;
  OutputField?: InputMaybe<Scalars['String']>;
  OutputType: Scalars['String'];
  Prompt?: InputMaybe<Scalars['String']>;
  SkipIfOutputFieldNotEmpty: Scalars['Boolean'];
  TriggerEvent: Scalars['String'];
  UserMessage: Scalars['String'];
};

export type UpdateEntityFieldInput = {
  AllowUpdateAPI: Scalars['Boolean'];
  AllowUpdateInView: Scalars['Boolean'];
  Category?: InputMaybe<Scalars['String']>;
  DefaultColumnWidth?: InputMaybe<Scalars['Int']>;
  DefaultInView: Scalars['Boolean'];
  Description?: InputMaybe<Scalars['String']>;
  DisplayName?: InputMaybe<Scalars['String']>;
  ExtendedType?: InputMaybe<Scalars['String']>;
  GeneratedFormSection: Scalars['String'];
  ID: Scalars['Int'];
  IncludeInGeneratedForm: Scalars['Boolean'];
  IncludeInUserSearchAPI: Scalars['Boolean'];
  IncludeRelatedEntityNameFieldInBaseView: Scalars['Boolean'];
  IsNameField: Scalars['Boolean'];
  RelatedEntityFieldName?: InputMaybe<Scalars['String']>;
  RelatedEntityID?: InputMaybe<Scalars['Int']>;
  RelatedEntityNameFieldMap?: InputMaybe<Scalars['String']>;
  UserSearchParamFormatAPI?: InputMaybe<Scalars['String']>;
  ValueListType: Scalars['String'];
  ViewCellTemplate?: InputMaybe<Scalars['String']>;
};

export type UpdateEntityInput = {
  AllowAllRowsAPI: Scalars['Boolean'];
  AllowCreateAPI: Scalars['Boolean'];
  AllowDeleteAPI: Scalars['Boolean'];
  AllowUpdateAPI: Scalars['Boolean'];
  AllowUserSearchAPI: Scalars['Boolean'];
  AuditRecordAccess: Scalars['Boolean'];
  AuditViewRuns: Scalars['Boolean'];
  BaseView: Scalars['String'];
  BaseViewGenerated: Scalars['Boolean'];
  CustomResolverAPI: Scalars['Boolean'];
  Description?: InputMaybe<Scalars['String']>;
  EntityObjectSubclassImportPath?: InputMaybe<Scalars['String']>;
  EntityObjectSubclassName?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncludeInAPI: Scalars['Boolean'];
  Name: Scalars['String'];
  ParentID?: InputMaybe<Scalars['Int']>;
  TrackRecordChanges: Scalars['Boolean'];
  UserFormClassName?: InputMaybe<Scalars['String']>;
  UserFormGenerated: Scalars['Boolean'];
  UserFormImportPath?: InputMaybe<Scalars['String']>;
  UserViewMaxRows?: InputMaybe<Scalars['Int']>;
  spCreate?: InputMaybe<Scalars['String']>;
  spCreateGenerated: Scalars['Boolean'];
  spDelete?: InputMaybe<Scalars['String']>;
  spDeleteGenerated: Scalars['Boolean'];
  spUpdate?: InputMaybe<Scalars['String']>;
  spUpdateGenerated: Scalars['Boolean'];
};

export type UpdateEntityPermissionInput = {
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanRead: Scalars['Boolean'];
  CanUpdate: Scalars['Boolean'];
  CreateRLSFilterID?: InputMaybe<Scalars['Int']>;
  DeleteRLSFilterID?: InputMaybe<Scalars['Int']>;
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  ReadRLSFilterID?: InputMaybe<Scalars['Int']>;
  RoleID: Scalars['Int'];
  UpdateRLSFilterID?: InputMaybe<Scalars['Int']>;
};

export type UpdateEntityRelationshipInput = {
  BundleInAPI: Scalars['Boolean'];
  DisplayInForm: Scalars['Boolean'];
  DisplayName?: InputMaybe<Scalars['String']>;
  DisplayUserViewID?: InputMaybe<Scalars['Int']>;
  EntityID: Scalars['Int'];
  EntityKeyField?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncludeInParentAllQuery: Scalars['Boolean'];
  JoinEntityInverseJoinField?: InputMaybe<Scalars['String']>;
  JoinEntityJoinField?: InputMaybe<Scalars['String']>;
  JoinView?: InputMaybe<Scalars['String']>;
  RelatedEntityID: Scalars['Int'];
  RelatedEntityJoinField: Scalars['String'];
  Type: Scalars['String'];
};

export type UpdateIntegrationInput = {
  BatchMaxRequestCount: Scalars['Int'];
  BatchRequestWaitTime: Scalars['Int'];
  ClassName?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  ImportPath?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  NavigationBaseURL?: InputMaybe<Scalars['String']>;
};

export type UpdateIntegrationURLFormatInput = {
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  IntegrationID: Scalars['Int'];
  URLFormat: Scalars['String'];
};

export type UpdateInvoiceInput = {
  AccountID: Scalars['Int'];
  CompanyIntegrationID: Scalars['Int'];
  ContactID?: InputMaybe<Scalars['Int']>;
  DueDate?: InputMaybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  InvoiceDate: Scalars['Timestamp'];
  InvoiceNumber: Scalars['String'];
  PaymentTermsID?: InputMaybe<Scalars['Int']>;
  PostingDate?: InputMaybe<Scalars['Timestamp']>;
  StatusID: Scalars['Int'];
  SubTotal: Scalars['Float'];
  Tax: Scalars['Float'];
  Total: Scalars['Float'];
};

export type UpdateLifecycleStageInput = {
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateListDetailInput = {
  ID: Scalars['Int'];
  ListID: Scalars['Int'];
  RecordID: Scalars['Int'];
  Sequence: Scalars['Int'];
};

export type UpdateListInput = {
  Description?: InputMaybe<Scalars['String']>;
  EntityID?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UserID: Scalars['Int'];
};

export type UpdatePaymentInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  Amount: Scalars['Float'];
  Comments?: InputMaybe<Scalars['String']>;
  CompanyIntegrationID: Scalars['Int'];
  Description?: InputMaybe<Scalars['String']>;
  DocumentNumber?: InputMaybe<Scalars['String']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  InvoiceID: Scalars['Int'];
  PaymentDate: Scalars['Timestamp'];
};

export type UpdateProjectBillingTypeInput = {
  Code: Scalars['String'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateProjectInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  BillingTypeID?: InputMaybe<Scalars['Int']>;
  BudgetAmount?: InputMaybe<Scalars['Float']>;
  CompanyIntegrationID?: InputMaybe<Scalars['Int']>;
  DueDate?: InputMaybe<Scalars['Timestamp']>;
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ExternalSystemRecordID?: InputMaybe<Scalars['String']>;
  FixedFee?: InputMaybe<Scalars['Float']>;
  ID: Scalars['Int'];
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Name: Scalars['String'];
  ProjectRate?: InputMaybe<Scalars['Float']>;
  RateTypeID?: InputMaybe<Scalars['Int']>;
  StartDate?: InputMaybe<Scalars['Timestamp']>;
  StatusID?: InputMaybe<Scalars['Int']>;
};

export type UpdateProjectRateTypeInput = {
  Code: Scalars['String'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateProjectStatusTypeInput = {
  Code: Scalars['String'];
  Description: Scalars['String'];
  ID: Scalars['Int'];
  IsClosed: Scalars['Boolean'];
  Name: Scalars['String'];
};

export type UpdateRoleInput = {
  AzureID?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  Name: Scalars['String'];
  SQLName: Scalars['String'];
};

export type UpdateTaskInput = {
  ActualEffort?: InputMaybe<Scalars['Float']>;
  ActualVariance?: InputMaybe<Scalars['Float']>;
  AssignedEmployeeID?: InputMaybe<Scalars['Int']>;
  BudgetedEffort?: InputMaybe<Scalars['Float']>;
  CalculatedActual?: InputMaybe<Scalars['Float']>;
  EndDate?: InputMaybe<Scalars['Timestamp']>;
  EstimateToComplete?: InputMaybe<Scalars['Float']>;
  ExternalSystemRecordID?: InputMaybe<Scalars['String']>;
  ForecastedEffort?: InputMaybe<Scalars['Float']>;
  ForecastedVariance?: InputMaybe<Scalars['Float']>;
  ID: Scalars['Int'];
  IsCompleted?: InputMaybe<Scalars['Boolean']>;
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  ParentID?: InputMaybe<Scalars['Int']>;
  ProjectID?: InputMaybe<Scalars['Int']>;
  Role?: InputMaybe<Scalars['String']>;
  Section?: InputMaybe<Scalars['String']>;
  Skills?: InputMaybe<Scalars['String']>;
  StartDate?: InputMaybe<Scalars['Timestamp']>;
  Status?: InputMaybe<Scalars['String']>;
  TaskTypeID?: InputMaybe<Scalars['Int']>;
};

export type UpdateTaskTypeInput = {
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  ParentID?: InputMaybe<Scalars['String']>;
};

export type UpdateTaxReturnInput = {
  AccountID?: InputMaybe<Scalars['Int']>;
  AccountingFees?: InputMaybe<Scalars['Float']>;
  AccountsPayable?: InputMaybe<Scalars['Float']>;
  AccountsReceivable?: InputMaybe<Scalars['Float']>;
  ActivityDescription?: InputMaybe<Scalars['String']>;
  AddressLine1?: InputMaybe<Scalars['String']>;
  AddressLine2?: InputMaybe<Scalars['String']>;
  AdvertisingExpense?: InputMaybe<Scalars['Float']>;
  AffiliatePaymentExpense?: InputMaybe<Scalars['Float']>;
  Affiliation?: InputMaybe<Scalars['Int']>;
  BODVotingMembers?: InputMaybe<Scalars['Int']>;
  CapitalStockPrincipal?: InputMaybe<Scalars['Float']>;
  Cash?: InputMaybe<Scalars['Float']>;
  City?: InputMaybe<Scalars['String']>;
  ConferenceExpense?: InputMaybe<Scalars['Float']>;
  CostBasisSecurities?: InputMaybe<Scalars['Float']>;
  DeferredRevenue?: InputMaybe<Scalars['Float']>;
  DepreciationExpense?: InputMaybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: InputMaybe<Scalars['Float']>;
  EscrowAccountLiability?: InputMaybe<Scalars['Float']>;
  FinancialStrength?: InputMaybe<Scalars['String']>;
  FundraisingExpenses?: InputMaybe<Scalars['Float']>;
  FundraisingNetIncome?: InputMaybe<Scalars['Float']>;
  GrantsPayable?: InputMaybe<Scalars['Float']>;
  GrantsToIndividuals?: InputMaybe<Scalars['Int']>;
  GrantsToOrgs?: InputMaybe<Scalars['Int']>;
  GrossFundraisingReceipts?: InputMaybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: InputMaybe<Scalars['Float']>;
  GrossSalesSecurities?: InputMaybe<Scalars['Float']>;
  HasForeignBankAcct?: InputMaybe<Scalars['Boolean']>;
  HasInvestmentIncome?: InputMaybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  InformationTechnologyExpense?: InputMaybe<Scalars['Float']>;
  InsuranceExpense?: InputMaybe<Scalars['Float']>;
  IntangibleAssetValue?: InputMaybe<Scalars['Float']>;
  InterestExpense?: InputMaybe<Scalars['Float']>;
  InventoryAssetValue?: InputMaybe<Scalars['Float']>;
  InvestmentManagementFees?: InputMaybe<Scalars['Float']>;
  IsHospital?: InputMaybe<Scalars['Boolean']>;
  LegalFees?: InputMaybe<Scalars['Float']>;
  LobbyingFees?: InputMaybe<Scalars['Float']>;
  ManagementFees?: InputMaybe<Scalars['Float']>;
  MissionDescription?: InputMaybe<Scalars['String']>;
  MortgagesNotesPayable?: InputMaybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: InputMaybe<Scalars['Float']>;
  NetRentRealEstate?: InputMaybe<Scalars['Float']>;
  NotesReceivable?: InputMaybe<Scalars['Float']>;
  NumberEmployees?: InputMaybe<Scalars['Int']>;
  NumberVolunteers?: InputMaybe<Scalars['Int']>;
  OccupancyExpense?: InputMaybe<Scalars['Float']>;
  OfficeExpense?: InputMaybe<Scalars['Float']>;
  OfficerCompensation?: InputMaybe<Scalars['Float']>;
  OtherAssets?: InputMaybe<Scalars['Float']>;
  OtherEmployeeBenefits?: InputMaybe<Scalars['Float']>;
  OtherFees?: InputMaybe<Scalars['Float']>;
  OtherLiabilities?: InputMaybe<Scalars['Float']>;
  OtherSalaries?: InputMaybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  PaidInCapitalSurplus?: InputMaybe<Scalars['Float']>;
  PayablesToOfficers?: InputMaybe<Scalars['Float']>;
  PayrollTaxes?: InputMaybe<Scalars['Float']>;
  PensionContributions?: InputMaybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  PledgesGrantsReceivable?: InputMaybe<Scalars['Float']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: InputMaybe<Scalars['Float']>;
  PreparerFirm?: InputMaybe<Scalars['String']>;
  PreparerFirmAddressLine1?: InputMaybe<Scalars['String']>;
  PreparerFirmAddressLine2?: InputMaybe<Scalars['String']>;
  PreparerFirmCity?: InputMaybe<Scalars['String']>;
  PreparerFirmPostalCode?: InputMaybe<Scalars['String']>;
  PreparerFirmStateProvince?: InputMaybe<Scalars['String']>;
  PreparerFirmTaxID?: InputMaybe<Scalars['String']>;
  PreparerPerson?: InputMaybe<Scalars['String']>;
  PreparerPersonPhone?: InputMaybe<Scalars['String']>;
  PreparerPersonTaxID?: InputMaybe<Scalars['String']>;
  ProfessionalFundraisingFees?: InputMaybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: InputMaybe<Scalars['Float']>;
  PublicSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  RealEstateAssetValue?: InputMaybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: InputMaybe<Scalars['Float']>;
  ReceivablesFromOfficers?: InputMaybe<Scalars['Float']>;
  RentalExpenseRealEstate?: InputMaybe<Scalars['Float']>;
  RetainedEarnings?: InputMaybe<Scalars['Float']>;
  ReturnType?: InputMaybe<Scalars['String']>;
  RoyaltyExpense?: InputMaybe<Scalars['Float']>;
  Savings?: InputMaybe<Scalars['Float']>;
  SourceJSON?: InputMaybe<Scalars['String']>;
  StateProvince?: InputMaybe<Scalars['String']>;
  Subsection?: InputMaybe<Scalars['String']>;
  SummaryText?: InputMaybe<Scalars['String']>;
  TaxExemptBondLiability?: InputMaybe<Scalars['Float']>;
  TaxID: Scalars['String'];
  TaxMonth?: InputMaybe<Scalars['Int']>;
  TaxPeriodEnd: Scalars['Timestamp'];
  TaxPeriodStart: Scalars['Timestamp'];
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  TotalAssets?: InputMaybe<Scalars['Float']>;
  TotalGrossReceipts?: InputMaybe<Scalars['Float']>;
  TotalInvestmentIncome?: InputMaybe<Scalars['Float']>;
  TotalLiabilities?: InputMaybe<Scalars['Float']>;
  TotalMemberIncome?: InputMaybe<Scalars['Float']>;
  TotalNetAssets?: InputMaybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: InputMaybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: InputMaybe<Scalars['Float']>;
  TotalRevenue?: InputMaybe<Scalars['Float']>;
  TravelExpense?: InputMaybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: InputMaybe<Scalars['Float']>;
  UnrestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  UnsecuredNotesPayable?: InputMaybe<Scalars['Float']>;
  Website?: InputMaybe<Scalars['String']>;
  YearFormed?: InputMaybe<Scalars['Int']>;
};

export type UpdateTimeEntryInput = {
  Comment?: InputMaybe<Scalars['String']>;
  Date?: InputMaybe<Scalars['Timestamp']>;
  Effort?: InputMaybe<Scalars['Float']>;
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ExternalSystemRecordID?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsDeleted?: InputMaybe<Scalars['Boolean']>;
  IsInvoiced?: InputMaybe<Scalars['Boolean']>;
  IsLocked?: InputMaybe<Scalars['Boolean']>;
  TaskID?: InputMaybe<Scalars['Int']>;
};

export type UpdateUserApplicationEntityInput = {
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  UserApplicationID: Scalars['Int'];
};

export type UpdateUserApplicationInput = {
  ApplicationID: Scalars['Int'];
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Sequence: Scalars['Int'];
  UserID: Scalars['Int'];
};

export type UpdateUserFavoriteInput = {
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UserID: Scalars['Int'];
};

export type UpdateUserInput = {
  EmployeeID?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  Type: Scalars['String'];
};

export type UpdateUserRecordLogInput = {
  EarliestAt: Scalars['Timestamp'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  LatestAt: Scalars['Timestamp'];
  RecordID: Scalars['Int'];
  TotalCount: Scalars['Int'];
  UserID: Scalars['Int'];
};

export type UpdateUserViewInput = {
  CustomFilterState: Scalars['Boolean'];
  CustomWhereClause: Scalars['Boolean'];
  Description?: InputMaybe<Scalars['String']>;
  EntityID: Scalars['Int'];
  FilterState?: InputMaybe<Scalars['String']>;
  GridState?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsDefault: Scalars['Boolean'];
  IsShared: Scalars['Boolean'];
  Name: Scalars['String'];
  UserID: Scalars['Int'];
  WhereClause?: InputMaybe<Scalars['String']>;
};

export type UpdateUserViewRunDetailInput = {
  ID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UserViewRunID: Scalars['Int'];
};

export type UpdateUserViewRunInput = {
  ID: Scalars['Int'];
  RunAt: Scalars['Timestamp'];
  RunByUserID: Scalars['Int'];
  UserViewID: Scalars['Int'];
};

export type UpdateWorkflowEngineInput = {
  Description?: InputMaybe<Scalars['String']>;
  DriverClass: Scalars['String'];
  DriverPath: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type UpdateWorkflowInput = {
  CompanyID: Scalars['Int'];
  Description?: InputMaybe<Scalars['String']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  WorkflowEngineID: Scalars['Int'];
};

export type UpdateWorkflowRunInput = {
  EndedAt?: InputMaybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  Results?: InputMaybe<Scalars['String']>;
  StartedAt: Scalars['Timestamp'];
  Status: Scalars['String'];
  WorkflowID: Scalars['Int'];
};

export type Update_990FullInput = {
  AccountingFees?: InputMaybe<Scalars['Float']>;
  AccountsPayable?: InputMaybe<Scalars['Float']>;
  AccountsReceivable?: InputMaybe<Scalars['Float']>;
  Activity?: InputMaybe<Scalars['Int']>;
  AdvertisingExpense?: InputMaybe<Scalars['Float']>;
  AffiliatePaymentExpense?: InputMaybe<Scalars['Float']>;
  Affiliation?: InputMaybe<Scalars['Int']>;
  AssetCode?: InputMaybe<Scalars['Int']>;
  CapitalStockPrincipal?: InputMaybe<Scalars['Float']>;
  Cash?: InputMaybe<Scalars['Float']>;
  City?: InputMaybe<Scalars['String']>;
  Classification?: InputMaybe<Scalars['Int']>;
  ConferenceExpense?: InputMaybe<Scalars['Float']>;
  CostBasisSecurities?: InputMaybe<Scalars['Float']>;
  Deductibility?: InputMaybe<Scalars['Int']>;
  DeferredRevenue?: InputMaybe<Scalars['Float']>;
  DepreciationExpense?: InputMaybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: InputMaybe<Scalars['Float']>;
  EIN?: InputMaybe<Scalars['String']>;
  EscrowAccountLiability?: InputMaybe<Scalars['Float']>;
  FilingRequirementCode?: InputMaybe<Scalars['Int']>;
  Foundation?: InputMaybe<Scalars['Int']>;
  FundraisingActivities?: InputMaybe<Scalars['String']>;
  FundraisingExpenses?: InputMaybe<Scalars['Float']>;
  FundraisingNetIncome?: InputMaybe<Scalars['Float']>;
  GrantsPayable?: InputMaybe<Scalars['Float']>;
  GrantsToIndividuals?: InputMaybe<Scalars['Int']>;
  GrantsToOrgs?: InputMaybe<Scalars['Int']>;
  GrossFundraisingReceipts?: InputMaybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: InputMaybe<Scalars['Float']>;
  GrossSalesSecurities?: InputMaybe<Scalars['Float']>;
  Group?: InputMaybe<Scalars['String']>;
  HasForeignBankAcct?: InputMaybe<Scalars['Boolean']>;
  HasInvestmentIncome?: InputMaybe<Scalars['Boolean']>;
  ICO?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncomeCode?: InputMaybe<Scalars['Int']>;
  InformationTechnologyExpense?: InputMaybe<Scalars['Float']>;
  InsuranceExpense?: InputMaybe<Scalars['Float']>;
  IntangibleAssetValue?: InputMaybe<Scalars['Float']>;
  InterestExpense?: InputMaybe<Scalars['Float']>;
  InventoryAssetValue?: InputMaybe<Scalars['Float']>;
  InvestmentManagementFees?: InputMaybe<Scalars['Float']>;
  IsHospital?: InputMaybe<Scalars['Boolean']>;
  LegalFees?: InputMaybe<Scalars['Float']>;
  LobbyingActivities?: InputMaybe<Scalars['String']>;
  LobbyingFees?: InputMaybe<Scalars['Float']>;
  ManagementFees?: InputMaybe<Scalars['Float']>;
  MortgagesNotesPayable?: InputMaybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: InputMaybe<Scalars['Float']>;
  NetRentRealEstate?: InputMaybe<Scalars['Float']>;
  NotesReceivable?: InputMaybe<Scalars['Float']>;
  NumberEmployees?: InputMaybe<Scalars['Int']>;
  OccupancyExpense?: InputMaybe<Scalars['Float']>;
  OfficeExpense?: InputMaybe<Scalars['Float']>;
  OfficerCompensation?: InputMaybe<Scalars['Float']>;
  Organization?: InputMaybe<Scalars['Int']>;
  OtherAssets?: InputMaybe<Scalars['Float']>;
  OtherEmployeeBenefits?: InputMaybe<Scalars['Float']>;
  OtherFees?: InputMaybe<Scalars['Float']>;
  OtherLiabilities?: InputMaybe<Scalars['Float']>;
  OtherSalaries?: InputMaybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  PaidInCapitalSurplus?: InputMaybe<Scalars['Float']>;
  PayablesToOfficers?: InputMaybe<Scalars['Float']>;
  PayrollTaxes?: InputMaybe<Scalars['Float']>;
  PensionContributions?: InputMaybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  PledgesGrantsReceivable?: InputMaybe<Scalars['Float']>;
  PoliticalActivities?: InputMaybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: InputMaybe<Scalars['Float']>;
  ProfessionalFundraisingFees?: InputMaybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueA?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueB?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueC?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueCodeA?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeB?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeC?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeD?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeE?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueD?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueE?: InputMaybe<Scalars['Float']>;
  PublicSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  RealEstateAssetValue?: InputMaybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: InputMaybe<Scalars['Float']>;
  ReceivablesFromOfficers?: InputMaybe<Scalars['Float']>;
  RentalExpenseRealEstate?: InputMaybe<Scalars['Float']>;
  RetainedEarnings?: InputMaybe<Scalars['Float']>;
  RoyaltyExpense?: InputMaybe<Scalars['Float']>;
  Ruling?: InputMaybe<Scalars['Int']>;
  Savings?: InputMaybe<Scalars['Float']>;
  SortName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Scalars['Int']>;
  Street?: InputMaybe<Scalars['String']>;
  Subsection?: InputMaybe<Scalars['Int']>;
  TaxExemptBondLiability?: InputMaybe<Scalars['Float']>;
  TaxMonth?: InputMaybe<Scalars['Int']>;
  TaxPeriod?: InputMaybe<Scalars['String']>;
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  TotalAssets?: InputMaybe<Scalars['Float']>;
  TotalGrossReceipts?: InputMaybe<Scalars['Float']>;
  TotalInvestmentIncome?: InputMaybe<Scalars['Float']>;
  TotalLiabilities?: InputMaybe<Scalars['Float']>;
  TotalMemberIncome?: InputMaybe<Scalars['Float']>;
  TotalNetAssets?: InputMaybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: InputMaybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: InputMaybe<Scalars['Float']>;
  TotalRevenue?: InputMaybe<Scalars['Float']>;
  TravelExpense?: InputMaybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: InputMaybe<Scalars['Float']>;
  UnrestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  UnsecuredNotesPayable?: InputMaybe<Scalars['Float']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type Update_990LatestInput = {
  AccountingFees?: InputMaybe<Scalars['Float']>;
  AccountsPayable?: InputMaybe<Scalars['Float']>;
  AccountsReceivable?: InputMaybe<Scalars['Float']>;
  Activity?: InputMaybe<Scalars['Int']>;
  AdvertisingExpense?: InputMaybe<Scalars['Float']>;
  AffiliatePaymentExpense?: InputMaybe<Scalars['Float']>;
  Affiliation?: InputMaybe<Scalars['Int']>;
  AssetCode?: InputMaybe<Scalars['Int']>;
  CapitalStockPrincipal?: InputMaybe<Scalars['Float']>;
  Cash?: InputMaybe<Scalars['Float']>;
  City?: InputMaybe<Scalars['String']>;
  Classification?: InputMaybe<Scalars['Int']>;
  ConferenceExpense?: InputMaybe<Scalars['Float']>;
  CostBasisSecurities?: InputMaybe<Scalars['Float']>;
  Deductibility?: InputMaybe<Scalars['Int']>;
  DeferredRevenue?: InputMaybe<Scalars['Float']>;
  DepreciationExpense?: InputMaybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: InputMaybe<Scalars['Float']>;
  EIN?: InputMaybe<Scalars['String']>;
  EscrowAccountLiability?: InputMaybe<Scalars['Float']>;
  FilingRequirementCode?: InputMaybe<Scalars['Int']>;
  Foundation?: InputMaybe<Scalars['Int']>;
  FundraisingActivities?: InputMaybe<Scalars['String']>;
  FundraisingExpenses?: InputMaybe<Scalars['Float']>;
  FundraisingNetIncome?: InputMaybe<Scalars['Float']>;
  GrantsPayable?: InputMaybe<Scalars['Float']>;
  GrantsToIndividuals?: InputMaybe<Scalars['Int']>;
  GrantsToOrgs?: InputMaybe<Scalars['Int']>;
  GrossFundraisingReceipts?: InputMaybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: InputMaybe<Scalars['Float']>;
  GrossSalesSecurities?: InputMaybe<Scalars['Float']>;
  Group?: InputMaybe<Scalars['String']>;
  HasForeignBankAcct?: InputMaybe<Scalars['Boolean']>;
  HasInvestmentIncome?: InputMaybe<Scalars['Boolean']>;
  ICO?: InputMaybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncomeCode?: InputMaybe<Scalars['Int']>;
  InformationTechnologyExpense?: InputMaybe<Scalars['Float']>;
  InsuranceExpense?: InputMaybe<Scalars['Float']>;
  IntangibleAssetValue?: InputMaybe<Scalars['Float']>;
  InterestExpense?: InputMaybe<Scalars['Float']>;
  InventoryAssetValue?: InputMaybe<Scalars['Float']>;
  InvestmentManagementFees?: InputMaybe<Scalars['Float']>;
  IsHospital?: InputMaybe<Scalars['Boolean']>;
  LegalFees?: InputMaybe<Scalars['Float']>;
  LobbyingActivities?: InputMaybe<Scalars['String']>;
  LobbyingFees?: InputMaybe<Scalars['Float']>;
  ManagementFees?: InputMaybe<Scalars['Float']>;
  MortgagesNotesPayable?: InputMaybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: InputMaybe<Scalars['Float']>;
  NetRentRealEstate?: InputMaybe<Scalars['Float']>;
  NotesReceivable?: InputMaybe<Scalars['Float']>;
  NumberEmployees?: InputMaybe<Scalars['Int']>;
  OccupancyExpense?: InputMaybe<Scalars['Float']>;
  OfficeExpense?: InputMaybe<Scalars['Float']>;
  OfficerCompensation?: InputMaybe<Scalars['Float']>;
  Organization?: InputMaybe<Scalars['Int']>;
  OtherAssets?: InputMaybe<Scalars['Float']>;
  OtherEmployeeBenefits?: InputMaybe<Scalars['Float']>;
  OtherFees?: InputMaybe<Scalars['Float']>;
  OtherLiabilities?: InputMaybe<Scalars['Float']>;
  OtherSalaries?: InputMaybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  PaidInCapitalSurplus?: InputMaybe<Scalars['Float']>;
  PayablesToOfficers?: InputMaybe<Scalars['Float']>;
  PayrollTaxes?: InputMaybe<Scalars['Float']>;
  PensionContributions?: InputMaybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  PledgesGrantsReceivable?: InputMaybe<Scalars['Float']>;
  PoliticalActivities?: InputMaybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: InputMaybe<Scalars['Float']>;
  ProfessionalFundraisingFees?: InputMaybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueA?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueB?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueC?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueCodeA?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeB?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeC?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeD?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueCodeE?: InputMaybe<Scalars['String']>;
  ProgramServiceRevenueD?: InputMaybe<Scalars['Float']>;
  ProgramServiceRevenueE?: InputMaybe<Scalars['Float']>;
  PublicSecuritiesAssetValue?: InputMaybe<Scalars['Float']>;
  RealEstateAssetValue?: InputMaybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: InputMaybe<Scalars['Float']>;
  ReceivablesFromOfficers?: InputMaybe<Scalars['Float']>;
  RentalExpenseRealEstate?: InputMaybe<Scalars['Float']>;
  RetainedEarnings?: InputMaybe<Scalars['Float']>;
  RoyaltyExpense?: InputMaybe<Scalars['Float']>;
  Ruling?: InputMaybe<Scalars['Int']>;
  Savings?: InputMaybe<Scalars['Float']>;
  SortName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Scalars['Int']>;
  Street?: InputMaybe<Scalars['String']>;
  Subsection?: InputMaybe<Scalars['Int']>;
  TaxExemptBondLiability?: InputMaybe<Scalars['Float']>;
  TaxMonth?: InputMaybe<Scalars['Int']>;
  TaxPeriod?: InputMaybe<Scalars['String']>;
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  TotalAssets?: InputMaybe<Scalars['Float']>;
  TotalGrossReceipts?: InputMaybe<Scalars['Float']>;
  TotalInvestmentIncome?: InputMaybe<Scalars['Float']>;
  TotalLiabilities?: InputMaybe<Scalars['Float']>;
  TotalMemberIncome?: InputMaybe<Scalars['Float']>;
  TotalNetAssets?: InputMaybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: InputMaybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: InputMaybe<Scalars['Float']>;
  TotalRevenue?: InputMaybe<Scalars['Float']>;
  TravelExpense?: InputMaybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: InputMaybe<Scalars['Float']>;
  UnrestrictedNetAssets?: InputMaybe<Scalars['Float']>;
  UnsecuredNotesPayable?: InputMaybe<Scalars['Float']>;
  Zip?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  CreatedAt: Scalars['Timestamp'];
  Email: Scalars['String'];
  EmployeeID?: Maybe<Scalars['Int']>;
  FirstLast?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Name: Scalars['String'];
  Supervisor?: Maybe<Scalars['String']>;
  SupervisorEmail?: Maybe<Scalars['String']>;
  Type: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  UserApplications: Array<UserApplication>;
  UserRoles: Array<UserRole>;
};

export type UserApplication = {
  __typename?: 'UserApplication';
  Application: Scalars['String'];
  ApplicationID: Scalars['Int'];
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  Sequence: Scalars['Int'];
  User: Scalars['String'];
  UserApplicationEntities: Array<UserApplicationEntity>;
  UserID: Scalars['Int'];
};

export type UserApplicationEntity = {
  __typename?: 'UserApplicationEntity';
  Application: Scalars['String'];
  Entity: Scalars['String'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  Sequence: Scalars['Int'];
  User: Scalars['String'];
  UserApplicationID: Scalars['Int'];
};

export type UserFavorite = {
  __typename?: 'UserFavorite';
  CreatedAt: Scalars['Timestamp'];
  Entity: Scalars['String'];
  EntityBaseTable: Scalars['String'];
  EntityBaseView: Scalars['String'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
  UserID: Scalars['Int'];
};

export type UserFavoriteResult = {
  __typename?: 'UserFavoriteResult';
  EntityID: Scalars['Int'];
  IsFavorite: Scalars['Boolean'];
  RecordID: Scalars['Int'];
  Success: Scalars['Boolean'];
  UserID: Scalars['Int'];
};

export type UserFavoriteSearchParams = {
  EntityID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UserID: Scalars['Int'];
};

export type UserFavoriteSetParams = {
  EntityID: Scalars['Int'];
  IsFavorite: Scalars['Boolean'];
  RecordID: Scalars['Int'];
  UserID: Scalars['Int'];
};

/** Tracks history of user access to records across the system, tracks reads and writes */
export type UserRecordLog = {
  __typename?: 'UserRecordLog';
  EarliestAt: Scalars['Timestamp'];
  Entity: Scalars['String'];
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  LatestAt: Scalars['Timestamp'];
  RecordID: Scalars['Int'];
  TotalCount: Scalars['Int'];
  UserEmail: Scalars['String'];
  UserFirstLast?: Maybe<Scalars['String']>;
  UserID: Scalars['Int'];
  UserName: Scalars['String'];
  UserSupervisor?: Maybe<Scalars['String']>;
  UserSupervisorEmail?: Maybe<Scalars['String']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  CreatedAt: Scalars['Timestamp'];
  ID: Scalars['Int'];
  Role: Scalars['String'];
  RoleID: Scalars['Int'];
  UpdatedAt: Scalars['Timestamp'];
  User: Scalars['String'];
  UserID: Scalars['Int'];
};

/** User Views contain the metadata for the user viewing system of entity data */
export type UserView = {
  __typename?: 'UserView';
  CreatedAt?: Maybe<Scalars['Timestamp']>;
  CustomFilterState: Scalars['Boolean'];
  CustomWhereClause: Scalars['Boolean'];
  Description?: Maybe<Scalars['String']>;
  Entity: Scalars['String'];
  EntityBaseView: Scalars['String'];
  EntityID: Scalars['Int'];
  FilterState?: Maybe<Scalars['String']>;
  GridState?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsDefault: Scalars['Boolean'];
  IsShared: Scalars['Boolean'];
  Name: Scalars['String'];
  UpdatedAt?: Maybe<Scalars['Timestamp']>;
  UserEmail: Scalars['String'];
  UserFirstLast?: Maybe<Scalars['String']>;
  UserID: Scalars['Int'];
  UserName: Scalars['String'];
  UserType: Scalars['String'];
  WhereClause?: Maybe<Scalars['String']>;
};

export type UserViewRun = {
  __typename?: 'UserViewRun';
  ID: Scalars['Int'];
  RunAt: Scalars['Timestamp'];
  RunByUser: Scalars['String'];
  RunByUserID: Scalars['Int'];
  UserView: Scalars['String'];
  UserViewID: Scalars['Int'];
  UserViewRunDetails: Array<UserViewRunDetail>;
};

export type UserViewRunDetail = {
  __typename?: 'UserViewRunDetail';
  EntityID: Scalars['Int'];
  ID: Scalars['Int'];
  RecordID: Scalars['Int'];
  UserViewID: Scalars['Int'];
  UserViewRunID: Scalars['Int'];
};

export type UtilityResultType = {
  __typename?: 'UtilityResultType';
  Result: Scalars['String'];
  Status: Scalars['String'];
};

export type Workflow = {
  __typename?: 'Workflow';
  CompanyID: Scalars['Int'];
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
  WorkflowEngine: Scalars['String'];
  WorkflowEngineID: Scalars['Int'];
};

export type WorkflowEngine = {
  __typename?: 'WorkflowEngine';
  CreatedAt: Scalars['Timestamp'];
  Description?: Maybe<Scalars['String']>;
  DriverClass: Scalars['String'];
  DriverPath: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  UpdatedAt: Scalars['Timestamp'];
};

export type WorkflowRun = {
  __typename?: 'WorkflowRun';
  EndedAt?: Maybe<Scalars['Timestamp']>;
  ExternalSystemRecordID: Scalars['String'];
  ID: Scalars['Int'];
  Results?: Maybe<Scalars['String']>;
  StartedAt: Scalars['Timestamp'];
  Status: Scalars['String'];
  Workflow: Scalars['String'];
  WorkflowEngine: Scalars['String'];
  WorkflowID: Scalars['Int'];
};

/** All 990 records for all years we have on file for all EINs */
export type _990Full = {
  __typename?: '_990Full';
  AccountID?: Maybe<Scalars['Int']>;
  AccountingFees?: Maybe<Scalars['Float']>;
  AccountsPayable?: Maybe<Scalars['Float']>;
  AccountsReceivable?: Maybe<Scalars['Float']>;
  Activity?: Maybe<Scalars['Int']>;
  AdvertisingExpense?: Maybe<Scalars['Float']>;
  AffiliatePaymentExpense?: Maybe<Scalars['Float']>;
  Affiliation?: Maybe<Scalars['Int']>;
  AssetCode?: Maybe<Scalars['Int']>;
  CapitalStockPrincipal?: Maybe<Scalars['Float']>;
  Cash?: Maybe<Scalars['Float']>;
  City?: Maybe<Scalars['String']>;
  Classification?: Maybe<Scalars['Int']>;
  ConferenceExpense?: Maybe<Scalars['Float']>;
  CostBasisSecurities?: Maybe<Scalars['Float']>;
  Deductibility?: Maybe<Scalars['Int']>;
  DeferredRevenue?: Maybe<Scalars['Float']>;
  DepreciationExpense?: Maybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: Maybe<Scalars['Float']>;
  EIN?: Maybe<Scalars['String']>;
  EscrowAccountLiability?: Maybe<Scalars['Float']>;
  FilingRequirementCode?: Maybe<Scalars['Int']>;
  Foundation?: Maybe<Scalars['Int']>;
  FundraisingActivities?: Maybe<Scalars['String']>;
  FundraisingExpenses?: Maybe<Scalars['Float']>;
  FundraisingNetIncome?: Maybe<Scalars['Float']>;
  GrantsPayable?: Maybe<Scalars['Float']>;
  GrantsToIndividuals?: Maybe<Scalars['Int']>;
  GrantsToOrgs?: Maybe<Scalars['Int']>;
  GrossFundraisingReceipts?: Maybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: Maybe<Scalars['Float']>;
  GrossSalesSecurities?: Maybe<Scalars['Float']>;
  Group?: Maybe<Scalars['String']>;
  HasForeignBankAcct?: Maybe<Scalars['Boolean']>;
  HasInvestmentIncome?: Maybe<Scalars['Boolean']>;
  ICO?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncomeCode?: Maybe<Scalars['Int']>;
  InformationTechnologyExpense?: Maybe<Scalars['Float']>;
  InsuranceExpense?: Maybe<Scalars['Float']>;
  IntangibleAssetValue?: Maybe<Scalars['Float']>;
  InterestExpense?: Maybe<Scalars['Float']>;
  InventoryAssetValue?: Maybe<Scalars['Float']>;
  InvestmentManagementFees?: Maybe<Scalars['Float']>;
  IsHospital?: Maybe<Scalars['Boolean']>;
  LegalFees?: Maybe<Scalars['Float']>;
  LobbyingActivities?: Maybe<Scalars['String']>;
  LobbyingFees?: Maybe<Scalars['Float']>;
  ManagementFees?: Maybe<Scalars['Float']>;
  MortgagesNotesPayable?: Maybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: Maybe<Scalars['Float']>;
  NetRentRealEstate?: Maybe<Scalars['Float']>;
  NotesReceivable?: Maybe<Scalars['Float']>;
  NumberEmployees?: Maybe<Scalars['Int']>;
  OccupancyExpense?: Maybe<Scalars['Float']>;
  OfficeExpense?: Maybe<Scalars['Float']>;
  OfficerCompensation?: Maybe<Scalars['Float']>;
  Organization?: Maybe<Scalars['Int']>;
  OtherAssets?: Maybe<Scalars['Float']>;
  OtherEmployeeBenefits?: Maybe<Scalars['Float']>;
  OtherFees?: Maybe<Scalars['Float']>;
  OtherLiabilities?: Maybe<Scalars['Float']>;
  OtherSalaries?: Maybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: Maybe<Scalars['Float']>;
  PaidInCapitalSurplus?: Maybe<Scalars['Float']>;
  PayablesToOfficers?: Maybe<Scalars['Float']>;
  PayrollTaxes?: Maybe<Scalars['Float']>;
  PensionContributions?: Maybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: Maybe<Scalars['Float']>;
  PledgesGrantsReceivable?: Maybe<Scalars['Float']>;
  PoliticalActivities?: Maybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: Maybe<Scalars['Float']>;
  ProfessionalFundraisingFees?: Maybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueA?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueB?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueC?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueCodeA?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeB?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeC?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeD?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeE?: Maybe<Scalars['String']>;
  ProgramServiceRevenueD?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueE?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueNameA?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameB?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameC?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameD?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameE?: Maybe<Scalars['String']>;
  PublicSecuritiesAssetValue?: Maybe<Scalars['Float']>;
  RealEstateAssetValue?: Maybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: Maybe<Scalars['Float']>;
  ReceivablesFromOfficers?: Maybe<Scalars['Float']>;
  RentalExpenseRealEstate?: Maybe<Scalars['Float']>;
  RetainedEarnings?: Maybe<Scalars['Float']>;
  RoyaltyExpense?: Maybe<Scalars['Float']>;
  Ruling?: Maybe<Scalars['Int']>;
  Savings?: Maybe<Scalars['Float']>;
  SortName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['Int']>;
  Street?: Maybe<Scalars['String']>;
  Subsection?: Maybe<Scalars['Int']>;
  TaxExemptBondLiability?: Maybe<Scalars['Float']>;
  TaxMonth?: Maybe<Scalars['Int']>;
  TaxPeriod?: Maybe<Scalars['String']>;
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: Maybe<Scalars['Float']>;
  TotalAssets?: Maybe<Scalars['Float']>;
  TotalGrossReceipts?: Maybe<Scalars['Float']>;
  TotalInvestmentIncome?: Maybe<Scalars['Float']>;
  TotalLiabilities?: Maybe<Scalars['Float']>;
  TotalMemberIncome?: Maybe<Scalars['Float']>;
  TotalNetAssets?: Maybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: Maybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: Maybe<Scalars['Float']>;
  TotalRevenue?: Maybe<Scalars['Float']>;
  TravelExpense?: Maybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: Maybe<Scalars['Float']>;
  UnrestrictedNetAssets?: Maybe<Scalars['Float']>;
  UnsecuredNotesPayable?: Maybe<Scalars['Float']>;
  Zip?: Maybe<Scalars['String']>;
};

/** Single Row per EIN showing the latest year 990 data for each EIN */
export type _990Latest = {
  __typename?: '_990Latest';
  AccountID?: Maybe<Scalars['Int']>;
  AccountingFees?: Maybe<Scalars['Float']>;
  AccountsPayable?: Maybe<Scalars['Float']>;
  AccountsReceivable?: Maybe<Scalars['Float']>;
  Activity?: Maybe<Scalars['Int']>;
  AdvertisingExpense?: Maybe<Scalars['Float']>;
  AffiliatePaymentExpense?: Maybe<Scalars['Float']>;
  Affiliation?: Maybe<Scalars['Int']>;
  AssetCode?: Maybe<Scalars['Int']>;
  CapitalStockPrincipal?: Maybe<Scalars['Float']>;
  Cash?: Maybe<Scalars['Float']>;
  City?: Maybe<Scalars['String']>;
  Classification?: Maybe<Scalars['Int']>;
  ConferenceExpense?: Maybe<Scalars['Float']>;
  CostBasisSecurities?: Maybe<Scalars['Float']>;
  Deductibility?: Maybe<Scalars['Int']>;
  DeferredRevenue?: Maybe<Scalars['Float']>;
  DepreciationExpense?: Maybe<Scalars['Float']>;
  DisqualifiedPersonCompensation?: Maybe<Scalars['Float']>;
  EIN?: Maybe<Scalars['String']>;
  EscrowAccountLiability?: Maybe<Scalars['Float']>;
  FilingRequirementCode?: Maybe<Scalars['Int']>;
  Foundation?: Maybe<Scalars['Int']>;
  FundraisingActivities?: Maybe<Scalars['String']>;
  FundraisingExpenses?: Maybe<Scalars['Float']>;
  FundraisingNetIncome?: Maybe<Scalars['Float']>;
  GrantsPayable?: Maybe<Scalars['Float']>;
  GrantsToIndividuals?: Maybe<Scalars['Int']>;
  GrantsToOrgs?: Maybe<Scalars['Int']>;
  GrossFundraisingReceipts?: Maybe<Scalars['Float']>;
  GrossRentsFromRealEstate?: Maybe<Scalars['Float']>;
  GrossSalesSecurities?: Maybe<Scalars['Float']>;
  Group?: Maybe<Scalars['String']>;
  HasForeignBankAcct?: Maybe<Scalars['Boolean']>;
  HasInvestmentIncome?: Maybe<Scalars['Boolean']>;
  ICO?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IncomeCode?: Maybe<Scalars['Int']>;
  InformationTechnologyExpense?: Maybe<Scalars['Float']>;
  InsuranceExpense?: Maybe<Scalars['Float']>;
  IntangibleAssetValue?: Maybe<Scalars['Float']>;
  InterestExpense?: Maybe<Scalars['Float']>;
  InventoryAssetValue?: Maybe<Scalars['Float']>;
  InvestmentManagementFees?: Maybe<Scalars['Float']>;
  IsHospital?: Maybe<Scalars['Boolean']>;
  LegalFees?: Maybe<Scalars['Float']>;
  LobbyingActivities?: Maybe<Scalars['String']>;
  LobbyingFees?: Maybe<Scalars['Float']>;
  ManagementFees?: Maybe<Scalars['Float']>;
  MortgagesNotesPayable?: Maybe<Scalars['Float']>;
  Name: Scalars['String'];
  NetGainSecurities?: Maybe<Scalars['Float']>;
  NetRentRealEstate?: Maybe<Scalars['Float']>;
  NotesReceivable?: Maybe<Scalars['Float']>;
  NumberEmployees?: Maybe<Scalars['Int']>;
  OccupancyExpense?: Maybe<Scalars['Float']>;
  OfficeExpense?: Maybe<Scalars['Float']>;
  OfficerCompensation?: Maybe<Scalars['Float']>;
  Organization?: Maybe<Scalars['Int']>;
  OtherAssets?: Maybe<Scalars['Float']>;
  OtherEmployeeBenefits?: Maybe<Scalars['Float']>;
  OtherFees?: Maybe<Scalars['Float']>;
  OtherLiabilities?: Maybe<Scalars['Float']>;
  OtherSalaries?: Maybe<Scalars['Float']>;
  OtherSecuritiesAssetValue?: Maybe<Scalars['Float']>;
  PaidInCapitalSurplus?: Maybe<Scalars['Float']>;
  PayablesToOfficers?: Maybe<Scalars['Float']>;
  PayrollTaxes?: Maybe<Scalars['Float']>;
  PensionContributions?: Maybe<Scalars['Float']>;
  PermanentlyRestrictedNetAssets?: Maybe<Scalars['Float']>;
  PledgesGrantsReceivable?: Maybe<Scalars['Float']>;
  PoliticalActivities?: Maybe<Scalars['String']>;
  PrepaidExpenseAssetValue?: Maybe<Scalars['Float']>;
  ProfessionalFundraisingFees?: Maybe<Scalars['Float']>;
  ProgramInvestmentsAssetValue?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueA?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueB?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueC?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueCodeA?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeB?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeC?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeD?: Maybe<Scalars['String']>;
  ProgramServiceRevenueCodeE?: Maybe<Scalars['String']>;
  ProgramServiceRevenueD?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueE?: Maybe<Scalars['Float']>;
  ProgramServiceRevenueNameA?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameB?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameC?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameD?: Maybe<Scalars['String']>;
  ProgramServiceRevenueNameE?: Maybe<Scalars['String']>;
  PublicSecuritiesAssetValue?: Maybe<Scalars['Float']>;
  RealEstateAssetValue?: Maybe<Scalars['Float']>;
  ReceivablesFromDisqualifiedPersons?: Maybe<Scalars['Float']>;
  ReceivablesFromOfficers?: Maybe<Scalars['Float']>;
  RentalExpenseRealEstate?: Maybe<Scalars['Float']>;
  RetainedEarnings?: Maybe<Scalars['Float']>;
  RoyaltyExpense?: Maybe<Scalars['Float']>;
  Ruling?: Maybe<Scalars['Int']>;
  Savings?: Maybe<Scalars['Float']>;
  SortName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['Int']>;
  Street?: Maybe<Scalars['String']>;
  Subsection?: Maybe<Scalars['Int']>;
  TaxExemptBondLiability?: Maybe<Scalars['Float']>;
  TaxMonth?: Maybe<Scalars['Int']>;
  TaxPeriod?: Maybe<Scalars['String']>;
  TaxYear: Scalars['Int'];
  TemporarilyRestrictedNetAssets?: Maybe<Scalars['Float']>;
  TotalAssets?: Maybe<Scalars['Float']>;
  TotalGrossReceipts?: Maybe<Scalars['Float']>;
  TotalInvestmentIncome?: Maybe<Scalars['Float']>;
  TotalLiabilities?: Maybe<Scalars['Float']>;
  TotalMemberIncome?: Maybe<Scalars['Float']>;
  TotalNetAssets?: Maybe<Scalars['Float']>;
  TotalNetAssetsPlusLiabilities?: Maybe<Scalars['Float']>;
  TotalProgramServiceRevenue?: Maybe<Scalars['Float']>;
  TotalRevenue?: Maybe<Scalars['Float']>;
  TravelExpense?: Maybe<Scalars['Float']>;
  TravelExpensePublicOfficials?: Maybe<Scalars['Float']>;
  UnrestrictedNetAssets?: Maybe<Scalars['Float']>;
  UnsecuredNotesPayable?: Maybe<Scalars['Float']>;
  Zip?: Maybe<Scalars['String']>;
};

export type EntitiesProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type EntitiesProviderQuery = { __typename?: 'Query', AllEntities: Array<{ __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string, EntityFields: Array<{ __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string }>, EntityRelationships: Array<{ __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string }> }>, AllApplications: Array<{ __typename?: 'Application', ID: number, Name: string, Description?: string, CreatedAt: number, UpdatedAt: number, ApplicationEntities: Array<{ __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string }> }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', CurrentUser: { __typename?: 'User', ID: number, Name: string, Type: string, EmployeeID?: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Email: string, Supervisor?: string, SupervisorEmail?: string } };

export type UserQueryVariables = Exact<{
  UserID: Scalars['Int'];
}>;


export type UserQuery = { __typename?: 'Query', UserFavoritesByUserID: Array<{ __typename?: 'UserFavorite', ID: number, UserID: number, EntityID: number, RecordID: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string }>, UserViewsByUserID: Array<{ __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string }> };

export type AccountScalarsFragment = { __typename?: 'Account', ID: number, BCMID: string, Name: string, TaxID?: string, Acronym?: string, OperatingName?: string, DisplayName?: string, Description?: string, AddressLine1?: string, AddressLine2?: string, AddressLine3?: string, City?: string, StateProvince?: string, PostalCode?: string, Country?: string, ISOCountryCode?: string, Domain?: string, Website?: string, LogoURL?: string, LeadershipPageURL?: string, PhoneNumber?: string, LinkedIn?: string, Facebook?: string, Logo?: string, LastReviewedDate?: number, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, Latest990ID?: number, Subsection?: number, TaxYear?: number, TaxMonth?: number, TotalRevenue?: number, ManagementFees?: number, AccountingFees?: number, LegalFees?: number, AdvertisingExpense?: number, InformationTechnologyExpense?: number, TotalAssets?: number, NumberEmployees?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueB?: number, ProgramServiceRevenueC?: number, ProgramServiceRevenueD?: number, ProgramServiceRevenueE?: number };

export type SingleAccountQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAccountQuery = { __typename?: 'Query', Account?: { __typename?: 'Account', ID: number, BCMID: string, Name: string, TaxID?: string, Acronym?: string, OperatingName?: string, DisplayName?: string, Description?: string, AddressLine1?: string, AddressLine2?: string, AddressLine3?: string, City?: string, StateProvince?: string, PostalCode?: string, Country?: string, ISOCountryCode?: string, Domain?: string, Website?: string, LogoURL?: string, LeadershipPageURL?: string, PhoneNumber?: string, LinkedIn?: string, Facebook?: string, Logo?: string, LastReviewedDate?: number, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, Latest990ID?: number, Subsection?: number, TaxYear?: number, TaxMonth?: number, TotalRevenue?: number, ManagementFees?: number, AccountingFees?: number, LegalFees?: number, AdvertisingExpense?: number, InformationTechnologyExpense?: number, TotalAssets?: number, NumberEmployees?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueB?: number, ProgramServiceRevenueC?: number, ProgramServiceRevenueD?: number, ProgramServiceRevenueE?: number } };

export type SingleAccountFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAccountFullQuery = { __typename?: 'Query', Account?: { __typename?: 'Account', ID: number, BCMID: string, Name: string, TaxID?: string, Acronym?: string, OperatingName?: string, DisplayName?: string, Description?: string, AddressLine1?: string, AddressLine2?: string, AddressLine3?: string, City?: string, StateProvince?: string, PostalCode?: string, Country?: string, ISOCountryCode?: string, Domain?: string, Website?: string, LogoURL?: string, LeadershipPageURL?: string, PhoneNumber?: string, LinkedIn?: string, Facebook?: string, Logo?: string, LastReviewedDate?: number, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, Latest990ID?: number, Subsection?: number, TaxYear?: number, TaxMonth?: number, TotalRevenue?: number, ManagementFees?: number, AccountingFees?: number, LegalFees?: number, AdvertisingExpense?: number, InformationTechnologyExpense?: number, TotalAssets?: number, NumberEmployees?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueB?: number, ProgramServiceRevenueC?: number, ProgramServiceRevenueD?: number, ProgramServiceRevenueE?: number, Contacts: Array<{ __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string }>, Deals: Array<{ __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string }>, Activities: Array<{ __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number }>, Companies: Array<{ __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string }>, Invoices: Array<{ __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number }>, _990Full: Array<{ __typename?: '_990Full', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number }>, AccountCompanyIntegrations: Array<{ __typename?: 'AccountCompanyIntegration', ID: number, AccountID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, AccountTypeID?: number, CompanyID: number, CompanyName: string, Account: string, AccountType: string }> } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', CreateAccount: { __typename?: 'Account', ID: number, BCMID: string, Name: string, TaxID?: string, Acronym?: string, OperatingName?: string, DisplayName?: string, Description?: string, AddressLine1?: string, AddressLine2?: string, AddressLine3?: string, City?: string, StateProvince?: string, PostalCode?: string, Country?: string, ISOCountryCode?: string, Domain?: string, Website?: string, LogoURL?: string, LeadershipPageURL?: string, PhoneNumber?: string, LinkedIn?: string, Facebook?: string, Logo?: string, LastReviewedDate?: number, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, Latest990ID?: number, Subsection?: number, TaxYear?: number, TaxMonth?: number, TotalRevenue?: number, ManagementFees?: number, AccountingFees?: number, LegalFees?: number, AdvertisingExpense?: number, InformationTechnologyExpense?: number, TotalAssets?: number, NumberEmployees?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueB?: number, ProgramServiceRevenueC?: number, ProgramServiceRevenueD?: number, ProgramServiceRevenueE?: number } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', UpdateAccount: { __typename?: 'Account', ID: number, BCMID: string, Name: string, TaxID?: string, Acronym?: string, OperatingName?: string, DisplayName?: string, Description?: string, AddressLine1?: string, AddressLine2?: string, AddressLine3?: string, City?: string, StateProvince?: string, PostalCode?: string, Country?: string, ISOCountryCode?: string, Domain?: string, Website?: string, LogoURL?: string, LeadershipPageURL?: string, PhoneNumber?: string, LinkedIn?: string, Facebook?: string, Logo?: string, LastReviewedDate?: number, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, Latest990ID?: number, Subsection?: number, TaxYear?: number, TaxMonth?: number, TotalRevenue?: number, ManagementFees?: number, AccountingFees?: number, LegalFees?: number, AdvertisingExpense?: number, InformationTechnologyExpense?: number, TotalAssets?: number, NumberEmployees?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueB?: number, ProgramServiceRevenueC?: number, ProgramServiceRevenueD?: number, ProgramServiceRevenueE?: number } };

export type DeleteAccountMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', DeleteAccount: number };

export type ContactScalarsFragment = { __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string };

export type SingleContactQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactQuery = { __typename?: 'Query', Contact?: { __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string } };

export type SingleContactFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactFullQuery = { __typename?: 'Query', Contact?: { __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string, ContactEmails: Array<{ __typename?: 'ContactEmail', ID: number, ContactID: number, Email: string, AccountID?: number, IsActive: boolean, EmailDomain?: string, Contact?: string, Account?: string }>, ContactAccounts: Array<{ __typename?: 'ContactAccount', ID: number, ContactID: number, AccountID: number, Sequence: number, StartedAt: number, EndedAt?: number, IsPrimary: boolean, Contact?: string, Account: string }>, Invoices: Array<{ __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number }>, ContactTopics: Array<{ __typename?: 'ContactTopic', ID: number, ContactID: number, Topic: string, TotalCount: number, EarliestDate: number, LatestDate: number, Contact?: string, Account?: string, Domain?: string, Website?: string }>, Companies: Array<{ __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string }>, Deals: Array<{ __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string }>, Activities: Array<{ __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number }> } };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', CreateContact: { __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', UpdateContact: { __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string } };

export type DeleteContactMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', DeleteContact: number };

export type DealScalarsFragment = { __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string };

export type SingleDealQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleDealQuery = { __typename?: 'Query', Deal?: { __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string } };

export type SingleDealFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleDealFullQuery = { __typename?: 'Query', Deal?: { __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string, Activities: Array<{ __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number }> } };

export type AllDealsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDealsQuery = { __typename?: 'Query', AllDeals: Array<{ __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string }> };

export type CreateDealMutationVariables = Exact<{
  input: CreateDealInput;
}>;


export type CreateDealMutation = { __typename?: 'Mutation', CreateDeal: { __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string } };

export type UpdateDealMutationVariables = Exact<{
  input: UpdateDealInput;
}>;


export type UpdateDealMutation = { __typename?: 'Mutation', UpdateDeal: { __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string } };

export type DeleteDealMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteDealMutation = { __typename?: 'Mutation', DeleteDeal: number };

export type ActivityScalarsFragment = { __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number };

export type SingleActivityQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleActivityQuery = { __typename?: 'Query', Activity?: { __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number } };

export type SingleActivityFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleActivityFullQuery = { __typename?: 'Query', Activity?: { __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number } };

export type UpdateActivityMutationVariables = Exact<{
  input: UpdateActivityInput;
}>;


export type UpdateActivityMutation = { __typename?: 'Mutation', UpdateActivity: { __typename?: 'Activity', ID: number, BCMID: string, EmployeeID?: number, ContactID?: number, AccountID?: number, DealID?: number, ActivityDate?: number, IsActive?: boolean, Description?: string, Summary?: string, Type?: string, Attachment?: string, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, AttachmentID?: number, Title?: string, IsOpened?: boolean, IsBounced?: boolean, IsReplied?: boolean, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeEmail?: string, EmployeeSupervisor?: number, EmployeeSupervisorFirstName?: string, EmployeeSupervisorLastName?: string, EmployeeSupervisorEmail?: string, Account?: string, AccountWebsite?: string, ContactFirstName?: string, ContactLastName?: string, ContactEmail?: string, Deal?: string, Integration: string, Company: string, CompanyID: number } };

export type CompanyScalarsFragment = { __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string };

export type SingleCompanyQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCompanyQuery = { __typename?: 'Query', Company?: { __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string } };

export type SingleCompanyFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCompanyFullQuery = { __typename?: 'Query', Company?: { __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string, Employees: Array<{ __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string }>, AccountCompanyIntegrations: Array<{ __typename?: 'AccountCompanyIntegration', ID: number, AccountID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, AccountTypeID?: number, CompanyID: number, CompanyName: string, Account: string, AccountType: string }>, Accounts: Array<{ __typename?: 'Account', ID: number, BCMID: string, Name: string, TaxID?: string, Acronym?: string, OperatingName?: string, DisplayName?: string, Description?: string, AddressLine1?: string, AddressLine2?: string, AddressLine3?: string, City?: string, StateProvince?: string, PostalCode?: string, Country?: string, ISOCountryCode?: string, Domain?: string, Website?: string, LogoURL?: string, LeadershipPageURL?: string, PhoneNumber?: string, LinkedIn?: string, Facebook?: string, Logo?: string, LastReviewedDate?: number, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, Latest990ID?: number, Subsection?: number, TaxYear?: number, TaxMonth?: number, TotalRevenue?: number, ManagementFees?: number, AccountingFees?: number, LegalFees?: number, AdvertisingExpense?: number, InformationTechnologyExpense?: number, TotalAssets?: number, NumberEmployees?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueB?: number, ProgramServiceRevenueC?: number, ProgramServiceRevenueD?: number, ProgramServiceRevenueE?: number }>, Contacts: Array<{ __typename?: 'Contact', ID: number, BCMID: string, FirstName: string, NickName?: string, LastName: string, AccountID?: number, LastReviewedDate?: number, Title?: string, RoleID?: number, LevelID?: number, Email1?: string, Email2?: string, EmailSource?: string, PhoneNumber?: string, ProfilePictureURL?: string, Twitter?: string, Instagram?: string, LinkedIn?: string, Facebook?: string, EmailStatus?: string, Prefix?: string, Suffix?: string, Tags?: string, Status?: string, ActivityCount: number, LatestActivityDate?: number, EarliestActivityDate?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, EmailDomain?: string, Account?: string, Domain?: string, Website?: string, Role?: string, Level?: string }>, Deals: Array<{ __typename?: 'Deal', ID: number, BCMID: string, ExternalSystemRecordID: string, CompanyIntegrationID: number, AccountID?: number, ContactID?: number, Title?: string, Description?: string, Value?: number, IncludeInForecast?: boolean, Probability?: number, CloseDate?: number, EmployeeID?: number, Pipeline?: string, LeadSource?: string, LeadSourceDetail?: string, ExternalSystemCreatedAt?: number, ExternalSystemUpdatedAt?: number, DealTypeID?: number, DealStageID?: number, CreatedAt: number, UpdatedAt: number, DealForecastCategoryID?: number, MRR: number, OneTimeFees: number, ContractTermMonths: number, ForecastNotes?: string, CompanyID: number, Company: string, CompanyLogoURL?: string, Account?: string, ContactFirstName?: string, ContactLastName?: string, ContactTitle?: string, ContactEmail1?: string, ContactPhoneNumber?: string, EmployeeEmail?: string, EmployeeFirstName?: string, EmployeeLastName?: string, EmployeeTitle?: string, EmployeeSupervisorEmail?: string, EmployeeSupervisor?: string }>, Invoices: Array<{ __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number }> } };

export type AllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCompaniesQuery = { __typename?: 'Query', AllCompanies: Array<{ __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string }> };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', CreateCompany: { __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string } };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', UpdateCompany: { __typename?: 'Company', ID: number, Name: string, Description: string, Website?: string, LogoURL?: string, CreatedAt: number, UpdatedAt: number, Domain?: string } };

export type DeleteCompanyMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', DeleteCompany: number };

export type EmployeeScalarsFragment = { __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string };

export type SingleEmployeeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEmployeeQuery = { __typename?: 'Query', Employee?: { __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string } };

export type SingleEmployeeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEmployeeFullQuery = { __typename?: 'Query', Employee?: { __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string, Employees: Array<{ __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string }> } };

export type AllEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEmployeesQuery = { __typename?: 'Query', AllEmployees: Array<{ __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string }> };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', CreateEmployee: { __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string } };

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', UpdateEmployee: { __typename?: 'Employee', ID: number, BCMID: string, FirstName: string, LastName: string, Title?: string, Email: string, Phone?: string, Active: boolean, CompanyID: number, SupervisorID?: number, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Supervisor?: string, SupervisorFirstName?: string, SupervisorLastName?: string, SupervisorEmail?: string } };

export type DeleteEmployeeMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', DeleteEmployee: number };

export type UserFavoriteScalarsFragment = { __typename?: 'UserFavorite', ID: number, UserID: number, EntityID: number, RecordID: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string };

export type SingleUserFavoriteQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserFavoriteQuery = { __typename?: 'Query', UserFavorite?: { __typename?: 'UserFavorite', ID: number, UserID: number, EntityID: number, RecordID: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string } };

export type SingleUserFavoriteFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserFavoriteFullQuery = { __typename?: 'Query', UserFavorite?: { __typename?: 'UserFavorite', ID: number, UserID: number, EntityID: number, RecordID: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string } };

export type CreateUserFavoriteMutationVariables = Exact<{
  input: CreateUserFavoriteInput;
}>;


export type CreateUserFavoriteMutation = { __typename?: 'Mutation', CreateUserFavorite: { __typename?: 'UserFavorite', ID: number, UserID: number, EntityID: number, RecordID: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string } };

export type UpdateUserFavoriteMutationVariables = Exact<{
  input: UpdateUserFavoriteInput;
}>;


export type UpdateUserFavoriteMutation = { __typename?: 'Mutation', UpdateUserFavorite: { __typename?: 'UserFavorite', ID: number, UserID: number, EntityID: number, RecordID: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string } };

export type DeleteUserFavoriteMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteUserFavoriteMutation = { __typename?: 'Mutation', DeleteUserFavorite: number };

export type AccountCompanyIntegrationScalarsFragment = { __typename?: 'AccountCompanyIntegration', ID: number, AccountID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, AccountTypeID?: number, CompanyID: number, CompanyName: string, Account: string, AccountType: string };

export type SingleAccountCompanyIntegrationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAccountCompanyIntegrationQuery = { __typename?: 'Query', AccountCompanyIntegration?: { __typename?: 'AccountCompanyIntegration', ID: number, AccountID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, AccountTypeID?: number, CompanyID: number, CompanyName: string, Account: string, AccountType: string } };

export type SingleAccountCompanyIntegrationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAccountCompanyIntegrationFullQuery = { __typename?: 'Query', AccountCompanyIntegration?: { __typename?: 'AccountCompanyIntegration', ID: number, AccountID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, AccountTypeID?: number, CompanyID: number, CompanyName: string, Account: string, AccountType: string } };

export type UpdateAccountCompanyIntegrationMutationVariables = Exact<{
  input: UpdateAccountCompanyIntegrationInput;
}>;


export type UpdateAccountCompanyIntegrationMutation = { __typename?: 'Mutation', UpdateAccountCompanyIntegration: { __typename?: 'AccountCompanyIntegration', ID: number, AccountID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, AccountTypeID?: number, CompanyID: number, CompanyName: string, Account: string, AccountType: string } };

export type ContactCompanyIntegrationScalarsFragment = { __typename?: 'ContactCompanyIntegration', ID: number, ContactID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, CompanyID: number, CompanyName: string };

export type SingleContactCompanyIntegrationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactCompanyIntegrationQuery = { __typename?: 'Query', ContactCompanyIntegration?: { __typename?: 'ContactCompanyIntegration', ID: number, ContactID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, CompanyID: number, CompanyName: string } };

export type SingleContactCompanyIntegrationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactCompanyIntegrationFullQuery = { __typename?: 'Query', ContactCompanyIntegration?: { __typename?: 'ContactCompanyIntegration', ID: number, ContactID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, CompanyID: number, CompanyName: string } };

export type UpdateContactCompanyIntegrationMutationVariables = Exact<{
  input: UpdateContactCompanyIntegrationInput;
}>;


export type UpdateContactCompanyIntegrationMutation = { __typename?: 'Mutation', UpdateContactCompanyIntegration: { __typename?: 'ContactCompanyIntegration', ID: number, ContactID: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, CompanyID: number, CompanyName: string } };

export type ActivityAttachmentScalarsFragment = { __typename?: 'ActivityAttachment', ID: number, Attachments?: string, CreatedAt: number, UpdatedAt: number };

export type SingleActivityAttachmentQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleActivityAttachmentQuery = { __typename?: 'Query', ActivityAttachment?: { __typename?: 'ActivityAttachment', ID: number, Attachments?: string, CreatedAt: number, UpdatedAt: number } };

export type SingleActivityAttachmentFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleActivityAttachmentFullQuery = { __typename?: 'Query', ActivityAttachment?: { __typename?: 'ActivityAttachment', ID: number, Attachments?: string, CreatedAt: number, UpdatedAt: number } };

export type UpdateActivityAttachmentMutationVariables = Exact<{
  input: UpdateActivityAttachmentInput;
}>;


export type UpdateActivityAttachmentMutation = { __typename?: 'Mutation', UpdateActivityAttachment: { __typename?: 'ActivityAttachment', ID: number, Attachments?: string, CreatedAt: number, UpdatedAt: number } };

export type ProjectScalarsFragment = { __typename?: 'Project', ID: number, Name: string, ExternalSystemRecordID?: string, StartDate?: number, DueDate?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, FixedFee?: number, ProjectRate?: number, CompanyIntegrationID?: number, EmployeeID?: number, AccountID?: number, BillingTypeID?: number, RateTypeID?: number, StatusID?: number, BudgetAmount?: number, Employee?: string, BillingType?: string, RateType?: string, Status?: string };

export type SingleProjectQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', ID: number, Name: string, ExternalSystemRecordID?: string, StartDate?: number, DueDate?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, FixedFee?: number, ProjectRate?: number, CompanyIntegrationID?: number, EmployeeID?: number, AccountID?: number, BillingTypeID?: number, RateTypeID?: number, StatusID?: number, BudgetAmount?: number, Employee?: string, BillingType?: string, RateType?: string, Status?: string } };

export type SingleProjectFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectFullQuery = { __typename?: 'Query', Project?: { __typename?: 'Project', ID: number, Name: string, ExternalSystemRecordID?: string, StartDate?: number, DueDate?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, FixedFee?: number, ProjectRate?: number, CompanyIntegrationID?: number, EmployeeID?: number, AccountID?: number, BillingTypeID?: number, RateTypeID?: number, StatusID?: number, BudgetAmount?: number, Employee?: string, BillingType?: string, RateType?: string, Status?: string } };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', UpdateProject: { __typename?: 'Project', ID: number, Name: string, ExternalSystemRecordID?: string, StartDate?: number, DueDate?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, FixedFee?: number, ProjectRate?: number, CompanyIntegrationID?: number, EmployeeID?: number, AccountID?: number, BillingTypeID?: number, RateTypeID?: number, StatusID?: number, BudgetAmount?: number, Employee?: string, BillingType?: string, RateType?: string, Status?: string } };

export type RoleScalarsFragment = { __typename?: 'Role', ID: number, Name: string, Description?: string, AzureID?: string, SQLName: string, CreatedAt: number, UpdatedAt: number };

export type SingleRoleQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleRoleQuery = { __typename?: 'Query', Role?: { __typename?: 'Role', ID: number, Name: string, Description?: string, AzureID?: string, SQLName: string, CreatedAt: number, UpdatedAt: number } };

export type SingleRoleFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleRoleFullQuery = { __typename?: 'Query', Role?: { __typename?: 'Role', ID: number, Name: string, Description?: string, AzureID?: string, SQLName: string, CreatedAt: number, UpdatedAt: number } };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'Query', AllRoles: Array<{ __typename?: 'Role', ID: number, Name: string, Description?: string, AzureID?: string, SQLName: string, CreatedAt: number, UpdatedAt: number }> };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', UpdateRole: { __typename?: 'Role', ID: number, Name: string, Description?: string, AzureID?: string, SQLName: string, CreatedAt: number, UpdatedAt: number } };

export type SkillScalarsFragment = { __typename?: 'Skill', ID: number, Name: string, ParentID: string, CreatedAt: number, UpdatedAt: number };

export type SingleSkillQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleSkillQuery = { __typename?: 'Query', Skill?: { __typename?: 'Skill', ID: number, Name: string, ParentID: string, CreatedAt: number, UpdatedAt: number } };

export type SingleSkillFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleSkillFullQuery = { __typename?: 'Query', Skill?: { __typename?: 'Skill', ID: number, Name: string, ParentID: string, CreatedAt: number, UpdatedAt: number } };

export type AllSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSkillsQuery = { __typename?: 'Query', AllSkills: Array<{ __typename?: 'Skill', ID: number, Name: string, ParentID: string, CreatedAt: number, UpdatedAt: number }> };

export type TaskScalarsFragment = { __typename?: 'Task', ID: number, ExternalSystemRecordID?: string, Name?: string, ParentID?: number, AssignedEmployeeID?: number, Role?: string, Skills?: string, BudgetedEffort?: number, ActualEffort?: number, EstimateToComplete?: number, StartDate?: number, EndDate?: number, IsCompleted?: boolean, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, ProjectID?: number, Section?: string, Status?: string, ForecastedEffort?: number, ForecastedVariance?: number, ActualVariance?: number, CalculatedActual?: number, TaskTypeID?: number, Parent?: string, AssignedEmployee?: string, Project?: string };

export type SingleTaskQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaskQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', ID: number, ExternalSystemRecordID?: string, Name?: string, ParentID?: number, AssignedEmployeeID?: number, Role?: string, Skills?: string, BudgetedEffort?: number, ActualEffort?: number, EstimateToComplete?: number, StartDate?: number, EndDate?: number, IsCompleted?: boolean, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, ProjectID?: number, Section?: string, Status?: string, ForecastedEffort?: number, ForecastedVariance?: number, ActualVariance?: number, CalculatedActual?: number, TaskTypeID?: number, Parent?: string, AssignedEmployee?: string, Project?: string } };

export type SingleTaskFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaskFullQuery = { __typename?: 'Query', Task?: { __typename?: 'Task', ID: number, ExternalSystemRecordID?: string, Name?: string, ParentID?: number, AssignedEmployeeID?: number, Role?: string, Skills?: string, BudgetedEffort?: number, ActualEffort?: number, EstimateToComplete?: number, StartDate?: number, EndDate?: number, IsCompleted?: boolean, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, ProjectID?: number, Section?: string, Status?: string, ForecastedEffort?: number, ForecastedVariance?: number, ActualVariance?: number, CalculatedActual?: number, TaskTypeID?: number, Parent?: string, AssignedEmployee?: string, Project?: string } };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', UpdateTask: { __typename?: 'Task', ID: number, ExternalSystemRecordID?: string, Name?: string, ParentID?: number, AssignedEmployeeID?: number, Role?: string, Skills?: string, BudgetedEffort?: number, ActualEffort?: number, EstimateToComplete?: number, StartDate?: number, EndDate?: number, IsCompleted?: boolean, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, ProjectID?: number, Section?: string, Status?: string, ForecastedEffort?: number, ForecastedVariance?: number, ActualVariance?: number, CalculatedActual?: number, TaskTypeID?: number, Parent?: string, AssignedEmployee?: string, Project?: string } };

export type TaskTypeScalarsFragment = { __typename?: 'TaskType', ID: number, Name: string, ParentID?: string, CreatedAt: number, UpdatedAt: number, IsActive: boolean };

export type SingleTaskTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaskTypeQuery = { __typename?: 'Query', TaskType?: { __typename?: 'TaskType', ID: number, Name: string, ParentID?: string, CreatedAt: number, UpdatedAt: number, IsActive: boolean } };

export type SingleTaskTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaskTypeFullQuery = { __typename?: 'Query', TaskType?: { __typename?: 'TaskType', ID: number, Name: string, ParentID?: string, CreatedAt: number, UpdatedAt: number, IsActive: boolean } };

export type AllTaskTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTaskTypesQuery = { __typename?: 'Query', AllTaskTypes: Array<{ __typename?: 'TaskType', ID: number, Name: string, ParentID?: string, CreatedAt: number, UpdatedAt: number, IsActive: boolean }> };

export type UpdateTaskTypeMutationVariables = Exact<{
  input: UpdateTaskTypeInput;
}>;


export type UpdateTaskTypeMutation = { __typename?: 'Mutation', UpdateTaskType: { __typename?: 'TaskType', ID: number, Name: string, ParentID?: string, CreatedAt: number, UpdatedAt: number, IsActive: boolean } };

export type IntegrationURLFormatScalarsFragment = { __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string };

export type SingleIntegrationURLFormatQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleIntegrationURLFormatQuery = { __typename?: 'Query', IntegrationURLFormat?: { __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string } };

export type SingleIntegrationURLFormatFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleIntegrationURLFormatFullQuery = { __typename?: 'Query', IntegrationURLFormat?: { __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string } };

export type AllIntegrationURLFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllIntegrationURLFormatsQuery = { __typename?: 'Query', AllIntegrationURLFormats: Array<{ __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string }> };

export type UpdateIntegrationURLFormatMutationVariables = Exact<{
  input: UpdateIntegrationURLFormatInput;
}>;


export type UpdateIntegrationURLFormatMutation = { __typename?: 'Mutation', UpdateIntegrationURLFormat: { __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string } };

export type IntegrationScalarsFragment = { __typename?: 'Integration', ID: number, Name: string, Description?: string, NavigationBaseURL?: string, ClassName?: string, ImportPath?: string, BatchMaxRequestCount: number, BatchRequestWaitTime: number, CreatedAt: number, UpdatedAt: number };

export type SingleIntegrationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleIntegrationQuery = { __typename?: 'Query', Integration?: { __typename?: 'Integration', ID: number, Name: string, Description?: string, NavigationBaseURL?: string, ClassName?: string, ImportPath?: string, BatchMaxRequestCount: number, BatchRequestWaitTime: number, CreatedAt: number, UpdatedAt: number } };

export type SingleIntegrationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleIntegrationFullQuery = { __typename?: 'Query', Integration?: { __typename?: 'Integration', ID: number, Name: string, Description?: string, NavigationBaseURL?: string, ClassName?: string, ImportPath?: string, BatchMaxRequestCount: number, BatchRequestWaitTime: number, CreatedAt: number, UpdatedAt: number, IntegrationURLFormats: Array<{ __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string }> } };

export type AllIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllIntegrationsQuery = { __typename?: 'Query', AllIntegrations: Array<{ __typename?: 'Integration', ID: number, Name: string, Description?: string, NavigationBaseURL?: string, ClassName?: string, ImportPath?: string, BatchMaxRequestCount: number, BatchRequestWaitTime: number, CreatedAt: number, UpdatedAt: number, IntegrationURLFormats: Array<{ __typename?: 'IntegrationURLFormat', ID: number, IntegrationID: number, EntityID: number, URLFormat: string, NavigationBaseURL?: string, FullURLFormat?: string }> }> };

export type UpdateIntegrationMutationVariables = Exact<{
  input: UpdateIntegrationInput;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', UpdateIntegration: { __typename?: 'Integration', ID: number, Name: string, Description?: string, NavigationBaseURL?: string, ClassName?: string, ImportPath?: string, BatchMaxRequestCount: number, BatchRequestWaitTime: number, CreatedAt: number, UpdatedAt: number } };

export type CompanyIntegrationScalarsFragment = { __typename?: 'CompanyIntegration', ID: number, CompanyID: number, IntegrationID: number, IsActive?: boolean, AccessToken?: string, RefreshToken?: string, TokenExpirationDate?: number, APIKey?: string, CreatedAt: number, UpdatedAt: number, ExternalSystemID?: string, IsExternalSystemReadOnly: boolean, ClientID?: string, ClientSecret?: string, CustomAttribute1?: string, Company: string, Integration: string, DriverClassName?: string, DriverImportPath?: string, LastRunID?: number, LastRunStartedAt?: number, LastRunEndedAt?: number };

export type SingleCompanyIntegrationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCompanyIntegrationQuery = { __typename?: 'Query', CompanyIntegration?: { __typename?: 'CompanyIntegration', ID: number, CompanyID: number, IntegrationID: number, IsActive?: boolean, AccessToken?: string, RefreshToken?: string, TokenExpirationDate?: number, APIKey?: string, CreatedAt: number, UpdatedAt: number, ExternalSystemID?: string, IsExternalSystemReadOnly: boolean, ClientID?: string, ClientSecret?: string, CustomAttribute1?: string, Company: string, Integration: string, DriverClassName?: string, DriverImportPath?: string, LastRunID?: number, LastRunStartedAt?: number, LastRunEndedAt?: number } };

export type SingleCompanyIntegrationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCompanyIntegrationFullQuery = { __typename?: 'Query', CompanyIntegration?: { __typename?: 'CompanyIntegration', ID: number, CompanyID: number, IntegrationID: number, IsActive?: boolean, AccessToken?: string, RefreshToken?: string, TokenExpirationDate?: number, APIKey?: string, CreatedAt: number, UpdatedAt: number, ExternalSystemID?: string, IsExternalSystemReadOnly: boolean, ClientID?: string, ClientSecret?: string, CustomAttribute1?: string, Company: string, Integration: string, DriverClassName?: string, DriverImportPath?: string, LastRunID?: number, LastRunStartedAt?: number, LastRunEndedAt?: number } };

export type UpdateCompanyIntegrationMutationVariables = Exact<{
  input: UpdateCompanyIntegrationInput;
}>;


export type UpdateCompanyIntegrationMutation = { __typename?: 'Mutation', UpdateCompanyIntegration: { __typename?: 'CompanyIntegration', ID: number, CompanyID: number, IntegrationID: number, IsActive?: boolean, AccessToken?: string, RefreshToken?: string, TokenExpirationDate?: number, APIKey?: string, CreatedAt: number, UpdatedAt: number, ExternalSystemID?: string, IsExternalSystemReadOnly: boolean, ClientID?: string, ClientSecret?: string, CustomAttribute1?: string, Company: string, Integration: string, DriverClassName?: string, DriverImportPath?: string, LastRunID?: number, LastRunStartedAt?: number, LastRunEndedAt?: number } };

export type EntityFieldScalarsFragment = { __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string };

export type SingleEntityFieldQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityFieldQuery = { __typename?: 'Query', EntityField?: { __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string } };

export type SingleEntityFieldFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityFieldFullQuery = { __typename?: 'Query', EntityField?: { __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string, EntityFieldValues: Array<{ __typename?: 'EntityFieldValue', ID: number, EntityFieldID: number, Sequence: number, Value: string, Code?: string, Description?: string, CreatedAt: number, UpdatedAt: number, EntityField: string }> } };

export type AllEntityFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEntityFieldsQuery = { __typename?: 'Query', AllEntityFields: Array<{ __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string }> };

export type CreateEntityFieldMutationVariables = Exact<{
  input: CreateEntityFieldInput;
}>;


export type CreateEntityFieldMutation = { __typename?: 'Mutation', CreateEntityField: { __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string } };

export type UpdateEntityFieldMutationVariables = Exact<{
  input: UpdateEntityFieldInput;
}>;


export type UpdateEntityFieldMutation = { __typename?: 'Mutation', UpdateEntityField: { __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string } };

export type DeleteEntityFieldMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteEntityFieldMutation = { __typename?: 'Mutation', DeleteEntityField: number };

export type EntityScalarsFragment = { __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string };

export type SingleEntityQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityQuery = { __typename?: 'Query', Entity?: { __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string } };

export type SingleEntityFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityFullQuery = { __typename?: 'Query', Entity?: { __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string, EntityAIActions: Array<{ __typename?: 'EntityAIAction', ID: number, EntityID: number, AIActionID: number, AIModelID?: number, Prompt?: string, TriggerEvent: string, UserMessage: string, OutputType: string, OutputField?: string, SkipIfOutputFieldNotEmpty: boolean, OutputEntityID?: number, Comments?: string, Entity: string, AIAction: string, AIModel?: string, OutputEntity?: string }>, EntityRelationships: Array<{ __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string }>, EntityPermissions: Array<{ __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string }>, EntityFields: Array<{ __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string }> } };

export type AllEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEntitiesQuery = { __typename?: 'Query', AllEntities: Array<{ __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string, EntityRelationships: Array<{ __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string }>, EntityPermissions: Array<{ __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string }>, EntityFields: Array<{ __typename?: 'EntityField', ID: number, EntityID: number, Sequence: number, Name: string, DisplayName?: string, Description?: string, Category?: string, Type: string, Length?: number, Precision?: number, Scale?: number, AllowsNull: boolean, DefaultValue?: string, AutoIncrement: boolean, ValueListType: string, ExtendedType?: string, DefaultInView: boolean, ViewCellTemplate?: string, DefaultColumnWidth?: number, AllowUpdateAPI: boolean, AllowUpdateInView: boolean, IncludeInUserSearchAPI: boolean, UserSearchParamFormatAPI?: string, IncludeInGeneratedForm: boolean, GeneratedFormSection: string, IsVirtual: boolean, IsNameField: boolean, RelatedEntityID?: number, RelatedEntityFieldName?: string, IncludeRelatedEntityNameFieldInBaseView: boolean, RelatedEntityNameFieldMap?: string, CreatedAt: number, UpdatedAt: number, Entity: string, SchemaName: string, BaseTable: string, BaseView: string, EntityCodeName?: string, EntityClassName: string, RelatedEntity?: string, RelatedEntitySchemaName?: string, RelatedEntityBaseTable?: string, RelatedEntityBaseView?: string, RelatedEntityCodeName?: string, RelatedEntityClassName?: string }> }> };

export type CreateEntityMutationVariables = Exact<{
  input: CreateEntityInput;
}>;


export type CreateEntityMutation = { __typename?: 'Mutation', CreateEntity: { __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string } };

export type UpdateEntityMutationVariables = Exact<{
  input: UpdateEntityInput;
}>;


export type UpdateEntityMutation = { __typename?: 'Mutation', UpdateEntity: { __typename?: 'Entity', ID: number, ParentID?: number, Name: string, Description?: string, BaseTable: string, BaseView: string, BaseViewGenerated: boolean, SchemaName: string, TrackRecordChanges: boolean, AuditRecordAccess: boolean, AuditViewRuns: boolean, IncludeInAPI: boolean, AllowAllRowsAPI: boolean, AllowUpdateAPI: boolean, AllowCreateAPI: boolean, AllowDeleteAPI: boolean, CustomResolverAPI: boolean, AllowUserSearchAPI: boolean, UserViewMaxRows?: number, spCreate?: string, spUpdate?: string, spDelete?: string, spCreateGenerated: boolean, spUpdateGenerated: boolean, spDeleteGenerated: boolean, UserFormGenerated: boolean, UserFormClassName?: string, UserFormImportPath?: string, EntityObjectSubclassName?: string, EntityObjectSubclassImportPath?: string, CreatedAt: number, UpdatedAt: number, CodeName?: string, ClassName: string, BaseTableCodeName: string, ParentEntity?: string, ParentBaseTable?: string, ParentBaseView?: string } };

export type DeleteEntityMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteEntityMutation = { __typename?: 'Mutation', DeleteEntity: number };

export type UserScalarsFragment = { __typename?: 'User', ID: number, Name: string, Type: string, EmployeeID?: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Email: string, Supervisor?: string, SupervisorEmail?: string };

export type SingleUserQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserQuery = { __typename?: 'Query', User?: { __typename?: 'User', ID: number, Name: string, Type: string, EmployeeID?: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Email: string, Supervisor?: string, SupervisorEmail?: string } };

export type SingleUserFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserFullQuery = { __typename?: 'Query', User?: { __typename?: 'User', ID: number, Name: string, Type: string, EmployeeID?: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Email: string, Supervisor?: string, SupervisorEmail?: string, UserApplications: Array<{ __typename?: 'UserApplication', ID: number, UserID: number, ApplicationID: number, Sequence: number, IsActive: boolean, User: string, Application: string }>, UserRoles: Array<{ __typename?: 'UserRole', ID: number, UserID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, User: string, Role: string }> } };

export type AllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUsersQuery = { __typename?: 'Query', AllUsers: Array<{ __typename?: 'User', ID: number, Name: string, Type: string, EmployeeID?: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Email: string, Supervisor?: string, SupervisorEmail?: string, UserRoles: Array<{ __typename?: 'UserRole', ID: number, UserID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, User: string, Role: string }> }> };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', UpdateUser: { __typename?: 'User', ID: number, Name: string, Type: string, EmployeeID?: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, FirstLast?: string, Email: string, Supervisor?: string, SupervisorEmail?: string } };

export type EntityRelationshipScalarsFragment = { __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string };

export type SingleEntityRelationshipQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityRelationshipQuery = { __typename?: 'Query', EntityRelationship?: { __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string } };

export type SingleEntityRelationshipFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityRelationshipFullQuery = { __typename?: 'Query', EntityRelationship?: { __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string } };

export type CreateEntityRelationshipMutationVariables = Exact<{
  input: CreateEntityRelationshipInput;
}>;


export type CreateEntityRelationshipMutation = { __typename?: 'Mutation', CreateEntityRelationship: { __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string } };

export type UpdateEntityRelationshipMutationVariables = Exact<{
  input: UpdateEntityRelationshipInput;
}>;


export type UpdateEntityRelationshipMutation = { __typename?: 'Mutation', UpdateEntityRelationship: { __typename?: 'EntityRelationship', ID: number, EntityID: number, RelatedEntityID: number, BundleInAPI: boolean, IncludeInParentAllQuery: boolean, Type: string, EntityKeyField?: string, RelatedEntityJoinField: string, JoinView?: string, JoinEntityJoinField?: string, JoinEntityInverseJoinField?: string, DisplayInForm: boolean, DisplayName?: string, DisplayUserViewID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, EntityBaseTable: string, EntityBaseView: string, RelatedEntity: string, RelatedEntityBaseTable: string, RelatedEntityBaseView: string, RelatedEntityClassName: string, RelatedEntityCodeName?: string, RelatedEntityBaseTableCodeName: string } };

export type DeleteEntityRelationshipMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteEntityRelationshipMutation = { __typename?: 'Mutation', DeleteEntityRelationship: number };

export type UserRecordLogScalarsFragment = { __typename?: 'UserRecordLog', ID: number, UserID: number, EntityID: number, RecordID: number, EarliestAt: number, LatestAt: number, TotalCount: number, Entity: string, UserName: string, UserFirstLast?: string, UserEmail: string, UserSupervisor?: string, UserSupervisorEmail?: string };

export type SingleUserRecordLogQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserRecordLogQuery = { __typename?: 'Query', UserRecordLog?: { __typename?: 'UserRecordLog', ID: number, UserID: number, EntityID: number, RecordID: number, EarliestAt: number, LatestAt: number, TotalCount: number, Entity: string, UserName: string, UserFirstLast?: string, UserEmail: string, UserSupervisor?: string, UserSupervisorEmail?: string } };

export type SingleUserRecordLogFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserRecordLogFullQuery = { __typename?: 'Query', UserRecordLog?: { __typename?: 'UserRecordLog', ID: number, UserID: number, EntityID: number, RecordID: number, EarliestAt: number, LatestAt: number, TotalCount: number, Entity: string, UserName: string, UserFirstLast?: string, UserEmail: string, UserSupervisor?: string, UserSupervisorEmail?: string } };

export type UpdateUserRecordLogMutationVariables = Exact<{
  input: UpdateUserRecordLogInput;
}>;


export type UpdateUserRecordLogMutation = { __typename?: 'Mutation', UpdateUserRecordLog: { __typename?: 'UserRecordLog', ID: number, UserID: number, EntityID: number, RecordID: number, EarliestAt: number, LatestAt: number, TotalCount: number, Entity: string, UserName: string, UserFirstLast?: string, UserEmail: string, UserSupervisor?: string, UserSupervisorEmail?: string } };

export type UserViewScalarsFragment = { __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string };

export type SingleUserViewQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserViewQuery = { __typename?: 'Query', UserView?: { __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string } };

export type SingleUserViewFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserViewFullQuery = { __typename?: 'Query', UserView?: { __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string } };

export type AllUserViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserViewsQuery = { __typename?: 'Query', AllUserViews: Array<{ __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string }> };

export type CreateUserViewMutationVariables = Exact<{
  input: CreateUserViewInput;
}>;


export type CreateUserViewMutation = { __typename?: 'Mutation', CreateUserView: { __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string } };

export type UpdateUserViewMutationVariables = Exact<{
  input: UpdateUserViewInput;
}>;


export type UpdateUserViewMutation = { __typename?: 'Mutation', UpdateUserView: { __typename?: 'UserView', ID: number, UserID: number, EntityID: number, Name: string, Description?: string, IsShared: boolean, IsDefault: boolean, GridState?: string, FilterState?: string, CustomFilterState: boolean, WhereClause?: string, CustomWhereClause: boolean, CreatedAt?: number, UpdatedAt?: number, UserName: string, UserFirstLast?: string, UserEmail: string, UserType: string, Entity: string, EntityBaseView: string } };

export type DeleteUserViewMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteUserViewMutation = { __typename?: 'Mutation', DeleteUserView: number };

export type ContactTopicScalarsFragment = { __typename?: 'ContactTopic', ID: number, ContactID: number, Topic: string, TotalCount: number, EarliestDate: number, LatestDate: number, Contact?: string, Account?: string, Domain?: string, Website?: string };

export type SingleContactTopicQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactTopicQuery = { __typename?: 'Query', ContactTopic?: { __typename?: 'ContactTopic', ID: number, ContactID: number, Topic: string, TotalCount: number, EarliestDate: number, LatestDate: number, Contact?: string, Account?: string, Domain?: string, Website?: string } };

export type SingleContactTopicFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactTopicFullQuery = { __typename?: 'Query', ContactTopic?: { __typename?: 'ContactTopic', ID: number, ContactID: number, Topic: string, TotalCount: number, EarliestDate: number, LatestDate: number, Contact?: string, Account?: string, Domain?: string, Website?: string } };

export type UpdateContactTopicMutationVariables = Exact<{
  input: UpdateContactTopicInput;
}>;


export type UpdateContactTopicMutation = { __typename?: 'Mutation', UpdateContactTopic: { __typename?: 'ContactTopic', ID: number, ContactID: number, Topic: string, TotalCount: number, EarliestDate: number, LatestDate: number, Contact?: string, Account?: string, Domain?: string, Website?: string } };

export type PaymentScalarsFragment = { __typename?: 'Payment', ID: number, BCMID: string, InvoiceID: number, PaymentDate: number, Amount: number, Description?: string, CompanyIntegrationID: number, ExternalSystemRecordID: string, DocumentNumber?: string, Comments?: string, CreatedAt: number, UpdatedAt: number, AccountID?: number, Company: string, CompanyID: number, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string };

export type SinglePaymentQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SinglePaymentQuery = { __typename?: 'Query', Payment?: { __typename?: 'Payment', ID: number, BCMID: string, InvoiceID: number, PaymentDate: number, Amount: number, Description?: string, CompanyIntegrationID: number, ExternalSystemRecordID: string, DocumentNumber?: string, Comments?: string, CreatedAt: number, UpdatedAt: number, AccountID?: number, Company: string, CompanyID: number, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string } };

export type SinglePaymentFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SinglePaymentFullQuery = { __typename?: 'Query', Payment?: { __typename?: 'Payment', ID: number, BCMID: string, InvoiceID: number, PaymentDate: number, Amount: number, Description?: string, CompanyIntegrationID: number, ExternalSystemRecordID: string, DocumentNumber?: string, Comments?: string, CreatedAt: number, UpdatedAt: number, AccountID?: number, Company: string, CompanyID: number, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string } };

export type UpdatePaymentMutationVariables = Exact<{
  input: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', UpdatePayment: { __typename?: 'Payment', ID: number, BCMID: string, InvoiceID: number, PaymentDate: number, Amount: number, Description?: string, CompanyIntegrationID: number, ExternalSystemRecordID: string, DocumentNumber?: string, Comments?: string, CreatedAt: number, UpdatedAt: number, AccountID?: number, Company: string, CompanyID: number, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string } };

export type InvoiceScalarsFragment = { __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number };

export type SingleInvoiceQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleInvoiceQuery = { __typename?: 'Query', Invoice?: { __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number } };

export type SingleInvoiceFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleInvoiceFullQuery = { __typename?: 'Query', Invoice?: { __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number, Payments: Array<{ __typename?: 'Payment', ID: number, BCMID: string, InvoiceID: number, PaymentDate: number, Amount: number, Description?: string, CompanyIntegrationID: number, ExternalSystemRecordID: string, DocumentNumber?: string, Comments?: string, CreatedAt: number, UpdatedAt: number, AccountID?: number, Company: string, CompanyID: number, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string }> } };

export type UpdateInvoiceMutationVariables = Exact<{
  input: UpdateInvoiceInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', UpdateInvoice: { __typename?: 'Invoice', ID: number, BCMID: string, InvoiceDate: number, AccountID: number, ContactID?: number, SubTotal: number, Tax: number, Total: number, CompanyIntegrationID: number, ExternalSystemRecordID: string, InvoiceNumber: string, PostingDate?: number, DueDate?: number, StatusID: number, PaymentTermsID?: number, CreatedAt: number, UpdatedAt: number, Company: string, Account: string, AccountWebsite?: string, Contact?: string, ContactEmail?: string, CompanyID: number } };

export type EmailServiceProvidersScalarsFragment = { __typename?: 'EmailServiceProviders', ID: number, Domain: string };

export type SingleEmailServiceProvidersQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEmailServiceProvidersQuery = { __typename?: 'Query', EmailServiceProviders?: { __typename?: 'EmailServiceProviders', ID: number, Domain: string } };

export type SingleEmailServiceProvidersFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEmailServiceProvidersFullQuery = { __typename?: 'Query', EmailServiceProviders?: { __typename?: 'EmailServiceProviders', ID: number, Domain: string } };

export type AllEmailServiceProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEmailServiceProvidersQuery = { __typename?: 'Query', AllEmailServiceProviders: Array<{ __typename?: 'EmailServiceProviders', ID: number, Domain: string }> };

export type UpdateEmailServiceProvidersMutationVariables = Exact<{
  input: UpdateEmailServiceProvidersInput;
}>;


export type UpdateEmailServiceProvidersMutation = { __typename?: 'Mutation', UpdateEmailServiceProviders: { __typename?: 'EmailServiceProviders', ID: number, Domain: string } };

export type _990FullScalarsFragment = { __typename?: '_990Full', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number };

export type Single_990FullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type Single_990FullQuery = { __typename?: 'Query', _990Full?: { __typename?: '_990Full', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number } };

export type Single_990FullFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type Single_990FullFullQuery = { __typename?: 'Query', _990Full?: { __typename?: '_990Full', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number } };

export type Update_990FullMutationVariables = Exact<{
  input: Update_990FullInput;
}>;


export type Update_990FullMutation = { __typename?: 'Mutation', Update_990Full: { __typename?: '_990Full', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number } };

export type _990LatestScalarsFragment = { __typename?: '_990Latest', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number };

export type Single_990LatestQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type Single_990LatestQuery = { __typename?: 'Query', _990Latest?: { __typename?: '_990Latest', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number } };

export type Single_990LatestFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type Single_990LatestFullQuery = { __typename?: 'Query', _990Latest?: { __typename?: '_990Latest', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number } };

export type Update_990LatestMutationVariables = Exact<{
  input: Update_990LatestInput;
}>;


export type Update_990LatestMutation = { __typename?: 'Mutation', Update_990Latest: { __typename?: '_990Latest', ID: number, EIN?: string, Name: string, ICO?: string, Street?: string, City?: string, State?: string, Zip?: string, Group?: string, Subsection?: number, Affiliation?: number, Classification?: number, Ruling?: number, Deductibility?: number, Foundation?: number, Activity?: number, Organization?: number, Status?: number, TaxPeriod?: string, TaxYear: number, TaxMonth?: number, AssetCode?: number, IncomeCode?: number, FilingRequirementCode?: number, SortName?: string, PoliticalActivities?: string, LobbyingActivities?: string, FundraisingActivities?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, ProgramServiceRevenueCodeA?: string, ProgramServiceRevenueA?: number, ProgramServiceRevenueCodeB?: string, ProgramServiceRevenueB?: number, ProgramServiceRevenueCodeC?: string, ProgramServiceRevenueC?: number, ProgramServiceRevenueCodeD?: string, ProgramServiceRevenueD?: number, ProgramServiceRevenueCodeE?: string, ProgramServiceRevenueE?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, ProgramServiceRevenueNameA?: string, ProgramServiceRevenueNameB?: string, ProgramServiceRevenueNameC?: string, ProgramServiceRevenueNameD?: string, ProgramServiceRevenueNameE?: string, AccountID?: number } };

export type ContactEmailScalarsFragment = { __typename?: 'ContactEmail', ID: number, ContactID: number, Email: string, AccountID?: number, IsActive: boolean, EmailDomain?: string, Contact?: string, Account?: string };

export type SingleContactEmailQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactEmailQuery = { __typename?: 'Query', ContactEmail?: { __typename?: 'ContactEmail', ID: number, ContactID: number, Email: string, AccountID?: number, IsActive: boolean, EmailDomain?: string, Contact?: string, Account?: string } };

export type SingleContactEmailFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactEmailFullQuery = { __typename?: 'Query', ContactEmail?: { __typename?: 'ContactEmail', ID: number, ContactID: number, Email: string, AccountID?: number, IsActive: boolean, EmailDomain?: string, Contact?: string, Account?: string } };

export type UpdateContactEmailMutationVariables = Exact<{
  input: UpdateContactEmailInput;
}>;


export type UpdateContactEmailMutation = { __typename?: 'Mutation', UpdateContactEmail: { __typename?: 'ContactEmail', ID: number, ContactID: number, Email: string, AccountID?: number, IsActive: boolean, EmailDomain?: string, Contact?: string, Account?: string } };

export type ContactAccountScalarsFragment = { __typename?: 'ContactAccount', ID: number, ContactID: number, AccountID: number, Sequence: number, StartedAt: number, EndedAt?: number, IsPrimary: boolean, Contact?: string, Account: string };

export type SingleContactAccountQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactAccountQuery = { __typename?: 'Query', ContactAccount?: { __typename?: 'ContactAccount', ID: number, ContactID: number, AccountID: number, Sequence: number, StartedAt: number, EndedAt?: number, IsPrimary: boolean, Contact?: string, Account: string } };

export type SingleContactAccountFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactAccountFullQuery = { __typename?: 'Query', ContactAccount?: { __typename?: 'ContactAccount', ID: number, ContactID: number, AccountID: number, Sequence: number, StartedAt: number, EndedAt?: number, IsPrimary: boolean, Contact?: string, Account: string } };

export type UpdateContactAccountMutationVariables = Exact<{
  input: UpdateContactAccountInput;
}>;


export type UpdateContactAccountMutation = { __typename?: 'Mutation', UpdateContactAccount: { __typename?: 'ContactAccount', ID: number, ContactID: number, AccountID: number, Sequence: number, StartedAt: number, EndedAt?: number, IsPrimary: boolean, Contact?: string, Account: string } };

export type LifecycleStageScalarsFragment = { __typename?: 'LifecycleStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number };

export type SingleLifecycleStageQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleLifecycleStageQuery = { __typename?: 'Query', LifecycleStage?: { __typename?: 'LifecycleStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type SingleLifecycleStageFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleLifecycleStageFullQuery = { __typename?: 'Query', LifecycleStage?: { __typename?: 'LifecycleStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type AllLifecycleStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLifecycleStagesQuery = { __typename?: 'Query', AllLifecycleStages: Array<{ __typename?: 'LifecycleStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number }> };

export type UpdateLifecycleStageMutationVariables = Exact<{
  input: UpdateLifecycleStageInput;
}>;


export type UpdateLifecycleStageMutation = { __typename?: 'Mutation', UpdateLifecycleStage: { __typename?: 'LifecycleStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type DealStageScalarsFragment = { __typename?: 'DealStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number };

export type SingleDealStageQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleDealStageQuery = { __typename?: 'Query', DealStage?: { __typename?: 'DealStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type SingleDealStageFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleDealStageFullQuery = { __typename?: 'Query', DealStage?: { __typename?: 'DealStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type AllDealStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDealStagesQuery = { __typename?: 'Query', AllDealStages: Array<{ __typename?: 'DealStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number }> };

export type UpdateDealStageMutationVariables = Exact<{
  input: UpdateDealStageInput;
}>;


export type UpdateDealStageMutation = { __typename?: 'Mutation', UpdateDealStage: { __typename?: 'DealStage', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type AccountTypeScalarsFragment = { __typename?: 'AccountType', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number };

export type SingleAccountTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAccountTypeQuery = { __typename?: 'Query', AccountType?: { __typename?: 'AccountType', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type SingleAccountTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAccountTypeFullQuery = { __typename?: 'Query', AccountType?: { __typename?: 'AccountType', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type AllAccountTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccountTypesQuery = { __typename?: 'Query', AllAccountTypes: Array<{ __typename?: 'AccountType', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number }> };

export type UpdateAccountTypeMutationVariables = Exact<{
  input: UpdateAccountTypeInput;
}>;


export type UpdateAccountTypeMutation = { __typename?: 'Mutation', UpdateAccountType: { __typename?: 'AccountType', ID: number, Name: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type TimeEntryScalarsFragment = { __typename?: 'TimeEntry', ID: number, Date?: number, Effort?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, EmployeeID?: number, TaskID?: number, Comment?: string, ExternalSystemRecordID?: string, IsInvoiced?: boolean, IsLocked?: boolean, Employee?: string, Task?: string };

export type SingleTimeEntryQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTimeEntryQuery = { __typename?: 'Query', TimeEntry?: { __typename?: 'TimeEntry', ID: number, Date?: number, Effort?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, EmployeeID?: number, TaskID?: number, Comment?: string, ExternalSystemRecordID?: string, IsInvoiced?: boolean, IsLocked?: boolean, Employee?: string, Task?: string } };

export type SingleTimeEntryFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTimeEntryFullQuery = { __typename?: 'Query', TimeEntry?: { __typename?: 'TimeEntry', ID: number, Date?: number, Effort?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, EmployeeID?: number, TaskID?: number, Comment?: string, ExternalSystemRecordID?: string, IsInvoiced?: boolean, IsLocked?: boolean, Employee?: string, Task?: string } };

export type UpdateTimeEntryMutationVariables = Exact<{
  input: UpdateTimeEntryInput;
}>;


export type UpdateTimeEntryMutation = { __typename?: 'Mutation', UpdateTimeEntry: { __typename?: 'TimeEntry', ID: number, Date?: number, Effort?: number, IsDeleted?: boolean, CreatedAt: number, UpdatedAt: number, EmployeeID?: number, TaskID?: number, Comment?: string, ExternalSystemRecordID?: string, IsInvoiced?: boolean, IsLocked?: boolean, Employee?: string, Task?: string } };

export type DealTypeScalarsFragment = { __typename?: 'DealType', ID: number, Name?: string, Description: string, CreatedAt: number, UpdatedAt: number, DisplayName?: string };

export type SingleDealTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleDealTypeQuery = { __typename?: 'Query', DealType?: { __typename?: 'DealType', ID: number, Name?: string, Description: string, CreatedAt: number, UpdatedAt: number, DisplayName?: string } };

export type SingleDealTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleDealTypeFullQuery = { __typename?: 'Query', DealType?: { __typename?: 'DealType', ID: number, Name?: string, Description: string, CreatedAt: number, UpdatedAt: number, DisplayName?: string } };

export type AllDealTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDealTypesQuery = { __typename?: 'Query', AllDealTypes: Array<{ __typename?: 'DealType', ID: number, Name?: string, Description: string, CreatedAt: number, UpdatedAt: number, DisplayName?: string }> };

export type UpdateDealTypeMutationVariables = Exact<{
  input: UpdateDealTypeInput;
}>;


export type UpdateDealTypeMutation = { __typename?: 'Mutation', UpdateDealType: { __typename?: 'DealType', ID: number, Name?: string, Description: string, CreatedAt: number, UpdatedAt: number, DisplayName?: string } };

export type ApplicationScalarsFragment = { __typename?: 'Application', ID: number, Name: string, Description?: string, CreatedAt: number, UpdatedAt: number };

export type SingleApplicationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleApplicationQuery = { __typename?: 'Query', Application?: { __typename?: 'Application', ID: number, Name: string, Description?: string, CreatedAt: number, UpdatedAt: number } };

export type SingleApplicationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleApplicationFullQuery = { __typename?: 'Query', Application?: { __typename?: 'Application', ID: number, Name: string, Description?: string, CreatedAt: number, UpdatedAt: number, ApplicationEntities: Array<{ __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string }>, ApplicationPermissions: Array<{ __typename?: 'ApplicationPermission', ID: number, ApplicationID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, Application: string, Role: string }> } };

export type AllApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllApplicationsQuery = { __typename?: 'Query', AllApplications: Array<{ __typename?: 'Application', ID: number, Name: string, Description?: string, CreatedAt: number, UpdatedAt: number, ApplicationEntities: Array<{ __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string }>, ApplicationPermissions: Array<{ __typename?: 'ApplicationPermission', ID: number, ApplicationID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, Application: string, Role: string }> }> };

export type UpdateApplicationMutationVariables = Exact<{
  input: UpdateApplicationInput;
}>;


export type UpdateApplicationMutation = { __typename?: 'Mutation', UpdateApplication: { __typename?: 'Application', ID: number, Name: string, Description?: string, CreatedAt: number, UpdatedAt: number } };

export type ApplicationEntityScalarsFragment = { __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string };

export type SingleApplicationEntityQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleApplicationEntityQuery = { __typename?: 'Query', ApplicationEntity?: { __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string } };

export type SingleApplicationEntityFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleApplicationEntityFullQuery = { __typename?: 'Query', ApplicationEntity?: { __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string } };

export type CreateApplicationEntityMutationVariables = Exact<{
  input: CreateApplicationEntityInput;
}>;


export type CreateApplicationEntityMutation = { __typename?: 'Mutation', CreateApplicationEntity: { __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string } };

export type UpdateApplicationEntityMutationVariables = Exact<{
  input: UpdateApplicationEntityInput;
}>;


export type UpdateApplicationEntityMutation = { __typename?: 'Mutation', UpdateApplicationEntity: { __typename?: 'ApplicationEntity', ID: number, ApplicationID: number, EntityID: number, Sequence: number, DefaultForNewUser: boolean, CreatedAt: number, UpdatedAt: number, Application: string, Entity: string, EntityBaseTable: string, EntityCodeName?: string, EntityClassName: string, EntityBaseTableCodeName: string } };

export type DeleteApplicationEntityMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteApplicationEntityMutation = { __typename?: 'Mutation', DeleteApplicationEntity: number };

export type EntityPermissionScalarsFragment = { __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string };

export type SingleEntityPermissionQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityPermissionQuery = { __typename?: 'Query', EntityPermission?: { __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string } };

export type SingleEntityPermissionFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityPermissionFullQuery = { __typename?: 'Query', EntityPermission?: { __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string } };

export type AllEntityPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEntityPermissionsQuery = { __typename?: 'Query', AllEntityPermissions: Array<{ __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string }> };

export type CreateEntityPermissionMutationVariables = Exact<{
  input: CreateEntityPermissionInput;
}>;


export type CreateEntityPermissionMutation = { __typename?: 'Mutation', CreateEntityPermission: { __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string } };

export type UpdateEntityPermissionMutationVariables = Exact<{
  input: UpdateEntityPermissionInput;
}>;


export type UpdateEntityPermissionMutation = { __typename?: 'Mutation', UpdateEntityPermission: { __typename?: 'EntityPermission', ID: number, EntityID: number, RoleID: number, CanCreate: boolean, CanRead: boolean, CanUpdate: boolean, CanDelete: boolean, ReadRLSFilterID?: number, CreateRLSFilterID?: number, UpdateRLSFilterID?: number, DeleteRLSFilterID?: number, CreatedAt: number, UpdatedAt: number, Entity: string, Role: string, RoleSQLName: string, CreateRLSFilter?: string, ReadRLSFilter?: string, UpdateRLSFilter?: string, DeleteRLSFilter?: string } };

export type DeleteEntityPermissionMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteEntityPermissionMutation = { __typename?: 'Mutation', DeleteEntityPermission: number };

export type ApplicationPermissionScalarsFragment = { __typename?: 'ApplicationPermission', ID: number, ApplicationID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, Application: string, Role: string };

export type SingleApplicationPermissionQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleApplicationPermissionQuery = { __typename?: 'Query', ApplicationPermission?: { __typename?: 'ApplicationPermission', ID: number, ApplicationID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, Application: string, Role: string } };

export type SingleApplicationPermissionFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleApplicationPermissionFullQuery = { __typename?: 'Query', ApplicationPermission?: { __typename?: 'ApplicationPermission', ID: number, ApplicationID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, Application: string, Role: string } };

export type UpdateApplicationPermissionMutationVariables = Exact<{
  input: UpdateApplicationPermissionInput;
}>;


export type UpdateApplicationPermissionMutation = { __typename?: 'Mutation', UpdateApplicationPermission: { __typename?: 'ApplicationPermission', ID: number, ApplicationID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, Application: string, Role: string } };

export type UserApplicationEntityScalarsFragment = { __typename?: 'UserApplicationEntity', ID: number, UserApplicationID: number, EntityID: number, Sequence: number, Application: string, User: string, Entity: string };

export type SingleUserApplicationEntityQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserApplicationEntityQuery = { __typename?: 'Query', UserApplicationEntity?: { __typename?: 'UserApplicationEntity', ID: number, UserApplicationID: number, EntityID: number, Sequence: number, Application: string, User: string, Entity: string } };

export type SingleUserApplicationEntityFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserApplicationEntityFullQuery = { __typename?: 'Query', UserApplicationEntity?: { __typename?: 'UserApplicationEntity', ID: number, UserApplicationID: number, EntityID: number, Sequence: number, Application: string, User: string, Entity: string } };

export type CreateUserApplicationEntityMutationVariables = Exact<{
  input: CreateUserApplicationEntityInput;
}>;


export type CreateUserApplicationEntityMutation = { __typename?: 'Mutation', CreateUserApplicationEntity: { __typename?: 'UserApplicationEntity', ID: number, UserApplicationID: number, EntityID: number, Sequence: number, Application: string, User: string, Entity: string } };

export type UpdateUserApplicationEntityMutationVariables = Exact<{
  input: UpdateUserApplicationEntityInput;
}>;


export type UpdateUserApplicationEntityMutation = { __typename?: 'Mutation', UpdateUserApplicationEntity: { __typename?: 'UserApplicationEntity', ID: number, UserApplicationID: number, EntityID: number, Sequence: number, Application: string, User: string, Entity: string } };

export type DeleteUserApplicationEntityMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteUserApplicationEntityMutation = { __typename?: 'Mutation', DeleteUserApplicationEntity: number };

export type UserApplicationScalarsFragment = { __typename?: 'UserApplication', ID: number, UserID: number, ApplicationID: number, Sequence: number, IsActive: boolean, User: string, Application: string };

export type SingleUserApplicationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserApplicationQuery = { __typename?: 'Query', UserApplication?: { __typename?: 'UserApplication', ID: number, UserID: number, ApplicationID: number, Sequence: number, IsActive: boolean, User: string, Application: string } };

export type SingleUserApplicationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserApplicationFullQuery = { __typename?: 'Query', UserApplication?: { __typename?: 'UserApplication', ID: number, UserID: number, ApplicationID: number, Sequence: number, IsActive: boolean, User: string, Application: string, UserApplicationEntities: Array<{ __typename?: 'UserApplicationEntity', ID: number, UserApplicationID: number, EntityID: number, Sequence: number, Application: string, User: string, Entity: string }> } };

export type UpdateUserApplicationMutationVariables = Exact<{
  input: UpdateUserApplicationInput;
}>;


export type UpdateUserApplicationMutation = { __typename?: 'Mutation', UpdateUserApplication: { __typename?: 'UserApplication', ID: number, UserID: number, ApplicationID: number, Sequence: number, IsActive: boolean, User: string, Application: string } };

export type ProjectStatusTypeScalarsFragment = { __typename?: 'ProjectStatusType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number, IsClosed: boolean };

export type SingleProjectStatusTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectStatusTypeQuery = { __typename?: 'Query', ProjectStatusType?: { __typename?: 'ProjectStatusType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number, IsClosed: boolean } };

export type SingleProjectStatusTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectStatusTypeFullQuery = { __typename?: 'Query', ProjectStatusType?: { __typename?: 'ProjectStatusType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number, IsClosed: boolean } };

export type UpdateProjectStatusTypeMutationVariables = Exact<{
  input: UpdateProjectStatusTypeInput;
}>;


export type UpdateProjectStatusTypeMutation = { __typename?: 'Mutation', UpdateProjectStatusType: { __typename?: 'ProjectStatusType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number, IsClosed: boolean } };

export type ProjectRateTypeScalarsFragment = { __typename?: 'ProjectRateType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number };

export type SingleProjectRateTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectRateTypeQuery = { __typename?: 'Query', ProjectRateType?: { __typename?: 'ProjectRateType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type SingleProjectRateTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectRateTypeFullQuery = { __typename?: 'Query', ProjectRateType?: { __typename?: 'ProjectRateType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type UpdateProjectRateTypeMutationVariables = Exact<{
  input: UpdateProjectRateTypeInput;
}>;


export type UpdateProjectRateTypeMutation = { __typename?: 'Mutation', UpdateProjectRateType: { __typename?: 'ProjectRateType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type ProjectBillingTypeScalarsFragment = { __typename?: 'ProjectBillingType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number };

export type SingleProjectBillingTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectBillingTypeQuery = { __typename?: 'Query', ProjectBillingType?: { __typename?: 'ProjectBillingType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type SingleProjectBillingTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleProjectBillingTypeFullQuery = { __typename?: 'Query', ProjectBillingType?: { __typename?: 'ProjectBillingType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type UpdateProjectBillingTypeMutationVariables = Exact<{
  input: UpdateProjectBillingTypeInput;
}>;


export type UpdateProjectBillingTypeMutation = { __typename?: 'Mutation', UpdateProjectBillingType: { __typename?: 'ProjectBillingType', ID: number, Name: string, Code: string, Description: string, CreatedAt: number, UpdatedAt: number } };

export type ListScalarsFragment = { __typename?: 'List', ID: number, Name: string, Description?: string, EntityID?: number, UserID: number, CreatedAt: number, UpdatedAt: number, Entity?: string, User: string };

export type SingleListQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleListQuery = { __typename?: 'Query', List?: { __typename?: 'List', ID: number, Name: string, Description?: string, EntityID?: number, UserID: number, CreatedAt: number, UpdatedAt: number, Entity?: string, User: string } };

export type SingleListFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleListFullQuery = { __typename?: 'Query', List?: { __typename?: 'List', ID: number, Name: string, Description?: string, EntityID?: number, UserID: number, CreatedAt: number, UpdatedAt: number, Entity?: string, User: string, ListDetails: Array<{ __typename?: 'ListDetail', ID: number, ListID: number, RecordID: number, Sequence: number }> } };

export type CreateListMutationVariables = Exact<{
  input: CreateListInput;
}>;


export type CreateListMutation = { __typename?: 'Mutation', CreateList: { __typename?: 'List', ID: number, Name: string, Description?: string, EntityID?: number, UserID: number, CreatedAt: number, UpdatedAt: number, Entity?: string, User: string } };

export type UpdateListMutationVariables = Exact<{
  input: UpdateListInput;
}>;


export type UpdateListMutation = { __typename?: 'Mutation', UpdateList: { __typename?: 'List', ID: number, Name: string, Description?: string, EntityID?: number, UserID: number, CreatedAt: number, UpdatedAt: number, Entity?: string, User: string } };

export type DeleteListMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteListMutation = { __typename?: 'Mutation', DeleteList: number };

export type ListDetailScalarsFragment = { __typename?: 'ListDetail', ID: number, ListID: number, RecordID: number, Sequence: number };

export type SingleListDetailQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleListDetailQuery = { __typename?: 'Query', ListDetail?: { __typename?: 'ListDetail', ID: number, ListID: number, RecordID: number, Sequence: number } };

export type SingleListDetailFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleListDetailFullQuery = { __typename?: 'Query', ListDetail?: { __typename?: 'ListDetail', ID: number, ListID: number, RecordID: number, Sequence: number } };

export type CreateListDetailMutationVariables = Exact<{
  input: CreateListDetailInput;
}>;


export type CreateListDetailMutation = { __typename?: 'Mutation', CreateListDetail: { __typename?: 'ListDetail', ID: number, ListID: number, RecordID: number, Sequence: number } };

export type UpdateListDetailMutationVariables = Exact<{
  input: UpdateListDetailInput;
}>;


export type UpdateListDetailMutation = { __typename?: 'Mutation', UpdateListDetail: { __typename?: 'ListDetail', ID: number, ListID: number, RecordID: number, Sequence: number } };

export type DeleteListDetailMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteListDetailMutation = { __typename?: 'Mutation', DeleteListDetail: number };

export type UserViewRunScalarsFragment = { __typename?: 'UserViewRun', ID: number, UserViewID: number, RunAt: number, RunByUserID: number, UserView: string, RunByUser: string };

export type SingleUserViewRunQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserViewRunQuery = { __typename?: 'Query', UserViewRun?: { __typename?: 'UserViewRun', ID: number, UserViewID: number, RunAt: number, RunByUserID: number, UserView: string, RunByUser: string } };

export type SingleUserViewRunFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserViewRunFullQuery = { __typename?: 'Query', UserViewRun?: { __typename?: 'UserViewRun', ID: number, UserViewID: number, RunAt: number, RunByUserID: number, UserView: string, RunByUser: string, UserViewRunDetails: Array<{ __typename?: 'UserViewRunDetail', ID: number, UserViewRunID: number, RecordID: number, UserViewID: number, EntityID: number }> } };

export type CreateUserViewRunMutationVariables = Exact<{
  input: CreateUserViewRunInput;
}>;


export type CreateUserViewRunMutation = { __typename?: 'Mutation', CreateUserViewRun: { __typename?: 'UserViewRun', ID: number, UserViewID: number, RunAt: number, RunByUserID: number, UserView: string, RunByUser: string } };

export type UpdateUserViewRunMutationVariables = Exact<{
  input: UpdateUserViewRunInput;
}>;


export type UpdateUserViewRunMutation = { __typename?: 'Mutation', UpdateUserViewRun: { __typename?: 'UserViewRun', ID: number, UserViewID: number, RunAt: number, RunByUserID: number, UserView: string, RunByUser: string } };

export type UserViewRunDetailScalarsFragment = { __typename?: 'UserViewRunDetail', ID: number, UserViewRunID: number, RecordID: number, UserViewID: number, EntityID: number };

export type SingleUserViewRunDetailQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserViewRunDetailQuery = { __typename?: 'Query', UserViewRunDetail?: { __typename?: 'UserViewRunDetail', ID: number, UserViewRunID: number, RecordID: number, UserViewID: number, EntityID: number } };

export type SingleUserViewRunDetailFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserViewRunDetailFullQuery = { __typename?: 'Query', UserViewRunDetail?: { __typename?: 'UserViewRunDetail', ID: number, UserViewRunID: number, RecordID: number, UserViewID: number, EntityID: number } };

export type CreateUserViewRunDetailMutationVariables = Exact<{
  input: CreateUserViewRunDetailInput;
}>;


export type CreateUserViewRunDetailMutation = { __typename?: 'Mutation', CreateUserViewRunDetail: { __typename?: 'UserViewRunDetail', ID: number, UserViewRunID: number, RecordID: number, UserViewID: number, EntityID: number } };

export type UpdateUserViewRunDetailMutationVariables = Exact<{
  input: UpdateUserViewRunDetailInput;
}>;


export type UpdateUserViewRunDetailMutation = { __typename?: 'Mutation', UpdateUserViewRunDetail: { __typename?: 'UserViewRunDetail', ID: number, UserViewRunID: number, RecordID: number, UserViewID: number, EntityID: number } };

export type WorkflowRunScalarsFragment = { __typename?: 'WorkflowRun', ID: number, WorkflowID: number, ExternalSystemRecordID: string, StartedAt: number, EndedAt?: number, Status: string, Results?: string, Workflow: string, WorkflowEngine: string };

export type SingleWorkflowRunQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleWorkflowRunQuery = { __typename?: 'Query', WorkflowRun?: { __typename?: 'WorkflowRun', ID: number, WorkflowID: number, ExternalSystemRecordID: string, StartedAt: number, EndedAt?: number, Status: string, Results?: string, Workflow: string, WorkflowEngine: string } };

export type SingleWorkflowRunFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleWorkflowRunFullQuery = { __typename?: 'Query', WorkflowRun?: { __typename?: 'WorkflowRun', ID: number, WorkflowID: number, ExternalSystemRecordID: string, StartedAt: number, EndedAt?: number, Status: string, Results?: string, Workflow: string, WorkflowEngine: string } };

export type UpdateWorkflowRunMutationVariables = Exact<{
  input: UpdateWorkflowRunInput;
}>;


export type UpdateWorkflowRunMutation = { __typename?: 'Mutation', UpdateWorkflowRun: { __typename?: 'WorkflowRun', ID: number, WorkflowID: number, ExternalSystemRecordID: string, StartedAt: number, EndedAt?: number, Status: string, Results?: string, Workflow: string, WorkflowEngine: string } };

export type WorkflowScalarsFragment = { __typename?: 'Workflow', ID: number, Name: string, Description?: string, WorkflowEngineID: number, CompanyID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, WorkflowEngine: string };

export type SingleWorkflowQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleWorkflowQuery = { __typename?: 'Query', Workflow?: { __typename?: 'Workflow', ID: number, Name: string, Description?: string, WorkflowEngineID: number, CompanyID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, WorkflowEngine: string } };

export type SingleWorkflowFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleWorkflowFullQuery = { __typename?: 'Query', Workflow?: { __typename?: 'Workflow', ID: number, Name: string, Description?: string, WorkflowEngineID: number, CompanyID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, WorkflowEngine: string } };

export type UpdateWorkflowMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', UpdateWorkflow: { __typename?: 'Workflow', ID: number, Name: string, Description?: string, WorkflowEngineID: number, CompanyID: number, ExternalSystemRecordID: string, CreatedAt: number, UpdatedAt: number, WorkflowEngine: string } };

export type CampaignScalarsFragment = { __typename?: 'Campaign', ID: number, BCMID: string, Name: string, EmployeeID?: number, StatusID?: number, ExternalSystemCreatedAt?: number, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, Employee?: string };

export type SingleCampaignQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCampaignQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', ID: number, BCMID: string, Name: string, EmployeeID?: number, StatusID?: number, ExternalSystemCreatedAt?: number, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, Employee?: string } };

export type SingleCampaignFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCampaignFullQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', ID: number, BCMID: string, Name: string, EmployeeID?: number, StatusID?: number, ExternalSystemCreatedAt?: number, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, Employee?: string } };

export type UpdateCampaignMutationVariables = Exact<{
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', UpdateCampaign: { __typename?: 'Campaign', ID: number, BCMID: string, Name: string, EmployeeID?: number, StatusID?: number, ExternalSystemCreatedAt?: number, CompanyIntegrationID: number, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number, Employee?: string } };

export type CampaignStepScalarsFragment = { __typename?: 'CampaignStep', ID: number, CampaignID: number, Sequence: number, Subject?: string, Body?: string, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number };

export type SingleCampaignStepQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCampaignStepQuery = { __typename?: 'Query', CampaignStep?: { __typename?: 'CampaignStep', ID: number, CampaignID: number, Sequence: number, Subject?: string, Body?: string, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number } };

export type SingleCampaignStepFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleCampaignStepFullQuery = { __typename?: 'Query', CampaignStep?: { __typename?: 'CampaignStep', ID: number, CampaignID: number, Sequence: number, Subject?: string, Body?: string, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number } };

export type UpdateCampaignStepMutationVariables = Exact<{
  input: UpdateCampaignStepInput;
}>;


export type UpdateCampaignStepMutation = { __typename?: 'Mutation', UpdateCampaignStep: { __typename?: 'CampaignStep', ID: number, CampaignID: number, Sequence: number, Subject?: string, Body?: string, ExternalSystemRecordID?: string, CreatedAt: number, UpdatedAt: number } };

export type WorkflowEngineScalarsFragment = { __typename?: 'WorkflowEngine', ID: number, Name: string, Description?: string, DriverPath: string, DriverClass: string, CreatedAt: number, UpdatedAt: number };

export type SingleWorkflowEngineQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleWorkflowEngineQuery = { __typename?: 'Query', WorkflowEngine?: { __typename?: 'WorkflowEngine', ID: number, Name: string, Description?: string, DriverPath: string, DriverClass: string, CreatedAt: number, UpdatedAt: number } };

export type SingleWorkflowEngineFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleWorkflowEngineFullQuery = { __typename?: 'Query', WorkflowEngine?: { __typename?: 'WorkflowEngine', ID: number, Name: string, Description?: string, DriverPath: string, DriverClass: string, CreatedAt: number, UpdatedAt: number } };

export type UpdateWorkflowEngineMutationVariables = Exact<{
  input: UpdateWorkflowEngineInput;
}>;


export type UpdateWorkflowEngineMutation = { __typename?: 'Mutation', UpdateWorkflowEngine: { __typename?: 'WorkflowEngine', ID: number, Name: string, Description?: string, DriverPath: string, DriverClass: string, CreatedAt: number, UpdatedAt: number } };

export type RecordChangeScalarsFragment = { __typename?: 'RecordChange', ID: number, EntityID: number, RecordID: number, UserID: number, ChangedAt: number, ChangesJSON: string, ChangesDescription: string, FullRecordJSON: string, Status: string, Comments?: string, Entity: string, User: string };

export type SingleRecordChangeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleRecordChangeQuery = { __typename?: 'Query', RecordChange?: { __typename?: 'RecordChange', ID: number, EntityID: number, RecordID: number, UserID: number, ChangedAt: number, ChangesJSON: string, ChangesDescription: string, FullRecordJSON: string, Status: string, Comments?: string, Entity: string, User: string } };

export type SingleRecordChangeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleRecordChangeFullQuery = { __typename?: 'Query', RecordChange?: { __typename?: 'RecordChange', ID: number, EntityID: number, RecordID: number, UserID: number, ChangedAt: number, ChangesJSON: string, ChangesDescription: string, FullRecordJSON: string, Status: string, Comments?: string, Entity: string, User: string } };

export type CreateRecordChangeMutationVariables = Exact<{
  input: CreateRecordChangeInput;
}>;


export type CreateRecordChangeMutation = { __typename?: 'Mutation', CreateRecordChange: { __typename?: 'RecordChange', ID: number, EntityID: number, RecordID: number, UserID: number, ChangedAt: number, ChangesJSON: string, ChangesDescription: string, FullRecordJSON: string, Status: string, Comments?: string, Entity: string, User: string } };

export type TeamScalarsFragment = { __typename?: 'Team', ID: number, Type: string, UpdatedAt?: number };

export type SingleTeamQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTeamQuery = { __typename?: 'Query', Team?: { __typename?: 'Team', ID: number, Type: string, UpdatedAt?: number } };

export type SingleTeamFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTeamFullQuery = { __typename?: 'Query', Team?: { __typename?: 'Team', ID: number, Type: string, UpdatedAt?: number } };

export type AllLatestMetadataUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLatestMetadataUpdatesQuery = { __typename?: 'Query', AllLatestMetadataUpdates: Array<{ __typename?: 'Team', ID: number, Type: string, UpdatedAt?: number }> };

export type UserRoleScalarsFragment = { __typename?: 'UserRole', ID: number, UserID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, User: string, Role: string };

export type SingleUserRoleQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserRoleQuery = { __typename?: 'Query', UserRole?: { __typename?: 'UserRole', ID: number, UserID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, User: string, Role: string } };

export type SingleUserRoleFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleUserRoleFullQuery = { __typename?: 'Query', UserRole?: { __typename?: 'UserRole', ID: number, UserID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, User: string, Role: string } };

export type AllUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserRolesQuery = { __typename?: 'Query', AllUserRoles: Array<{ __typename?: 'UserRole', ID: number, UserID: number, RoleID: number, CreatedAt: number, UpdatedAt: number, User: string, Role: string }> };

export type RowLevelSecurityFilterScalarsFragment = { __typename?: 'RowLevelSecurityFilter', ID: number, Name: string, Description?: string, FilterText?: string, CreatedAt: number, UpdatedAt: number };

export type SingleRowLevelSecurityFilterQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleRowLevelSecurityFilterQuery = { __typename?: 'Query', RowLevelSecurityFilter?: { __typename?: 'RowLevelSecurityFilter', ID: number, Name: string, Description?: string, FilterText?: string, CreatedAt: number, UpdatedAt: number } };

export type SingleRowLevelSecurityFilterFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleRowLevelSecurityFilterFullQuery = { __typename?: 'Query', RowLevelSecurityFilter?: { __typename?: 'RowLevelSecurityFilter', ID: number, Name: string, Description?: string, FilterText?: string, CreatedAt: number, UpdatedAt: number } };

export type AllRowLevelSecurityFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRowLevelSecurityFiltersQuery = { __typename?: 'Query', AllRowLevelSecurityFilters: Array<{ __typename?: 'RowLevelSecurityFilter', ID: number, Name: string, Description?: string, FilterText?: string, CreatedAt: number, UpdatedAt: number }> };

export type AuditLogScalarsFragment = { __typename?: 'AuditLog', ID: number, AuditLogTypeID: number, UserID: number, AuthorizationID?: number, Status: string, Details?: string, EntityID?: number, RecordID?: number, CreatedAt: number, UpdatedAt: number, AuditLogType: string, User: string, Entity?: string };

export type SingleAuditLogQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuditLogQuery = { __typename?: 'Query', AuditLog?: { __typename?: 'AuditLog', ID: number, AuditLogTypeID: number, UserID: number, AuthorizationID?: number, Status: string, Details?: string, EntityID?: number, RecordID?: number, CreatedAt: number, UpdatedAt: number, AuditLogType: string, User: string, Entity?: string } };

export type SingleAuditLogFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuditLogFullQuery = { __typename?: 'Query', AuditLog?: { __typename?: 'AuditLog', ID: number, AuditLogTypeID: number, UserID: number, AuthorizationID?: number, Status: string, Details?: string, EntityID?: number, RecordID?: number, CreatedAt: number, UpdatedAt: number, AuditLogType: string, User: string, Entity?: string } };

export type CreateAuditLogMutationVariables = Exact<{
  input: CreateAuditLogInput;
}>;


export type CreateAuditLogMutation = { __typename?: 'Mutation', CreateAuditLog: { __typename?: 'AuditLog', ID: number, AuditLogTypeID: number, UserID: number, AuthorizationID?: number, Status: string, Details?: string, EntityID?: number, RecordID?: number, CreatedAt: number, UpdatedAt: number, AuditLogType: string, User: string, Entity?: string } };

export type UpdateAuditLogMutationVariables = Exact<{
  input: UpdateAuditLogInput;
}>;


export type UpdateAuditLogMutation = { __typename?: 'Mutation', UpdateAuditLog: { __typename?: 'AuditLog', ID: number, AuditLogTypeID: number, UserID: number, AuthorizationID?: number, Status: string, Details?: string, EntityID?: number, RecordID?: number, CreatedAt: number, UpdatedAt: number, AuditLogType: string, User: string, Entity?: string } };

export type AuthorizationScalarsFragment = { __typename?: 'Authorization', ID: number, ParentID?: number, Name: string, IsActive: boolean, UseAuditLog: boolean, Description?: string, CreatedAt: number, UpdatedAt: number };

export type SingleAuthorizationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuthorizationQuery = { __typename?: 'Query', Authorization?: { __typename?: 'Authorization', ID: number, ParentID?: number, Name: string, IsActive: boolean, UseAuditLog: boolean, Description?: string, CreatedAt: number, UpdatedAt: number } };

export type SingleAuthorizationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuthorizationFullQuery = { __typename?: 'Query', Authorization?: { __typename?: 'Authorization', ID: number, ParentID?: number, Name: string, IsActive: boolean, UseAuditLog: boolean, Description?: string, CreatedAt: number, UpdatedAt: number, AuthorizationRoles: Array<{ __typename?: 'AuthorizationRole', ID: number, AuthorizationID: number, RoleID: number, Type: string, CreatedAt: number, UpdatedAt: number, Role: string }> } };

export type AllAuthorizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAuthorizationsQuery = { __typename?: 'Query', AllAuthorizations: Array<{ __typename?: 'Authorization', ID: number, ParentID?: number, Name: string, IsActive: boolean, UseAuditLog: boolean, Description?: string, CreatedAt: number, UpdatedAt: number }> };

export type AuthorizationRoleScalarsFragment = { __typename?: 'AuthorizationRole', ID: number, AuthorizationID: number, RoleID: number, Type: string, CreatedAt: number, UpdatedAt: number, Role: string };

export type SingleAuthorizationRoleQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuthorizationRoleQuery = { __typename?: 'Query', AuthorizationRole?: { __typename?: 'AuthorizationRole', ID: number, AuthorizationID: number, RoleID: number, Type: string, CreatedAt: number, UpdatedAt: number, Role: string } };

export type SingleAuthorizationRoleFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuthorizationRoleFullQuery = { __typename?: 'Query', AuthorizationRole?: { __typename?: 'AuthorizationRole', ID: number, AuthorizationID: number, RoleID: number, Type: string, CreatedAt: number, UpdatedAt: number, Role: string } };

export type AllAuthorizationRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAuthorizationRolesQuery = { __typename?: 'Query', AllAuthorizationRoles: Array<{ __typename?: 'AuthorizationRole', ID: number, AuthorizationID: number, RoleID: number, Type: string, CreatedAt: number, UpdatedAt: number, Role: string }> };

export type AuditLogTypeScalarsFragment = { __typename?: 'AuditLogType', ID: number, ParentID?: number, Name: string, Description?: string, AuthorizationID?: number, CreatedAt: number, UpdatedAt: number, Parent?: string };

export type SingleAuditLogTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuditLogTypeQuery = { __typename?: 'Query', AuditLogType?: { __typename?: 'AuditLogType', ID: number, ParentID?: number, Name: string, Description?: string, AuthorizationID?: number, CreatedAt: number, UpdatedAt: number, Parent?: string } };

export type SingleAuditLogTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAuditLogTypeFullQuery = { __typename?: 'Query', AuditLogType?: { __typename?: 'AuditLogType', ID: number, ParentID?: number, Name: string, Description?: string, AuthorizationID?: number, CreatedAt: number, UpdatedAt: number, Parent?: string } };

export type AllAuditLogTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAuditLogTypesQuery = { __typename?: 'Query', AllAuditLogTypes: Array<{ __typename?: 'AuditLogType', ID: number, ParentID?: number, Name: string, Description?: string, AuthorizationID?: number, CreatedAt: number, UpdatedAt: number, Parent?: string }> };

export type EntityFieldValueScalarsFragment = { __typename?: 'EntityFieldValue', ID: number, EntityFieldID: number, Sequence: number, Value: string, Code?: string, Description?: string, CreatedAt: number, UpdatedAt: number, EntityField: string };

export type SingleEntityFieldValueQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityFieldValueQuery = { __typename?: 'Query', EntityFieldValue?: { __typename?: 'EntityFieldValue', ID: number, EntityFieldID: number, Sequence: number, Value: string, Code?: string, Description?: string, CreatedAt: number, UpdatedAt: number, EntityField: string } };

export type SingleEntityFieldValueFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityFieldValueFullQuery = { __typename?: 'Query', EntityFieldValue?: { __typename?: 'EntityFieldValue', ID: number, EntityFieldID: number, Sequence: number, Value: string, Code?: string, Description?: string, CreatedAt: number, UpdatedAt: number, EntityField: string } };

export type TaxReturnScalarsFragment = { __typename?: 'TaxReturn', ID: number, TaxID: string, Name: string, ReturnType?: string, TaxPeriodStart: number, TaxPeriodEnd: number, TaxYear: number, TaxMonth?: number, AddressLine1?: string, AddressLine2?: string, City?: string, StateProvince?: string, PostalCode?: string, Website?: string, Subsection?: string, Affiliation?: number, YearFormed?: number, ActivityDescription?: string, MissionDescription?: string, BODVotingMembers?: number, PreparerFirm?: string, PreparerFirmTaxID?: string, PreparerFirmAddressLine1?: string, PreparerFirmAddressLine2?: string, PreparerFirmCity?: string, PreparerFirmStateProvince?: string, PreparerFirmPostalCode?: string, PreparerPerson?: string, PreparerPersonTaxID?: string, PreparerPersonPhone?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, NumberVolunteers?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, AccountID?: number, SourceJSON?: string, SummaryText?: string, FinancialStrength?: string, Account?: string };

export type SingleTaxReturnQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnQuery = { __typename?: 'Query', TaxReturn?: { __typename?: 'TaxReturn', ID: number, TaxID: string, Name: string, ReturnType?: string, TaxPeriodStart: number, TaxPeriodEnd: number, TaxYear: number, TaxMonth?: number, AddressLine1?: string, AddressLine2?: string, City?: string, StateProvince?: string, PostalCode?: string, Website?: string, Subsection?: string, Affiliation?: number, YearFormed?: number, ActivityDescription?: string, MissionDescription?: string, BODVotingMembers?: number, PreparerFirm?: string, PreparerFirmTaxID?: string, PreparerFirmAddressLine1?: string, PreparerFirmAddressLine2?: string, PreparerFirmCity?: string, PreparerFirmStateProvince?: string, PreparerFirmPostalCode?: string, PreparerPerson?: string, PreparerPersonTaxID?: string, PreparerPersonPhone?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, NumberVolunteers?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, AccountID?: number, SourceJSON?: string, SummaryText?: string, FinancialStrength?: string, Account?: string } };

export type SingleTaxReturnFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnFullQuery = { __typename?: 'Query', TaxReturn?: { __typename?: 'TaxReturn', ID: number, TaxID: string, Name: string, ReturnType?: string, TaxPeriodStart: number, TaxPeriodEnd: number, TaxYear: number, TaxMonth?: number, AddressLine1?: string, AddressLine2?: string, City?: string, StateProvince?: string, PostalCode?: string, Website?: string, Subsection?: string, Affiliation?: number, YearFormed?: number, ActivityDescription?: string, MissionDescription?: string, BODVotingMembers?: number, PreparerFirm?: string, PreparerFirmTaxID?: string, PreparerFirmAddressLine1?: string, PreparerFirmAddressLine2?: string, PreparerFirmCity?: string, PreparerFirmStateProvince?: string, PreparerFirmPostalCode?: string, PreparerPerson?: string, PreparerPersonTaxID?: string, PreparerPersonPhone?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, NumberVolunteers?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, AccountID?: number, SourceJSON?: string, SummaryText?: string, FinancialStrength?: string, Account?: string, TaxReturnDetails: Array<{ __typename?: 'TaxReturnDetail', ID: number, TaxReturnID: number, Type: string, Name: string, StartingAmount?: number, EndingAmount: number, Code?: string }>, TaxReturnCompensation: Array<{ __typename?: 'TaxReturnCompensation', ID: number, TaxReturnID: number, PersonName: string, Title?: string, AverageHoursPerWeek?: number, IsOfficer: boolean, Compensation: number, RelatedOrgCompensation?: number, OtherCompensation?: number, TotalCompensation?: number, PartialYear: boolean, StartDate?: number, EndDate?: number, AnnualizedTotalCompensation?: number, ContactID?: number, Contact?: string }>, TaxReturnContractors: Array<{ __typename?: 'TaxReturnContractor', ID: number, TaxReturnID: number, Name: string, Type: string, Amount: number, AddressLine1?: string, City?: string, StateProvince?: string, PostalCode?: string, AccountID?: number, Account?: string }> } };

export type CreateTaxReturnMutationVariables = Exact<{
  input: CreateTaxReturnInput;
}>;


export type CreateTaxReturnMutation = { __typename?: 'Mutation', CreateTaxReturn: { __typename?: 'TaxReturn', ID: number, TaxID: string, Name: string, ReturnType?: string, TaxPeriodStart: number, TaxPeriodEnd: number, TaxYear: number, TaxMonth?: number, AddressLine1?: string, AddressLine2?: string, City?: string, StateProvince?: string, PostalCode?: string, Website?: string, Subsection?: string, Affiliation?: number, YearFormed?: number, ActivityDescription?: string, MissionDescription?: string, BODVotingMembers?: number, PreparerFirm?: string, PreparerFirmTaxID?: string, PreparerFirmAddressLine1?: string, PreparerFirmAddressLine2?: string, PreparerFirmCity?: string, PreparerFirmStateProvince?: string, PreparerFirmPostalCode?: string, PreparerPerson?: string, PreparerPersonTaxID?: string, PreparerPersonPhone?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, NumberVolunteers?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, AccountID?: number, SourceJSON?: string, SummaryText?: string, FinancialStrength?: string, Account?: string } };

export type UpdateTaxReturnMutationVariables = Exact<{
  input: UpdateTaxReturnInput;
}>;


export type UpdateTaxReturnMutation = { __typename?: 'Mutation', UpdateTaxReturn: { __typename?: 'TaxReturn', ID: number, TaxID: string, Name: string, ReturnType?: string, TaxPeriodStart: number, TaxPeriodEnd: number, TaxYear: number, TaxMonth?: number, AddressLine1?: string, AddressLine2?: string, City?: string, StateProvince?: string, PostalCode?: string, Website?: string, Subsection?: string, Affiliation?: number, YearFormed?: number, ActivityDescription?: string, MissionDescription?: string, BODVotingMembers?: number, PreparerFirm?: string, PreparerFirmTaxID?: string, PreparerFirmAddressLine1?: string, PreparerFirmAddressLine2?: string, PreparerFirmCity?: string, PreparerFirmStateProvince?: string, PreparerFirmPostalCode?: string, PreparerPerson?: string, PreparerPersonTaxID?: string, PreparerPersonPhone?: string, IsHospital?: boolean, GrantsToOrgs?: number, GrantsToIndividuals?: number, HasInvestmentIncome?: boolean, TotalInvestmentIncome?: number, NumberEmployees?: number, NumberVolunteers?: number, HasForeignBankAcct?: boolean, TotalGrossReceipts?: number, TotalMemberIncome?: number, TotalProgramServiceRevenue?: number, GrossRentsFromRealEstate?: number, RentalExpenseRealEstate?: number, NetRentRealEstate?: number, GrossSalesSecurities?: number, CostBasisSecurities?: number, NetGainSecurities?: number, GrossFundraisingReceipts?: number, FundraisingExpenses?: number, FundraisingNetIncome?: number, TotalRevenue?: number, OfficerCompensation?: number, DisqualifiedPersonCompensation?: number, OtherSalaries?: number, PensionContributions?: number, OtherEmployeeBenefits?: number, PayrollTaxes?: number, ManagementFees?: number, LegalFees?: number, AccountingFees?: number, LobbyingFees?: number, ProfessionalFundraisingFees?: number, InvestmentManagementFees?: number, OtherFees?: number, AdvertisingExpense?: number, OfficeExpense?: number, InformationTechnologyExpense?: number, RoyaltyExpense?: number, OccupancyExpense?: number, TravelExpense?: number, TravelExpensePublicOfficials?: number, ConferenceExpense?: number, InterestExpense?: number, AffiliatePaymentExpense?: number, DepreciationExpense?: number, InsuranceExpense?: number, Cash?: number, Savings?: number, PledgesGrantsReceivable?: number, AccountsReceivable?: number, ReceivablesFromOfficers?: number, ReceivablesFromDisqualifiedPersons?: number, NotesReceivable?: number, InventoryAssetValue?: number, PrepaidExpenseAssetValue?: number, RealEstateAssetValue?: number, PublicSecuritiesAssetValue?: number, OtherSecuritiesAssetValue?: number, ProgramInvestmentsAssetValue?: number, IntangibleAssetValue?: number, OtherAssets?: number, TotalAssets?: number, AccountsPayable?: number, GrantsPayable?: number, DeferredRevenue?: number, TaxExemptBondLiability?: number, EscrowAccountLiability?: number, PayablesToOfficers?: number, MortgagesNotesPayable?: number, UnsecuredNotesPayable?: number, OtherLiabilities?: number, TotalLiabilities?: number, UnrestrictedNetAssets?: number, TemporarilyRestrictedNetAssets?: number, PermanentlyRestrictedNetAssets?: number, CapitalStockPrincipal?: number, PaidInCapitalSurplus?: number, RetainedEarnings?: number, TotalNetAssets?: number, TotalNetAssetsPlusLiabilities?: number, AccountID?: number, SourceJSON?: string, SummaryText?: string, FinancialStrength?: string, Account?: string } };

export type TaxReturnDetailScalarsFragment = { __typename?: 'TaxReturnDetail', ID: number, TaxReturnID: number, Type: string, Name: string, StartingAmount?: number, EndingAmount: number, Code?: string };

export type SingleTaxReturnDetailQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnDetailQuery = { __typename?: 'Query', TaxReturnDetail?: { __typename?: 'TaxReturnDetail', ID: number, TaxReturnID: number, Type: string, Name: string, StartingAmount?: number, EndingAmount: number, Code?: string } };

export type SingleTaxReturnDetailFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnDetailFullQuery = { __typename?: 'Query', TaxReturnDetail?: { __typename?: 'TaxReturnDetail', ID: number, TaxReturnID: number, Type: string, Name: string, StartingAmount?: number, EndingAmount: number, Code?: string } };

export type CreateTaxReturnDetailMutationVariables = Exact<{
  input: CreateTaxReturnDetailInput;
}>;


export type CreateTaxReturnDetailMutation = { __typename?: 'Mutation', CreateTaxReturnDetail: { __typename?: 'TaxReturnDetail', ID: number, TaxReturnID: number, Type: string, Name: string, StartingAmount?: number, EndingAmount: number, Code?: string } };

export type TaxReturnCompensationScalarsFragment = { __typename?: 'TaxReturnCompensation', ID: number, TaxReturnID: number, PersonName: string, Title?: string, AverageHoursPerWeek?: number, IsOfficer: boolean, Compensation: number, RelatedOrgCompensation?: number, OtherCompensation?: number, TotalCompensation?: number, PartialYear: boolean, StartDate?: number, EndDate?: number, AnnualizedTotalCompensation?: number, ContactID?: number, Contact?: string };

export type SingleTaxReturnCompensationQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnCompensationQuery = { __typename?: 'Query', TaxReturnCompensation?: { __typename?: 'TaxReturnCompensation', ID: number, TaxReturnID: number, PersonName: string, Title?: string, AverageHoursPerWeek?: number, IsOfficer: boolean, Compensation: number, RelatedOrgCompensation?: number, OtherCompensation?: number, TotalCompensation?: number, PartialYear: boolean, StartDate?: number, EndDate?: number, AnnualizedTotalCompensation?: number, ContactID?: number, Contact?: string } };

export type SingleTaxReturnCompensationFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnCompensationFullQuery = { __typename?: 'Query', TaxReturnCompensation?: { __typename?: 'TaxReturnCompensation', ID: number, TaxReturnID: number, PersonName: string, Title?: string, AverageHoursPerWeek?: number, IsOfficer: boolean, Compensation: number, RelatedOrgCompensation?: number, OtherCompensation?: number, TotalCompensation?: number, PartialYear: boolean, StartDate?: number, EndDate?: number, AnnualizedTotalCompensation?: number, ContactID?: number, Contact?: string } };

export type CreateTaxReturnCompensationMutationVariables = Exact<{
  input: CreateTaxReturnCompensationInput;
}>;


export type CreateTaxReturnCompensationMutation = { __typename?: 'Mutation', CreateTaxReturnCompensation: { __typename?: 'TaxReturnCompensation', ID: number, TaxReturnID: number, PersonName: string, Title?: string, AverageHoursPerWeek?: number, IsOfficer: boolean, Compensation: number, RelatedOrgCompensation?: number, OtherCompensation?: number, TotalCompensation?: number, PartialYear: boolean, StartDate?: number, EndDate?: number, AnnualizedTotalCompensation?: number, ContactID?: number, Contact?: string } };

export type TaxReturnContractorScalarsFragment = { __typename?: 'TaxReturnContractor', ID: number, TaxReturnID: number, Name: string, Type: string, Amount: number, AddressLine1?: string, City?: string, StateProvince?: string, PostalCode?: string, AccountID?: number, Account?: string };

export type SingleTaxReturnContractorQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnContractorQuery = { __typename?: 'Query', TaxReturnContractor?: { __typename?: 'TaxReturnContractor', ID: number, TaxReturnID: number, Name: string, Type: string, Amount: number, AddressLine1?: string, City?: string, StateProvince?: string, PostalCode?: string, AccountID?: number, Account?: string } };

export type SingleTaxReturnContractorFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleTaxReturnContractorFullQuery = { __typename?: 'Query', TaxReturnContractor?: { __typename?: 'TaxReturnContractor', ID: number, TaxReturnID: number, Name: string, Type: string, Amount: number, AddressLine1?: string, City?: string, StateProvince?: string, PostalCode?: string, AccountID?: number, Account?: string } };

export type CreateTaxReturnContractorMutationVariables = Exact<{
  input: CreateTaxReturnContractorInput;
}>;


export type CreateTaxReturnContractorMutation = { __typename?: 'Mutation', CreateTaxReturnContractor: { __typename?: 'TaxReturnContractor', ID: number, TaxReturnID: number, Name: string, Type: string, Amount: number, AddressLine1?: string, City?: string, StateProvince?: string, PostalCode?: string, AccountID?: number, Account?: string } };

export type AIModelScalarsFragment = { __typename?: 'AIModel', ID: number, Name: string, Vendor?: string, AIModelTypeID: number, Description?: string, DriverClass?: string, DriverImportPath?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number };

export type SingleAIModelQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIModelQuery = { __typename?: 'Query', AIModel?: { __typename?: 'AIModel', ID: number, Name: string, Vendor?: string, AIModelTypeID: number, Description?: string, DriverClass?: string, DriverImportPath?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number } };

export type SingleAIModelFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIModelFullQuery = { __typename?: 'Query', AIModel?: { __typename?: 'AIModel', ID: number, Name: string, Vendor?: string, AIModelTypeID: number, Description?: string, DriverClass?: string, DriverImportPath?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number } };

export type AllAIModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAIModelsQuery = { __typename?: 'Query', AllAIModels: Array<{ __typename?: 'AIModel', ID: number, Name: string, Vendor?: string, AIModelTypeID: number, Description?: string, DriverClass?: string, DriverImportPath?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number }> };

export type UpdateAIModelMutationVariables = Exact<{
  input: UpdateAIModelInput;
}>;


export type UpdateAIModelMutation = { __typename?: 'Mutation', UpdateAIModel: { __typename?: 'AIModel', ID: number, Name: string, Vendor?: string, AIModelTypeID: number, Description?: string, DriverClass?: string, DriverImportPath?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number } };

export type AIActionScalarsFragment = { __typename?: 'AIAction', ID: number, Name: string, Description?: string, DefaultModelID?: number, DefaultPrompt?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number, DefaultModel?: string };

export type SingleAIActionQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIActionQuery = { __typename?: 'Query', AIAction?: { __typename?: 'AIAction', ID: number, Name: string, Description?: string, DefaultModelID?: number, DefaultPrompt?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number, DefaultModel?: string } };

export type SingleAIActionFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIActionFullQuery = { __typename?: 'Query', AIAction?: { __typename?: 'AIAction', ID: number, Name: string, Description?: string, DefaultModelID?: number, DefaultPrompt?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number, DefaultModel?: string } };

export type AllAIActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAIActionsQuery = { __typename?: 'Query', AllAIActions: Array<{ __typename?: 'AIAction', ID: number, Name: string, Description?: string, DefaultModelID?: number, DefaultPrompt?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number, DefaultModel?: string }> };

export type UpdateAIActionMutationVariables = Exact<{
  input: UpdateAIActionInput;
}>;


export type UpdateAIActionMutation = { __typename?: 'Mutation', UpdateAIAction: { __typename?: 'AIAction', ID: number, Name: string, Description?: string, DefaultModelID?: number, DefaultPrompt?: string, IsActive: boolean, CreatedAt: number, UpdatedAt: number, DefaultModel?: string } };

export type AIModelActionScalarsFragment = { __typename?: 'AIModelAction', ID: number, AIModelID: number, AIActionID: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, AIModel: string, AIAction: string };

export type SingleAIModelActionQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIModelActionQuery = { __typename?: 'Query', AIModelAction?: { __typename?: 'AIModelAction', ID: number, AIModelID: number, AIActionID: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, AIModel: string, AIAction: string } };

export type SingleAIModelActionFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIModelActionFullQuery = { __typename?: 'Query', AIModelAction?: { __typename?: 'AIModelAction', ID: number, AIModelID: number, AIActionID: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, AIModel: string, AIAction: string } };

export type AllAIModelActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAIModelActionsQuery = { __typename?: 'Query', AllAIModelActions: Array<{ __typename?: 'AIModelAction', ID: number, AIModelID: number, AIActionID: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, AIModel: string, AIAction: string }> };

export type UpdateAIModelActionMutationVariables = Exact<{
  input: UpdateAIModelActionInput;
}>;


export type UpdateAIModelActionMutation = { __typename?: 'Mutation', UpdateAIModelAction: { __typename?: 'AIModelAction', ID: number, AIModelID: number, AIActionID: number, IsActive: boolean, CreatedAt: number, UpdatedAt: number, AIModel: string, AIAction: string } };

export type EntityAIActionScalarsFragment = { __typename?: 'EntityAIAction', ID: number, EntityID: number, AIActionID: number, AIModelID?: number, Prompt?: string, TriggerEvent: string, UserMessage: string, OutputType: string, OutputField?: string, SkipIfOutputFieldNotEmpty: boolean, OutputEntityID?: number, Comments?: string, Entity: string, AIAction: string, AIModel?: string, OutputEntity?: string };

export type SingleEntityAIActionQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityAIActionQuery = { __typename?: 'Query', EntityAIAction?: { __typename?: 'EntityAIAction', ID: number, EntityID: number, AIActionID: number, AIModelID?: number, Prompt?: string, TriggerEvent: string, UserMessage: string, OutputType: string, OutputField?: string, SkipIfOutputFieldNotEmpty: boolean, OutputEntityID?: number, Comments?: string, Entity: string, AIAction: string, AIModel?: string, OutputEntity?: string } };

export type SingleEntityAIActionFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleEntityAIActionFullQuery = { __typename?: 'Query', EntityAIAction?: { __typename?: 'EntityAIAction', ID: number, EntityID: number, AIActionID: number, AIModelID?: number, Prompt?: string, TriggerEvent: string, UserMessage: string, OutputType: string, OutputField?: string, SkipIfOutputFieldNotEmpty: boolean, OutputEntityID?: number, Comments?: string, Entity: string, AIAction: string, AIModel?: string, OutputEntity?: string } };

export type UpdateEntityAIActionMutationVariables = Exact<{
  input: UpdateEntityAIActionInput;
}>;


export type UpdateEntityAIActionMutation = { __typename?: 'Mutation', UpdateEntityAIAction: { __typename?: 'EntityAIAction', ID: number, EntityID: number, AIActionID: number, AIModelID?: number, Prompt?: string, TriggerEvent: string, UserMessage: string, OutputType: string, OutputField?: string, SkipIfOutputFieldNotEmpty: boolean, OutputEntityID?: number, Comments?: string, Entity: string, AIAction: string, AIModel?: string, OutputEntity?: string } };

export type AIModelTypeScalarsFragment = { __typename?: 'AIModelType', ID: number, Name: string, Description?: string };

export type SingleAIModelTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIModelTypeQuery = { __typename?: 'Query', AIModelType?: { __typename?: 'AIModelType', ID: number, Name: string, Description?: string } };

export type SingleAIModelTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleAIModelTypeFullQuery = { __typename?: 'Query', AIModelType?: { __typename?: 'AIModelType', ID: number, Name: string, Description?: string } };

export type AllAIModelTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAIModelTypesQuery = { __typename?: 'Query', AllAIModelTypes: Array<{ __typename?: 'AIModelType', ID: number, Name: string, Description?: string }> };

export type UpdateAIModelTypeMutationVariables = Exact<{
  input: UpdateAIModelTypeInput;
}>;


export type UpdateAIModelTypeMutation = { __typename?: 'Mutation', UpdateAIModelType: { __typename?: 'AIModelType', ID: number, Name: string, Description?: string } };

export type ContactRoleScalarsFragment = { __typename?: 'ContactRole', ID: number, Name: string, Description?: string, Keywords?: string };

export type SingleContactRoleQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactRoleQuery = { __typename?: 'Query', ContactRole?: { __typename?: 'ContactRole', ID: number, Name: string, Description?: string, Keywords?: string } };

export type SingleContactRoleFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactRoleFullQuery = { __typename?: 'Query', ContactRole?: { __typename?: 'ContactRole', ID: number, Name: string, Description?: string, Keywords?: string } };

export type ContactLevelScalarsFragment = { __typename?: 'ContactLevel', ID: number, Name: string, Description?: string, Rank: number, Keywords?: string, ExcludeKeywords?: string };

export type SingleContactLevelQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactLevelQuery = { __typename?: 'Query', ContactLevel?: { __typename?: 'ContactLevel', ID: number, Name: string, Description?: string, Rank: number, Keywords?: string, ExcludeKeywords?: string } };

export type SingleContactLevelFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleContactLevelFullQuery = { __typename?: 'Query', ContactLevel?: { __typename?: 'ContactLevel', ID: number, Name: string, Description?: string, Rank: number, Keywords?: string, ExcludeKeywords?: string } };

export type QueueTypeScalarsFragment = { __typename?: 'QueueType', ID: number, Name: string, Description?: string, DriverClass: string, DriverImportPath?: string };

export type SingleQueueTypeQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleQueueTypeQuery = { __typename?: 'Query', QueueType?: { __typename?: 'QueueType', ID: number, Name: string, Description?: string, DriverClass: string, DriverImportPath?: string } };

export type SingleQueueTypeFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleQueueTypeFullQuery = { __typename?: 'Query', QueueType?: { __typename?: 'QueueType', ID: number, Name: string, Description?: string, DriverClass: string, DriverImportPath?: string } };

export type QueueScalarsFragment = { __typename?: 'Queue', ID: number, Name: string, Description?: string, QueueTypeID: number, IsActive: boolean, QueueType: string };

export type SingleQueueQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleQueueQuery = { __typename?: 'Query', Queue?: { __typename?: 'Queue', ID: number, Name: string, Description?: string, QueueTypeID: number, IsActive: boolean, QueueType: string } };

export type SingleQueueFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleQueueFullQuery = { __typename?: 'Query', Queue?: { __typename?: 'Queue', ID: number, Name: string, Description?: string, QueueTypeID: number, IsActive: boolean, QueueType: string } };

export type QueueTaskScalarsFragment = { __typename?: 'QueueTask', ID: number, QueueID: number, Status: string, StartedAt?: number, EndedAt?: number, Output?: string, ErrorMessage?: string, Comments?: string };

export type SingleQueueTaskQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleQueueTaskQuery = { __typename?: 'Query', QueueTask?: { __typename?: 'QueueTask', ID: number, QueueID: number, Status: string, StartedAt?: number, EndedAt?: number, Output?: string, ErrorMessage?: string, Comments?: string } };

export type SingleQueueTaskFullQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type SingleQueueTaskFullQuery = { __typename?: 'Query', QueueTask?: { __typename?: 'QueueTask', ID: number, QueueID: number, Status: string, StartedAt?: number, EndedAt?: number, Output?: string, ErrorMessage?: string, Comments?: string } };

export const AccountScalarsFragmentDoc = gql`
    fragment AccountScalars on Account {
  ID
  BCMID
  Name
  TaxID
  Acronym
  OperatingName
  DisplayName
  Description
  AddressLine1
  AddressLine2
  AddressLine3
  City
  StateProvince
  PostalCode
  Country
  ISOCountryCode
  Domain
  Website
  LogoURL
  LeadershipPageURL
  PhoneNumber
  LinkedIn
  Facebook
  Logo
  LastReviewedDate
  ActivityCount
  LatestActivityDate
  EarliestActivityDate
  CreatedAt
  UpdatedAt
  Latest990ID
  Subsection
  TaxYear
  TaxMonth
  TotalRevenue
  ManagementFees
  AccountingFees
  LegalFees
  AdvertisingExpense
  InformationTechnologyExpense
  TotalAssets
  NumberEmployees
  ProgramServiceRevenueNameA
  ProgramServiceRevenueNameB
  ProgramServiceRevenueNameC
  ProgramServiceRevenueNameD
  ProgramServiceRevenueNameE
  ProgramServiceRevenueA
  ProgramServiceRevenueB
  ProgramServiceRevenueC
  ProgramServiceRevenueD
  ProgramServiceRevenueE
}
    `;
export const ContactScalarsFragmentDoc = gql`
    fragment ContactScalars on Contact {
  ID
  BCMID
  FirstName
  NickName
  LastName
  AccountID
  LastReviewedDate
  Title
  RoleID
  LevelID
  Email1
  Email2
  EmailSource
  PhoneNumber
  ProfilePictureURL
  Twitter
  Instagram
  LinkedIn
  Facebook
  EmailStatus
  Prefix
  Suffix
  Tags
  Status
  ActivityCount
  LatestActivityDate
  EarliestActivityDate
  CreatedAt
  UpdatedAt
  FirstLast
  EmailDomain
  Account
  Domain
  Website
  Role
  Level
}
    `;
export const DealScalarsFragmentDoc = gql`
    fragment DealScalars on Deal {
  ID
  BCMID
  ExternalSystemRecordID
  CompanyIntegrationID
  AccountID
  ContactID
  Title
  Description
  Value
  IncludeInForecast
  Probability
  CloseDate
  EmployeeID
  Pipeline
  LeadSource
  LeadSourceDetail
  ExternalSystemCreatedAt
  ExternalSystemUpdatedAt
  DealTypeID
  DealStageID
  CreatedAt
  UpdatedAt
  DealForecastCategoryID
  MRR
  OneTimeFees
  ContractTermMonths
  ForecastNotes
  CompanyID
  Company
  CompanyLogoURL
  Account
  ContactFirstName
  ContactLastName
  ContactTitle
  ContactEmail1
  ContactPhoneNumber
  EmployeeEmail
  EmployeeFirstName
  EmployeeLastName
  EmployeeTitle
  EmployeeSupervisorEmail
  EmployeeSupervisor
}
    `;
export const ActivityScalarsFragmentDoc = gql`
    fragment ActivityScalars on Activity {
  ID
  BCMID
  EmployeeID
  ContactID
  AccountID
  DealID
  ActivityDate
  IsActive
  Description
  Summary
  Type
  Attachment
  CompanyIntegrationID
  ExternalSystemRecordID
  CreatedAt
  UpdatedAt
  AttachmentID
  Title
  IsOpened
  IsBounced
  IsReplied
  EmployeeFirstName
  EmployeeLastName
  EmployeeEmail
  EmployeeSupervisor
  EmployeeSupervisorFirstName
  EmployeeSupervisorLastName
  EmployeeSupervisorEmail
  Account
  AccountWebsite
  ContactFirstName
  ContactLastName
  ContactEmail
  Deal
  Integration
  Company
  CompanyID
}
    `;
export const CompanyScalarsFragmentDoc = gql`
    fragment CompanyScalars on Company {
  ID
  Name
  Description
  Website
  LogoURL
  CreatedAt
  UpdatedAt
  Domain
}
    `;
export const EmployeeScalarsFragmentDoc = gql`
    fragment EmployeeScalars on Employee {
  ID
  BCMID
  FirstName
  LastName
  Title
  Email
  Phone
  Active
  CompanyID
  SupervisorID
  CreatedAt
  UpdatedAt
  FirstLast
  Supervisor
  SupervisorFirstName
  SupervisorLastName
  SupervisorEmail
}
    `;
export const UserFavoriteScalarsFragmentDoc = gql`
    fragment UserFavoriteScalars on UserFavorite {
  ID
  UserID
  EntityID
  RecordID
  CreatedAt
  UpdatedAt
  Entity
  EntityBaseTable
  EntityBaseView
}
    `;
export const AccountCompanyIntegrationScalarsFragmentDoc = gql`
    fragment AccountCompanyIntegrationScalars on AccountCompanyIntegration {
  ID
  AccountID
  CompanyIntegrationID
  ExternalSystemRecordID
  CreatedAt
  UpdatedAt
  AccountTypeID
  CompanyID
  CompanyName
  Account
  AccountType
}
    `;
export const ContactCompanyIntegrationScalarsFragmentDoc = gql`
    fragment ContactCompanyIntegrationScalars on ContactCompanyIntegration {
  ID
  ContactID
  CompanyIntegrationID
  ExternalSystemRecordID
  CreatedAt
  UpdatedAt
  CompanyID
  CompanyName
}
    `;
export const ActivityAttachmentScalarsFragmentDoc = gql`
    fragment ActivityAttachmentScalars on ActivityAttachment {
  ID
  Attachments
  CreatedAt
  UpdatedAt
}
    `;
export const ProjectScalarsFragmentDoc = gql`
    fragment ProjectScalars on Project {
  ID
  Name
  ExternalSystemRecordID
  StartDate
  DueDate
  IsDeleted
  CreatedAt
  UpdatedAt
  FixedFee
  ProjectRate
  CompanyIntegrationID
  EmployeeID
  AccountID
  BillingTypeID
  RateTypeID
  StatusID
  BudgetAmount
  Employee
  BillingType
  RateType
  Status
}
    `;
export const RoleScalarsFragmentDoc = gql`
    fragment RoleScalars on Role {
  ID
  Name
  Description
  AzureID
  SQLName
  CreatedAt
  UpdatedAt
}
    `;
export const SkillScalarsFragmentDoc = gql`
    fragment SkillScalars on Skill {
  ID
  Name
  ParentID
  CreatedAt
  UpdatedAt
}
    `;
export const TaskScalarsFragmentDoc = gql`
    fragment TaskScalars on Task {
  ID
  ExternalSystemRecordID
  Name
  ParentID
  AssignedEmployeeID
  Role
  Skills
  BudgetedEffort
  ActualEffort
  EstimateToComplete
  StartDate
  EndDate
  IsCompleted
  IsDeleted
  CreatedAt
  UpdatedAt
  ProjectID
  Section
  Status
  ForecastedEffort
  ForecastedVariance
  ActualVariance
  CalculatedActual
  TaskTypeID
  Parent
  AssignedEmployee
  Project
}
    `;
export const TaskTypeScalarsFragmentDoc = gql`
    fragment TaskTypeScalars on TaskType {
  ID
  Name
  ParentID
  CreatedAt
  UpdatedAt
  IsActive
}
    `;
export const IntegrationURLFormatScalarsFragmentDoc = gql`
    fragment IntegrationURLFormatScalars on IntegrationURLFormat {
  ID
  IntegrationID
  EntityID
  URLFormat
  NavigationBaseURL
  FullURLFormat
}
    `;
export const IntegrationScalarsFragmentDoc = gql`
    fragment IntegrationScalars on Integration {
  ID
  Name
  Description
  NavigationBaseURL
  ClassName
  ImportPath
  BatchMaxRequestCount
  BatchRequestWaitTime
  CreatedAt
  UpdatedAt
}
    `;
export const CompanyIntegrationScalarsFragmentDoc = gql`
    fragment CompanyIntegrationScalars on CompanyIntegration {
  ID
  CompanyID
  IntegrationID
  IsActive
  AccessToken
  RefreshToken
  TokenExpirationDate
  APIKey
  CreatedAt
  UpdatedAt
  ExternalSystemID
  IsExternalSystemReadOnly
  ClientID
  ClientSecret
  CustomAttribute1
  Company
  Integration
  DriverClassName
  DriverImportPath
  LastRunID
  LastRunStartedAt
  LastRunEndedAt
}
    `;
export const EntityFieldScalarsFragmentDoc = gql`
    fragment EntityFieldScalars on EntityField {
  ID
  EntityID
  Sequence
  Name
  DisplayName
  Description
  Category
  Type
  Length
  Precision
  Scale
  AllowsNull
  DefaultValue
  AutoIncrement
  ValueListType
  ExtendedType
  DefaultInView
  ViewCellTemplate
  DefaultColumnWidth
  AllowUpdateAPI
  AllowUpdateInView
  IncludeInUserSearchAPI
  UserSearchParamFormatAPI
  IncludeInGeneratedForm
  GeneratedFormSection
  IsVirtual
  IsNameField
  RelatedEntityID
  RelatedEntityFieldName
  IncludeRelatedEntityNameFieldInBaseView
  RelatedEntityNameFieldMap
  CreatedAt
  UpdatedAt
  Entity
  SchemaName
  BaseTable
  BaseView
  EntityCodeName
  EntityClassName
  RelatedEntity
  RelatedEntitySchemaName
  RelatedEntityBaseTable
  RelatedEntityBaseView
  RelatedEntityCodeName
  RelatedEntityClassName
}
    `;
export const EntityScalarsFragmentDoc = gql`
    fragment EntityScalars on Entity {
  ID
  ParentID
  Name
  Description
  BaseTable
  BaseView
  BaseViewGenerated
  SchemaName
  TrackRecordChanges
  AuditRecordAccess
  AuditViewRuns
  IncludeInAPI
  AllowAllRowsAPI
  AllowUpdateAPI
  AllowCreateAPI
  AllowDeleteAPI
  CustomResolverAPI
  AllowUserSearchAPI
  UserViewMaxRows
  spCreate
  spUpdate
  spDelete
  spCreateGenerated
  spUpdateGenerated
  spDeleteGenerated
  UserFormGenerated
  UserFormClassName
  UserFormImportPath
  EntityObjectSubclassName
  EntityObjectSubclassImportPath
  CreatedAt
  UpdatedAt
  CodeName
  ClassName
  BaseTableCodeName
  ParentEntity
  ParentBaseTable
  ParentBaseView
}
    `;
export const UserScalarsFragmentDoc = gql`
    fragment UserScalars on User {
  ID
  Name
  Type
  EmployeeID
  IsActive
  CreatedAt
  UpdatedAt
  FirstLast
  Email
  Supervisor
  SupervisorEmail
}
    `;
export const EntityRelationshipScalarsFragmentDoc = gql`
    fragment EntityRelationshipScalars on EntityRelationship {
  ID
  EntityID
  RelatedEntityID
  BundleInAPI
  IncludeInParentAllQuery
  Type
  EntityKeyField
  RelatedEntityJoinField
  JoinView
  JoinEntityJoinField
  JoinEntityInverseJoinField
  DisplayInForm
  DisplayName
  DisplayUserViewID
  CreatedAt
  UpdatedAt
  Entity
  EntityBaseTable
  EntityBaseView
  RelatedEntity
  RelatedEntityBaseTable
  RelatedEntityBaseView
  RelatedEntityClassName
  RelatedEntityCodeName
  RelatedEntityBaseTableCodeName
}
    `;
export const UserRecordLogScalarsFragmentDoc = gql`
    fragment UserRecordLogScalars on UserRecordLog {
  ID
  UserID
  EntityID
  RecordID
  EarliestAt
  LatestAt
  TotalCount
  Entity
  UserName
  UserFirstLast
  UserEmail
  UserSupervisor
  UserSupervisorEmail
}
    `;
export const UserViewScalarsFragmentDoc = gql`
    fragment UserViewScalars on UserView {
  ID
  UserID
  EntityID
  Name
  Description
  IsShared
  IsDefault
  GridState
  FilterState
  CustomFilterState
  WhereClause
  CustomWhereClause
  CreatedAt
  UpdatedAt
  UserName
  UserFirstLast
  UserEmail
  UserType
  Entity
  EntityBaseView
}
    `;
export const ContactTopicScalarsFragmentDoc = gql`
    fragment ContactTopicScalars on ContactTopic {
  ID
  ContactID
  Topic
  TotalCount
  EarliestDate
  LatestDate
  Contact
  Account
  Domain
  Website
}
    `;
export const PaymentScalarsFragmentDoc = gql`
    fragment PaymentScalars on Payment {
  ID
  BCMID
  InvoiceID
  PaymentDate
  Amount
  Description
  CompanyIntegrationID
  ExternalSystemRecordID
  DocumentNumber
  Comments
  CreatedAt
  UpdatedAt
  AccountID
  Company
  CompanyID
  Account
  AccountWebsite
  Contact
  ContactEmail
}
    `;
export const InvoiceScalarsFragmentDoc = gql`
    fragment InvoiceScalars on Invoice {
  ID
  BCMID
  InvoiceDate
  AccountID
  ContactID
  SubTotal
  Tax
  Total
  CompanyIntegrationID
  ExternalSystemRecordID
  InvoiceNumber
  PostingDate
  DueDate
  StatusID
  PaymentTermsID
  CreatedAt
  UpdatedAt
  Company
  Account
  AccountWebsite
  Contact
  ContactEmail
  CompanyID
}
    `;
export const EmailServiceProvidersScalarsFragmentDoc = gql`
    fragment EmailServiceProvidersScalars on EmailServiceProviders {
  ID
  Domain
}
    `;
export const _990FullScalarsFragmentDoc = gql`
    fragment _990FullScalars on _990Full {
  ID
  EIN
  Name
  ICO
  Street
  City
  State
  Zip
  Group
  Subsection
  Affiliation
  Classification
  Ruling
  Deductibility
  Foundation
  Activity
  Organization
  Status
  TaxPeriod
  TaxYear
  TaxMonth
  AssetCode
  IncomeCode
  FilingRequirementCode
  SortName
  PoliticalActivities
  LobbyingActivities
  FundraisingActivities
  IsHospital
  GrantsToOrgs
  GrantsToIndividuals
  HasInvestmentIncome
  TotalInvestmentIncome
  NumberEmployees
  HasForeignBankAcct
  TotalGrossReceipts
  TotalMemberIncome
  TotalProgramServiceRevenue
  ProgramServiceRevenueCodeA
  ProgramServiceRevenueA
  ProgramServiceRevenueCodeB
  ProgramServiceRevenueB
  ProgramServiceRevenueCodeC
  ProgramServiceRevenueC
  ProgramServiceRevenueCodeD
  ProgramServiceRevenueD
  ProgramServiceRevenueCodeE
  ProgramServiceRevenueE
  GrossRentsFromRealEstate
  RentalExpenseRealEstate
  NetRentRealEstate
  GrossSalesSecurities
  CostBasisSecurities
  NetGainSecurities
  GrossFundraisingReceipts
  FundraisingExpenses
  FundraisingNetIncome
  TotalRevenue
  OfficerCompensation
  DisqualifiedPersonCompensation
  OtherSalaries
  PensionContributions
  OtherEmployeeBenefits
  PayrollTaxes
  ManagementFees
  LegalFees
  AccountingFees
  LobbyingFees
  ProfessionalFundraisingFees
  InvestmentManagementFees
  OtherFees
  AdvertisingExpense
  OfficeExpense
  InformationTechnologyExpense
  RoyaltyExpense
  OccupancyExpense
  TravelExpense
  TravelExpensePublicOfficials
  ConferenceExpense
  InterestExpense
  AffiliatePaymentExpense
  DepreciationExpense
  InsuranceExpense
  Cash
  Savings
  PledgesGrantsReceivable
  AccountsReceivable
  ReceivablesFromOfficers
  ReceivablesFromDisqualifiedPersons
  NotesReceivable
  InventoryAssetValue
  PrepaidExpenseAssetValue
  RealEstateAssetValue
  PublicSecuritiesAssetValue
  OtherSecuritiesAssetValue
  ProgramInvestmentsAssetValue
  IntangibleAssetValue
  OtherAssets
  TotalAssets
  AccountsPayable
  GrantsPayable
  DeferredRevenue
  TaxExemptBondLiability
  EscrowAccountLiability
  PayablesToOfficers
  MortgagesNotesPayable
  UnsecuredNotesPayable
  OtherLiabilities
  TotalLiabilities
  UnrestrictedNetAssets
  TemporarilyRestrictedNetAssets
  PermanentlyRestrictedNetAssets
  CapitalStockPrincipal
  PaidInCapitalSurplus
  RetainedEarnings
  TotalNetAssets
  TotalNetAssetsPlusLiabilities
  ProgramServiceRevenueNameA
  ProgramServiceRevenueNameB
  ProgramServiceRevenueNameC
  ProgramServiceRevenueNameD
  ProgramServiceRevenueNameE
  AccountID
}
    `;
export const _990LatestScalarsFragmentDoc = gql`
    fragment _990LatestScalars on _990Latest {
  ID
  EIN
  Name
  ICO
  Street
  City
  State
  Zip
  Group
  Subsection
  Affiliation
  Classification
  Ruling
  Deductibility
  Foundation
  Activity
  Organization
  Status
  TaxPeriod
  TaxYear
  TaxMonth
  AssetCode
  IncomeCode
  FilingRequirementCode
  SortName
  PoliticalActivities
  LobbyingActivities
  FundraisingActivities
  IsHospital
  GrantsToOrgs
  GrantsToIndividuals
  HasInvestmentIncome
  TotalInvestmentIncome
  NumberEmployees
  HasForeignBankAcct
  TotalGrossReceipts
  TotalMemberIncome
  TotalProgramServiceRevenue
  ProgramServiceRevenueCodeA
  ProgramServiceRevenueA
  ProgramServiceRevenueCodeB
  ProgramServiceRevenueB
  ProgramServiceRevenueCodeC
  ProgramServiceRevenueC
  ProgramServiceRevenueCodeD
  ProgramServiceRevenueD
  ProgramServiceRevenueCodeE
  ProgramServiceRevenueE
  GrossRentsFromRealEstate
  RentalExpenseRealEstate
  NetRentRealEstate
  GrossSalesSecurities
  CostBasisSecurities
  NetGainSecurities
  GrossFundraisingReceipts
  FundraisingExpenses
  FundraisingNetIncome
  TotalRevenue
  OfficerCompensation
  DisqualifiedPersonCompensation
  OtherSalaries
  PensionContributions
  OtherEmployeeBenefits
  PayrollTaxes
  ManagementFees
  LegalFees
  AccountingFees
  LobbyingFees
  ProfessionalFundraisingFees
  InvestmentManagementFees
  OtherFees
  AdvertisingExpense
  OfficeExpense
  InformationTechnologyExpense
  RoyaltyExpense
  OccupancyExpense
  TravelExpense
  TravelExpensePublicOfficials
  ConferenceExpense
  InterestExpense
  AffiliatePaymentExpense
  DepreciationExpense
  InsuranceExpense
  Cash
  Savings
  PledgesGrantsReceivable
  AccountsReceivable
  ReceivablesFromOfficers
  ReceivablesFromDisqualifiedPersons
  NotesReceivable
  InventoryAssetValue
  PrepaidExpenseAssetValue
  RealEstateAssetValue
  PublicSecuritiesAssetValue
  OtherSecuritiesAssetValue
  ProgramInvestmentsAssetValue
  IntangibleAssetValue
  OtherAssets
  TotalAssets
  AccountsPayable
  GrantsPayable
  DeferredRevenue
  TaxExemptBondLiability
  EscrowAccountLiability
  PayablesToOfficers
  MortgagesNotesPayable
  UnsecuredNotesPayable
  OtherLiabilities
  TotalLiabilities
  UnrestrictedNetAssets
  TemporarilyRestrictedNetAssets
  PermanentlyRestrictedNetAssets
  CapitalStockPrincipal
  PaidInCapitalSurplus
  RetainedEarnings
  TotalNetAssets
  TotalNetAssetsPlusLiabilities
  ProgramServiceRevenueNameA
  ProgramServiceRevenueNameB
  ProgramServiceRevenueNameC
  ProgramServiceRevenueNameD
  ProgramServiceRevenueNameE
  AccountID
}
    `;
export const ContactEmailScalarsFragmentDoc = gql`
    fragment ContactEmailScalars on ContactEmail {
  ID
  ContactID
  Email
  AccountID
  IsActive
  EmailDomain
  Contact
  Account
}
    `;
export const ContactAccountScalarsFragmentDoc = gql`
    fragment ContactAccountScalars on ContactAccount {
  ID
  ContactID
  AccountID
  Sequence
  StartedAt
  EndedAt
  IsPrimary
  Contact
  Account
}
    `;
export const LifecycleStageScalarsFragmentDoc = gql`
    fragment LifecycleStageScalars on LifecycleStage {
  ID
  Name
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const DealStageScalarsFragmentDoc = gql`
    fragment DealStageScalars on DealStage {
  ID
  Name
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const AccountTypeScalarsFragmentDoc = gql`
    fragment AccountTypeScalars on AccountType {
  ID
  Name
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const TimeEntryScalarsFragmentDoc = gql`
    fragment TimeEntryScalars on TimeEntry {
  ID
  Date
  Effort
  IsDeleted
  CreatedAt
  UpdatedAt
  EmployeeID
  TaskID
  Comment
  ExternalSystemRecordID
  IsInvoiced
  IsLocked
  Employee
  Task
}
    `;
export const DealTypeScalarsFragmentDoc = gql`
    fragment DealTypeScalars on DealType {
  ID
  Name
  Description
  CreatedAt
  UpdatedAt
  DisplayName
}
    `;
export const ApplicationScalarsFragmentDoc = gql`
    fragment ApplicationScalars on Application {
  ID
  Name
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const ApplicationEntityScalarsFragmentDoc = gql`
    fragment ApplicationEntityScalars on ApplicationEntity {
  ID
  ApplicationID
  EntityID
  Sequence
  DefaultForNewUser
  CreatedAt
  UpdatedAt
  Application
  Entity
  EntityBaseTable
  EntityCodeName
  EntityClassName
  EntityBaseTableCodeName
}
    `;
export const EntityPermissionScalarsFragmentDoc = gql`
    fragment EntityPermissionScalars on EntityPermission {
  ID
  EntityID
  RoleID
  CanCreate
  CanRead
  CanUpdate
  CanDelete
  ReadRLSFilterID
  CreateRLSFilterID
  UpdateRLSFilterID
  DeleteRLSFilterID
  CreatedAt
  UpdatedAt
  Entity
  Role
  RoleSQLName
  CreateRLSFilter
  ReadRLSFilter
  UpdateRLSFilter
  DeleteRLSFilter
}
    `;
export const ApplicationPermissionScalarsFragmentDoc = gql`
    fragment ApplicationPermissionScalars on ApplicationPermission {
  ID
  ApplicationID
  RoleID
  CreatedAt
  UpdatedAt
  Application
  Role
}
    `;
export const UserApplicationEntityScalarsFragmentDoc = gql`
    fragment UserApplicationEntityScalars on UserApplicationEntity {
  ID
  UserApplicationID
  EntityID
  Sequence
  Application
  User
  Entity
}
    `;
export const UserApplicationScalarsFragmentDoc = gql`
    fragment UserApplicationScalars on UserApplication {
  ID
  UserID
  ApplicationID
  Sequence
  IsActive
  User
  Application
}
    `;
export const ProjectStatusTypeScalarsFragmentDoc = gql`
    fragment ProjectStatusTypeScalars on ProjectStatusType {
  ID
  Name
  Code
  Description
  CreatedAt
  UpdatedAt
  IsClosed
}
    `;
export const ProjectRateTypeScalarsFragmentDoc = gql`
    fragment ProjectRateTypeScalars on ProjectRateType {
  ID
  Name
  Code
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const ProjectBillingTypeScalarsFragmentDoc = gql`
    fragment ProjectBillingTypeScalars on ProjectBillingType {
  ID
  Name
  Code
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const ListScalarsFragmentDoc = gql`
    fragment ListScalars on List {
  ID
  Name
  Description
  EntityID
  UserID
  CreatedAt
  UpdatedAt
  Entity
  User
}
    `;
export const ListDetailScalarsFragmentDoc = gql`
    fragment ListDetailScalars on ListDetail {
  ID
  ListID
  RecordID
  Sequence
}
    `;
export const UserViewRunScalarsFragmentDoc = gql`
    fragment UserViewRunScalars on UserViewRun {
  ID
  UserViewID
  RunAt
  RunByUserID
  UserView
  RunByUser
}
    `;
export const UserViewRunDetailScalarsFragmentDoc = gql`
    fragment UserViewRunDetailScalars on UserViewRunDetail {
  ID
  UserViewRunID
  RecordID
  UserViewID
  EntityID
}
    `;
export const WorkflowRunScalarsFragmentDoc = gql`
    fragment WorkflowRunScalars on WorkflowRun {
  ID
  WorkflowID
  ExternalSystemRecordID
  StartedAt
  EndedAt
  Status
  Results
  Workflow
  WorkflowEngine
}
    `;
export const WorkflowScalarsFragmentDoc = gql`
    fragment WorkflowScalars on Workflow {
  ID
  Name
  Description
  WorkflowEngineID
  CompanyID
  ExternalSystemRecordID
  CreatedAt
  UpdatedAt
  WorkflowEngine
}
    `;
export const CampaignScalarsFragmentDoc = gql`
    fragment CampaignScalars on Campaign {
  ID
  BCMID
  Name
  EmployeeID
  StatusID
  ExternalSystemCreatedAt
  CompanyIntegrationID
  ExternalSystemRecordID
  CreatedAt
  UpdatedAt
  Employee
}
    `;
export const CampaignStepScalarsFragmentDoc = gql`
    fragment CampaignStepScalars on CampaignStep {
  ID
  CampaignID
  Sequence
  Subject
  Body
  ExternalSystemRecordID
  CreatedAt
  UpdatedAt
}
    `;
export const WorkflowEngineScalarsFragmentDoc = gql`
    fragment WorkflowEngineScalars on WorkflowEngine {
  ID
  Name
  Description
  DriverPath
  DriverClass
  CreatedAt
  UpdatedAt
}
    `;
export const RecordChangeScalarsFragmentDoc = gql`
    fragment RecordChangeScalars on RecordChange {
  ID
  EntityID
  RecordID
  UserID
  ChangedAt
  ChangesJSON
  ChangesDescription
  FullRecordJSON
  Status
  Comments
  Entity
  User
}
    `;
export const TeamScalarsFragmentDoc = gql`
    fragment TeamScalars on Team {
  ID
  Type
  UpdatedAt
}
    `;
export const UserRoleScalarsFragmentDoc = gql`
    fragment UserRoleScalars on UserRole {
  ID
  UserID
  RoleID
  CreatedAt
  UpdatedAt
  User
  Role
}
    `;
export const RowLevelSecurityFilterScalarsFragmentDoc = gql`
    fragment RowLevelSecurityFilterScalars on RowLevelSecurityFilter {
  ID
  Name
  Description
  FilterText
  CreatedAt
  UpdatedAt
}
    `;
export const AuditLogScalarsFragmentDoc = gql`
    fragment AuditLogScalars on AuditLog {
  ID
  AuditLogTypeID
  UserID
  AuthorizationID
  Status
  Details
  EntityID
  RecordID
  CreatedAt
  UpdatedAt
  AuditLogType
  User
  Entity
}
    `;
export const AuthorizationScalarsFragmentDoc = gql`
    fragment AuthorizationScalars on Authorization {
  ID
  ParentID
  Name
  IsActive
  UseAuditLog
  Description
  CreatedAt
  UpdatedAt
}
    `;
export const AuthorizationRoleScalarsFragmentDoc = gql`
    fragment AuthorizationRoleScalars on AuthorizationRole {
  ID
  AuthorizationID
  RoleID
  Type
  CreatedAt
  UpdatedAt
  Role
}
    `;
export const AuditLogTypeScalarsFragmentDoc = gql`
    fragment AuditLogTypeScalars on AuditLogType {
  ID
  ParentID
  Name
  Description
  AuthorizationID
  CreatedAt
  UpdatedAt
  Parent
}
    `;
export const EntityFieldValueScalarsFragmentDoc = gql`
    fragment EntityFieldValueScalars on EntityFieldValue {
  ID
  EntityFieldID
  Sequence
  Value
  Code
  Description
  CreatedAt
  UpdatedAt
  EntityField
}
    `;
export const TaxReturnScalarsFragmentDoc = gql`
    fragment TaxReturnScalars on TaxReturn {
  ID
  TaxID
  Name
  ReturnType
  TaxPeriodStart
  TaxPeriodEnd
  TaxYear
  TaxMonth
  AddressLine1
  AddressLine2
  City
  StateProvince
  PostalCode
  Website
  Subsection
  Affiliation
  YearFormed
  ActivityDescription
  MissionDescription
  BODVotingMembers
  PreparerFirm
  PreparerFirmTaxID
  PreparerFirmAddressLine1
  PreparerFirmAddressLine2
  PreparerFirmCity
  PreparerFirmStateProvince
  PreparerFirmPostalCode
  PreparerPerson
  PreparerPersonTaxID
  PreparerPersonPhone
  IsHospital
  GrantsToOrgs
  GrantsToIndividuals
  HasInvestmentIncome
  TotalInvestmentIncome
  NumberEmployees
  NumberVolunteers
  HasForeignBankAcct
  TotalGrossReceipts
  TotalMemberIncome
  TotalProgramServiceRevenue
  GrossRentsFromRealEstate
  RentalExpenseRealEstate
  NetRentRealEstate
  GrossSalesSecurities
  CostBasisSecurities
  NetGainSecurities
  GrossFundraisingReceipts
  FundraisingExpenses
  FundraisingNetIncome
  TotalRevenue
  OfficerCompensation
  DisqualifiedPersonCompensation
  OtherSalaries
  PensionContributions
  OtherEmployeeBenefits
  PayrollTaxes
  ManagementFees
  LegalFees
  AccountingFees
  LobbyingFees
  ProfessionalFundraisingFees
  InvestmentManagementFees
  OtherFees
  AdvertisingExpense
  OfficeExpense
  InformationTechnologyExpense
  RoyaltyExpense
  OccupancyExpense
  TravelExpense
  TravelExpensePublicOfficials
  ConferenceExpense
  InterestExpense
  AffiliatePaymentExpense
  DepreciationExpense
  InsuranceExpense
  Cash
  Savings
  PledgesGrantsReceivable
  AccountsReceivable
  ReceivablesFromOfficers
  ReceivablesFromDisqualifiedPersons
  NotesReceivable
  InventoryAssetValue
  PrepaidExpenseAssetValue
  RealEstateAssetValue
  PublicSecuritiesAssetValue
  OtherSecuritiesAssetValue
  ProgramInvestmentsAssetValue
  IntangibleAssetValue
  OtherAssets
  TotalAssets
  AccountsPayable
  GrantsPayable
  DeferredRevenue
  TaxExemptBondLiability
  EscrowAccountLiability
  PayablesToOfficers
  MortgagesNotesPayable
  UnsecuredNotesPayable
  OtherLiabilities
  TotalLiabilities
  UnrestrictedNetAssets
  TemporarilyRestrictedNetAssets
  PermanentlyRestrictedNetAssets
  CapitalStockPrincipal
  PaidInCapitalSurplus
  RetainedEarnings
  TotalNetAssets
  TotalNetAssetsPlusLiabilities
  AccountID
  SourceJSON
  SummaryText
  FinancialStrength
  Account
}
    `;
export const TaxReturnDetailScalarsFragmentDoc = gql`
    fragment TaxReturnDetailScalars on TaxReturnDetail {
  ID
  TaxReturnID
  Type
  Name
  StartingAmount
  EndingAmount
  Code
}
    `;
export const TaxReturnCompensationScalarsFragmentDoc = gql`
    fragment TaxReturnCompensationScalars on TaxReturnCompensation {
  ID
  TaxReturnID
  PersonName
  Title
  AverageHoursPerWeek
  IsOfficer
  Compensation
  RelatedOrgCompensation
  OtherCompensation
  TotalCompensation
  PartialYear
  StartDate
  EndDate
  AnnualizedTotalCompensation
  ContactID
  Contact
}
    `;
export const TaxReturnContractorScalarsFragmentDoc = gql`
    fragment TaxReturnContractorScalars on TaxReturnContractor {
  ID
  TaxReturnID
  Name
  Type
  Amount
  AddressLine1
  City
  StateProvince
  PostalCode
  AccountID
  Account
}
    `;
export const AIModelScalarsFragmentDoc = gql`
    fragment AIModelScalars on AIModel {
  ID
  Name
  Vendor
  AIModelTypeID
  Description
  DriverClass
  DriverImportPath
  IsActive
  CreatedAt
  UpdatedAt
}
    `;
export const AIActionScalarsFragmentDoc = gql`
    fragment AIActionScalars on AIAction {
  ID
  Name
  Description
  DefaultModelID
  DefaultPrompt
  IsActive
  CreatedAt
  UpdatedAt
  DefaultModel
}
    `;
export const AIModelActionScalarsFragmentDoc = gql`
    fragment AIModelActionScalars on AIModelAction {
  ID
  AIModelID
  AIActionID
  IsActive
  CreatedAt
  UpdatedAt
  AIModel
  AIAction
}
    `;
export const EntityAIActionScalarsFragmentDoc = gql`
    fragment EntityAIActionScalars on EntityAIAction {
  ID
  EntityID
  AIActionID
  AIModelID
  Prompt
  TriggerEvent
  UserMessage
  OutputType
  OutputField
  SkipIfOutputFieldNotEmpty
  OutputEntityID
  Comments
  Entity
  AIAction
  AIModel
  OutputEntity
}
    `;
export const AIModelTypeScalarsFragmentDoc = gql`
    fragment AIModelTypeScalars on AIModelType {
  ID
  Name
  Description
}
    `;
export const ContactRoleScalarsFragmentDoc = gql`
    fragment ContactRoleScalars on ContactRole {
  ID
  Name
  Description
  Keywords
}
    `;
export const ContactLevelScalarsFragmentDoc = gql`
    fragment ContactLevelScalars on ContactLevel {
  ID
  Name
  Description
  Rank
  Keywords
  ExcludeKeywords
}
    `;
export const QueueTypeScalarsFragmentDoc = gql`
    fragment QueueTypeScalars on QueueType {
  ID
  Name
  Description
  DriverClass
  DriverImportPath
}
    `;
export const QueueScalarsFragmentDoc = gql`
    fragment QueueScalars on Queue {
  ID
  Name
  Description
  QueueTypeID
  IsActive
  QueueType
}
    `;
export const QueueTaskScalarsFragmentDoc = gql`
    fragment QueueTaskScalars on QueueTask {
  ID
  QueueID
  Status
  StartedAt
  EndedAt
  Output
  ErrorMessage
  Comments
}
    `;
export const EntitiesProviderDocument = gql`
    query EntitiesProvider {
  AllEntities {
    ...EntityScalars
    EntityFields {
      ...EntityFieldScalars
    }
    EntityRelationships {
      ...EntityRelationshipScalars
    }
  }
  AllApplications {
    ...ApplicationScalars
    ApplicationEntities {
      ...ApplicationEntityScalars
    }
  }
}
    ${EntityScalarsFragmentDoc}
${EntityFieldScalarsFragmentDoc}
${EntityRelationshipScalarsFragmentDoc}
${ApplicationScalarsFragmentDoc}
${ApplicationEntityScalarsFragmentDoc}`;

/**
 * __useEntitiesProviderQuery__
 *
 * To run a query within a React component, call `useEntitiesProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitiesProviderQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesProviderQuery, EntitiesProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesProviderQuery, EntitiesProviderQueryVariables>(EntitiesProviderDocument, options);
      }
export function useEntitiesProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesProviderQuery, EntitiesProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesProviderQuery, EntitiesProviderQueryVariables>(EntitiesProviderDocument, options);
        }
export type EntitiesProviderQueryHookResult = ReturnType<typeof useEntitiesProviderQuery>;
export type EntitiesProviderLazyQueryHookResult = ReturnType<typeof useEntitiesProviderLazyQuery>;
export type EntitiesProviderQueryResult = Apollo.QueryResult<EntitiesProviderQuery, EntitiesProviderQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  CurrentUser {
    ...UserScalars
  }
}
    ${UserScalarsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UserDocument = gql`
    query User($UserID: Int!) {
  UserFavoritesByUserID(UserID: $UserID) {
    ...UserFavoriteScalars
  }
  UserViewsByUserID(UserID: $UserID) {
    ...UserViewScalars
  }
}
    ${UserFavoriteScalarsFragmentDoc}
${UserViewScalarsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      UserID: // value for 'UserID'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const SingleAccountDocument = gql`
    query SingleAccount($ID: Int!) {
  Account(ID: $ID) {
    ...AccountScalars
  }
}
    ${AccountScalarsFragmentDoc}`;

/**
 * __useSingleAccountQuery__
 *
 * To run a query within a React component, call `useSingleAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAccountQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAccountQuery(baseOptions: Apollo.QueryHookOptions<SingleAccountQuery, SingleAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAccountQuery, SingleAccountQueryVariables>(SingleAccountDocument, options);
      }
export function useSingleAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAccountQuery, SingleAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAccountQuery, SingleAccountQueryVariables>(SingleAccountDocument, options);
        }
export type SingleAccountQueryHookResult = ReturnType<typeof useSingleAccountQuery>;
export type SingleAccountLazyQueryHookResult = ReturnType<typeof useSingleAccountLazyQuery>;
export type SingleAccountQueryResult = Apollo.QueryResult<SingleAccountQuery, SingleAccountQueryVariables>;
export const SingleAccountFullDocument = gql`
    query SingleAccountFull($ID: Int!) {
  Account(ID: $ID) {
    ...AccountScalars
    Contacts {
      ...ContactScalars
    }
    Deals {
      ...DealScalars
    }
    Activities {
      ...ActivityScalars
    }
    Companies {
      ...CompanyScalars
    }
    Invoices {
      ...InvoiceScalars
    }
    _990Full {
      ..._990FullScalars
    }
    AccountCompanyIntegrations {
      ...AccountCompanyIntegrationScalars
    }
  }
}
    ${AccountScalarsFragmentDoc}
${ContactScalarsFragmentDoc}
${DealScalarsFragmentDoc}
${ActivityScalarsFragmentDoc}
${CompanyScalarsFragmentDoc}
${InvoiceScalarsFragmentDoc}
${_990FullScalarsFragmentDoc}
${AccountCompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleAccountFullQuery__
 *
 * To run a query within a React component, call `useSingleAccountFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAccountFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAccountFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAccountFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAccountFullQuery, SingleAccountFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAccountFullQuery, SingleAccountFullQueryVariables>(SingleAccountFullDocument, options);
      }
export function useSingleAccountFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAccountFullQuery, SingleAccountFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAccountFullQuery, SingleAccountFullQueryVariables>(SingleAccountFullDocument, options);
        }
export type SingleAccountFullQueryHookResult = ReturnType<typeof useSingleAccountFullQuery>;
export type SingleAccountFullLazyQueryHookResult = ReturnType<typeof useSingleAccountFullLazyQuery>;
export type SingleAccountFullQueryResult = Apollo.QueryResult<SingleAccountFullQuery, SingleAccountFullQueryVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: CreateAccountInput!) {
  CreateAccount(input: $input) {
    ...AccountScalars
  }
}
    ${AccountScalarsFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($input: UpdateAccountInput!) {
  UpdateAccount(input: $input) {
    ...AccountScalars
  }
}
    ${AccountScalarsFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($ID: Int!) {
  DeleteAccount(ID: $ID)
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const SingleContactDocument = gql`
    query SingleContact($ID: Int!) {
  Contact(ID: $ID) {
    ...ContactScalars
  }
}
    ${ContactScalarsFragmentDoc}`;

/**
 * __useSingleContactQuery__
 *
 * To run a query within a React component, call `useSingleContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactQuery(baseOptions: Apollo.QueryHookOptions<SingleContactQuery, SingleContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactQuery, SingleContactQueryVariables>(SingleContactDocument, options);
      }
export function useSingleContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactQuery, SingleContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactQuery, SingleContactQueryVariables>(SingleContactDocument, options);
        }
export type SingleContactQueryHookResult = ReturnType<typeof useSingleContactQuery>;
export type SingleContactLazyQueryHookResult = ReturnType<typeof useSingleContactLazyQuery>;
export type SingleContactQueryResult = Apollo.QueryResult<SingleContactQuery, SingleContactQueryVariables>;
export const SingleContactFullDocument = gql`
    query SingleContactFull($ID: Int!) {
  Contact(ID: $ID) {
    ...ContactScalars
    ContactEmails {
      ...ContactEmailScalars
    }
    ContactAccounts {
      ...ContactAccountScalars
    }
    Invoices {
      ...InvoiceScalars
    }
    ContactTopics {
      ...ContactTopicScalars
    }
    Companies {
      ...CompanyScalars
    }
    Deals {
      ...DealScalars
    }
    Activities {
      ...ActivityScalars
    }
  }
}
    ${ContactScalarsFragmentDoc}
${ContactEmailScalarsFragmentDoc}
${ContactAccountScalarsFragmentDoc}
${InvoiceScalarsFragmentDoc}
${ContactTopicScalarsFragmentDoc}
${CompanyScalarsFragmentDoc}
${DealScalarsFragmentDoc}
${ActivityScalarsFragmentDoc}`;

/**
 * __useSingleContactFullQuery__
 *
 * To run a query within a React component, call `useSingleContactFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactFullQuery, SingleContactFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactFullQuery, SingleContactFullQueryVariables>(SingleContactFullDocument, options);
      }
export function useSingleContactFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactFullQuery, SingleContactFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactFullQuery, SingleContactFullQueryVariables>(SingleContactFullDocument, options);
        }
export type SingleContactFullQueryHookResult = ReturnType<typeof useSingleContactFullQuery>;
export type SingleContactFullLazyQueryHookResult = ReturnType<typeof useSingleContactFullLazyQuery>;
export type SingleContactFullQueryResult = Apollo.QueryResult<SingleContactFullQuery, SingleContactFullQueryVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  CreateContact(input: $input) {
    ...ContactScalars
  }
}
    ${ContactScalarsFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateContactInput!) {
  UpdateContact(input: $input) {
    ...ContactScalars
  }
}
    ${ContactScalarsFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($ID: Int!) {
  DeleteContact(ID: $ID)
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const SingleDealDocument = gql`
    query SingleDeal($ID: Int!) {
  Deal(ID: $ID) {
    ...DealScalars
  }
}
    ${DealScalarsFragmentDoc}`;

/**
 * __useSingleDealQuery__
 *
 * To run a query within a React component, call `useSingleDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleDealQuery(baseOptions: Apollo.QueryHookOptions<SingleDealQuery, SingleDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealQuery, SingleDealQueryVariables>(SingleDealDocument, options);
      }
export function useSingleDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealQuery, SingleDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealQuery, SingleDealQueryVariables>(SingleDealDocument, options);
        }
export type SingleDealQueryHookResult = ReturnType<typeof useSingleDealQuery>;
export type SingleDealLazyQueryHookResult = ReturnType<typeof useSingleDealLazyQuery>;
export type SingleDealQueryResult = Apollo.QueryResult<SingleDealQuery, SingleDealQueryVariables>;
export const SingleDealFullDocument = gql`
    query SingleDealFull($ID: Int!) {
  Deal(ID: $ID) {
    ...DealScalars
    Activities {
      ...ActivityScalars
    }
  }
}
    ${DealScalarsFragmentDoc}
${ActivityScalarsFragmentDoc}`;

/**
 * __useSingleDealFullQuery__
 *
 * To run a query within a React component, call `useSingleDealFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleDealFullQuery(baseOptions: Apollo.QueryHookOptions<SingleDealFullQuery, SingleDealFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealFullQuery, SingleDealFullQueryVariables>(SingleDealFullDocument, options);
      }
export function useSingleDealFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealFullQuery, SingleDealFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealFullQuery, SingleDealFullQueryVariables>(SingleDealFullDocument, options);
        }
export type SingleDealFullQueryHookResult = ReturnType<typeof useSingleDealFullQuery>;
export type SingleDealFullLazyQueryHookResult = ReturnType<typeof useSingleDealFullLazyQuery>;
export type SingleDealFullQueryResult = Apollo.QueryResult<SingleDealFullQuery, SingleDealFullQueryVariables>;
export const AllDealsDocument = gql`
    query AllDeals {
  AllDeals {
    ...DealScalars
  }
}
    ${DealScalarsFragmentDoc}`;

/**
 * __useAllDealsQuery__
 *
 * To run a query within a React component, call `useAllDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDealsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDealsQuery(baseOptions?: Apollo.QueryHookOptions<AllDealsQuery, AllDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDealsQuery, AllDealsQueryVariables>(AllDealsDocument, options);
      }
export function useAllDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDealsQuery, AllDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDealsQuery, AllDealsQueryVariables>(AllDealsDocument, options);
        }
export type AllDealsQueryHookResult = ReturnType<typeof useAllDealsQuery>;
export type AllDealsLazyQueryHookResult = ReturnType<typeof useAllDealsLazyQuery>;
export type AllDealsQueryResult = Apollo.QueryResult<AllDealsQuery, AllDealsQueryVariables>;
export const CreateDealDocument = gql`
    mutation CreateDeal($input: CreateDealInput!) {
  CreateDeal(input: $input) {
    ...DealScalars
  }
}
    ${DealScalarsFragmentDoc}`;
export type CreateDealMutationFn = Apollo.MutationFunction<CreateDealMutation, CreateDealMutationVariables>;

/**
 * __useCreateDealMutation__
 *
 * To run a mutation, you first call `useCreateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealMutation, { data, loading, error }] = useCreateDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDealMutation(baseOptions?: Apollo.MutationHookOptions<CreateDealMutation, CreateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDealMutation, CreateDealMutationVariables>(CreateDealDocument, options);
      }
export type CreateDealMutationHookResult = ReturnType<typeof useCreateDealMutation>;
export type CreateDealMutationResult = Apollo.MutationResult<CreateDealMutation>;
export type CreateDealMutationOptions = Apollo.BaseMutationOptions<CreateDealMutation, CreateDealMutationVariables>;
export const UpdateDealDocument = gql`
    mutation UpdateDeal($input: UpdateDealInput!) {
  UpdateDeal(input: $input) {
    ...DealScalars
  }
}
    ${DealScalarsFragmentDoc}`;
export type UpdateDealMutationFn = Apollo.MutationFunction<UpdateDealMutation, UpdateDealMutationVariables>;

/**
 * __useUpdateDealMutation__
 *
 * To run a mutation, you first call `useUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealMutation, { data, loading, error }] = useUpdateDealMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDealMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealMutation, UpdateDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealMutation, UpdateDealMutationVariables>(UpdateDealDocument, options);
      }
export type UpdateDealMutationHookResult = ReturnType<typeof useUpdateDealMutation>;
export type UpdateDealMutationResult = Apollo.MutationResult<UpdateDealMutation>;
export type UpdateDealMutationOptions = Apollo.BaseMutationOptions<UpdateDealMutation, UpdateDealMutationVariables>;
export const DeleteDealDocument = gql`
    mutation DeleteDeal($ID: Int!) {
  DeleteDeal(ID: $ID)
}
    `;
export type DeleteDealMutationFn = Apollo.MutationFunction<DeleteDealMutation, DeleteDealMutationVariables>;

/**
 * __useDeleteDealMutation__
 *
 * To run a mutation, you first call `useDeleteDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealMutation, { data, loading, error }] = useDeleteDealMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteDealMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDealMutation, DeleteDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDealMutation, DeleteDealMutationVariables>(DeleteDealDocument, options);
      }
export type DeleteDealMutationHookResult = ReturnType<typeof useDeleteDealMutation>;
export type DeleteDealMutationResult = Apollo.MutationResult<DeleteDealMutation>;
export type DeleteDealMutationOptions = Apollo.BaseMutationOptions<DeleteDealMutation, DeleteDealMutationVariables>;
export const SingleActivityDocument = gql`
    query SingleActivity($ID: Int!) {
  Activity(ID: $ID) {
    ...ActivityScalars
  }
}
    ${ActivityScalarsFragmentDoc}`;

/**
 * __useSingleActivityQuery__
 *
 * To run a query within a React component, call `useSingleActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleActivityQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleActivityQuery(baseOptions: Apollo.QueryHookOptions<SingleActivityQuery, SingleActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleActivityQuery, SingleActivityQueryVariables>(SingleActivityDocument, options);
      }
export function useSingleActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleActivityQuery, SingleActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleActivityQuery, SingleActivityQueryVariables>(SingleActivityDocument, options);
        }
export type SingleActivityQueryHookResult = ReturnType<typeof useSingleActivityQuery>;
export type SingleActivityLazyQueryHookResult = ReturnType<typeof useSingleActivityLazyQuery>;
export type SingleActivityQueryResult = Apollo.QueryResult<SingleActivityQuery, SingleActivityQueryVariables>;
export const SingleActivityFullDocument = gql`
    query SingleActivityFull($ID: Int!) {
  Activity(ID: $ID) {
    ...ActivityScalars
  }
}
    ${ActivityScalarsFragmentDoc}`;

/**
 * __useSingleActivityFullQuery__
 *
 * To run a query within a React component, call `useSingleActivityFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleActivityFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleActivityFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleActivityFullQuery(baseOptions: Apollo.QueryHookOptions<SingleActivityFullQuery, SingleActivityFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleActivityFullQuery, SingleActivityFullQueryVariables>(SingleActivityFullDocument, options);
      }
export function useSingleActivityFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleActivityFullQuery, SingleActivityFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleActivityFullQuery, SingleActivityFullQueryVariables>(SingleActivityFullDocument, options);
        }
export type SingleActivityFullQueryHookResult = ReturnType<typeof useSingleActivityFullQuery>;
export type SingleActivityFullLazyQueryHookResult = ReturnType<typeof useSingleActivityFullLazyQuery>;
export type SingleActivityFullQueryResult = Apollo.QueryResult<SingleActivityFullQuery, SingleActivityFullQueryVariables>;
export const UpdateActivityDocument = gql`
    mutation UpdateActivity($input: UpdateActivityInput!) {
  UpdateActivity(input: $input) {
    ...ActivityScalars
  }
}
    ${ActivityScalarsFragmentDoc}`;
export type UpdateActivityMutationFn = Apollo.MutationFunction<UpdateActivityMutation, UpdateActivityMutationVariables>;

/**
 * __useUpdateActivityMutation__
 *
 * To run a mutation, you first call `useUpdateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityMutation, { data, loading, error }] = useUpdateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityMutation, UpdateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, options);
      }
export type UpdateActivityMutationHookResult = ReturnType<typeof useUpdateActivityMutation>;
export type UpdateActivityMutationResult = Apollo.MutationResult<UpdateActivityMutation>;
export type UpdateActivityMutationOptions = Apollo.BaseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const SingleCompanyDocument = gql`
    query SingleCompany($ID: Int!) {
  Company(ID: $ID) {
    ...CompanyScalars
  }
}
    ${CompanyScalarsFragmentDoc}`;

/**
 * __useSingleCompanyQuery__
 *
 * To run a query within a React component, call `useSingleCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCompanyQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCompanyQuery(baseOptions: Apollo.QueryHookOptions<SingleCompanyQuery, SingleCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCompanyQuery, SingleCompanyQueryVariables>(SingleCompanyDocument, options);
      }
export function useSingleCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCompanyQuery, SingleCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCompanyQuery, SingleCompanyQueryVariables>(SingleCompanyDocument, options);
        }
export type SingleCompanyQueryHookResult = ReturnType<typeof useSingleCompanyQuery>;
export type SingleCompanyLazyQueryHookResult = ReturnType<typeof useSingleCompanyLazyQuery>;
export type SingleCompanyQueryResult = Apollo.QueryResult<SingleCompanyQuery, SingleCompanyQueryVariables>;
export const SingleCompanyFullDocument = gql`
    query SingleCompanyFull($ID: Int!) {
  Company(ID: $ID) {
    ...CompanyScalars
    Employees {
      ...EmployeeScalars
    }
    AccountCompanyIntegrations {
      ...AccountCompanyIntegrationScalars
    }
    Accounts {
      ...AccountScalars
    }
    Contacts {
      ...ContactScalars
    }
    Deals {
      ...DealScalars
    }
    Invoices {
      ...InvoiceScalars
    }
  }
}
    ${CompanyScalarsFragmentDoc}
${EmployeeScalarsFragmentDoc}
${AccountCompanyIntegrationScalarsFragmentDoc}
${AccountScalarsFragmentDoc}
${ContactScalarsFragmentDoc}
${DealScalarsFragmentDoc}
${InvoiceScalarsFragmentDoc}`;

/**
 * __useSingleCompanyFullQuery__
 *
 * To run a query within a React component, call `useSingleCompanyFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCompanyFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCompanyFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCompanyFullQuery(baseOptions: Apollo.QueryHookOptions<SingleCompanyFullQuery, SingleCompanyFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCompanyFullQuery, SingleCompanyFullQueryVariables>(SingleCompanyFullDocument, options);
      }
export function useSingleCompanyFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCompanyFullQuery, SingleCompanyFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCompanyFullQuery, SingleCompanyFullQueryVariables>(SingleCompanyFullDocument, options);
        }
export type SingleCompanyFullQueryHookResult = ReturnType<typeof useSingleCompanyFullQuery>;
export type SingleCompanyFullLazyQueryHookResult = ReturnType<typeof useSingleCompanyFullLazyQuery>;
export type SingleCompanyFullQueryResult = Apollo.QueryResult<SingleCompanyFullQuery, SingleCompanyFullQueryVariables>;
export const AllCompaniesDocument = gql`
    query AllCompanies {
  AllCompanies {
    ...CompanyScalars
  }
}
    ${CompanyScalarsFragmentDoc}`;

/**
 * __useAllCompaniesQuery__
 *
 * To run a query within a React component, call `useAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
      }
export function useAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export type AllCompaniesQueryHookResult = ReturnType<typeof useAllCompaniesQuery>;
export type AllCompaniesLazyQueryHookResult = ReturnType<typeof useAllCompaniesLazyQuery>;
export type AllCompaniesQueryResult = Apollo.QueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($input: CreateCompanyInput!) {
  CreateCompany(input: $input) {
    ...CompanyScalars
  }
}
    ${CompanyScalarsFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: UpdateCompanyInput!) {
  UpdateCompany(input: $input) {
    ...CompanyScalars
  }
}
    ${CompanyScalarsFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($ID: Int!) {
  DeleteCompany(ID: $ID)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const SingleEmployeeDocument = gql`
    query SingleEmployee($ID: Int!) {
  Employee(ID: $ID) {
    ...EmployeeScalars
  }
}
    ${EmployeeScalarsFragmentDoc}`;

/**
 * __useSingleEmployeeQuery__
 *
 * To run a query within a React component, call `useSingleEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEmployeeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEmployeeQuery(baseOptions: Apollo.QueryHookOptions<SingleEmployeeQuery, SingleEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEmployeeQuery, SingleEmployeeQueryVariables>(SingleEmployeeDocument, options);
      }
export function useSingleEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEmployeeQuery, SingleEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEmployeeQuery, SingleEmployeeQueryVariables>(SingleEmployeeDocument, options);
        }
export type SingleEmployeeQueryHookResult = ReturnType<typeof useSingleEmployeeQuery>;
export type SingleEmployeeLazyQueryHookResult = ReturnType<typeof useSingleEmployeeLazyQuery>;
export type SingleEmployeeQueryResult = Apollo.QueryResult<SingleEmployeeQuery, SingleEmployeeQueryVariables>;
export const SingleEmployeeFullDocument = gql`
    query SingleEmployeeFull($ID: Int!) {
  Employee(ID: $ID) {
    ...EmployeeScalars
    Employees {
      ...EmployeeScalars
    }
  }
}
    ${EmployeeScalarsFragmentDoc}`;

/**
 * __useSingleEmployeeFullQuery__
 *
 * To run a query within a React component, call `useSingleEmployeeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEmployeeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEmployeeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEmployeeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEmployeeFullQuery, SingleEmployeeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEmployeeFullQuery, SingleEmployeeFullQueryVariables>(SingleEmployeeFullDocument, options);
      }
export function useSingleEmployeeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEmployeeFullQuery, SingleEmployeeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEmployeeFullQuery, SingleEmployeeFullQueryVariables>(SingleEmployeeFullDocument, options);
        }
export type SingleEmployeeFullQueryHookResult = ReturnType<typeof useSingleEmployeeFullQuery>;
export type SingleEmployeeFullLazyQueryHookResult = ReturnType<typeof useSingleEmployeeFullLazyQuery>;
export type SingleEmployeeFullQueryResult = Apollo.QueryResult<SingleEmployeeFullQuery, SingleEmployeeFullQueryVariables>;
export const AllEmployeesDocument = gql`
    query AllEmployees {
  AllEmployees {
    ...EmployeeScalars
  }
}
    ${EmployeeScalarsFragmentDoc}`;

/**
 * __useAllEmployeesQuery__
 *
 * To run a query within a React component, call `useAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<AllEmployeesQuery, AllEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEmployeesQuery, AllEmployeesQueryVariables>(AllEmployeesDocument, options);
      }
export function useAllEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEmployeesQuery, AllEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEmployeesQuery, AllEmployeesQueryVariables>(AllEmployeesDocument, options);
        }
export type AllEmployeesQueryHookResult = ReturnType<typeof useAllEmployeesQuery>;
export type AllEmployeesLazyQueryHookResult = ReturnType<typeof useAllEmployeesLazyQuery>;
export type AllEmployeesQueryResult = Apollo.QueryResult<AllEmployeesQuery, AllEmployeesQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($input: CreateEmployeeInput!) {
  CreateEmployee(input: $input) {
    ...EmployeeScalars
  }
}
    ${EmployeeScalarsFragmentDoc}`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($input: UpdateEmployeeInput!) {
  UpdateEmployee(input: $input) {
    ...EmployeeScalars
  }
}
    ${EmployeeScalarsFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($ID: Int!) {
  DeleteEmployee(ID: $ID)
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const SingleUserFavoriteDocument = gql`
    query SingleUserFavorite($ID: Int!) {
  UserFavorite(ID: $ID) {
    ...UserFavoriteScalars
  }
}
    ${UserFavoriteScalarsFragmentDoc}`;

/**
 * __useSingleUserFavoriteQuery__
 *
 * To run a query within a React component, call `useSingleUserFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserFavoriteQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserFavoriteQuery(baseOptions: Apollo.QueryHookOptions<SingleUserFavoriteQuery, SingleUserFavoriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserFavoriteQuery, SingleUserFavoriteQueryVariables>(SingleUserFavoriteDocument, options);
      }
export function useSingleUserFavoriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserFavoriteQuery, SingleUserFavoriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserFavoriteQuery, SingleUserFavoriteQueryVariables>(SingleUserFavoriteDocument, options);
        }
export type SingleUserFavoriteQueryHookResult = ReturnType<typeof useSingleUserFavoriteQuery>;
export type SingleUserFavoriteLazyQueryHookResult = ReturnType<typeof useSingleUserFavoriteLazyQuery>;
export type SingleUserFavoriteQueryResult = Apollo.QueryResult<SingleUserFavoriteQuery, SingleUserFavoriteQueryVariables>;
export const SingleUserFavoriteFullDocument = gql`
    query SingleUserFavoriteFull($ID: Int!) {
  UserFavorite(ID: $ID) {
    ...UserFavoriteScalars
  }
}
    ${UserFavoriteScalarsFragmentDoc}`;

/**
 * __useSingleUserFavoriteFullQuery__
 *
 * To run a query within a React component, call `useSingleUserFavoriteFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserFavoriteFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserFavoriteFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserFavoriteFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserFavoriteFullQuery, SingleUserFavoriteFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserFavoriteFullQuery, SingleUserFavoriteFullQueryVariables>(SingleUserFavoriteFullDocument, options);
      }
export function useSingleUserFavoriteFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserFavoriteFullQuery, SingleUserFavoriteFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserFavoriteFullQuery, SingleUserFavoriteFullQueryVariables>(SingleUserFavoriteFullDocument, options);
        }
export type SingleUserFavoriteFullQueryHookResult = ReturnType<typeof useSingleUserFavoriteFullQuery>;
export type SingleUserFavoriteFullLazyQueryHookResult = ReturnType<typeof useSingleUserFavoriteFullLazyQuery>;
export type SingleUserFavoriteFullQueryResult = Apollo.QueryResult<SingleUserFavoriteFullQuery, SingleUserFavoriteFullQueryVariables>;
export const CreateUserFavoriteDocument = gql`
    mutation CreateUserFavorite($input: CreateUserFavoriteInput!) {
  CreateUserFavorite(input: $input) {
    ...UserFavoriteScalars
  }
}
    ${UserFavoriteScalarsFragmentDoc}`;
export type CreateUserFavoriteMutationFn = Apollo.MutationFunction<CreateUserFavoriteMutation, CreateUserFavoriteMutationVariables>;

/**
 * __useCreateUserFavoriteMutation__
 *
 * To run a mutation, you first call `useCreateUserFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFavoriteMutation, { data, loading, error }] = useCreateUserFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFavoriteMutation, CreateUserFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFavoriteMutation, CreateUserFavoriteMutationVariables>(CreateUserFavoriteDocument, options);
      }
export type CreateUserFavoriteMutationHookResult = ReturnType<typeof useCreateUserFavoriteMutation>;
export type CreateUserFavoriteMutationResult = Apollo.MutationResult<CreateUserFavoriteMutation>;
export type CreateUserFavoriteMutationOptions = Apollo.BaseMutationOptions<CreateUserFavoriteMutation, CreateUserFavoriteMutationVariables>;
export const UpdateUserFavoriteDocument = gql`
    mutation UpdateUserFavorite($input: UpdateUserFavoriteInput!) {
  UpdateUserFavorite(input: $input) {
    ...UserFavoriteScalars
  }
}
    ${UserFavoriteScalarsFragmentDoc}`;
export type UpdateUserFavoriteMutationFn = Apollo.MutationFunction<UpdateUserFavoriteMutation, UpdateUserFavoriteMutationVariables>;

/**
 * __useUpdateUserFavoriteMutation__
 *
 * To run a mutation, you first call `useUpdateUserFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFavoriteMutation, { data, loading, error }] = useUpdateUserFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserFavoriteMutation, UpdateUserFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserFavoriteMutation, UpdateUserFavoriteMutationVariables>(UpdateUserFavoriteDocument, options);
      }
export type UpdateUserFavoriteMutationHookResult = ReturnType<typeof useUpdateUserFavoriteMutation>;
export type UpdateUserFavoriteMutationResult = Apollo.MutationResult<UpdateUserFavoriteMutation>;
export type UpdateUserFavoriteMutationOptions = Apollo.BaseMutationOptions<UpdateUserFavoriteMutation, UpdateUserFavoriteMutationVariables>;
export const DeleteUserFavoriteDocument = gql`
    mutation DeleteUserFavorite($ID: Int!) {
  DeleteUserFavorite(ID: $ID)
}
    `;
export type DeleteUserFavoriteMutationFn = Apollo.MutationFunction<DeleteUserFavoriteMutation, DeleteUserFavoriteMutationVariables>;

/**
 * __useDeleteUserFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteUserFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFavoriteMutation, { data, loading, error }] = useDeleteUserFavoriteMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteUserFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserFavoriteMutation, DeleteUserFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserFavoriteMutation, DeleteUserFavoriteMutationVariables>(DeleteUserFavoriteDocument, options);
      }
export type DeleteUserFavoriteMutationHookResult = ReturnType<typeof useDeleteUserFavoriteMutation>;
export type DeleteUserFavoriteMutationResult = Apollo.MutationResult<DeleteUserFavoriteMutation>;
export type DeleteUserFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteUserFavoriteMutation, DeleteUserFavoriteMutationVariables>;
export const SingleAccountCompanyIntegrationDocument = gql`
    query SingleAccountCompanyIntegration($ID: Int!) {
  AccountCompanyIntegration(ID: $ID) {
    ...AccountCompanyIntegrationScalars
  }
}
    ${AccountCompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleAccountCompanyIntegrationQuery__
 *
 * To run a query within a React component, call `useSingleAccountCompanyIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAccountCompanyIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAccountCompanyIntegrationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAccountCompanyIntegrationQuery(baseOptions: Apollo.QueryHookOptions<SingleAccountCompanyIntegrationQuery, SingleAccountCompanyIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAccountCompanyIntegrationQuery, SingleAccountCompanyIntegrationQueryVariables>(SingleAccountCompanyIntegrationDocument, options);
      }
export function useSingleAccountCompanyIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAccountCompanyIntegrationQuery, SingleAccountCompanyIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAccountCompanyIntegrationQuery, SingleAccountCompanyIntegrationQueryVariables>(SingleAccountCompanyIntegrationDocument, options);
        }
export type SingleAccountCompanyIntegrationQueryHookResult = ReturnType<typeof useSingleAccountCompanyIntegrationQuery>;
export type SingleAccountCompanyIntegrationLazyQueryHookResult = ReturnType<typeof useSingleAccountCompanyIntegrationLazyQuery>;
export type SingleAccountCompanyIntegrationQueryResult = Apollo.QueryResult<SingleAccountCompanyIntegrationQuery, SingleAccountCompanyIntegrationQueryVariables>;
export const SingleAccountCompanyIntegrationFullDocument = gql`
    query SingleAccountCompanyIntegrationFull($ID: Int!) {
  AccountCompanyIntegration(ID: $ID) {
    ...AccountCompanyIntegrationScalars
  }
}
    ${AccountCompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleAccountCompanyIntegrationFullQuery__
 *
 * To run a query within a React component, call `useSingleAccountCompanyIntegrationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAccountCompanyIntegrationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAccountCompanyIntegrationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAccountCompanyIntegrationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAccountCompanyIntegrationFullQuery, SingleAccountCompanyIntegrationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAccountCompanyIntegrationFullQuery, SingleAccountCompanyIntegrationFullQueryVariables>(SingleAccountCompanyIntegrationFullDocument, options);
      }
export function useSingleAccountCompanyIntegrationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAccountCompanyIntegrationFullQuery, SingleAccountCompanyIntegrationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAccountCompanyIntegrationFullQuery, SingleAccountCompanyIntegrationFullQueryVariables>(SingleAccountCompanyIntegrationFullDocument, options);
        }
export type SingleAccountCompanyIntegrationFullQueryHookResult = ReturnType<typeof useSingleAccountCompanyIntegrationFullQuery>;
export type SingleAccountCompanyIntegrationFullLazyQueryHookResult = ReturnType<typeof useSingleAccountCompanyIntegrationFullLazyQuery>;
export type SingleAccountCompanyIntegrationFullQueryResult = Apollo.QueryResult<SingleAccountCompanyIntegrationFullQuery, SingleAccountCompanyIntegrationFullQueryVariables>;
export const UpdateAccountCompanyIntegrationDocument = gql`
    mutation UpdateAccountCompanyIntegration($input: UpdateAccountCompanyIntegrationInput!) {
  UpdateAccountCompanyIntegration(input: $input) {
    ...AccountCompanyIntegrationScalars
  }
}
    ${AccountCompanyIntegrationScalarsFragmentDoc}`;
export type UpdateAccountCompanyIntegrationMutationFn = Apollo.MutationFunction<UpdateAccountCompanyIntegrationMutation, UpdateAccountCompanyIntegrationMutationVariables>;

/**
 * __useUpdateAccountCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateAccountCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountCompanyIntegrationMutation, { data, loading, error }] = useUpdateAccountCompanyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountCompanyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountCompanyIntegrationMutation, UpdateAccountCompanyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountCompanyIntegrationMutation, UpdateAccountCompanyIntegrationMutationVariables>(UpdateAccountCompanyIntegrationDocument, options);
      }
export type UpdateAccountCompanyIntegrationMutationHookResult = ReturnType<typeof useUpdateAccountCompanyIntegrationMutation>;
export type UpdateAccountCompanyIntegrationMutationResult = Apollo.MutationResult<UpdateAccountCompanyIntegrationMutation>;
export type UpdateAccountCompanyIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateAccountCompanyIntegrationMutation, UpdateAccountCompanyIntegrationMutationVariables>;
export const SingleContactCompanyIntegrationDocument = gql`
    query SingleContactCompanyIntegration($ID: Int!) {
  ContactCompanyIntegration(ID: $ID) {
    ...ContactCompanyIntegrationScalars
  }
}
    ${ContactCompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleContactCompanyIntegrationQuery__
 *
 * To run a query within a React component, call `useSingleContactCompanyIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactCompanyIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactCompanyIntegrationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactCompanyIntegrationQuery(baseOptions: Apollo.QueryHookOptions<SingleContactCompanyIntegrationQuery, SingleContactCompanyIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactCompanyIntegrationQuery, SingleContactCompanyIntegrationQueryVariables>(SingleContactCompanyIntegrationDocument, options);
      }
export function useSingleContactCompanyIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactCompanyIntegrationQuery, SingleContactCompanyIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactCompanyIntegrationQuery, SingleContactCompanyIntegrationQueryVariables>(SingleContactCompanyIntegrationDocument, options);
        }
export type SingleContactCompanyIntegrationQueryHookResult = ReturnType<typeof useSingleContactCompanyIntegrationQuery>;
export type SingleContactCompanyIntegrationLazyQueryHookResult = ReturnType<typeof useSingleContactCompanyIntegrationLazyQuery>;
export type SingleContactCompanyIntegrationQueryResult = Apollo.QueryResult<SingleContactCompanyIntegrationQuery, SingleContactCompanyIntegrationQueryVariables>;
export const SingleContactCompanyIntegrationFullDocument = gql`
    query SingleContactCompanyIntegrationFull($ID: Int!) {
  ContactCompanyIntegration(ID: $ID) {
    ...ContactCompanyIntegrationScalars
  }
}
    ${ContactCompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleContactCompanyIntegrationFullQuery__
 *
 * To run a query within a React component, call `useSingleContactCompanyIntegrationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactCompanyIntegrationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactCompanyIntegrationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactCompanyIntegrationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactCompanyIntegrationFullQuery, SingleContactCompanyIntegrationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactCompanyIntegrationFullQuery, SingleContactCompanyIntegrationFullQueryVariables>(SingleContactCompanyIntegrationFullDocument, options);
      }
export function useSingleContactCompanyIntegrationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactCompanyIntegrationFullQuery, SingleContactCompanyIntegrationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactCompanyIntegrationFullQuery, SingleContactCompanyIntegrationFullQueryVariables>(SingleContactCompanyIntegrationFullDocument, options);
        }
export type SingleContactCompanyIntegrationFullQueryHookResult = ReturnType<typeof useSingleContactCompanyIntegrationFullQuery>;
export type SingleContactCompanyIntegrationFullLazyQueryHookResult = ReturnType<typeof useSingleContactCompanyIntegrationFullLazyQuery>;
export type SingleContactCompanyIntegrationFullQueryResult = Apollo.QueryResult<SingleContactCompanyIntegrationFullQuery, SingleContactCompanyIntegrationFullQueryVariables>;
export const UpdateContactCompanyIntegrationDocument = gql`
    mutation UpdateContactCompanyIntegration($input: UpdateContactCompanyIntegrationInput!) {
  UpdateContactCompanyIntegration(input: $input) {
    ...ContactCompanyIntegrationScalars
  }
}
    ${ContactCompanyIntegrationScalarsFragmentDoc}`;
export type UpdateContactCompanyIntegrationMutationFn = Apollo.MutationFunction<UpdateContactCompanyIntegrationMutation, UpdateContactCompanyIntegrationMutationVariables>;

/**
 * __useUpdateContactCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateContactCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCompanyIntegrationMutation, { data, loading, error }] = useUpdateContactCompanyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactCompanyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactCompanyIntegrationMutation, UpdateContactCompanyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactCompanyIntegrationMutation, UpdateContactCompanyIntegrationMutationVariables>(UpdateContactCompanyIntegrationDocument, options);
      }
export type UpdateContactCompanyIntegrationMutationHookResult = ReturnType<typeof useUpdateContactCompanyIntegrationMutation>;
export type UpdateContactCompanyIntegrationMutationResult = Apollo.MutationResult<UpdateContactCompanyIntegrationMutation>;
export type UpdateContactCompanyIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateContactCompanyIntegrationMutation, UpdateContactCompanyIntegrationMutationVariables>;
export const SingleActivityAttachmentDocument = gql`
    query SingleActivityAttachment($ID: Int!) {
  ActivityAttachment(ID: $ID) {
    ...ActivityAttachmentScalars
  }
}
    ${ActivityAttachmentScalarsFragmentDoc}`;

/**
 * __useSingleActivityAttachmentQuery__
 *
 * To run a query within a React component, call `useSingleActivityAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleActivityAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleActivityAttachmentQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleActivityAttachmentQuery(baseOptions: Apollo.QueryHookOptions<SingleActivityAttachmentQuery, SingleActivityAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleActivityAttachmentQuery, SingleActivityAttachmentQueryVariables>(SingleActivityAttachmentDocument, options);
      }
export function useSingleActivityAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleActivityAttachmentQuery, SingleActivityAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleActivityAttachmentQuery, SingleActivityAttachmentQueryVariables>(SingleActivityAttachmentDocument, options);
        }
export type SingleActivityAttachmentQueryHookResult = ReturnType<typeof useSingleActivityAttachmentQuery>;
export type SingleActivityAttachmentLazyQueryHookResult = ReturnType<typeof useSingleActivityAttachmentLazyQuery>;
export type SingleActivityAttachmentQueryResult = Apollo.QueryResult<SingleActivityAttachmentQuery, SingleActivityAttachmentQueryVariables>;
export const SingleActivityAttachmentFullDocument = gql`
    query SingleActivityAttachmentFull($ID: Int!) {
  ActivityAttachment(ID: $ID) {
    ...ActivityAttachmentScalars
  }
}
    ${ActivityAttachmentScalarsFragmentDoc}`;

/**
 * __useSingleActivityAttachmentFullQuery__
 *
 * To run a query within a React component, call `useSingleActivityAttachmentFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleActivityAttachmentFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleActivityAttachmentFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleActivityAttachmentFullQuery(baseOptions: Apollo.QueryHookOptions<SingleActivityAttachmentFullQuery, SingleActivityAttachmentFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleActivityAttachmentFullQuery, SingleActivityAttachmentFullQueryVariables>(SingleActivityAttachmentFullDocument, options);
      }
export function useSingleActivityAttachmentFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleActivityAttachmentFullQuery, SingleActivityAttachmentFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleActivityAttachmentFullQuery, SingleActivityAttachmentFullQueryVariables>(SingleActivityAttachmentFullDocument, options);
        }
export type SingleActivityAttachmentFullQueryHookResult = ReturnType<typeof useSingleActivityAttachmentFullQuery>;
export type SingleActivityAttachmentFullLazyQueryHookResult = ReturnType<typeof useSingleActivityAttachmentFullLazyQuery>;
export type SingleActivityAttachmentFullQueryResult = Apollo.QueryResult<SingleActivityAttachmentFullQuery, SingleActivityAttachmentFullQueryVariables>;
export const UpdateActivityAttachmentDocument = gql`
    mutation UpdateActivityAttachment($input: UpdateActivityAttachmentInput!) {
  UpdateActivityAttachment(input: $input) {
    ...ActivityAttachmentScalars
  }
}
    ${ActivityAttachmentScalarsFragmentDoc}`;
export type UpdateActivityAttachmentMutationFn = Apollo.MutationFunction<UpdateActivityAttachmentMutation, UpdateActivityAttachmentMutationVariables>;

/**
 * __useUpdateActivityAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateActivityAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityAttachmentMutation, { data, loading, error }] = useUpdateActivityAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityAttachmentMutation, UpdateActivityAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityAttachmentMutation, UpdateActivityAttachmentMutationVariables>(UpdateActivityAttachmentDocument, options);
      }
export type UpdateActivityAttachmentMutationHookResult = ReturnType<typeof useUpdateActivityAttachmentMutation>;
export type UpdateActivityAttachmentMutationResult = Apollo.MutationResult<UpdateActivityAttachmentMutation>;
export type UpdateActivityAttachmentMutationOptions = Apollo.BaseMutationOptions<UpdateActivityAttachmentMutation, UpdateActivityAttachmentMutationVariables>;
export const SingleProjectDocument = gql`
    query SingleProject($ID: Int!) {
  Project(ID: $ID) {
    ...ProjectScalars
  }
}
    ${ProjectScalarsFragmentDoc}`;

/**
 * __useSingleProjectQuery__
 *
 * To run a query within a React component, call `useSingleProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectQuery, SingleProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectQuery, SingleProjectQueryVariables>(SingleProjectDocument, options);
      }
export function useSingleProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectQuery, SingleProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectQuery, SingleProjectQueryVariables>(SingleProjectDocument, options);
        }
export type SingleProjectQueryHookResult = ReturnType<typeof useSingleProjectQuery>;
export type SingleProjectLazyQueryHookResult = ReturnType<typeof useSingleProjectLazyQuery>;
export type SingleProjectQueryResult = Apollo.QueryResult<SingleProjectQuery, SingleProjectQueryVariables>;
export const SingleProjectFullDocument = gql`
    query SingleProjectFull($ID: Int!) {
  Project(ID: $ID) {
    ...ProjectScalars
  }
}
    ${ProjectScalarsFragmentDoc}`;

/**
 * __useSingleProjectFullQuery__
 *
 * To run a query within a React component, call `useSingleProjectFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectFullQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectFullQuery, SingleProjectFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectFullQuery, SingleProjectFullQueryVariables>(SingleProjectFullDocument, options);
      }
export function useSingleProjectFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectFullQuery, SingleProjectFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectFullQuery, SingleProjectFullQueryVariables>(SingleProjectFullDocument, options);
        }
export type SingleProjectFullQueryHookResult = ReturnType<typeof useSingleProjectFullQuery>;
export type SingleProjectFullLazyQueryHookResult = ReturnType<typeof useSingleProjectFullLazyQuery>;
export type SingleProjectFullQueryResult = Apollo.QueryResult<SingleProjectFullQuery, SingleProjectFullQueryVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($input: UpdateProjectInput!) {
  UpdateProject(input: $input) {
    ...ProjectScalars
  }
}
    ${ProjectScalarsFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const SingleRoleDocument = gql`
    query SingleRole($ID: Int!) {
  Role(ID: $ID) {
    ...RoleScalars
  }
}
    ${RoleScalarsFragmentDoc}`;

/**
 * __useSingleRoleQuery__
 *
 * To run a query within a React component, call `useSingleRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRoleQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleRoleQuery(baseOptions: Apollo.QueryHookOptions<SingleRoleQuery, SingleRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRoleQuery, SingleRoleQueryVariables>(SingleRoleDocument, options);
      }
export function useSingleRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRoleQuery, SingleRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRoleQuery, SingleRoleQueryVariables>(SingleRoleDocument, options);
        }
export type SingleRoleQueryHookResult = ReturnType<typeof useSingleRoleQuery>;
export type SingleRoleLazyQueryHookResult = ReturnType<typeof useSingleRoleLazyQuery>;
export type SingleRoleQueryResult = Apollo.QueryResult<SingleRoleQuery, SingleRoleQueryVariables>;
export const SingleRoleFullDocument = gql`
    query SingleRoleFull($ID: Int!) {
  Role(ID: $ID) {
    ...RoleScalars
  }
}
    ${RoleScalarsFragmentDoc}`;

/**
 * __useSingleRoleFullQuery__
 *
 * To run a query within a React component, call `useSingleRoleFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRoleFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRoleFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleRoleFullQuery(baseOptions: Apollo.QueryHookOptions<SingleRoleFullQuery, SingleRoleFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRoleFullQuery, SingleRoleFullQueryVariables>(SingleRoleFullDocument, options);
      }
export function useSingleRoleFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRoleFullQuery, SingleRoleFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRoleFullQuery, SingleRoleFullQueryVariables>(SingleRoleFullDocument, options);
        }
export type SingleRoleFullQueryHookResult = ReturnType<typeof useSingleRoleFullQuery>;
export type SingleRoleFullLazyQueryHookResult = ReturnType<typeof useSingleRoleFullLazyQuery>;
export type SingleRoleFullQueryResult = Apollo.QueryResult<SingleRoleFullQuery, SingleRoleFullQueryVariables>;
export const AllRolesDocument = gql`
    query AllRoles {
  AllRoles {
    ...RoleScalars
  }
}
    ${RoleScalarsFragmentDoc}`;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRoleInput!) {
  UpdateRole(input: $input) {
    ...RoleScalars
  }
}
    ${RoleScalarsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const SingleSkillDocument = gql`
    query SingleSkill($ID: Int!) {
  Skill(ID: $ID) {
    ...SkillScalars
  }
}
    ${SkillScalarsFragmentDoc}`;

/**
 * __useSingleSkillQuery__
 *
 * To run a query within a React component, call `useSingleSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleSkillQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleSkillQuery(baseOptions: Apollo.QueryHookOptions<SingleSkillQuery, SingleSkillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleSkillQuery, SingleSkillQueryVariables>(SingleSkillDocument, options);
      }
export function useSingleSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleSkillQuery, SingleSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleSkillQuery, SingleSkillQueryVariables>(SingleSkillDocument, options);
        }
export type SingleSkillQueryHookResult = ReturnType<typeof useSingleSkillQuery>;
export type SingleSkillLazyQueryHookResult = ReturnType<typeof useSingleSkillLazyQuery>;
export type SingleSkillQueryResult = Apollo.QueryResult<SingleSkillQuery, SingleSkillQueryVariables>;
export const SingleSkillFullDocument = gql`
    query SingleSkillFull($ID: Int!) {
  Skill(ID: $ID) {
    ...SkillScalars
  }
}
    ${SkillScalarsFragmentDoc}`;

/**
 * __useSingleSkillFullQuery__
 *
 * To run a query within a React component, call `useSingleSkillFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleSkillFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleSkillFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleSkillFullQuery(baseOptions: Apollo.QueryHookOptions<SingleSkillFullQuery, SingleSkillFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleSkillFullQuery, SingleSkillFullQueryVariables>(SingleSkillFullDocument, options);
      }
export function useSingleSkillFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleSkillFullQuery, SingleSkillFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleSkillFullQuery, SingleSkillFullQueryVariables>(SingleSkillFullDocument, options);
        }
export type SingleSkillFullQueryHookResult = ReturnType<typeof useSingleSkillFullQuery>;
export type SingleSkillFullLazyQueryHookResult = ReturnType<typeof useSingleSkillFullLazyQuery>;
export type SingleSkillFullQueryResult = Apollo.QueryResult<SingleSkillFullQuery, SingleSkillFullQueryVariables>;
export const AllSkillsDocument = gql`
    query AllSkills {
  AllSkills {
    ...SkillScalars
  }
}
    ${SkillScalarsFragmentDoc}`;

/**
 * __useAllSkillsQuery__
 *
 * To run a query within a React component, call `useAllSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSkillsQuery(baseOptions?: Apollo.QueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSkillsQuery, AllSkillsQueryVariables>(AllSkillsDocument, options);
      }
export function useAllSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSkillsQuery, AllSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSkillsQuery, AllSkillsQueryVariables>(AllSkillsDocument, options);
        }
export type AllSkillsQueryHookResult = ReturnType<typeof useAllSkillsQuery>;
export type AllSkillsLazyQueryHookResult = ReturnType<typeof useAllSkillsLazyQuery>;
export type AllSkillsQueryResult = Apollo.QueryResult<AllSkillsQuery, AllSkillsQueryVariables>;
export const SingleTaskDocument = gql`
    query SingleTask($ID: Int!) {
  Task(ID: $ID) {
    ...TaskScalars
  }
}
    ${TaskScalarsFragmentDoc}`;

/**
 * __useSingleTaskQuery__
 *
 * To run a query within a React component, call `useSingleTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaskQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaskQuery(baseOptions: Apollo.QueryHookOptions<SingleTaskQuery, SingleTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaskQuery, SingleTaskQueryVariables>(SingleTaskDocument, options);
      }
export function useSingleTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaskQuery, SingleTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaskQuery, SingleTaskQueryVariables>(SingleTaskDocument, options);
        }
export type SingleTaskQueryHookResult = ReturnType<typeof useSingleTaskQuery>;
export type SingleTaskLazyQueryHookResult = ReturnType<typeof useSingleTaskLazyQuery>;
export type SingleTaskQueryResult = Apollo.QueryResult<SingleTaskQuery, SingleTaskQueryVariables>;
export const SingleTaskFullDocument = gql`
    query SingleTaskFull($ID: Int!) {
  Task(ID: $ID) {
    ...TaskScalars
  }
}
    ${TaskScalarsFragmentDoc}`;

/**
 * __useSingleTaskFullQuery__
 *
 * To run a query within a React component, call `useSingleTaskFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaskFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaskFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaskFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTaskFullQuery, SingleTaskFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaskFullQuery, SingleTaskFullQueryVariables>(SingleTaskFullDocument, options);
      }
export function useSingleTaskFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaskFullQuery, SingleTaskFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaskFullQuery, SingleTaskFullQueryVariables>(SingleTaskFullDocument, options);
        }
export type SingleTaskFullQueryHookResult = ReturnType<typeof useSingleTaskFullQuery>;
export type SingleTaskFullLazyQueryHookResult = ReturnType<typeof useSingleTaskFullLazyQuery>;
export type SingleTaskFullQueryResult = Apollo.QueryResult<SingleTaskFullQuery, SingleTaskFullQueryVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!) {
  UpdateTask(input: $input) {
    ...TaskScalars
  }
}
    ${TaskScalarsFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const SingleTaskTypeDocument = gql`
    query SingleTaskType($ID: Int!) {
  TaskType(ID: $ID) {
    ...TaskTypeScalars
  }
}
    ${TaskTypeScalarsFragmentDoc}`;

/**
 * __useSingleTaskTypeQuery__
 *
 * To run a query within a React component, call `useSingleTaskTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaskTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaskTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaskTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleTaskTypeQuery, SingleTaskTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaskTypeQuery, SingleTaskTypeQueryVariables>(SingleTaskTypeDocument, options);
      }
export function useSingleTaskTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaskTypeQuery, SingleTaskTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaskTypeQuery, SingleTaskTypeQueryVariables>(SingleTaskTypeDocument, options);
        }
export type SingleTaskTypeQueryHookResult = ReturnType<typeof useSingleTaskTypeQuery>;
export type SingleTaskTypeLazyQueryHookResult = ReturnType<typeof useSingleTaskTypeLazyQuery>;
export type SingleTaskTypeQueryResult = Apollo.QueryResult<SingleTaskTypeQuery, SingleTaskTypeQueryVariables>;
export const SingleTaskTypeFullDocument = gql`
    query SingleTaskTypeFull($ID: Int!) {
  TaskType(ID: $ID) {
    ...TaskTypeScalars
  }
}
    ${TaskTypeScalarsFragmentDoc}`;

/**
 * __useSingleTaskTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleTaskTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaskTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaskTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaskTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTaskTypeFullQuery, SingleTaskTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaskTypeFullQuery, SingleTaskTypeFullQueryVariables>(SingleTaskTypeFullDocument, options);
      }
export function useSingleTaskTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaskTypeFullQuery, SingleTaskTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaskTypeFullQuery, SingleTaskTypeFullQueryVariables>(SingleTaskTypeFullDocument, options);
        }
export type SingleTaskTypeFullQueryHookResult = ReturnType<typeof useSingleTaskTypeFullQuery>;
export type SingleTaskTypeFullLazyQueryHookResult = ReturnType<typeof useSingleTaskTypeFullLazyQuery>;
export type SingleTaskTypeFullQueryResult = Apollo.QueryResult<SingleTaskTypeFullQuery, SingleTaskTypeFullQueryVariables>;
export const AllTaskTypesDocument = gql`
    query AllTaskTypes {
  AllTaskTypes {
    ...TaskTypeScalars
  }
}
    ${TaskTypeScalarsFragmentDoc}`;

/**
 * __useAllTaskTypesQuery__
 *
 * To run a query within a React component, call `useAllTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTaskTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllTaskTypesQuery, AllTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTaskTypesQuery, AllTaskTypesQueryVariables>(AllTaskTypesDocument, options);
      }
export function useAllTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTaskTypesQuery, AllTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTaskTypesQuery, AllTaskTypesQueryVariables>(AllTaskTypesDocument, options);
        }
export type AllTaskTypesQueryHookResult = ReturnType<typeof useAllTaskTypesQuery>;
export type AllTaskTypesLazyQueryHookResult = ReturnType<typeof useAllTaskTypesLazyQuery>;
export type AllTaskTypesQueryResult = Apollo.QueryResult<AllTaskTypesQuery, AllTaskTypesQueryVariables>;
export const UpdateTaskTypeDocument = gql`
    mutation UpdateTaskType($input: UpdateTaskTypeInput!) {
  UpdateTaskType(input: $input) {
    ...TaskTypeScalars
  }
}
    ${TaskTypeScalarsFragmentDoc}`;
export type UpdateTaskTypeMutationFn = Apollo.MutationFunction<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>;

/**
 * __useUpdateTaskTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTypeMutation, { data, loading, error }] = useUpdateTaskTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>(UpdateTaskTypeDocument, options);
      }
export type UpdateTaskTypeMutationHookResult = ReturnType<typeof useUpdateTaskTypeMutation>;
export type UpdateTaskTypeMutationResult = Apollo.MutationResult<UpdateTaskTypeMutation>;
export type UpdateTaskTypeMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>;
export const SingleIntegrationURLFormatDocument = gql`
    query SingleIntegrationURLFormat($ID: Int!) {
  IntegrationURLFormat(ID: $ID) {
    ...IntegrationURLFormatScalars
  }
}
    ${IntegrationURLFormatScalarsFragmentDoc}`;

/**
 * __useSingleIntegrationURLFormatQuery__
 *
 * To run a query within a React component, call `useSingleIntegrationURLFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleIntegrationURLFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleIntegrationURLFormatQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleIntegrationURLFormatQuery(baseOptions: Apollo.QueryHookOptions<SingleIntegrationURLFormatQuery, SingleIntegrationURLFormatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleIntegrationURLFormatQuery, SingleIntegrationURLFormatQueryVariables>(SingleIntegrationURLFormatDocument, options);
      }
export function useSingleIntegrationURLFormatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleIntegrationURLFormatQuery, SingleIntegrationURLFormatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleIntegrationURLFormatQuery, SingleIntegrationURLFormatQueryVariables>(SingleIntegrationURLFormatDocument, options);
        }
export type SingleIntegrationURLFormatQueryHookResult = ReturnType<typeof useSingleIntegrationURLFormatQuery>;
export type SingleIntegrationURLFormatLazyQueryHookResult = ReturnType<typeof useSingleIntegrationURLFormatLazyQuery>;
export type SingleIntegrationURLFormatQueryResult = Apollo.QueryResult<SingleIntegrationURLFormatQuery, SingleIntegrationURLFormatQueryVariables>;
export const SingleIntegrationURLFormatFullDocument = gql`
    query SingleIntegrationURLFormatFull($ID: Int!) {
  IntegrationURLFormat(ID: $ID) {
    ...IntegrationURLFormatScalars
  }
}
    ${IntegrationURLFormatScalarsFragmentDoc}`;

/**
 * __useSingleIntegrationURLFormatFullQuery__
 *
 * To run a query within a React component, call `useSingleIntegrationURLFormatFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleIntegrationURLFormatFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleIntegrationURLFormatFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleIntegrationURLFormatFullQuery(baseOptions: Apollo.QueryHookOptions<SingleIntegrationURLFormatFullQuery, SingleIntegrationURLFormatFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleIntegrationURLFormatFullQuery, SingleIntegrationURLFormatFullQueryVariables>(SingleIntegrationURLFormatFullDocument, options);
      }
export function useSingleIntegrationURLFormatFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleIntegrationURLFormatFullQuery, SingleIntegrationURLFormatFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleIntegrationURLFormatFullQuery, SingleIntegrationURLFormatFullQueryVariables>(SingleIntegrationURLFormatFullDocument, options);
        }
export type SingleIntegrationURLFormatFullQueryHookResult = ReturnType<typeof useSingleIntegrationURLFormatFullQuery>;
export type SingleIntegrationURLFormatFullLazyQueryHookResult = ReturnType<typeof useSingleIntegrationURLFormatFullLazyQuery>;
export type SingleIntegrationURLFormatFullQueryResult = Apollo.QueryResult<SingleIntegrationURLFormatFullQuery, SingleIntegrationURLFormatFullQueryVariables>;
export const AllIntegrationURLFormatsDocument = gql`
    query AllIntegrationURLFormats {
  AllIntegrationURLFormats {
    ...IntegrationURLFormatScalars
  }
}
    ${IntegrationURLFormatScalarsFragmentDoc}`;

/**
 * __useAllIntegrationURLFormatsQuery__
 *
 * To run a query within a React component, call `useAllIntegrationURLFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllIntegrationURLFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllIntegrationURLFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllIntegrationURLFormatsQuery(baseOptions?: Apollo.QueryHookOptions<AllIntegrationURLFormatsQuery, AllIntegrationURLFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllIntegrationURLFormatsQuery, AllIntegrationURLFormatsQueryVariables>(AllIntegrationURLFormatsDocument, options);
      }
export function useAllIntegrationURLFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllIntegrationURLFormatsQuery, AllIntegrationURLFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllIntegrationURLFormatsQuery, AllIntegrationURLFormatsQueryVariables>(AllIntegrationURLFormatsDocument, options);
        }
export type AllIntegrationURLFormatsQueryHookResult = ReturnType<typeof useAllIntegrationURLFormatsQuery>;
export type AllIntegrationURLFormatsLazyQueryHookResult = ReturnType<typeof useAllIntegrationURLFormatsLazyQuery>;
export type AllIntegrationURLFormatsQueryResult = Apollo.QueryResult<AllIntegrationURLFormatsQuery, AllIntegrationURLFormatsQueryVariables>;
export const UpdateIntegrationURLFormatDocument = gql`
    mutation UpdateIntegrationURLFormat($input: UpdateIntegrationURLFormatInput!) {
  UpdateIntegrationURLFormat(input: $input) {
    ...IntegrationURLFormatScalars
  }
}
    ${IntegrationURLFormatScalarsFragmentDoc}`;
export type UpdateIntegrationURLFormatMutationFn = Apollo.MutationFunction<UpdateIntegrationURLFormatMutation, UpdateIntegrationURLFormatMutationVariables>;

/**
 * __useUpdateIntegrationURLFormatMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationURLFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationURLFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationUrlFormatMutation, { data, loading, error }] = useUpdateIntegrationURLFormatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationURLFormatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationURLFormatMutation, UpdateIntegrationURLFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationURLFormatMutation, UpdateIntegrationURLFormatMutationVariables>(UpdateIntegrationURLFormatDocument, options);
      }
export type UpdateIntegrationURLFormatMutationHookResult = ReturnType<typeof useUpdateIntegrationURLFormatMutation>;
export type UpdateIntegrationURLFormatMutationResult = Apollo.MutationResult<UpdateIntegrationURLFormatMutation>;
export type UpdateIntegrationURLFormatMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationURLFormatMutation, UpdateIntegrationURLFormatMutationVariables>;
export const SingleIntegrationDocument = gql`
    query SingleIntegration($ID: Int!) {
  Integration(ID: $ID) {
    ...IntegrationScalars
  }
}
    ${IntegrationScalarsFragmentDoc}`;

/**
 * __useSingleIntegrationQuery__
 *
 * To run a query within a React component, call `useSingleIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleIntegrationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleIntegrationQuery(baseOptions: Apollo.QueryHookOptions<SingleIntegrationQuery, SingleIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleIntegrationQuery, SingleIntegrationQueryVariables>(SingleIntegrationDocument, options);
      }
export function useSingleIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleIntegrationQuery, SingleIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleIntegrationQuery, SingleIntegrationQueryVariables>(SingleIntegrationDocument, options);
        }
export type SingleIntegrationQueryHookResult = ReturnType<typeof useSingleIntegrationQuery>;
export type SingleIntegrationLazyQueryHookResult = ReturnType<typeof useSingleIntegrationLazyQuery>;
export type SingleIntegrationQueryResult = Apollo.QueryResult<SingleIntegrationQuery, SingleIntegrationQueryVariables>;
export const SingleIntegrationFullDocument = gql`
    query SingleIntegrationFull($ID: Int!) {
  Integration(ID: $ID) {
    ...IntegrationScalars
    IntegrationURLFormats {
      ...IntegrationURLFormatScalars
    }
  }
}
    ${IntegrationScalarsFragmentDoc}
${IntegrationURLFormatScalarsFragmentDoc}`;

/**
 * __useSingleIntegrationFullQuery__
 *
 * To run a query within a React component, call `useSingleIntegrationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleIntegrationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleIntegrationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleIntegrationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleIntegrationFullQuery, SingleIntegrationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleIntegrationFullQuery, SingleIntegrationFullQueryVariables>(SingleIntegrationFullDocument, options);
      }
export function useSingleIntegrationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleIntegrationFullQuery, SingleIntegrationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleIntegrationFullQuery, SingleIntegrationFullQueryVariables>(SingleIntegrationFullDocument, options);
        }
export type SingleIntegrationFullQueryHookResult = ReturnType<typeof useSingleIntegrationFullQuery>;
export type SingleIntegrationFullLazyQueryHookResult = ReturnType<typeof useSingleIntegrationFullLazyQuery>;
export type SingleIntegrationFullQueryResult = Apollo.QueryResult<SingleIntegrationFullQuery, SingleIntegrationFullQueryVariables>;
export const AllIntegrationsDocument = gql`
    query AllIntegrations {
  AllIntegrations {
    ...IntegrationScalars
    IntegrationURLFormats {
      ...IntegrationURLFormatScalars
    }
  }
}
    ${IntegrationScalarsFragmentDoc}
${IntegrationURLFormatScalarsFragmentDoc}`;

/**
 * __useAllIntegrationsQuery__
 *
 * To run a query within a React component, call `useAllIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<AllIntegrationsQuery, AllIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllIntegrationsQuery, AllIntegrationsQueryVariables>(AllIntegrationsDocument, options);
      }
export function useAllIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllIntegrationsQuery, AllIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllIntegrationsQuery, AllIntegrationsQueryVariables>(AllIntegrationsDocument, options);
        }
export type AllIntegrationsQueryHookResult = ReturnType<typeof useAllIntegrationsQuery>;
export type AllIntegrationsLazyQueryHookResult = ReturnType<typeof useAllIntegrationsLazyQuery>;
export type AllIntegrationsQueryResult = Apollo.QueryResult<AllIntegrationsQuery, AllIntegrationsQueryVariables>;
export const UpdateIntegrationDocument = gql`
    mutation UpdateIntegration($input: UpdateIntegrationInput!) {
  UpdateIntegration(input: $input) {
    ...IntegrationScalars
  }
}
    ${IntegrationScalarsFragmentDoc}`;
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(UpdateIntegrationDocument, options);
      }
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;
export const SingleCompanyIntegrationDocument = gql`
    query SingleCompanyIntegration($ID: Int!) {
  CompanyIntegration(ID: $ID) {
    ...CompanyIntegrationScalars
  }
}
    ${CompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleCompanyIntegrationQuery__
 *
 * To run a query within a React component, call `useSingleCompanyIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCompanyIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCompanyIntegrationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCompanyIntegrationQuery(baseOptions: Apollo.QueryHookOptions<SingleCompanyIntegrationQuery, SingleCompanyIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCompanyIntegrationQuery, SingleCompanyIntegrationQueryVariables>(SingleCompanyIntegrationDocument, options);
      }
export function useSingleCompanyIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCompanyIntegrationQuery, SingleCompanyIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCompanyIntegrationQuery, SingleCompanyIntegrationQueryVariables>(SingleCompanyIntegrationDocument, options);
        }
export type SingleCompanyIntegrationQueryHookResult = ReturnType<typeof useSingleCompanyIntegrationQuery>;
export type SingleCompanyIntegrationLazyQueryHookResult = ReturnType<typeof useSingleCompanyIntegrationLazyQuery>;
export type SingleCompanyIntegrationQueryResult = Apollo.QueryResult<SingleCompanyIntegrationQuery, SingleCompanyIntegrationQueryVariables>;
export const SingleCompanyIntegrationFullDocument = gql`
    query SingleCompanyIntegrationFull($ID: Int!) {
  CompanyIntegration(ID: $ID) {
    ...CompanyIntegrationScalars
  }
}
    ${CompanyIntegrationScalarsFragmentDoc}`;

/**
 * __useSingleCompanyIntegrationFullQuery__
 *
 * To run a query within a React component, call `useSingleCompanyIntegrationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCompanyIntegrationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCompanyIntegrationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCompanyIntegrationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleCompanyIntegrationFullQuery, SingleCompanyIntegrationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCompanyIntegrationFullQuery, SingleCompanyIntegrationFullQueryVariables>(SingleCompanyIntegrationFullDocument, options);
      }
export function useSingleCompanyIntegrationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCompanyIntegrationFullQuery, SingleCompanyIntegrationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCompanyIntegrationFullQuery, SingleCompanyIntegrationFullQueryVariables>(SingleCompanyIntegrationFullDocument, options);
        }
export type SingleCompanyIntegrationFullQueryHookResult = ReturnType<typeof useSingleCompanyIntegrationFullQuery>;
export type SingleCompanyIntegrationFullLazyQueryHookResult = ReturnType<typeof useSingleCompanyIntegrationFullLazyQuery>;
export type SingleCompanyIntegrationFullQueryResult = Apollo.QueryResult<SingleCompanyIntegrationFullQuery, SingleCompanyIntegrationFullQueryVariables>;
export const UpdateCompanyIntegrationDocument = gql`
    mutation UpdateCompanyIntegration($input: UpdateCompanyIntegrationInput!) {
  UpdateCompanyIntegration(input: $input) {
    ...CompanyIntegrationScalars
  }
}
    ${CompanyIntegrationScalarsFragmentDoc}`;
export type UpdateCompanyIntegrationMutationFn = Apollo.MutationFunction<UpdateCompanyIntegrationMutation, UpdateCompanyIntegrationMutationVariables>;

/**
 * __useUpdateCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyIntegrationMutation, { data, loading, error }] = useUpdateCompanyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyIntegrationMutation, UpdateCompanyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyIntegrationMutation, UpdateCompanyIntegrationMutationVariables>(UpdateCompanyIntegrationDocument, options);
      }
export type UpdateCompanyIntegrationMutationHookResult = ReturnType<typeof useUpdateCompanyIntegrationMutation>;
export type UpdateCompanyIntegrationMutationResult = Apollo.MutationResult<UpdateCompanyIntegrationMutation>;
export type UpdateCompanyIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyIntegrationMutation, UpdateCompanyIntegrationMutationVariables>;
export const SingleEntityFieldDocument = gql`
    query SingleEntityField($ID: Int!) {
  EntityField(ID: $ID) {
    ...EntityFieldScalars
  }
}
    ${EntityFieldScalarsFragmentDoc}`;

/**
 * __useSingleEntityFieldQuery__
 *
 * To run a query within a React component, call `useSingleEntityFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityFieldQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityFieldQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityFieldQuery, SingleEntityFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityFieldQuery, SingleEntityFieldQueryVariables>(SingleEntityFieldDocument, options);
      }
export function useSingleEntityFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityFieldQuery, SingleEntityFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityFieldQuery, SingleEntityFieldQueryVariables>(SingleEntityFieldDocument, options);
        }
export type SingleEntityFieldQueryHookResult = ReturnType<typeof useSingleEntityFieldQuery>;
export type SingleEntityFieldLazyQueryHookResult = ReturnType<typeof useSingleEntityFieldLazyQuery>;
export type SingleEntityFieldQueryResult = Apollo.QueryResult<SingleEntityFieldQuery, SingleEntityFieldQueryVariables>;
export const SingleEntityFieldFullDocument = gql`
    query SingleEntityFieldFull($ID: Int!) {
  EntityField(ID: $ID) {
    ...EntityFieldScalars
    EntityFieldValues {
      ...EntityFieldValueScalars
    }
  }
}
    ${EntityFieldScalarsFragmentDoc}
${EntityFieldValueScalarsFragmentDoc}`;

/**
 * __useSingleEntityFieldFullQuery__
 *
 * To run a query within a React component, call `useSingleEntityFieldFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityFieldFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityFieldFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityFieldFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityFieldFullQuery, SingleEntityFieldFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityFieldFullQuery, SingleEntityFieldFullQueryVariables>(SingleEntityFieldFullDocument, options);
      }
export function useSingleEntityFieldFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityFieldFullQuery, SingleEntityFieldFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityFieldFullQuery, SingleEntityFieldFullQueryVariables>(SingleEntityFieldFullDocument, options);
        }
export type SingleEntityFieldFullQueryHookResult = ReturnType<typeof useSingleEntityFieldFullQuery>;
export type SingleEntityFieldFullLazyQueryHookResult = ReturnType<typeof useSingleEntityFieldFullLazyQuery>;
export type SingleEntityFieldFullQueryResult = Apollo.QueryResult<SingleEntityFieldFullQuery, SingleEntityFieldFullQueryVariables>;
export const AllEntityFieldsDocument = gql`
    query AllEntityFields {
  AllEntityFields {
    ...EntityFieldScalars
  }
}
    ${EntityFieldScalarsFragmentDoc}`;

/**
 * __useAllEntityFieldsQuery__
 *
 * To run a query within a React component, call `useAllEntityFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEntityFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEntityFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEntityFieldsQuery(baseOptions?: Apollo.QueryHookOptions<AllEntityFieldsQuery, AllEntityFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEntityFieldsQuery, AllEntityFieldsQueryVariables>(AllEntityFieldsDocument, options);
      }
export function useAllEntityFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEntityFieldsQuery, AllEntityFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEntityFieldsQuery, AllEntityFieldsQueryVariables>(AllEntityFieldsDocument, options);
        }
export type AllEntityFieldsQueryHookResult = ReturnType<typeof useAllEntityFieldsQuery>;
export type AllEntityFieldsLazyQueryHookResult = ReturnType<typeof useAllEntityFieldsLazyQuery>;
export type AllEntityFieldsQueryResult = Apollo.QueryResult<AllEntityFieldsQuery, AllEntityFieldsQueryVariables>;
export const CreateEntityFieldDocument = gql`
    mutation CreateEntityField($input: CreateEntityFieldInput!) {
  CreateEntityField(input: $input) {
    ...EntityFieldScalars
  }
}
    ${EntityFieldScalarsFragmentDoc}`;
export type CreateEntityFieldMutationFn = Apollo.MutationFunction<CreateEntityFieldMutation, CreateEntityFieldMutationVariables>;

/**
 * __useCreateEntityFieldMutation__
 *
 * To run a mutation, you first call `useCreateEntityFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityFieldMutation, { data, loading, error }] = useCreateEntityFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityFieldMutation, CreateEntityFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityFieldMutation, CreateEntityFieldMutationVariables>(CreateEntityFieldDocument, options);
      }
export type CreateEntityFieldMutationHookResult = ReturnType<typeof useCreateEntityFieldMutation>;
export type CreateEntityFieldMutationResult = Apollo.MutationResult<CreateEntityFieldMutation>;
export type CreateEntityFieldMutationOptions = Apollo.BaseMutationOptions<CreateEntityFieldMutation, CreateEntityFieldMutationVariables>;
export const UpdateEntityFieldDocument = gql`
    mutation UpdateEntityField($input: UpdateEntityFieldInput!) {
  UpdateEntityField(input: $input) {
    ...EntityFieldScalars
  }
}
    ${EntityFieldScalarsFragmentDoc}`;
export type UpdateEntityFieldMutationFn = Apollo.MutationFunction<UpdateEntityFieldMutation, UpdateEntityFieldMutationVariables>;

/**
 * __useUpdateEntityFieldMutation__
 *
 * To run a mutation, you first call `useUpdateEntityFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityFieldMutation, { data, loading, error }] = useUpdateEntityFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityFieldMutation, UpdateEntityFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityFieldMutation, UpdateEntityFieldMutationVariables>(UpdateEntityFieldDocument, options);
      }
export type UpdateEntityFieldMutationHookResult = ReturnType<typeof useUpdateEntityFieldMutation>;
export type UpdateEntityFieldMutationResult = Apollo.MutationResult<UpdateEntityFieldMutation>;
export type UpdateEntityFieldMutationOptions = Apollo.BaseMutationOptions<UpdateEntityFieldMutation, UpdateEntityFieldMutationVariables>;
export const DeleteEntityFieldDocument = gql`
    mutation DeleteEntityField($ID: Int!) {
  DeleteEntityField(ID: $ID)
}
    `;
export type DeleteEntityFieldMutationFn = Apollo.MutationFunction<DeleteEntityFieldMutation, DeleteEntityFieldMutationVariables>;

/**
 * __useDeleteEntityFieldMutation__
 *
 * To run a mutation, you first call `useDeleteEntityFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityFieldMutation, { data, loading, error }] = useDeleteEntityFieldMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteEntityFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityFieldMutation, DeleteEntityFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityFieldMutation, DeleteEntityFieldMutationVariables>(DeleteEntityFieldDocument, options);
      }
export type DeleteEntityFieldMutationHookResult = ReturnType<typeof useDeleteEntityFieldMutation>;
export type DeleteEntityFieldMutationResult = Apollo.MutationResult<DeleteEntityFieldMutation>;
export type DeleteEntityFieldMutationOptions = Apollo.BaseMutationOptions<DeleteEntityFieldMutation, DeleteEntityFieldMutationVariables>;
export const SingleEntityDocument = gql`
    query SingleEntity($ID: Int!) {
  Entity(ID: $ID) {
    ...EntityScalars
  }
}
    ${EntityScalarsFragmentDoc}`;

/**
 * __useSingleEntityQuery__
 *
 * To run a query within a React component, call `useSingleEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityQuery, SingleEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityQuery, SingleEntityQueryVariables>(SingleEntityDocument, options);
      }
export function useSingleEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityQuery, SingleEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityQuery, SingleEntityQueryVariables>(SingleEntityDocument, options);
        }
export type SingleEntityQueryHookResult = ReturnType<typeof useSingleEntityQuery>;
export type SingleEntityLazyQueryHookResult = ReturnType<typeof useSingleEntityLazyQuery>;
export type SingleEntityQueryResult = Apollo.QueryResult<SingleEntityQuery, SingleEntityQueryVariables>;
export const SingleEntityFullDocument = gql`
    query SingleEntityFull($ID: Int!) {
  Entity(ID: $ID) {
    ...EntityScalars
    EntityAIActions {
      ...EntityAIActionScalars
    }
    EntityRelationships {
      ...EntityRelationshipScalars
    }
    EntityPermissions {
      ...EntityPermissionScalars
    }
    EntityFields {
      ...EntityFieldScalars
    }
  }
}
    ${EntityScalarsFragmentDoc}
${EntityAIActionScalarsFragmentDoc}
${EntityRelationshipScalarsFragmentDoc}
${EntityPermissionScalarsFragmentDoc}
${EntityFieldScalarsFragmentDoc}`;

/**
 * __useSingleEntityFullQuery__
 *
 * To run a query within a React component, call `useSingleEntityFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityFullQuery, SingleEntityFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityFullQuery, SingleEntityFullQueryVariables>(SingleEntityFullDocument, options);
      }
export function useSingleEntityFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityFullQuery, SingleEntityFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityFullQuery, SingleEntityFullQueryVariables>(SingleEntityFullDocument, options);
        }
export type SingleEntityFullQueryHookResult = ReturnType<typeof useSingleEntityFullQuery>;
export type SingleEntityFullLazyQueryHookResult = ReturnType<typeof useSingleEntityFullLazyQuery>;
export type SingleEntityFullQueryResult = Apollo.QueryResult<SingleEntityFullQuery, SingleEntityFullQueryVariables>;
export const AllEntitiesDocument = gql`
    query AllEntities {
  AllEntities {
    ...EntityScalars
    EntityRelationships {
      ...EntityRelationshipScalars
    }
    EntityPermissions {
      ...EntityPermissionScalars
    }
    EntityFields {
      ...EntityFieldScalars
    }
  }
}
    ${EntityScalarsFragmentDoc}
${EntityRelationshipScalarsFragmentDoc}
${EntityPermissionScalarsFragmentDoc}
${EntityFieldScalarsFragmentDoc}`;

/**
 * __useAllEntitiesQuery__
 *
 * To run a query within a React component, call `useAllEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
      }
export function useAllEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
        }
export type AllEntitiesQueryHookResult = ReturnType<typeof useAllEntitiesQuery>;
export type AllEntitiesLazyQueryHookResult = ReturnType<typeof useAllEntitiesLazyQuery>;
export type AllEntitiesQueryResult = Apollo.QueryResult<AllEntitiesQuery, AllEntitiesQueryVariables>;
export const CreateEntityDocument = gql`
    mutation CreateEntity($input: CreateEntityInput!) {
  CreateEntity(input: $input) {
    ...EntityScalars
  }
}
    ${EntityScalarsFragmentDoc}`;
export type CreateEntityMutationFn = Apollo.MutationFunction<CreateEntityMutation, CreateEntityMutationVariables>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityMutation, CreateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(CreateEntityDocument, options);
      }
export type CreateEntityMutationHookResult = ReturnType<typeof useCreateEntityMutation>;
export type CreateEntityMutationResult = Apollo.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = Apollo.BaseMutationOptions<CreateEntityMutation, CreateEntityMutationVariables>;
export const UpdateEntityDocument = gql`
    mutation UpdateEntity($input: UpdateEntityInput!) {
  UpdateEntity(input: $input) {
    ...EntityScalars
  }
}
    ${EntityScalarsFragmentDoc}`;
export type UpdateEntityMutationFn = Apollo.MutationFunction<UpdateEntityMutation, UpdateEntityMutationVariables>;

/**
 * __useUpdateEntityMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMutation, { data, loading, error }] = useUpdateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityMutation, UpdateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityMutation, UpdateEntityMutationVariables>(UpdateEntityDocument, options);
      }
export type UpdateEntityMutationHookResult = ReturnType<typeof useUpdateEntityMutation>;
export type UpdateEntityMutationResult = Apollo.MutationResult<UpdateEntityMutation>;
export type UpdateEntityMutationOptions = Apollo.BaseMutationOptions<UpdateEntityMutation, UpdateEntityMutationVariables>;
export const DeleteEntityDocument = gql`
    mutation DeleteEntity($ID: Int!) {
  DeleteEntity(ID: $ID)
}
    `;
export type DeleteEntityMutationFn = Apollo.MutationFunction<DeleteEntityMutation, DeleteEntityMutationVariables>;

/**
 * __useDeleteEntityMutation__
 *
 * To run a mutation, you first call `useDeleteEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityMutation, { data, loading, error }] = useDeleteEntityMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteEntityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityMutation, DeleteEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityMutation, DeleteEntityMutationVariables>(DeleteEntityDocument, options);
      }
export type DeleteEntityMutationHookResult = ReturnType<typeof useDeleteEntityMutation>;
export type DeleteEntityMutationResult = Apollo.MutationResult<DeleteEntityMutation>;
export type DeleteEntityMutationOptions = Apollo.BaseMutationOptions<DeleteEntityMutation, DeleteEntityMutationVariables>;
export const SingleUserDocument = gql`
    query SingleUser($ID: Int!) {
  User(ID: $ID) {
    ...UserScalars
  }
}
    ${UserScalarsFragmentDoc}`;

/**
 * __useSingleUserQuery__
 *
 * To run a query within a React component, call `useSingleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserQuery(baseOptions: Apollo.QueryHookOptions<SingleUserQuery, SingleUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserQuery, SingleUserQueryVariables>(SingleUserDocument, options);
      }
export function useSingleUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserQuery, SingleUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserQuery, SingleUserQueryVariables>(SingleUserDocument, options);
        }
export type SingleUserQueryHookResult = ReturnType<typeof useSingleUserQuery>;
export type SingleUserLazyQueryHookResult = ReturnType<typeof useSingleUserLazyQuery>;
export type SingleUserQueryResult = Apollo.QueryResult<SingleUserQuery, SingleUserQueryVariables>;
export const SingleUserFullDocument = gql`
    query SingleUserFull($ID: Int!) {
  User(ID: $ID) {
    ...UserScalars
    UserApplications {
      ...UserApplicationScalars
    }
    UserRoles {
      ...UserRoleScalars
    }
  }
}
    ${UserScalarsFragmentDoc}
${UserApplicationScalarsFragmentDoc}
${UserRoleScalarsFragmentDoc}`;

/**
 * __useSingleUserFullQuery__
 *
 * To run a query within a React component, call `useSingleUserFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserFullQuery, SingleUserFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserFullQuery, SingleUserFullQueryVariables>(SingleUserFullDocument, options);
      }
export function useSingleUserFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserFullQuery, SingleUserFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserFullQuery, SingleUserFullQueryVariables>(SingleUserFullDocument, options);
        }
export type SingleUserFullQueryHookResult = ReturnType<typeof useSingleUserFullQuery>;
export type SingleUserFullLazyQueryHookResult = ReturnType<typeof useSingleUserFullLazyQuery>;
export type SingleUserFullQueryResult = Apollo.QueryResult<SingleUserFullQuery, SingleUserFullQueryVariables>;
export const AllUsersDocument = gql`
    query AllUsers {
  AllUsers {
    ...UserScalars
    UserRoles {
      ...UserRoleScalars
    }
  }
}
    ${UserScalarsFragmentDoc}
${UserRoleScalarsFragmentDoc}`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  UpdateUser(input: $input) {
    ...UserScalars
  }
}
    ${UserScalarsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const SingleEntityRelationshipDocument = gql`
    query SingleEntityRelationship($ID: Int!) {
  EntityRelationship(ID: $ID) {
    ...EntityRelationshipScalars
  }
}
    ${EntityRelationshipScalarsFragmentDoc}`;

/**
 * __useSingleEntityRelationshipQuery__
 *
 * To run a query within a React component, call `useSingleEntityRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityRelationshipQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityRelationshipQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityRelationshipQuery, SingleEntityRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityRelationshipQuery, SingleEntityRelationshipQueryVariables>(SingleEntityRelationshipDocument, options);
      }
export function useSingleEntityRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityRelationshipQuery, SingleEntityRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityRelationshipQuery, SingleEntityRelationshipQueryVariables>(SingleEntityRelationshipDocument, options);
        }
export type SingleEntityRelationshipQueryHookResult = ReturnType<typeof useSingleEntityRelationshipQuery>;
export type SingleEntityRelationshipLazyQueryHookResult = ReturnType<typeof useSingleEntityRelationshipLazyQuery>;
export type SingleEntityRelationshipQueryResult = Apollo.QueryResult<SingleEntityRelationshipQuery, SingleEntityRelationshipQueryVariables>;
export const SingleEntityRelationshipFullDocument = gql`
    query SingleEntityRelationshipFull($ID: Int!) {
  EntityRelationship(ID: $ID) {
    ...EntityRelationshipScalars
  }
}
    ${EntityRelationshipScalarsFragmentDoc}`;

/**
 * __useSingleEntityRelationshipFullQuery__
 *
 * To run a query within a React component, call `useSingleEntityRelationshipFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityRelationshipFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityRelationshipFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityRelationshipFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityRelationshipFullQuery, SingleEntityRelationshipFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityRelationshipFullQuery, SingleEntityRelationshipFullQueryVariables>(SingleEntityRelationshipFullDocument, options);
      }
export function useSingleEntityRelationshipFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityRelationshipFullQuery, SingleEntityRelationshipFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityRelationshipFullQuery, SingleEntityRelationshipFullQueryVariables>(SingleEntityRelationshipFullDocument, options);
        }
export type SingleEntityRelationshipFullQueryHookResult = ReturnType<typeof useSingleEntityRelationshipFullQuery>;
export type SingleEntityRelationshipFullLazyQueryHookResult = ReturnType<typeof useSingleEntityRelationshipFullLazyQuery>;
export type SingleEntityRelationshipFullQueryResult = Apollo.QueryResult<SingleEntityRelationshipFullQuery, SingleEntityRelationshipFullQueryVariables>;
export const CreateEntityRelationshipDocument = gql`
    mutation CreateEntityRelationship($input: CreateEntityRelationshipInput!) {
  CreateEntityRelationship(input: $input) {
    ...EntityRelationshipScalars
  }
}
    ${EntityRelationshipScalarsFragmentDoc}`;
export type CreateEntityRelationshipMutationFn = Apollo.MutationFunction<CreateEntityRelationshipMutation, CreateEntityRelationshipMutationVariables>;

/**
 * __useCreateEntityRelationshipMutation__
 *
 * To run a mutation, you first call `useCreateEntityRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityRelationshipMutation, { data, loading, error }] = useCreateEntityRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityRelationshipMutation, CreateEntityRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityRelationshipMutation, CreateEntityRelationshipMutationVariables>(CreateEntityRelationshipDocument, options);
      }
export type CreateEntityRelationshipMutationHookResult = ReturnType<typeof useCreateEntityRelationshipMutation>;
export type CreateEntityRelationshipMutationResult = Apollo.MutationResult<CreateEntityRelationshipMutation>;
export type CreateEntityRelationshipMutationOptions = Apollo.BaseMutationOptions<CreateEntityRelationshipMutation, CreateEntityRelationshipMutationVariables>;
export const UpdateEntityRelationshipDocument = gql`
    mutation UpdateEntityRelationship($input: UpdateEntityRelationshipInput!) {
  UpdateEntityRelationship(input: $input) {
    ...EntityRelationshipScalars
  }
}
    ${EntityRelationshipScalarsFragmentDoc}`;
export type UpdateEntityRelationshipMutationFn = Apollo.MutationFunction<UpdateEntityRelationshipMutation, UpdateEntityRelationshipMutationVariables>;

/**
 * __useUpdateEntityRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateEntityRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityRelationshipMutation, { data, loading, error }] = useUpdateEntityRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityRelationshipMutation, UpdateEntityRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityRelationshipMutation, UpdateEntityRelationshipMutationVariables>(UpdateEntityRelationshipDocument, options);
      }
export type UpdateEntityRelationshipMutationHookResult = ReturnType<typeof useUpdateEntityRelationshipMutation>;
export type UpdateEntityRelationshipMutationResult = Apollo.MutationResult<UpdateEntityRelationshipMutation>;
export type UpdateEntityRelationshipMutationOptions = Apollo.BaseMutationOptions<UpdateEntityRelationshipMutation, UpdateEntityRelationshipMutationVariables>;
export const DeleteEntityRelationshipDocument = gql`
    mutation DeleteEntityRelationship($ID: Int!) {
  DeleteEntityRelationship(ID: $ID)
}
    `;
export type DeleteEntityRelationshipMutationFn = Apollo.MutationFunction<DeleteEntityRelationshipMutation, DeleteEntityRelationshipMutationVariables>;

/**
 * __useDeleteEntityRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteEntityRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityRelationshipMutation, { data, loading, error }] = useDeleteEntityRelationshipMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteEntityRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityRelationshipMutation, DeleteEntityRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityRelationshipMutation, DeleteEntityRelationshipMutationVariables>(DeleteEntityRelationshipDocument, options);
      }
export type DeleteEntityRelationshipMutationHookResult = ReturnType<typeof useDeleteEntityRelationshipMutation>;
export type DeleteEntityRelationshipMutationResult = Apollo.MutationResult<DeleteEntityRelationshipMutation>;
export type DeleteEntityRelationshipMutationOptions = Apollo.BaseMutationOptions<DeleteEntityRelationshipMutation, DeleteEntityRelationshipMutationVariables>;
export const SingleUserRecordLogDocument = gql`
    query SingleUserRecordLog($ID: Int!) {
  UserRecordLog(ID: $ID) {
    ...UserRecordLogScalars
  }
}
    ${UserRecordLogScalarsFragmentDoc}`;

/**
 * __useSingleUserRecordLogQuery__
 *
 * To run a query within a React component, call `useSingleUserRecordLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserRecordLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserRecordLogQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserRecordLogQuery(baseOptions: Apollo.QueryHookOptions<SingleUserRecordLogQuery, SingleUserRecordLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserRecordLogQuery, SingleUserRecordLogQueryVariables>(SingleUserRecordLogDocument, options);
      }
export function useSingleUserRecordLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserRecordLogQuery, SingleUserRecordLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserRecordLogQuery, SingleUserRecordLogQueryVariables>(SingleUserRecordLogDocument, options);
        }
export type SingleUserRecordLogQueryHookResult = ReturnType<typeof useSingleUserRecordLogQuery>;
export type SingleUserRecordLogLazyQueryHookResult = ReturnType<typeof useSingleUserRecordLogLazyQuery>;
export type SingleUserRecordLogQueryResult = Apollo.QueryResult<SingleUserRecordLogQuery, SingleUserRecordLogQueryVariables>;
export const SingleUserRecordLogFullDocument = gql`
    query SingleUserRecordLogFull($ID: Int!) {
  UserRecordLog(ID: $ID) {
    ...UserRecordLogScalars
  }
}
    ${UserRecordLogScalarsFragmentDoc}`;

/**
 * __useSingleUserRecordLogFullQuery__
 *
 * To run a query within a React component, call `useSingleUserRecordLogFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserRecordLogFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserRecordLogFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserRecordLogFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserRecordLogFullQuery, SingleUserRecordLogFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserRecordLogFullQuery, SingleUserRecordLogFullQueryVariables>(SingleUserRecordLogFullDocument, options);
      }
export function useSingleUserRecordLogFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserRecordLogFullQuery, SingleUserRecordLogFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserRecordLogFullQuery, SingleUserRecordLogFullQueryVariables>(SingleUserRecordLogFullDocument, options);
        }
export type SingleUserRecordLogFullQueryHookResult = ReturnType<typeof useSingleUserRecordLogFullQuery>;
export type SingleUserRecordLogFullLazyQueryHookResult = ReturnType<typeof useSingleUserRecordLogFullLazyQuery>;
export type SingleUserRecordLogFullQueryResult = Apollo.QueryResult<SingleUserRecordLogFullQuery, SingleUserRecordLogFullQueryVariables>;
export const UpdateUserRecordLogDocument = gql`
    mutation UpdateUserRecordLog($input: UpdateUserRecordLogInput!) {
  UpdateUserRecordLog(input: $input) {
    ...UserRecordLogScalars
  }
}
    ${UserRecordLogScalarsFragmentDoc}`;
export type UpdateUserRecordLogMutationFn = Apollo.MutationFunction<UpdateUserRecordLogMutation, UpdateUserRecordLogMutationVariables>;

/**
 * __useUpdateUserRecordLogMutation__
 *
 * To run a mutation, you first call `useUpdateUserRecordLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRecordLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRecordLogMutation, { data, loading, error }] = useUpdateUserRecordLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRecordLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRecordLogMutation, UpdateUserRecordLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRecordLogMutation, UpdateUserRecordLogMutationVariables>(UpdateUserRecordLogDocument, options);
      }
export type UpdateUserRecordLogMutationHookResult = ReturnType<typeof useUpdateUserRecordLogMutation>;
export type UpdateUserRecordLogMutationResult = Apollo.MutationResult<UpdateUserRecordLogMutation>;
export type UpdateUserRecordLogMutationOptions = Apollo.BaseMutationOptions<UpdateUserRecordLogMutation, UpdateUserRecordLogMutationVariables>;
export const SingleUserViewDocument = gql`
    query SingleUserView($ID: Int!) {
  UserView(ID: $ID) {
    ...UserViewScalars
  }
}
    ${UserViewScalarsFragmentDoc}`;

/**
 * __useSingleUserViewQuery__
 *
 * To run a query within a React component, call `useSingleUserViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserViewQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserViewQuery(baseOptions: Apollo.QueryHookOptions<SingleUserViewQuery, SingleUserViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserViewQuery, SingleUserViewQueryVariables>(SingleUserViewDocument, options);
      }
export function useSingleUserViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserViewQuery, SingleUserViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserViewQuery, SingleUserViewQueryVariables>(SingleUserViewDocument, options);
        }
export type SingleUserViewQueryHookResult = ReturnType<typeof useSingleUserViewQuery>;
export type SingleUserViewLazyQueryHookResult = ReturnType<typeof useSingleUserViewLazyQuery>;
export type SingleUserViewQueryResult = Apollo.QueryResult<SingleUserViewQuery, SingleUserViewQueryVariables>;
export const SingleUserViewFullDocument = gql`
    query SingleUserViewFull($ID: Int!) {
  UserView(ID: $ID) {
    ...UserViewScalars
  }
}
    ${UserViewScalarsFragmentDoc}`;

/**
 * __useSingleUserViewFullQuery__
 *
 * To run a query within a React component, call `useSingleUserViewFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserViewFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserViewFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserViewFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserViewFullQuery, SingleUserViewFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserViewFullQuery, SingleUserViewFullQueryVariables>(SingleUserViewFullDocument, options);
      }
export function useSingleUserViewFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserViewFullQuery, SingleUserViewFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserViewFullQuery, SingleUserViewFullQueryVariables>(SingleUserViewFullDocument, options);
        }
export type SingleUserViewFullQueryHookResult = ReturnType<typeof useSingleUserViewFullQuery>;
export type SingleUserViewFullLazyQueryHookResult = ReturnType<typeof useSingleUserViewFullLazyQuery>;
export type SingleUserViewFullQueryResult = Apollo.QueryResult<SingleUserViewFullQuery, SingleUserViewFullQueryVariables>;
export const AllUserViewsDocument = gql`
    query AllUserViews {
  AllUserViews {
    ...UserViewScalars
  }
}
    ${UserViewScalarsFragmentDoc}`;

/**
 * __useAllUserViewsQuery__
 *
 * To run a query within a React component, call `useAllUserViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserViewsQuery(baseOptions?: Apollo.QueryHookOptions<AllUserViewsQuery, AllUserViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserViewsQuery, AllUserViewsQueryVariables>(AllUserViewsDocument, options);
      }
export function useAllUserViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserViewsQuery, AllUserViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserViewsQuery, AllUserViewsQueryVariables>(AllUserViewsDocument, options);
        }
export type AllUserViewsQueryHookResult = ReturnType<typeof useAllUserViewsQuery>;
export type AllUserViewsLazyQueryHookResult = ReturnType<typeof useAllUserViewsLazyQuery>;
export type AllUserViewsQueryResult = Apollo.QueryResult<AllUserViewsQuery, AllUserViewsQueryVariables>;
export const CreateUserViewDocument = gql`
    mutation CreateUserView($input: CreateUserViewInput!) {
  CreateUserView(input: $input) {
    ...UserViewScalars
  }
}
    ${UserViewScalarsFragmentDoc}`;
export type CreateUserViewMutationFn = Apollo.MutationFunction<CreateUserViewMutation, CreateUserViewMutationVariables>;

/**
 * __useCreateUserViewMutation__
 *
 * To run a mutation, you first call `useCreateUserViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserViewMutation, { data, loading, error }] = useCreateUserViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserViewMutation, CreateUserViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserViewMutation, CreateUserViewMutationVariables>(CreateUserViewDocument, options);
      }
export type CreateUserViewMutationHookResult = ReturnType<typeof useCreateUserViewMutation>;
export type CreateUserViewMutationResult = Apollo.MutationResult<CreateUserViewMutation>;
export type CreateUserViewMutationOptions = Apollo.BaseMutationOptions<CreateUserViewMutation, CreateUserViewMutationVariables>;
export const UpdateUserViewDocument = gql`
    mutation UpdateUserView($input: UpdateUserViewInput!) {
  UpdateUserView(input: $input) {
    ...UserViewScalars
  }
}
    ${UserViewScalarsFragmentDoc}`;
export type UpdateUserViewMutationFn = Apollo.MutationFunction<UpdateUserViewMutation, UpdateUserViewMutationVariables>;

/**
 * __useUpdateUserViewMutation__
 *
 * To run a mutation, you first call `useUpdateUserViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserViewMutation, { data, loading, error }] = useUpdateUserViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserViewMutation, UpdateUserViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserViewMutation, UpdateUserViewMutationVariables>(UpdateUserViewDocument, options);
      }
export type UpdateUserViewMutationHookResult = ReturnType<typeof useUpdateUserViewMutation>;
export type UpdateUserViewMutationResult = Apollo.MutationResult<UpdateUserViewMutation>;
export type UpdateUserViewMutationOptions = Apollo.BaseMutationOptions<UpdateUserViewMutation, UpdateUserViewMutationVariables>;
export const DeleteUserViewDocument = gql`
    mutation DeleteUserView($ID: Int!) {
  DeleteUserView(ID: $ID)
}
    `;
export type DeleteUserViewMutationFn = Apollo.MutationFunction<DeleteUserViewMutation, DeleteUserViewMutationVariables>;

/**
 * __useDeleteUserViewMutation__
 *
 * To run a mutation, you first call `useDeleteUserViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserViewMutation, { data, loading, error }] = useDeleteUserViewMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteUserViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserViewMutation, DeleteUserViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserViewMutation, DeleteUserViewMutationVariables>(DeleteUserViewDocument, options);
      }
export type DeleteUserViewMutationHookResult = ReturnType<typeof useDeleteUserViewMutation>;
export type DeleteUserViewMutationResult = Apollo.MutationResult<DeleteUserViewMutation>;
export type DeleteUserViewMutationOptions = Apollo.BaseMutationOptions<DeleteUserViewMutation, DeleteUserViewMutationVariables>;
export const SingleContactTopicDocument = gql`
    query SingleContactTopic($ID: Int!) {
  ContactTopic(ID: $ID) {
    ...ContactTopicScalars
  }
}
    ${ContactTopicScalarsFragmentDoc}`;

/**
 * __useSingleContactTopicQuery__
 *
 * To run a query within a React component, call `useSingleContactTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactTopicQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactTopicQuery(baseOptions: Apollo.QueryHookOptions<SingleContactTopicQuery, SingleContactTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactTopicQuery, SingleContactTopicQueryVariables>(SingleContactTopicDocument, options);
      }
export function useSingleContactTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactTopicQuery, SingleContactTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactTopicQuery, SingleContactTopicQueryVariables>(SingleContactTopicDocument, options);
        }
export type SingleContactTopicQueryHookResult = ReturnType<typeof useSingleContactTopicQuery>;
export type SingleContactTopicLazyQueryHookResult = ReturnType<typeof useSingleContactTopicLazyQuery>;
export type SingleContactTopicQueryResult = Apollo.QueryResult<SingleContactTopicQuery, SingleContactTopicQueryVariables>;
export const SingleContactTopicFullDocument = gql`
    query SingleContactTopicFull($ID: Int!) {
  ContactTopic(ID: $ID) {
    ...ContactTopicScalars
  }
}
    ${ContactTopicScalarsFragmentDoc}`;

/**
 * __useSingleContactTopicFullQuery__
 *
 * To run a query within a React component, call `useSingleContactTopicFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactTopicFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactTopicFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactTopicFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactTopicFullQuery, SingleContactTopicFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactTopicFullQuery, SingleContactTopicFullQueryVariables>(SingleContactTopicFullDocument, options);
      }
export function useSingleContactTopicFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactTopicFullQuery, SingleContactTopicFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactTopicFullQuery, SingleContactTopicFullQueryVariables>(SingleContactTopicFullDocument, options);
        }
export type SingleContactTopicFullQueryHookResult = ReturnType<typeof useSingleContactTopicFullQuery>;
export type SingleContactTopicFullLazyQueryHookResult = ReturnType<typeof useSingleContactTopicFullLazyQuery>;
export type SingleContactTopicFullQueryResult = Apollo.QueryResult<SingleContactTopicFullQuery, SingleContactTopicFullQueryVariables>;
export const UpdateContactTopicDocument = gql`
    mutation UpdateContactTopic($input: UpdateContactTopicInput!) {
  UpdateContactTopic(input: $input) {
    ...ContactTopicScalars
  }
}
    ${ContactTopicScalarsFragmentDoc}`;
export type UpdateContactTopicMutationFn = Apollo.MutationFunction<UpdateContactTopicMutation, UpdateContactTopicMutationVariables>;

/**
 * __useUpdateContactTopicMutation__
 *
 * To run a mutation, you first call `useUpdateContactTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactTopicMutation, { data, loading, error }] = useUpdateContactTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactTopicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactTopicMutation, UpdateContactTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactTopicMutation, UpdateContactTopicMutationVariables>(UpdateContactTopicDocument, options);
      }
export type UpdateContactTopicMutationHookResult = ReturnType<typeof useUpdateContactTopicMutation>;
export type UpdateContactTopicMutationResult = Apollo.MutationResult<UpdateContactTopicMutation>;
export type UpdateContactTopicMutationOptions = Apollo.BaseMutationOptions<UpdateContactTopicMutation, UpdateContactTopicMutationVariables>;
export const SinglePaymentDocument = gql`
    query SinglePayment($ID: Int!) {
  Payment(ID: $ID) {
    ...PaymentScalars
  }
}
    ${PaymentScalarsFragmentDoc}`;

/**
 * __useSinglePaymentQuery__
 *
 * To run a query within a React component, call `useSinglePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinglePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinglePaymentQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSinglePaymentQuery(baseOptions: Apollo.QueryHookOptions<SinglePaymentQuery, SinglePaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SinglePaymentQuery, SinglePaymentQueryVariables>(SinglePaymentDocument, options);
      }
export function useSinglePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SinglePaymentQuery, SinglePaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SinglePaymentQuery, SinglePaymentQueryVariables>(SinglePaymentDocument, options);
        }
export type SinglePaymentQueryHookResult = ReturnType<typeof useSinglePaymentQuery>;
export type SinglePaymentLazyQueryHookResult = ReturnType<typeof useSinglePaymentLazyQuery>;
export type SinglePaymentQueryResult = Apollo.QueryResult<SinglePaymentQuery, SinglePaymentQueryVariables>;
export const SinglePaymentFullDocument = gql`
    query SinglePaymentFull($ID: Int!) {
  Payment(ID: $ID) {
    ...PaymentScalars
  }
}
    ${PaymentScalarsFragmentDoc}`;

/**
 * __useSinglePaymentFullQuery__
 *
 * To run a query within a React component, call `useSinglePaymentFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinglePaymentFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinglePaymentFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSinglePaymentFullQuery(baseOptions: Apollo.QueryHookOptions<SinglePaymentFullQuery, SinglePaymentFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SinglePaymentFullQuery, SinglePaymentFullQueryVariables>(SinglePaymentFullDocument, options);
      }
export function useSinglePaymentFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SinglePaymentFullQuery, SinglePaymentFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SinglePaymentFullQuery, SinglePaymentFullQueryVariables>(SinglePaymentFullDocument, options);
        }
export type SinglePaymentFullQueryHookResult = ReturnType<typeof useSinglePaymentFullQuery>;
export type SinglePaymentFullLazyQueryHookResult = ReturnType<typeof useSinglePaymentFullLazyQuery>;
export type SinglePaymentFullQueryResult = Apollo.QueryResult<SinglePaymentFullQuery, SinglePaymentFullQueryVariables>;
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($input: UpdatePaymentInput!) {
  UpdatePayment(input: $input) {
    ...PaymentScalars
  }
}
    ${PaymentScalarsFragmentDoc}`;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const SingleInvoiceDocument = gql`
    query SingleInvoice($ID: Int!) {
  Invoice(ID: $ID) {
    ...InvoiceScalars
  }
}
    ${InvoiceScalarsFragmentDoc}`;

/**
 * __useSingleInvoiceQuery__
 *
 * To run a query within a React component, call `useSingleInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleInvoiceQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleInvoiceQuery(baseOptions: Apollo.QueryHookOptions<SingleInvoiceQuery, SingleInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleInvoiceQuery, SingleInvoiceQueryVariables>(SingleInvoiceDocument, options);
      }
export function useSingleInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleInvoiceQuery, SingleInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleInvoiceQuery, SingleInvoiceQueryVariables>(SingleInvoiceDocument, options);
        }
export type SingleInvoiceQueryHookResult = ReturnType<typeof useSingleInvoiceQuery>;
export type SingleInvoiceLazyQueryHookResult = ReturnType<typeof useSingleInvoiceLazyQuery>;
export type SingleInvoiceQueryResult = Apollo.QueryResult<SingleInvoiceQuery, SingleInvoiceQueryVariables>;
export const SingleInvoiceFullDocument = gql`
    query SingleInvoiceFull($ID: Int!) {
  Invoice(ID: $ID) {
    ...InvoiceScalars
    Payments {
      ...PaymentScalars
    }
  }
}
    ${InvoiceScalarsFragmentDoc}
${PaymentScalarsFragmentDoc}`;

/**
 * __useSingleInvoiceFullQuery__
 *
 * To run a query within a React component, call `useSingleInvoiceFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleInvoiceFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleInvoiceFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleInvoiceFullQuery(baseOptions: Apollo.QueryHookOptions<SingleInvoiceFullQuery, SingleInvoiceFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleInvoiceFullQuery, SingleInvoiceFullQueryVariables>(SingleInvoiceFullDocument, options);
      }
export function useSingleInvoiceFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleInvoiceFullQuery, SingleInvoiceFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleInvoiceFullQuery, SingleInvoiceFullQueryVariables>(SingleInvoiceFullDocument, options);
        }
export type SingleInvoiceFullQueryHookResult = ReturnType<typeof useSingleInvoiceFullQuery>;
export type SingleInvoiceFullLazyQueryHookResult = ReturnType<typeof useSingleInvoiceFullLazyQuery>;
export type SingleInvoiceFullQueryResult = Apollo.QueryResult<SingleInvoiceFullQuery, SingleInvoiceFullQueryVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($input: UpdateInvoiceInput!) {
  UpdateInvoice(input: $input) {
    ...InvoiceScalars
  }
}
    ${InvoiceScalarsFragmentDoc}`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const SingleEmailServiceProvidersDocument = gql`
    query SingleEmailServiceProviders($ID: Int!) {
  EmailServiceProviders(ID: $ID) {
    ...EmailServiceProvidersScalars
  }
}
    ${EmailServiceProvidersScalarsFragmentDoc}`;

/**
 * __useSingleEmailServiceProvidersQuery__
 *
 * To run a query within a React component, call `useSingleEmailServiceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEmailServiceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEmailServiceProvidersQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEmailServiceProvidersQuery(baseOptions: Apollo.QueryHookOptions<SingleEmailServiceProvidersQuery, SingleEmailServiceProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEmailServiceProvidersQuery, SingleEmailServiceProvidersQueryVariables>(SingleEmailServiceProvidersDocument, options);
      }
export function useSingleEmailServiceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEmailServiceProvidersQuery, SingleEmailServiceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEmailServiceProvidersQuery, SingleEmailServiceProvidersQueryVariables>(SingleEmailServiceProvidersDocument, options);
        }
export type SingleEmailServiceProvidersQueryHookResult = ReturnType<typeof useSingleEmailServiceProvidersQuery>;
export type SingleEmailServiceProvidersLazyQueryHookResult = ReturnType<typeof useSingleEmailServiceProvidersLazyQuery>;
export type SingleEmailServiceProvidersQueryResult = Apollo.QueryResult<SingleEmailServiceProvidersQuery, SingleEmailServiceProvidersQueryVariables>;
export const SingleEmailServiceProvidersFullDocument = gql`
    query SingleEmailServiceProvidersFull($ID: Int!) {
  EmailServiceProviders(ID: $ID) {
    ...EmailServiceProvidersScalars
  }
}
    ${EmailServiceProvidersScalarsFragmentDoc}`;

/**
 * __useSingleEmailServiceProvidersFullQuery__
 *
 * To run a query within a React component, call `useSingleEmailServiceProvidersFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEmailServiceProvidersFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEmailServiceProvidersFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEmailServiceProvidersFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEmailServiceProvidersFullQuery, SingleEmailServiceProvidersFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEmailServiceProvidersFullQuery, SingleEmailServiceProvidersFullQueryVariables>(SingleEmailServiceProvidersFullDocument, options);
      }
export function useSingleEmailServiceProvidersFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEmailServiceProvidersFullQuery, SingleEmailServiceProvidersFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEmailServiceProvidersFullQuery, SingleEmailServiceProvidersFullQueryVariables>(SingleEmailServiceProvidersFullDocument, options);
        }
export type SingleEmailServiceProvidersFullQueryHookResult = ReturnType<typeof useSingleEmailServiceProvidersFullQuery>;
export type SingleEmailServiceProvidersFullLazyQueryHookResult = ReturnType<typeof useSingleEmailServiceProvidersFullLazyQuery>;
export type SingleEmailServiceProvidersFullQueryResult = Apollo.QueryResult<SingleEmailServiceProvidersFullQuery, SingleEmailServiceProvidersFullQueryVariables>;
export const AllEmailServiceProvidersDocument = gql`
    query AllEmailServiceProviders {
  AllEmailServiceProviders {
    ...EmailServiceProvidersScalars
  }
}
    ${EmailServiceProvidersScalarsFragmentDoc}`;

/**
 * __useAllEmailServiceProvidersQuery__
 *
 * To run a query within a React component, call `useAllEmailServiceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEmailServiceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEmailServiceProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEmailServiceProvidersQuery(baseOptions?: Apollo.QueryHookOptions<AllEmailServiceProvidersQuery, AllEmailServiceProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEmailServiceProvidersQuery, AllEmailServiceProvidersQueryVariables>(AllEmailServiceProvidersDocument, options);
      }
export function useAllEmailServiceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEmailServiceProvidersQuery, AllEmailServiceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEmailServiceProvidersQuery, AllEmailServiceProvidersQueryVariables>(AllEmailServiceProvidersDocument, options);
        }
export type AllEmailServiceProvidersQueryHookResult = ReturnType<typeof useAllEmailServiceProvidersQuery>;
export type AllEmailServiceProvidersLazyQueryHookResult = ReturnType<typeof useAllEmailServiceProvidersLazyQuery>;
export type AllEmailServiceProvidersQueryResult = Apollo.QueryResult<AllEmailServiceProvidersQuery, AllEmailServiceProvidersQueryVariables>;
export const UpdateEmailServiceProvidersDocument = gql`
    mutation UpdateEmailServiceProviders($input: UpdateEmailServiceProvidersInput!) {
  UpdateEmailServiceProviders(input: $input) {
    ...EmailServiceProvidersScalars
  }
}
    ${EmailServiceProvidersScalarsFragmentDoc}`;
export type UpdateEmailServiceProvidersMutationFn = Apollo.MutationFunction<UpdateEmailServiceProvidersMutation, UpdateEmailServiceProvidersMutationVariables>;

/**
 * __useUpdateEmailServiceProvidersMutation__
 *
 * To run a mutation, you first call `useUpdateEmailServiceProvidersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailServiceProvidersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailServiceProvidersMutation, { data, loading, error }] = useUpdateEmailServiceProvidersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailServiceProvidersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailServiceProvidersMutation, UpdateEmailServiceProvidersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailServiceProvidersMutation, UpdateEmailServiceProvidersMutationVariables>(UpdateEmailServiceProvidersDocument, options);
      }
export type UpdateEmailServiceProvidersMutationHookResult = ReturnType<typeof useUpdateEmailServiceProvidersMutation>;
export type UpdateEmailServiceProvidersMutationResult = Apollo.MutationResult<UpdateEmailServiceProvidersMutation>;
export type UpdateEmailServiceProvidersMutationOptions = Apollo.BaseMutationOptions<UpdateEmailServiceProvidersMutation, UpdateEmailServiceProvidersMutationVariables>;
export const Single_990FullDocument = gql`
    query Single_990Full($ID: Int!) {
  _990Full(ID: $ID) {
    ..._990FullScalars
  }
}
    ${_990FullScalarsFragmentDoc}`;

/**
 * __useSingle_990FullQuery__
 *
 * To run a query within a React component, call `useSingle_990FullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingle_990FullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingle_990FullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingle_990FullQuery(baseOptions: Apollo.QueryHookOptions<Single_990FullQuery, Single_990FullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Single_990FullQuery, Single_990FullQueryVariables>(Single_990FullDocument, options);
      }
export function useSingle_990FullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Single_990FullQuery, Single_990FullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Single_990FullQuery, Single_990FullQueryVariables>(Single_990FullDocument, options);
        }
export type Single_990FullQueryHookResult = ReturnType<typeof useSingle_990FullQuery>;
export type Single_990FullLazyQueryHookResult = ReturnType<typeof useSingle_990FullLazyQuery>;
export type Single_990FullQueryResult = Apollo.QueryResult<Single_990FullQuery, Single_990FullQueryVariables>;
export const Single_990FullFullDocument = gql`
    query Single_990FullFull($ID: Int!) {
  _990Full(ID: $ID) {
    ..._990FullScalars
  }
}
    ${_990FullScalarsFragmentDoc}`;

/**
 * __useSingle_990FullFullQuery__
 *
 * To run a query within a React component, call `useSingle_990FullFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingle_990FullFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingle_990FullFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingle_990FullFullQuery(baseOptions: Apollo.QueryHookOptions<Single_990FullFullQuery, Single_990FullFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Single_990FullFullQuery, Single_990FullFullQueryVariables>(Single_990FullFullDocument, options);
      }
export function useSingle_990FullFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Single_990FullFullQuery, Single_990FullFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Single_990FullFullQuery, Single_990FullFullQueryVariables>(Single_990FullFullDocument, options);
        }
export type Single_990FullFullQueryHookResult = ReturnType<typeof useSingle_990FullFullQuery>;
export type Single_990FullFullLazyQueryHookResult = ReturnType<typeof useSingle_990FullFullLazyQuery>;
export type Single_990FullFullQueryResult = Apollo.QueryResult<Single_990FullFullQuery, Single_990FullFullQueryVariables>;
export const Update_990FullDocument = gql`
    mutation Update_990Full($input: Update_990FullInput!) {
  Update_990Full(input: $input) {
    ..._990FullScalars
  }
}
    ${_990FullScalarsFragmentDoc}`;
export type Update_990FullMutationFn = Apollo.MutationFunction<Update_990FullMutation, Update_990FullMutationVariables>;

/**
 * __useUpdate_990FullMutation__
 *
 * To run a mutation, you first call `useUpdate_990FullMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_990FullMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [update_990FullMutation, { data, loading, error }] = useUpdate_990FullMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdate_990FullMutation(baseOptions?: Apollo.MutationHookOptions<Update_990FullMutation, Update_990FullMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_990FullMutation, Update_990FullMutationVariables>(Update_990FullDocument, options);
      }
export type Update_990FullMutationHookResult = ReturnType<typeof useUpdate_990FullMutation>;
export type Update_990FullMutationResult = Apollo.MutationResult<Update_990FullMutation>;
export type Update_990FullMutationOptions = Apollo.BaseMutationOptions<Update_990FullMutation, Update_990FullMutationVariables>;
export const Single_990LatestDocument = gql`
    query Single_990Latest($ID: Int!) {
  _990Latest(ID: $ID) {
    ..._990LatestScalars
  }
}
    ${_990LatestScalarsFragmentDoc}`;

/**
 * __useSingle_990LatestQuery__
 *
 * To run a query within a React component, call `useSingle_990LatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingle_990LatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingle_990LatestQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingle_990LatestQuery(baseOptions: Apollo.QueryHookOptions<Single_990LatestQuery, Single_990LatestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Single_990LatestQuery, Single_990LatestQueryVariables>(Single_990LatestDocument, options);
      }
export function useSingle_990LatestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Single_990LatestQuery, Single_990LatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Single_990LatestQuery, Single_990LatestQueryVariables>(Single_990LatestDocument, options);
        }
export type Single_990LatestQueryHookResult = ReturnType<typeof useSingle_990LatestQuery>;
export type Single_990LatestLazyQueryHookResult = ReturnType<typeof useSingle_990LatestLazyQuery>;
export type Single_990LatestQueryResult = Apollo.QueryResult<Single_990LatestQuery, Single_990LatestQueryVariables>;
export const Single_990LatestFullDocument = gql`
    query Single_990LatestFull($ID: Int!) {
  _990Latest(ID: $ID) {
    ..._990LatestScalars
  }
}
    ${_990LatestScalarsFragmentDoc}`;

/**
 * __useSingle_990LatestFullQuery__
 *
 * To run a query within a React component, call `useSingle_990LatestFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingle_990LatestFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingle_990LatestFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingle_990LatestFullQuery(baseOptions: Apollo.QueryHookOptions<Single_990LatestFullQuery, Single_990LatestFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Single_990LatestFullQuery, Single_990LatestFullQueryVariables>(Single_990LatestFullDocument, options);
      }
export function useSingle_990LatestFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Single_990LatestFullQuery, Single_990LatestFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Single_990LatestFullQuery, Single_990LatestFullQueryVariables>(Single_990LatestFullDocument, options);
        }
export type Single_990LatestFullQueryHookResult = ReturnType<typeof useSingle_990LatestFullQuery>;
export type Single_990LatestFullLazyQueryHookResult = ReturnType<typeof useSingle_990LatestFullLazyQuery>;
export type Single_990LatestFullQueryResult = Apollo.QueryResult<Single_990LatestFullQuery, Single_990LatestFullQueryVariables>;
export const Update_990LatestDocument = gql`
    mutation Update_990Latest($input: Update_990LatestInput!) {
  Update_990Latest(input: $input) {
    ..._990LatestScalars
  }
}
    ${_990LatestScalarsFragmentDoc}`;
export type Update_990LatestMutationFn = Apollo.MutationFunction<Update_990LatestMutation, Update_990LatestMutationVariables>;

/**
 * __useUpdate_990LatestMutation__
 *
 * To run a mutation, you first call `useUpdate_990LatestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_990LatestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [update_990LatestMutation, { data, loading, error }] = useUpdate_990LatestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdate_990LatestMutation(baseOptions?: Apollo.MutationHookOptions<Update_990LatestMutation, Update_990LatestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_990LatestMutation, Update_990LatestMutationVariables>(Update_990LatestDocument, options);
      }
export type Update_990LatestMutationHookResult = ReturnType<typeof useUpdate_990LatestMutation>;
export type Update_990LatestMutationResult = Apollo.MutationResult<Update_990LatestMutation>;
export type Update_990LatestMutationOptions = Apollo.BaseMutationOptions<Update_990LatestMutation, Update_990LatestMutationVariables>;
export const SingleContactEmailDocument = gql`
    query SingleContactEmail($ID: Int!) {
  ContactEmail(ID: $ID) {
    ...ContactEmailScalars
  }
}
    ${ContactEmailScalarsFragmentDoc}`;

/**
 * __useSingleContactEmailQuery__
 *
 * To run a query within a React component, call `useSingleContactEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactEmailQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactEmailQuery(baseOptions: Apollo.QueryHookOptions<SingleContactEmailQuery, SingleContactEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactEmailQuery, SingleContactEmailQueryVariables>(SingleContactEmailDocument, options);
      }
export function useSingleContactEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactEmailQuery, SingleContactEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactEmailQuery, SingleContactEmailQueryVariables>(SingleContactEmailDocument, options);
        }
export type SingleContactEmailQueryHookResult = ReturnType<typeof useSingleContactEmailQuery>;
export type SingleContactEmailLazyQueryHookResult = ReturnType<typeof useSingleContactEmailLazyQuery>;
export type SingleContactEmailQueryResult = Apollo.QueryResult<SingleContactEmailQuery, SingleContactEmailQueryVariables>;
export const SingleContactEmailFullDocument = gql`
    query SingleContactEmailFull($ID: Int!) {
  ContactEmail(ID: $ID) {
    ...ContactEmailScalars
  }
}
    ${ContactEmailScalarsFragmentDoc}`;

/**
 * __useSingleContactEmailFullQuery__
 *
 * To run a query within a React component, call `useSingleContactEmailFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactEmailFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactEmailFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactEmailFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactEmailFullQuery, SingleContactEmailFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactEmailFullQuery, SingleContactEmailFullQueryVariables>(SingleContactEmailFullDocument, options);
      }
export function useSingleContactEmailFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactEmailFullQuery, SingleContactEmailFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactEmailFullQuery, SingleContactEmailFullQueryVariables>(SingleContactEmailFullDocument, options);
        }
export type SingleContactEmailFullQueryHookResult = ReturnType<typeof useSingleContactEmailFullQuery>;
export type SingleContactEmailFullLazyQueryHookResult = ReturnType<typeof useSingleContactEmailFullLazyQuery>;
export type SingleContactEmailFullQueryResult = Apollo.QueryResult<SingleContactEmailFullQuery, SingleContactEmailFullQueryVariables>;
export const UpdateContactEmailDocument = gql`
    mutation UpdateContactEmail($input: UpdateContactEmailInput!) {
  UpdateContactEmail(input: $input) {
    ...ContactEmailScalars
  }
}
    ${ContactEmailScalarsFragmentDoc}`;
export type UpdateContactEmailMutationFn = Apollo.MutationFunction<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>;

/**
 * __useUpdateContactEmailMutation__
 *
 * To run a mutation, you first call `useUpdateContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactEmailMutation, { data, loading, error }] = useUpdateContactEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>(UpdateContactEmailDocument, options);
      }
export type UpdateContactEmailMutationHookResult = ReturnType<typeof useUpdateContactEmailMutation>;
export type UpdateContactEmailMutationResult = Apollo.MutationResult<UpdateContactEmailMutation>;
export type UpdateContactEmailMutationOptions = Apollo.BaseMutationOptions<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>;
export const SingleContactAccountDocument = gql`
    query SingleContactAccount($ID: Int!) {
  ContactAccount(ID: $ID) {
    ...ContactAccountScalars
  }
}
    ${ContactAccountScalarsFragmentDoc}`;

/**
 * __useSingleContactAccountQuery__
 *
 * To run a query within a React component, call `useSingleContactAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactAccountQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactAccountQuery(baseOptions: Apollo.QueryHookOptions<SingleContactAccountQuery, SingleContactAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactAccountQuery, SingleContactAccountQueryVariables>(SingleContactAccountDocument, options);
      }
export function useSingleContactAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactAccountQuery, SingleContactAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactAccountQuery, SingleContactAccountQueryVariables>(SingleContactAccountDocument, options);
        }
export type SingleContactAccountQueryHookResult = ReturnType<typeof useSingleContactAccountQuery>;
export type SingleContactAccountLazyQueryHookResult = ReturnType<typeof useSingleContactAccountLazyQuery>;
export type SingleContactAccountQueryResult = Apollo.QueryResult<SingleContactAccountQuery, SingleContactAccountQueryVariables>;
export const SingleContactAccountFullDocument = gql`
    query SingleContactAccountFull($ID: Int!) {
  ContactAccount(ID: $ID) {
    ...ContactAccountScalars
  }
}
    ${ContactAccountScalarsFragmentDoc}`;

/**
 * __useSingleContactAccountFullQuery__
 *
 * To run a query within a React component, call `useSingleContactAccountFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactAccountFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactAccountFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactAccountFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactAccountFullQuery, SingleContactAccountFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactAccountFullQuery, SingleContactAccountFullQueryVariables>(SingleContactAccountFullDocument, options);
      }
export function useSingleContactAccountFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactAccountFullQuery, SingleContactAccountFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactAccountFullQuery, SingleContactAccountFullQueryVariables>(SingleContactAccountFullDocument, options);
        }
export type SingleContactAccountFullQueryHookResult = ReturnType<typeof useSingleContactAccountFullQuery>;
export type SingleContactAccountFullLazyQueryHookResult = ReturnType<typeof useSingleContactAccountFullLazyQuery>;
export type SingleContactAccountFullQueryResult = Apollo.QueryResult<SingleContactAccountFullQuery, SingleContactAccountFullQueryVariables>;
export const UpdateContactAccountDocument = gql`
    mutation UpdateContactAccount($input: UpdateContactAccountInput!) {
  UpdateContactAccount(input: $input) {
    ...ContactAccountScalars
  }
}
    ${ContactAccountScalarsFragmentDoc}`;
export type UpdateContactAccountMutationFn = Apollo.MutationFunction<UpdateContactAccountMutation, UpdateContactAccountMutationVariables>;

/**
 * __useUpdateContactAccountMutation__
 *
 * To run a mutation, you first call `useUpdateContactAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactAccountMutation, { data, loading, error }] = useUpdateContactAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactAccountMutation, UpdateContactAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactAccountMutation, UpdateContactAccountMutationVariables>(UpdateContactAccountDocument, options);
      }
export type UpdateContactAccountMutationHookResult = ReturnType<typeof useUpdateContactAccountMutation>;
export type UpdateContactAccountMutationResult = Apollo.MutationResult<UpdateContactAccountMutation>;
export type UpdateContactAccountMutationOptions = Apollo.BaseMutationOptions<UpdateContactAccountMutation, UpdateContactAccountMutationVariables>;
export const SingleLifecycleStageDocument = gql`
    query SingleLifecycleStage($ID: Int!) {
  LifecycleStage(ID: $ID) {
    ...LifecycleStageScalars
  }
}
    ${LifecycleStageScalarsFragmentDoc}`;

/**
 * __useSingleLifecycleStageQuery__
 *
 * To run a query within a React component, call `useSingleLifecycleStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLifecycleStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLifecycleStageQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleLifecycleStageQuery(baseOptions: Apollo.QueryHookOptions<SingleLifecycleStageQuery, SingleLifecycleStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleLifecycleStageQuery, SingleLifecycleStageQueryVariables>(SingleLifecycleStageDocument, options);
      }
export function useSingleLifecycleStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleLifecycleStageQuery, SingleLifecycleStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleLifecycleStageQuery, SingleLifecycleStageQueryVariables>(SingleLifecycleStageDocument, options);
        }
export type SingleLifecycleStageQueryHookResult = ReturnType<typeof useSingleLifecycleStageQuery>;
export type SingleLifecycleStageLazyQueryHookResult = ReturnType<typeof useSingleLifecycleStageLazyQuery>;
export type SingleLifecycleStageQueryResult = Apollo.QueryResult<SingleLifecycleStageQuery, SingleLifecycleStageQueryVariables>;
export const SingleLifecycleStageFullDocument = gql`
    query SingleLifecycleStageFull($ID: Int!) {
  LifecycleStage(ID: $ID) {
    ...LifecycleStageScalars
  }
}
    ${LifecycleStageScalarsFragmentDoc}`;

/**
 * __useSingleLifecycleStageFullQuery__
 *
 * To run a query within a React component, call `useSingleLifecycleStageFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLifecycleStageFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLifecycleStageFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleLifecycleStageFullQuery(baseOptions: Apollo.QueryHookOptions<SingleLifecycleStageFullQuery, SingleLifecycleStageFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleLifecycleStageFullQuery, SingleLifecycleStageFullQueryVariables>(SingleLifecycleStageFullDocument, options);
      }
export function useSingleLifecycleStageFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleLifecycleStageFullQuery, SingleLifecycleStageFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleLifecycleStageFullQuery, SingleLifecycleStageFullQueryVariables>(SingleLifecycleStageFullDocument, options);
        }
export type SingleLifecycleStageFullQueryHookResult = ReturnType<typeof useSingleLifecycleStageFullQuery>;
export type SingleLifecycleStageFullLazyQueryHookResult = ReturnType<typeof useSingleLifecycleStageFullLazyQuery>;
export type SingleLifecycleStageFullQueryResult = Apollo.QueryResult<SingleLifecycleStageFullQuery, SingleLifecycleStageFullQueryVariables>;
export const AllLifecycleStagesDocument = gql`
    query AllLifecycleStages {
  AllLifecycleStages {
    ...LifecycleStageScalars
  }
}
    ${LifecycleStageScalarsFragmentDoc}`;

/**
 * __useAllLifecycleStagesQuery__
 *
 * To run a query within a React component, call `useAllLifecycleStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLifecycleStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLifecycleStagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLifecycleStagesQuery(baseOptions?: Apollo.QueryHookOptions<AllLifecycleStagesQuery, AllLifecycleStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLifecycleStagesQuery, AllLifecycleStagesQueryVariables>(AllLifecycleStagesDocument, options);
      }
export function useAllLifecycleStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLifecycleStagesQuery, AllLifecycleStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLifecycleStagesQuery, AllLifecycleStagesQueryVariables>(AllLifecycleStagesDocument, options);
        }
export type AllLifecycleStagesQueryHookResult = ReturnType<typeof useAllLifecycleStagesQuery>;
export type AllLifecycleStagesLazyQueryHookResult = ReturnType<typeof useAllLifecycleStagesLazyQuery>;
export type AllLifecycleStagesQueryResult = Apollo.QueryResult<AllLifecycleStagesQuery, AllLifecycleStagesQueryVariables>;
export const UpdateLifecycleStageDocument = gql`
    mutation UpdateLifecycleStage($input: UpdateLifecycleStageInput!) {
  UpdateLifecycleStage(input: $input) {
    ...LifecycleStageScalars
  }
}
    ${LifecycleStageScalarsFragmentDoc}`;
export type UpdateLifecycleStageMutationFn = Apollo.MutationFunction<UpdateLifecycleStageMutation, UpdateLifecycleStageMutationVariables>;

/**
 * __useUpdateLifecycleStageMutation__
 *
 * To run a mutation, you first call `useUpdateLifecycleStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifecycleStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifecycleStageMutation, { data, loading, error }] = useUpdateLifecycleStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLifecycleStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLifecycleStageMutation, UpdateLifecycleStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLifecycleStageMutation, UpdateLifecycleStageMutationVariables>(UpdateLifecycleStageDocument, options);
      }
export type UpdateLifecycleStageMutationHookResult = ReturnType<typeof useUpdateLifecycleStageMutation>;
export type UpdateLifecycleStageMutationResult = Apollo.MutationResult<UpdateLifecycleStageMutation>;
export type UpdateLifecycleStageMutationOptions = Apollo.BaseMutationOptions<UpdateLifecycleStageMutation, UpdateLifecycleStageMutationVariables>;
export const SingleDealStageDocument = gql`
    query SingleDealStage($ID: Int!) {
  DealStage(ID: $ID) {
    ...DealStageScalars
  }
}
    ${DealStageScalarsFragmentDoc}`;

/**
 * __useSingleDealStageQuery__
 *
 * To run a query within a React component, call `useSingleDealStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealStageQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleDealStageQuery(baseOptions: Apollo.QueryHookOptions<SingleDealStageQuery, SingleDealStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealStageQuery, SingleDealStageQueryVariables>(SingleDealStageDocument, options);
      }
export function useSingleDealStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealStageQuery, SingleDealStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealStageQuery, SingleDealStageQueryVariables>(SingleDealStageDocument, options);
        }
export type SingleDealStageQueryHookResult = ReturnType<typeof useSingleDealStageQuery>;
export type SingleDealStageLazyQueryHookResult = ReturnType<typeof useSingleDealStageLazyQuery>;
export type SingleDealStageQueryResult = Apollo.QueryResult<SingleDealStageQuery, SingleDealStageQueryVariables>;
export const SingleDealStageFullDocument = gql`
    query SingleDealStageFull($ID: Int!) {
  DealStage(ID: $ID) {
    ...DealStageScalars
  }
}
    ${DealStageScalarsFragmentDoc}`;

/**
 * __useSingleDealStageFullQuery__
 *
 * To run a query within a React component, call `useSingleDealStageFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealStageFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealStageFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleDealStageFullQuery(baseOptions: Apollo.QueryHookOptions<SingleDealStageFullQuery, SingleDealStageFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealStageFullQuery, SingleDealStageFullQueryVariables>(SingleDealStageFullDocument, options);
      }
export function useSingleDealStageFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealStageFullQuery, SingleDealStageFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealStageFullQuery, SingleDealStageFullQueryVariables>(SingleDealStageFullDocument, options);
        }
export type SingleDealStageFullQueryHookResult = ReturnType<typeof useSingleDealStageFullQuery>;
export type SingleDealStageFullLazyQueryHookResult = ReturnType<typeof useSingleDealStageFullLazyQuery>;
export type SingleDealStageFullQueryResult = Apollo.QueryResult<SingleDealStageFullQuery, SingleDealStageFullQueryVariables>;
export const AllDealStagesDocument = gql`
    query AllDealStages {
  AllDealStages {
    ...DealStageScalars
  }
}
    ${DealStageScalarsFragmentDoc}`;

/**
 * __useAllDealStagesQuery__
 *
 * To run a query within a React component, call `useAllDealStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDealStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDealStagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDealStagesQuery(baseOptions?: Apollo.QueryHookOptions<AllDealStagesQuery, AllDealStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDealStagesQuery, AllDealStagesQueryVariables>(AllDealStagesDocument, options);
      }
export function useAllDealStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDealStagesQuery, AllDealStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDealStagesQuery, AllDealStagesQueryVariables>(AllDealStagesDocument, options);
        }
export type AllDealStagesQueryHookResult = ReturnType<typeof useAllDealStagesQuery>;
export type AllDealStagesLazyQueryHookResult = ReturnType<typeof useAllDealStagesLazyQuery>;
export type AllDealStagesQueryResult = Apollo.QueryResult<AllDealStagesQuery, AllDealStagesQueryVariables>;
export const UpdateDealStageDocument = gql`
    mutation UpdateDealStage($input: UpdateDealStageInput!) {
  UpdateDealStage(input: $input) {
    ...DealStageScalars
  }
}
    ${DealStageScalarsFragmentDoc}`;
export type UpdateDealStageMutationFn = Apollo.MutationFunction<UpdateDealStageMutation, UpdateDealStageMutationVariables>;

/**
 * __useUpdateDealStageMutation__
 *
 * To run a mutation, you first call `useUpdateDealStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealStageMutation, { data, loading, error }] = useUpdateDealStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDealStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealStageMutation, UpdateDealStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealStageMutation, UpdateDealStageMutationVariables>(UpdateDealStageDocument, options);
      }
export type UpdateDealStageMutationHookResult = ReturnType<typeof useUpdateDealStageMutation>;
export type UpdateDealStageMutationResult = Apollo.MutationResult<UpdateDealStageMutation>;
export type UpdateDealStageMutationOptions = Apollo.BaseMutationOptions<UpdateDealStageMutation, UpdateDealStageMutationVariables>;
export const SingleAccountTypeDocument = gql`
    query SingleAccountType($ID: Int!) {
  AccountType(ID: $ID) {
    ...AccountTypeScalars
  }
}
    ${AccountTypeScalarsFragmentDoc}`;

/**
 * __useSingleAccountTypeQuery__
 *
 * To run a query within a React component, call `useSingleAccountTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAccountTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAccountTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAccountTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleAccountTypeQuery, SingleAccountTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAccountTypeQuery, SingleAccountTypeQueryVariables>(SingleAccountTypeDocument, options);
      }
export function useSingleAccountTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAccountTypeQuery, SingleAccountTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAccountTypeQuery, SingleAccountTypeQueryVariables>(SingleAccountTypeDocument, options);
        }
export type SingleAccountTypeQueryHookResult = ReturnType<typeof useSingleAccountTypeQuery>;
export type SingleAccountTypeLazyQueryHookResult = ReturnType<typeof useSingleAccountTypeLazyQuery>;
export type SingleAccountTypeQueryResult = Apollo.QueryResult<SingleAccountTypeQuery, SingleAccountTypeQueryVariables>;
export const SingleAccountTypeFullDocument = gql`
    query SingleAccountTypeFull($ID: Int!) {
  AccountType(ID: $ID) {
    ...AccountTypeScalars
  }
}
    ${AccountTypeScalarsFragmentDoc}`;

/**
 * __useSingleAccountTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleAccountTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAccountTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAccountTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAccountTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAccountTypeFullQuery, SingleAccountTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAccountTypeFullQuery, SingleAccountTypeFullQueryVariables>(SingleAccountTypeFullDocument, options);
      }
export function useSingleAccountTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAccountTypeFullQuery, SingleAccountTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAccountTypeFullQuery, SingleAccountTypeFullQueryVariables>(SingleAccountTypeFullDocument, options);
        }
export type SingleAccountTypeFullQueryHookResult = ReturnType<typeof useSingleAccountTypeFullQuery>;
export type SingleAccountTypeFullLazyQueryHookResult = ReturnType<typeof useSingleAccountTypeFullLazyQuery>;
export type SingleAccountTypeFullQueryResult = Apollo.QueryResult<SingleAccountTypeFullQuery, SingleAccountTypeFullQueryVariables>;
export const AllAccountTypesDocument = gql`
    query AllAccountTypes {
  AllAccountTypes {
    ...AccountTypeScalars
  }
}
    ${AccountTypeScalarsFragmentDoc}`;

/**
 * __useAllAccountTypesQuery__
 *
 * To run a query within a React component, call `useAllAccountTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAccountTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAccountTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAccountTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllAccountTypesQuery, AllAccountTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAccountTypesQuery, AllAccountTypesQueryVariables>(AllAccountTypesDocument, options);
      }
export function useAllAccountTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAccountTypesQuery, AllAccountTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAccountTypesQuery, AllAccountTypesQueryVariables>(AllAccountTypesDocument, options);
        }
export type AllAccountTypesQueryHookResult = ReturnType<typeof useAllAccountTypesQuery>;
export type AllAccountTypesLazyQueryHookResult = ReturnType<typeof useAllAccountTypesLazyQuery>;
export type AllAccountTypesQueryResult = Apollo.QueryResult<AllAccountTypesQuery, AllAccountTypesQueryVariables>;
export const UpdateAccountTypeDocument = gql`
    mutation UpdateAccountType($input: UpdateAccountTypeInput!) {
  UpdateAccountType(input: $input) {
    ...AccountTypeScalars
  }
}
    ${AccountTypeScalarsFragmentDoc}`;
export type UpdateAccountTypeMutationFn = Apollo.MutationFunction<UpdateAccountTypeMutation, UpdateAccountTypeMutationVariables>;

/**
 * __useUpdateAccountTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAccountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountTypeMutation, { data, loading, error }] = useUpdateAccountTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountTypeMutation, UpdateAccountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountTypeMutation, UpdateAccountTypeMutationVariables>(UpdateAccountTypeDocument, options);
      }
export type UpdateAccountTypeMutationHookResult = ReturnType<typeof useUpdateAccountTypeMutation>;
export type UpdateAccountTypeMutationResult = Apollo.MutationResult<UpdateAccountTypeMutation>;
export type UpdateAccountTypeMutationOptions = Apollo.BaseMutationOptions<UpdateAccountTypeMutation, UpdateAccountTypeMutationVariables>;
export const SingleTimeEntryDocument = gql`
    query SingleTimeEntry($ID: Int!) {
  TimeEntry(ID: $ID) {
    ...TimeEntryScalars
  }
}
    ${TimeEntryScalarsFragmentDoc}`;

/**
 * __useSingleTimeEntryQuery__
 *
 * To run a query within a React component, call `useSingleTimeEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTimeEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTimeEntryQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTimeEntryQuery(baseOptions: Apollo.QueryHookOptions<SingleTimeEntryQuery, SingleTimeEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTimeEntryQuery, SingleTimeEntryQueryVariables>(SingleTimeEntryDocument, options);
      }
export function useSingleTimeEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTimeEntryQuery, SingleTimeEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTimeEntryQuery, SingleTimeEntryQueryVariables>(SingleTimeEntryDocument, options);
        }
export type SingleTimeEntryQueryHookResult = ReturnType<typeof useSingleTimeEntryQuery>;
export type SingleTimeEntryLazyQueryHookResult = ReturnType<typeof useSingleTimeEntryLazyQuery>;
export type SingleTimeEntryQueryResult = Apollo.QueryResult<SingleTimeEntryQuery, SingleTimeEntryQueryVariables>;
export const SingleTimeEntryFullDocument = gql`
    query SingleTimeEntryFull($ID: Int!) {
  TimeEntry(ID: $ID) {
    ...TimeEntryScalars
  }
}
    ${TimeEntryScalarsFragmentDoc}`;

/**
 * __useSingleTimeEntryFullQuery__
 *
 * To run a query within a React component, call `useSingleTimeEntryFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTimeEntryFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTimeEntryFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTimeEntryFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTimeEntryFullQuery, SingleTimeEntryFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTimeEntryFullQuery, SingleTimeEntryFullQueryVariables>(SingleTimeEntryFullDocument, options);
      }
export function useSingleTimeEntryFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTimeEntryFullQuery, SingleTimeEntryFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTimeEntryFullQuery, SingleTimeEntryFullQueryVariables>(SingleTimeEntryFullDocument, options);
        }
export type SingleTimeEntryFullQueryHookResult = ReturnType<typeof useSingleTimeEntryFullQuery>;
export type SingleTimeEntryFullLazyQueryHookResult = ReturnType<typeof useSingleTimeEntryFullLazyQuery>;
export type SingleTimeEntryFullQueryResult = Apollo.QueryResult<SingleTimeEntryFullQuery, SingleTimeEntryFullQueryVariables>;
export const UpdateTimeEntryDocument = gql`
    mutation UpdateTimeEntry($input: UpdateTimeEntryInput!) {
  UpdateTimeEntry(input: $input) {
    ...TimeEntryScalars
  }
}
    ${TimeEntryScalarsFragmentDoc}`;
export type UpdateTimeEntryMutationFn = Apollo.MutationFunction<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>;

/**
 * __useUpdateTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeEntryMutation, { data, loading, error }] = useUpdateTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>(UpdateTimeEntryDocument, options);
      }
export type UpdateTimeEntryMutationHookResult = ReturnType<typeof useUpdateTimeEntryMutation>;
export type UpdateTimeEntryMutationResult = Apollo.MutationResult<UpdateTimeEntryMutation>;
export type UpdateTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>;
export const SingleDealTypeDocument = gql`
    query SingleDealType($ID: Int!) {
  DealType(ID: $ID) {
    ...DealTypeScalars
  }
}
    ${DealTypeScalarsFragmentDoc}`;

/**
 * __useSingleDealTypeQuery__
 *
 * To run a query within a React component, call `useSingleDealTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleDealTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleDealTypeQuery, SingleDealTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealTypeQuery, SingleDealTypeQueryVariables>(SingleDealTypeDocument, options);
      }
export function useSingleDealTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealTypeQuery, SingleDealTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealTypeQuery, SingleDealTypeQueryVariables>(SingleDealTypeDocument, options);
        }
export type SingleDealTypeQueryHookResult = ReturnType<typeof useSingleDealTypeQuery>;
export type SingleDealTypeLazyQueryHookResult = ReturnType<typeof useSingleDealTypeLazyQuery>;
export type SingleDealTypeQueryResult = Apollo.QueryResult<SingleDealTypeQuery, SingleDealTypeQueryVariables>;
export const SingleDealTypeFullDocument = gql`
    query SingleDealTypeFull($ID: Int!) {
  DealType(ID: $ID) {
    ...DealTypeScalars
  }
}
    ${DealTypeScalarsFragmentDoc}`;

/**
 * __useSingleDealTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleDealTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleDealTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleDealTypeFullQuery, SingleDealTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealTypeFullQuery, SingleDealTypeFullQueryVariables>(SingleDealTypeFullDocument, options);
      }
export function useSingleDealTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealTypeFullQuery, SingleDealTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealTypeFullQuery, SingleDealTypeFullQueryVariables>(SingleDealTypeFullDocument, options);
        }
export type SingleDealTypeFullQueryHookResult = ReturnType<typeof useSingleDealTypeFullQuery>;
export type SingleDealTypeFullLazyQueryHookResult = ReturnType<typeof useSingleDealTypeFullLazyQuery>;
export type SingleDealTypeFullQueryResult = Apollo.QueryResult<SingleDealTypeFullQuery, SingleDealTypeFullQueryVariables>;
export const AllDealTypesDocument = gql`
    query AllDealTypes {
  AllDealTypes {
    ...DealTypeScalars
  }
}
    ${DealTypeScalarsFragmentDoc}`;

/**
 * __useAllDealTypesQuery__
 *
 * To run a query within a React component, call `useAllDealTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDealTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDealTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDealTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllDealTypesQuery, AllDealTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDealTypesQuery, AllDealTypesQueryVariables>(AllDealTypesDocument, options);
      }
export function useAllDealTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDealTypesQuery, AllDealTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDealTypesQuery, AllDealTypesQueryVariables>(AllDealTypesDocument, options);
        }
export type AllDealTypesQueryHookResult = ReturnType<typeof useAllDealTypesQuery>;
export type AllDealTypesLazyQueryHookResult = ReturnType<typeof useAllDealTypesLazyQuery>;
export type AllDealTypesQueryResult = Apollo.QueryResult<AllDealTypesQuery, AllDealTypesQueryVariables>;
export const UpdateDealTypeDocument = gql`
    mutation UpdateDealType($input: UpdateDealTypeInput!) {
  UpdateDealType(input: $input) {
    ...DealTypeScalars
  }
}
    ${DealTypeScalarsFragmentDoc}`;
export type UpdateDealTypeMutationFn = Apollo.MutationFunction<UpdateDealTypeMutation, UpdateDealTypeMutationVariables>;

/**
 * __useUpdateDealTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDealTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealTypeMutation, { data, loading, error }] = useUpdateDealTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDealTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealTypeMutation, UpdateDealTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealTypeMutation, UpdateDealTypeMutationVariables>(UpdateDealTypeDocument, options);
      }
export type UpdateDealTypeMutationHookResult = ReturnType<typeof useUpdateDealTypeMutation>;
export type UpdateDealTypeMutationResult = Apollo.MutationResult<UpdateDealTypeMutation>;
export type UpdateDealTypeMutationOptions = Apollo.BaseMutationOptions<UpdateDealTypeMutation, UpdateDealTypeMutationVariables>;
export const SingleApplicationDocument = gql`
    query SingleApplication($ID: Int!) {
  Application(ID: $ID) {
    ...ApplicationScalars
  }
}
    ${ApplicationScalarsFragmentDoc}`;

/**
 * __useSingleApplicationQuery__
 *
 * To run a query within a React component, call `useSingleApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleApplicationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleApplicationQuery(baseOptions: Apollo.QueryHookOptions<SingleApplicationQuery, SingleApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleApplicationQuery, SingleApplicationQueryVariables>(SingleApplicationDocument, options);
      }
export function useSingleApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleApplicationQuery, SingleApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleApplicationQuery, SingleApplicationQueryVariables>(SingleApplicationDocument, options);
        }
export type SingleApplicationQueryHookResult = ReturnType<typeof useSingleApplicationQuery>;
export type SingleApplicationLazyQueryHookResult = ReturnType<typeof useSingleApplicationLazyQuery>;
export type SingleApplicationQueryResult = Apollo.QueryResult<SingleApplicationQuery, SingleApplicationQueryVariables>;
export const SingleApplicationFullDocument = gql`
    query SingleApplicationFull($ID: Int!) {
  Application(ID: $ID) {
    ...ApplicationScalars
    ApplicationEntities {
      ...ApplicationEntityScalars
    }
    ApplicationPermissions {
      ...ApplicationPermissionScalars
    }
  }
}
    ${ApplicationScalarsFragmentDoc}
${ApplicationEntityScalarsFragmentDoc}
${ApplicationPermissionScalarsFragmentDoc}`;

/**
 * __useSingleApplicationFullQuery__
 *
 * To run a query within a React component, call `useSingleApplicationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleApplicationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleApplicationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleApplicationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleApplicationFullQuery, SingleApplicationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleApplicationFullQuery, SingleApplicationFullQueryVariables>(SingleApplicationFullDocument, options);
      }
export function useSingleApplicationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleApplicationFullQuery, SingleApplicationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleApplicationFullQuery, SingleApplicationFullQueryVariables>(SingleApplicationFullDocument, options);
        }
export type SingleApplicationFullQueryHookResult = ReturnType<typeof useSingleApplicationFullQuery>;
export type SingleApplicationFullLazyQueryHookResult = ReturnType<typeof useSingleApplicationFullLazyQuery>;
export type SingleApplicationFullQueryResult = Apollo.QueryResult<SingleApplicationFullQuery, SingleApplicationFullQueryVariables>;
export const AllApplicationsDocument = gql`
    query AllApplications {
  AllApplications {
    ...ApplicationScalars
    ApplicationEntities {
      ...ApplicationEntityScalars
    }
    ApplicationPermissions {
      ...ApplicationPermissionScalars
    }
  }
}
    ${ApplicationScalarsFragmentDoc}
${ApplicationEntityScalarsFragmentDoc}
${ApplicationPermissionScalarsFragmentDoc}`;

/**
 * __useAllApplicationsQuery__
 *
 * To run a query within a React component, call `useAllApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<AllApplicationsQuery, AllApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllApplicationsQuery, AllApplicationsQueryVariables>(AllApplicationsDocument, options);
      }
export function useAllApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllApplicationsQuery, AllApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllApplicationsQuery, AllApplicationsQueryVariables>(AllApplicationsDocument, options);
        }
export type AllApplicationsQueryHookResult = ReturnType<typeof useAllApplicationsQuery>;
export type AllApplicationsLazyQueryHookResult = ReturnType<typeof useAllApplicationsLazyQuery>;
export type AllApplicationsQueryResult = Apollo.QueryResult<AllApplicationsQuery, AllApplicationsQueryVariables>;
export const UpdateApplicationDocument = gql`
    mutation UpdateApplication($input: UpdateApplicationInput!) {
  UpdateApplication(input: $input) {
    ...ApplicationScalars
  }
}
    ${ApplicationScalarsFragmentDoc}`;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const SingleApplicationEntityDocument = gql`
    query SingleApplicationEntity($ID: Int!) {
  ApplicationEntity(ID: $ID) {
    ...ApplicationEntityScalars
  }
}
    ${ApplicationEntityScalarsFragmentDoc}`;

/**
 * __useSingleApplicationEntityQuery__
 *
 * To run a query within a React component, call `useSingleApplicationEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleApplicationEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleApplicationEntityQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleApplicationEntityQuery(baseOptions: Apollo.QueryHookOptions<SingleApplicationEntityQuery, SingleApplicationEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleApplicationEntityQuery, SingleApplicationEntityQueryVariables>(SingleApplicationEntityDocument, options);
      }
export function useSingleApplicationEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleApplicationEntityQuery, SingleApplicationEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleApplicationEntityQuery, SingleApplicationEntityQueryVariables>(SingleApplicationEntityDocument, options);
        }
export type SingleApplicationEntityQueryHookResult = ReturnType<typeof useSingleApplicationEntityQuery>;
export type SingleApplicationEntityLazyQueryHookResult = ReturnType<typeof useSingleApplicationEntityLazyQuery>;
export type SingleApplicationEntityQueryResult = Apollo.QueryResult<SingleApplicationEntityQuery, SingleApplicationEntityQueryVariables>;
export const SingleApplicationEntityFullDocument = gql`
    query SingleApplicationEntityFull($ID: Int!) {
  ApplicationEntity(ID: $ID) {
    ...ApplicationEntityScalars
  }
}
    ${ApplicationEntityScalarsFragmentDoc}`;

/**
 * __useSingleApplicationEntityFullQuery__
 *
 * To run a query within a React component, call `useSingleApplicationEntityFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleApplicationEntityFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleApplicationEntityFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleApplicationEntityFullQuery(baseOptions: Apollo.QueryHookOptions<SingleApplicationEntityFullQuery, SingleApplicationEntityFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleApplicationEntityFullQuery, SingleApplicationEntityFullQueryVariables>(SingleApplicationEntityFullDocument, options);
      }
export function useSingleApplicationEntityFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleApplicationEntityFullQuery, SingleApplicationEntityFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleApplicationEntityFullQuery, SingleApplicationEntityFullQueryVariables>(SingleApplicationEntityFullDocument, options);
        }
export type SingleApplicationEntityFullQueryHookResult = ReturnType<typeof useSingleApplicationEntityFullQuery>;
export type SingleApplicationEntityFullLazyQueryHookResult = ReturnType<typeof useSingleApplicationEntityFullLazyQuery>;
export type SingleApplicationEntityFullQueryResult = Apollo.QueryResult<SingleApplicationEntityFullQuery, SingleApplicationEntityFullQueryVariables>;
export const CreateApplicationEntityDocument = gql`
    mutation CreateApplicationEntity($input: CreateApplicationEntityInput!) {
  CreateApplicationEntity(input: $input) {
    ...ApplicationEntityScalars
  }
}
    ${ApplicationEntityScalarsFragmentDoc}`;
export type CreateApplicationEntityMutationFn = Apollo.MutationFunction<CreateApplicationEntityMutation, CreateApplicationEntityMutationVariables>;

/**
 * __useCreateApplicationEntityMutation__
 *
 * To run a mutation, you first call `useCreateApplicationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationEntityMutation, { data, loading, error }] = useCreateApplicationEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationEntityMutation, CreateApplicationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationEntityMutation, CreateApplicationEntityMutationVariables>(CreateApplicationEntityDocument, options);
      }
export type CreateApplicationEntityMutationHookResult = ReturnType<typeof useCreateApplicationEntityMutation>;
export type CreateApplicationEntityMutationResult = Apollo.MutationResult<CreateApplicationEntityMutation>;
export type CreateApplicationEntityMutationOptions = Apollo.BaseMutationOptions<CreateApplicationEntityMutation, CreateApplicationEntityMutationVariables>;
export const UpdateApplicationEntityDocument = gql`
    mutation UpdateApplicationEntity($input: UpdateApplicationEntityInput!) {
  UpdateApplicationEntity(input: $input) {
    ...ApplicationEntityScalars
  }
}
    ${ApplicationEntityScalarsFragmentDoc}`;
export type UpdateApplicationEntityMutationFn = Apollo.MutationFunction<UpdateApplicationEntityMutation, UpdateApplicationEntityMutationVariables>;

/**
 * __useUpdateApplicationEntityMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationEntityMutation, { data, loading, error }] = useUpdateApplicationEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationEntityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationEntityMutation, UpdateApplicationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationEntityMutation, UpdateApplicationEntityMutationVariables>(UpdateApplicationEntityDocument, options);
      }
export type UpdateApplicationEntityMutationHookResult = ReturnType<typeof useUpdateApplicationEntityMutation>;
export type UpdateApplicationEntityMutationResult = Apollo.MutationResult<UpdateApplicationEntityMutation>;
export type UpdateApplicationEntityMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationEntityMutation, UpdateApplicationEntityMutationVariables>;
export const DeleteApplicationEntityDocument = gql`
    mutation DeleteApplicationEntity($ID: Int!) {
  DeleteApplicationEntity(ID: $ID)
}
    `;
export type DeleteApplicationEntityMutationFn = Apollo.MutationFunction<DeleteApplicationEntityMutation, DeleteApplicationEntityMutationVariables>;

/**
 * __useDeleteApplicationEntityMutation__
 *
 * To run a mutation, you first call `useDeleteApplicationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicationEntityMutation, { data, loading, error }] = useDeleteApplicationEntityMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteApplicationEntityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApplicationEntityMutation, DeleteApplicationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApplicationEntityMutation, DeleteApplicationEntityMutationVariables>(DeleteApplicationEntityDocument, options);
      }
export type DeleteApplicationEntityMutationHookResult = ReturnType<typeof useDeleteApplicationEntityMutation>;
export type DeleteApplicationEntityMutationResult = Apollo.MutationResult<DeleteApplicationEntityMutation>;
export type DeleteApplicationEntityMutationOptions = Apollo.BaseMutationOptions<DeleteApplicationEntityMutation, DeleteApplicationEntityMutationVariables>;
export const SingleEntityPermissionDocument = gql`
    query SingleEntityPermission($ID: Int!) {
  EntityPermission(ID: $ID) {
    ...EntityPermissionScalars
  }
}
    ${EntityPermissionScalarsFragmentDoc}`;

/**
 * __useSingleEntityPermissionQuery__
 *
 * To run a query within a React component, call `useSingleEntityPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityPermissionQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityPermissionQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityPermissionQuery, SingleEntityPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityPermissionQuery, SingleEntityPermissionQueryVariables>(SingleEntityPermissionDocument, options);
      }
export function useSingleEntityPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityPermissionQuery, SingleEntityPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityPermissionQuery, SingleEntityPermissionQueryVariables>(SingleEntityPermissionDocument, options);
        }
export type SingleEntityPermissionQueryHookResult = ReturnType<typeof useSingleEntityPermissionQuery>;
export type SingleEntityPermissionLazyQueryHookResult = ReturnType<typeof useSingleEntityPermissionLazyQuery>;
export type SingleEntityPermissionQueryResult = Apollo.QueryResult<SingleEntityPermissionQuery, SingleEntityPermissionQueryVariables>;
export const SingleEntityPermissionFullDocument = gql`
    query SingleEntityPermissionFull($ID: Int!) {
  EntityPermission(ID: $ID) {
    ...EntityPermissionScalars
  }
}
    ${EntityPermissionScalarsFragmentDoc}`;

/**
 * __useSingleEntityPermissionFullQuery__
 *
 * To run a query within a React component, call `useSingleEntityPermissionFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityPermissionFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityPermissionFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityPermissionFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityPermissionFullQuery, SingleEntityPermissionFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityPermissionFullQuery, SingleEntityPermissionFullQueryVariables>(SingleEntityPermissionFullDocument, options);
      }
export function useSingleEntityPermissionFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityPermissionFullQuery, SingleEntityPermissionFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityPermissionFullQuery, SingleEntityPermissionFullQueryVariables>(SingleEntityPermissionFullDocument, options);
        }
export type SingleEntityPermissionFullQueryHookResult = ReturnType<typeof useSingleEntityPermissionFullQuery>;
export type SingleEntityPermissionFullLazyQueryHookResult = ReturnType<typeof useSingleEntityPermissionFullLazyQuery>;
export type SingleEntityPermissionFullQueryResult = Apollo.QueryResult<SingleEntityPermissionFullQuery, SingleEntityPermissionFullQueryVariables>;
export const AllEntityPermissionsDocument = gql`
    query AllEntityPermissions {
  AllEntityPermissions {
    ...EntityPermissionScalars
  }
}
    ${EntityPermissionScalarsFragmentDoc}`;

/**
 * __useAllEntityPermissionsQuery__
 *
 * To run a query within a React component, call `useAllEntityPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEntityPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEntityPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEntityPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<AllEntityPermissionsQuery, AllEntityPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEntityPermissionsQuery, AllEntityPermissionsQueryVariables>(AllEntityPermissionsDocument, options);
      }
export function useAllEntityPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEntityPermissionsQuery, AllEntityPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEntityPermissionsQuery, AllEntityPermissionsQueryVariables>(AllEntityPermissionsDocument, options);
        }
export type AllEntityPermissionsQueryHookResult = ReturnType<typeof useAllEntityPermissionsQuery>;
export type AllEntityPermissionsLazyQueryHookResult = ReturnType<typeof useAllEntityPermissionsLazyQuery>;
export type AllEntityPermissionsQueryResult = Apollo.QueryResult<AllEntityPermissionsQuery, AllEntityPermissionsQueryVariables>;
export const CreateEntityPermissionDocument = gql`
    mutation CreateEntityPermission($input: CreateEntityPermissionInput!) {
  CreateEntityPermission(input: $input) {
    ...EntityPermissionScalars
  }
}
    ${EntityPermissionScalarsFragmentDoc}`;
export type CreateEntityPermissionMutationFn = Apollo.MutationFunction<CreateEntityPermissionMutation, CreateEntityPermissionMutationVariables>;

/**
 * __useCreateEntityPermissionMutation__
 *
 * To run a mutation, you first call `useCreateEntityPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityPermissionMutation, { data, loading, error }] = useCreateEntityPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityPermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityPermissionMutation, CreateEntityPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityPermissionMutation, CreateEntityPermissionMutationVariables>(CreateEntityPermissionDocument, options);
      }
export type CreateEntityPermissionMutationHookResult = ReturnType<typeof useCreateEntityPermissionMutation>;
export type CreateEntityPermissionMutationResult = Apollo.MutationResult<CreateEntityPermissionMutation>;
export type CreateEntityPermissionMutationOptions = Apollo.BaseMutationOptions<CreateEntityPermissionMutation, CreateEntityPermissionMutationVariables>;
export const UpdateEntityPermissionDocument = gql`
    mutation UpdateEntityPermission($input: UpdateEntityPermissionInput!) {
  UpdateEntityPermission(input: $input) {
    ...EntityPermissionScalars
  }
}
    ${EntityPermissionScalarsFragmentDoc}`;
export type UpdateEntityPermissionMutationFn = Apollo.MutationFunction<UpdateEntityPermissionMutation, UpdateEntityPermissionMutationVariables>;

/**
 * __useUpdateEntityPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateEntityPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityPermissionMutation, { data, loading, error }] = useUpdateEntityPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityPermissionMutation, UpdateEntityPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityPermissionMutation, UpdateEntityPermissionMutationVariables>(UpdateEntityPermissionDocument, options);
      }
export type UpdateEntityPermissionMutationHookResult = ReturnType<typeof useUpdateEntityPermissionMutation>;
export type UpdateEntityPermissionMutationResult = Apollo.MutationResult<UpdateEntityPermissionMutation>;
export type UpdateEntityPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateEntityPermissionMutation, UpdateEntityPermissionMutationVariables>;
export const DeleteEntityPermissionDocument = gql`
    mutation DeleteEntityPermission($ID: Int!) {
  DeleteEntityPermission(ID: $ID)
}
    `;
export type DeleteEntityPermissionMutationFn = Apollo.MutationFunction<DeleteEntityPermissionMutation, DeleteEntityPermissionMutationVariables>;

/**
 * __useDeleteEntityPermissionMutation__
 *
 * To run a mutation, you first call `useDeleteEntityPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityPermissionMutation, { data, loading, error }] = useDeleteEntityPermissionMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteEntityPermissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityPermissionMutation, DeleteEntityPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityPermissionMutation, DeleteEntityPermissionMutationVariables>(DeleteEntityPermissionDocument, options);
      }
export type DeleteEntityPermissionMutationHookResult = ReturnType<typeof useDeleteEntityPermissionMutation>;
export type DeleteEntityPermissionMutationResult = Apollo.MutationResult<DeleteEntityPermissionMutation>;
export type DeleteEntityPermissionMutationOptions = Apollo.BaseMutationOptions<DeleteEntityPermissionMutation, DeleteEntityPermissionMutationVariables>;
export const SingleApplicationPermissionDocument = gql`
    query SingleApplicationPermission($ID: Int!) {
  ApplicationPermission(ID: $ID) {
    ...ApplicationPermissionScalars
  }
}
    ${ApplicationPermissionScalarsFragmentDoc}`;

/**
 * __useSingleApplicationPermissionQuery__
 *
 * To run a query within a React component, call `useSingleApplicationPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleApplicationPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleApplicationPermissionQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleApplicationPermissionQuery(baseOptions: Apollo.QueryHookOptions<SingleApplicationPermissionQuery, SingleApplicationPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleApplicationPermissionQuery, SingleApplicationPermissionQueryVariables>(SingleApplicationPermissionDocument, options);
      }
export function useSingleApplicationPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleApplicationPermissionQuery, SingleApplicationPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleApplicationPermissionQuery, SingleApplicationPermissionQueryVariables>(SingleApplicationPermissionDocument, options);
        }
export type SingleApplicationPermissionQueryHookResult = ReturnType<typeof useSingleApplicationPermissionQuery>;
export type SingleApplicationPermissionLazyQueryHookResult = ReturnType<typeof useSingleApplicationPermissionLazyQuery>;
export type SingleApplicationPermissionQueryResult = Apollo.QueryResult<SingleApplicationPermissionQuery, SingleApplicationPermissionQueryVariables>;
export const SingleApplicationPermissionFullDocument = gql`
    query SingleApplicationPermissionFull($ID: Int!) {
  ApplicationPermission(ID: $ID) {
    ...ApplicationPermissionScalars
  }
}
    ${ApplicationPermissionScalarsFragmentDoc}`;

/**
 * __useSingleApplicationPermissionFullQuery__
 *
 * To run a query within a React component, call `useSingleApplicationPermissionFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleApplicationPermissionFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleApplicationPermissionFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleApplicationPermissionFullQuery(baseOptions: Apollo.QueryHookOptions<SingleApplicationPermissionFullQuery, SingleApplicationPermissionFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleApplicationPermissionFullQuery, SingleApplicationPermissionFullQueryVariables>(SingleApplicationPermissionFullDocument, options);
      }
export function useSingleApplicationPermissionFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleApplicationPermissionFullQuery, SingleApplicationPermissionFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleApplicationPermissionFullQuery, SingleApplicationPermissionFullQueryVariables>(SingleApplicationPermissionFullDocument, options);
        }
export type SingleApplicationPermissionFullQueryHookResult = ReturnType<typeof useSingleApplicationPermissionFullQuery>;
export type SingleApplicationPermissionFullLazyQueryHookResult = ReturnType<typeof useSingleApplicationPermissionFullLazyQuery>;
export type SingleApplicationPermissionFullQueryResult = Apollo.QueryResult<SingleApplicationPermissionFullQuery, SingleApplicationPermissionFullQueryVariables>;
export const UpdateApplicationPermissionDocument = gql`
    mutation UpdateApplicationPermission($input: UpdateApplicationPermissionInput!) {
  UpdateApplicationPermission(input: $input) {
    ...ApplicationPermissionScalars
  }
}
    ${ApplicationPermissionScalarsFragmentDoc}`;
export type UpdateApplicationPermissionMutationFn = Apollo.MutationFunction<UpdateApplicationPermissionMutation, UpdateApplicationPermissionMutationVariables>;

/**
 * __useUpdateApplicationPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationPermissionMutation, { data, loading, error }] = useUpdateApplicationPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationPermissionMutation, UpdateApplicationPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationPermissionMutation, UpdateApplicationPermissionMutationVariables>(UpdateApplicationPermissionDocument, options);
      }
export type UpdateApplicationPermissionMutationHookResult = ReturnType<typeof useUpdateApplicationPermissionMutation>;
export type UpdateApplicationPermissionMutationResult = Apollo.MutationResult<UpdateApplicationPermissionMutation>;
export type UpdateApplicationPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationPermissionMutation, UpdateApplicationPermissionMutationVariables>;
export const SingleUserApplicationEntityDocument = gql`
    query SingleUserApplicationEntity($ID: Int!) {
  UserApplicationEntity(ID: $ID) {
    ...UserApplicationEntityScalars
  }
}
    ${UserApplicationEntityScalarsFragmentDoc}`;

/**
 * __useSingleUserApplicationEntityQuery__
 *
 * To run a query within a React component, call `useSingleUserApplicationEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserApplicationEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserApplicationEntityQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserApplicationEntityQuery(baseOptions: Apollo.QueryHookOptions<SingleUserApplicationEntityQuery, SingleUserApplicationEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserApplicationEntityQuery, SingleUserApplicationEntityQueryVariables>(SingleUserApplicationEntityDocument, options);
      }
export function useSingleUserApplicationEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserApplicationEntityQuery, SingleUserApplicationEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserApplicationEntityQuery, SingleUserApplicationEntityQueryVariables>(SingleUserApplicationEntityDocument, options);
        }
export type SingleUserApplicationEntityQueryHookResult = ReturnType<typeof useSingleUserApplicationEntityQuery>;
export type SingleUserApplicationEntityLazyQueryHookResult = ReturnType<typeof useSingleUserApplicationEntityLazyQuery>;
export type SingleUserApplicationEntityQueryResult = Apollo.QueryResult<SingleUserApplicationEntityQuery, SingleUserApplicationEntityQueryVariables>;
export const SingleUserApplicationEntityFullDocument = gql`
    query SingleUserApplicationEntityFull($ID: Int!) {
  UserApplicationEntity(ID: $ID) {
    ...UserApplicationEntityScalars
  }
}
    ${UserApplicationEntityScalarsFragmentDoc}`;

/**
 * __useSingleUserApplicationEntityFullQuery__
 *
 * To run a query within a React component, call `useSingleUserApplicationEntityFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserApplicationEntityFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserApplicationEntityFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserApplicationEntityFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserApplicationEntityFullQuery, SingleUserApplicationEntityFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserApplicationEntityFullQuery, SingleUserApplicationEntityFullQueryVariables>(SingleUserApplicationEntityFullDocument, options);
      }
export function useSingleUserApplicationEntityFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserApplicationEntityFullQuery, SingleUserApplicationEntityFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserApplicationEntityFullQuery, SingleUserApplicationEntityFullQueryVariables>(SingleUserApplicationEntityFullDocument, options);
        }
export type SingleUserApplicationEntityFullQueryHookResult = ReturnType<typeof useSingleUserApplicationEntityFullQuery>;
export type SingleUserApplicationEntityFullLazyQueryHookResult = ReturnType<typeof useSingleUserApplicationEntityFullLazyQuery>;
export type SingleUserApplicationEntityFullQueryResult = Apollo.QueryResult<SingleUserApplicationEntityFullQuery, SingleUserApplicationEntityFullQueryVariables>;
export const CreateUserApplicationEntityDocument = gql`
    mutation CreateUserApplicationEntity($input: CreateUserApplicationEntityInput!) {
  CreateUserApplicationEntity(input: $input) {
    ...UserApplicationEntityScalars
  }
}
    ${UserApplicationEntityScalarsFragmentDoc}`;
export type CreateUserApplicationEntityMutationFn = Apollo.MutationFunction<CreateUserApplicationEntityMutation, CreateUserApplicationEntityMutationVariables>;

/**
 * __useCreateUserApplicationEntityMutation__
 *
 * To run a mutation, you first call `useCreateUserApplicationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserApplicationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserApplicationEntityMutation, { data, loading, error }] = useCreateUserApplicationEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserApplicationEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserApplicationEntityMutation, CreateUserApplicationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserApplicationEntityMutation, CreateUserApplicationEntityMutationVariables>(CreateUserApplicationEntityDocument, options);
      }
export type CreateUserApplicationEntityMutationHookResult = ReturnType<typeof useCreateUserApplicationEntityMutation>;
export type CreateUserApplicationEntityMutationResult = Apollo.MutationResult<CreateUserApplicationEntityMutation>;
export type CreateUserApplicationEntityMutationOptions = Apollo.BaseMutationOptions<CreateUserApplicationEntityMutation, CreateUserApplicationEntityMutationVariables>;
export const UpdateUserApplicationEntityDocument = gql`
    mutation UpdateUserApplicationEntity($input: UpdateUserApplicationEntityInput!) {
  UpdateUserApplicationEntity(input: $input) {
    ...UserApplicationEntityScalars
  }
}
    ${UserApplicationEntityScalarsFragmentDoc}`;
export type UpdateUserApplicationEntityMutationFn = Apollo.MutationFunction<UpdateUserApplicationEntityMutation, UpdateUserApplicationEntityMutationVariables>;

/**
 * __useUpdateUserApplicationEntityMutation__
 *
 * To run a mutation, you first call `useUpdateUserApplicationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserApplicationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserApplicationEntityMutation, { data, loading, error }] = useUpdateUserApplicationEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserApplicationEntityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserApplicationEntityMutation, UpdateUserApplicationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserApplicationEntityMutation, UpdateUserApplicationEntityMutationVariables>(UpdateUserApplicationEntityDocument, options);
      }
export type UpdateUserApplicationEntityMutationHookResult = ReturnType<typeof useUpdateUserApplicationEntityMutation>;
export type UpdateUserApplicationEntityMutationResult = Apollo.MutationResult<UpdateUserApplicationEntityMutation>;
export type UpdateUserApplicationEntityMutationOptions = Apollo.BaseMutationOptions<UpdateUserApplicationEntityMutation, UpdateUserApplicationEntityMutationVariables>;
export const DeleteUserApplicationEntityDocument = gql`
    mutation DeleteUserApplicationEntity($ID: Int!) {
  DeleteUserApplicationEntity(ID: $ID)
}
    `;
export type DeleteUserApplicationEntityMutationFn = Apollo.MutationFunction<DeleteUserApplicationEntityMutation, DeleteUserApplicationEntityMutationVariables>;

/**
 * __useDeleteUserApplicationEntityMutation__
 *
 * To run a mutation, you first call `useDeleteUserApplicationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserApplicationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserApplicationEntityMutation, { data, loading, error }] = useDeleteUserApplicationEntityMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteUserApplicationEntityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserApplicationEntityMutation, DeleteUserApplicationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserApplicationEntityMutation, DeleteUserApplicationEntityMutationVariables>(DeleteUserApplicationEntityDocument, options);
      }
export type DeleteUserApplicationEntityMutationHookResult = ReturnType<typeof useDeleteUserApplicationEntityMutation>;
export type DeleteUserApplicationEntityMutationResult = Apollo.MutationResult<DeleteUserApplicationEntityMutation>;
export type DeleteUserApplicationEntityMutationOptions = Apollo.BaseMutationOptions<DeleteUserApplicationEntityMutation, DeleteUserApplicationEntityMutationVariables>;
export const SingleUserApplicationDocument = gql`
    query SingleUserApplication($ID: Int!) {
  UserApplication(ID: $ID) {
    ...UserApplicationScalars
  }
}
    ${UserApplicationScalarsFragmentDoc}`;

/**
 * __useSingleUserApplicationQuery__
 *
 * To run a query within a React component, call `useSingleUserApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserApplicationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserApplicationQuery(baseOptions: Apollo.QueryHookOptions<SingleUserApplicationQuery, SingleUserApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserApplicationQuery, SingleUserApplicationQueryVariables>(SingleUserApplicationDocument, options);
      }
export function useSingleUserApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserApplicationQuery, SingleUserApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserApplicationQuery, SingleUserApplicationQueryVariables>(SingleUserApplicationDocument, options);
        }
export type SingleUserApplicationQueryHookResult = ReturnType<typeof useSingleUserApplicationQuery>;
export type SingleUserApplicationLazyQueryHookResult = ReturnType<typeof useSingleUserApplicationLazyQuery>;
export type SingleUserApplicationQueryResult = Apollo.QueryResult<SingleUserApplicationQuery, SingleUserApplicationQueryVariables>;
export const SingleUserApplicationFullDocument = gql`
    query SingleUserApplicationFull($ID: Int!) {
  UserApplication(ID: $ID) {
    ...UserApplicationScalars
    UserApplicationEntities {
      ...UserApplicationEntityScalars
    }
  }
}
    ${UserApplicationScalarsFragmentDoc}
${UserApplicationEntityScalarsFragmentDoc}`;

/**
 * __useSingleUserApplicationFullQuery__
 *
 * To run a query within a React component, call `useSingleUserApplicationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserApplicationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserApplicationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserApplicationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserApplicationFullQuery, SingleUserApplicationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserApplicationFullQuery, SingleUserApplicationFullQueryVariables>(SingleUserApplicationFullDocument, options);
      }
export function useSingleUserApplicationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserApplicationFullQuery, SingleUserApplicationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserApplicationFullQuery, SingleUserApplicationFullQueryVariables>(SingleUserApplicationFullDocument, options);
        }
export type SingleUserApplicationFullQueryHookResult = ReturnType<typeof useSingleUserApplicationFullQuery>;
export type SingleUserApplicationFullLazyQueryHookResult = ReturnType<typeof useSingleUserApplicationFullLazyQuery>;
export type SingleUserApplicationFullQueryResult = Apollo.QueryResult<SingleUserApplicationFullQuery, SingleUserApplicationFullQueryVariables>;
export const UpdateUserApplicationDocument = gql`
    mutation UpdateUserApplication($input: UpdateUserApplicationInput!) {
  UpdateUserApplication(input: $input) {
    ...UserApplicationScalars
  }
}
    ${UserApplicationScalarsFragmentDoc}`;
export type UpdateUserApplicationMutationFn = Apollo.MutationFunction<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>;

/**
 * __useUpdateUserApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateUserApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserApplicationMutation, { data, loading, error }] = useUpdateUserApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>(UpdateUserApplicationDocument, options);
      }
export type UpdateUserApplicationMutationHookResult = ReturnType<typeof useUpdateUserApplicationMutation>;
export type UpdateUserApplicationMutationResult = Apollo.MutationResult<UpdateUserApplicationMutation>;
export type UpdateUserApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateUserApplicationMutation, UpdateUserApplicationMutationVariables>;
export const SingleProjectStatusTypeDocument = gql`
    query SingleProjectStatusType($ID: Int!) {
  ProjectStatusType(ID: $ID) {
    ...ProjectStatusTypeScalars
  }
}
    ${ProjectStatusTypeScalarsFragmentDoc}`;

/**
 * __useSingleProjectStatusTypeQuery__
 *
 * To run a query within a React component, call `useSingleProjectStatusTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectStatusTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectStatusTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectStatusTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectStatusTypeQuery, SingleProjectStatusTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectStatusTypeQuery, SingleProjectStatusTypeQueryVariables>(SingleProjectStatusTypeDocument, options);
      }
export function useSingleProjectStatusTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectStatusTypeQuery, SingleProjectStatusTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectStatusTypeQuery, SingleProjectStatusTypeQueryVariables>(SingleProjectStatusTypeDocument, options);
        }
export type SingleProjectStatusTypeQueryHookResult = ReturnType<typeof useSingleProjectStatusTypeQuery>;
export type SingleProjectStatusTypeLazyQueryHookResult = ReturnType<typeof useSingleProjectStatusTypeLazyQuery>;
export type SingleProjectStatusTypeQueryResult = Apollo.QueryResult<SingleProjectStatusTypeQuery, SingleProjectStatusTypeQueryVariables>;
export const SingleProjectStatusTypeFullDocument = gql`
    query SingleProjectStatusTypeFull($ID: Int!) {
  ProjectStatusType(ID: $ID) {
    ...ProjectStatusTypeScalars
  }
}
    ${ProjectStatusTypeScalarsFragmentDoc}`;

/**
 * __useSingleProjectStatusTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleProjectStatusTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectStatusTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectStatusTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectStatusTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectStatusTypeFullQuery, SingleProjectStatusTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectStatusTypeFullQuery, SingleProjectStatusTypeFullQueryVariables>(SingleProjectStatusTypeFullDocument, options);
      }
export function useSingleProjectStatusTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectStatusTypeFullQuery, SingleProjectStatusTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectStatusTypeFullQuery, SingleProjectStatusTypeFullQueryVariables>(SingleProjectStatusTypeFullDocument, options);
        }
export type SingleProjectStatusTypeFullQueryHookResult = ReturnType<typeof useSingleProjectStatusTypeFullQuery>;
export type SingleProjectStatusTypeFullLazyQueryHookResult = ReturnType<typeof useSingleProjectStatusTypeFullLazyQuery>;
export type SingleProjectStatusTypeFullQueryResult = Apollo.QueryResult<SingleProjectStatusTypeFullQuery, SingleProjectStatusTypeFullQueryVariables>;
export const UpdateProjectStatusTypeDocument = gql`
    mutation UpdateProjectStatusType($input: UpdateProjectStatusTypeInput!) {
  UpdateProjectStatusType(input: $input) {
    ...ProjectStatusTypeScalars
  }
}
    ${ProjectStatusTypeScalarsFragmentDoc}`;
export type UpdateProjectStatusTypeMutationFn = Apollo.MutationFunction<UpdateProjectStatusTypeMutation, UpdateProjectStatusTypeMutationVariables>;

/**
 * __useUpdateProjectStatusTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatusTypeMutation, { data, loading, error }] = useUpdateProjectStatusTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectStatusTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectStatusTypeMutation, UpdateProjectStatusTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectStatusTypeMutation, UpdateProjectStatusTypeMutationVariables>(UpdateProjectStatusTypeDocument, options);
      }
export type UpdateProjectStatusTypeMutationHookResult = ReturnType<typeof useUpdateProjectStatusTypeMutation>;
export type UpdateProjectStatusTypeMutationResult = Apollo.MutationResult<UpdateProjectStatusTypeMutation>;
export type UpdateProjectStatusTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProjectStatusTypeMutation, UpdateProjectStatusTypeMutationVariables>;
export const SingleProjectRateTypeDocument = gql`
    query SingleProjectRateType($ID: Int!) {
  ProjectRateType(ID: $ID) {
    ...ProjectRateTypeScalars
  }
}
    ${ProjectRateTypeScalarsFragmentDoc}`;

/**
 * __useSingleProjectRateTypeQuery__
 *
 * To run a query within a React component, call `useSingleProjectRateTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectRateTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectRateTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectRateTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectRateTypeQuery, SingleProjectRateTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectRateTypeQuery, SingleProjectRateTypeQueryVariables>(SingleProjectRateTypeDocument, options);
      }
export function useSingleProjectRateTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectRateTypeQuery, SingleProjectRateTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectRateTypeQuery, SingleProjectRateTypeQueryVariables>(SingleProjectRateTypeDocument, options);
        }
export type SingleProjectRateTypeQueryHookResult = ReturnType<typeof useSingleProjectRateTypeQuery>;
export type SingleProjectRateTypeLazyQueryHookResult = ReturnType<typeof useSingleProjectRateTypeLazyQuery>;
export type SingleProjectRateTypeQueryResult = Apollo.QueryResult<SingleProjectRateTypeQuery, SingleProjectRateTypeQueryVariables>;
export const SingleProjectRateTypeFullDocument = gql`
    query SingleProjectRateTypeFull($ID: Int!) {
  ProjectRateType(ID: $ID) {
    ...ProjectRateTypeScalars
  }
}
    ${ProjectRateTypeScalarsFragmentDoc}`;

/**
 * __useSingleProjectRateTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleProjectRateTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectRateTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectRateTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectRateTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectRateTypeFullQuery, SingleProjectRateTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectRateTypeFullQuery, SingleProjectRateTypeFullQueryVariables>(SingleProjectRateTypeFullDocument, options);
      }
export function useSingleProjectRateTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectRateTypeFullQuery, SingleProjectRateTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectRateTypeFullQuery, SingleProjectRateTypeFullQueryVariables>(SingleProjectRateTypeFullDocument, options);
        }
export type SingleProjectRateTypeFullQueryHookResult = ReturnType<typeof useSingleProjectRateTypeFullQuery>;
export type SingleProjectRateTypeFullLazyQueryHookResult = ReturnType<typeof useSingleProjectRateTypeFullLazyQuery>;
export type SingleProjectRateTypeFullQueryResult = Apollo.QueryResult<SingleProjectRateTypeFullQuery, SingleProjectRateTypeFullQueryVariables>;
export const UpdateProjectRateTypeDocument = gql`
    mutation UpdateProjectRateType($input: UpdateProjectRateTypeInput!) {
  UpdateProjectRateType(input: $input) {
    ...ProjectRateTypeScalars
  }
}
    ${ProjectRateTypeScalarsFragmentDoc}`;
export type UpdateProjectRateTypeMutationFn = Apollo.MutationFunction<UpdateProjectRateTypeMutation, UpdateProjectRateTypeMutationVariables>;

/**
 * __useUpdateProjectRateTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRateTypeMutation, { data, loading, error }] = useUpdateProjectRateTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectRateTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectRateTypeMutation, UpdateProjectRateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectRateTypeMutation, UpdateProjectRateTypeMutationVariables>(UpdateProjectRateTypeDocument, options);
      }
export type UpdateProjectRateTypeMutationHookResult = ReturnType<typeof useUpdateProjectRateTypeMutation>;
export type UpdateProjectRateTypeMutationResult = Apollo.MutationResult<UpdateProjectRateTypeMutation>;
export type UpdateProjectRateTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRateTypeMutation, UpdateProjectRateTypeMutationVariables>;
export const SingleProjectBillingTypeDocument = gql`
    query SingleProjectBillingType($ID: Int!) {
  ProjectBillingType(ID: $ID) {
    ...ProjectBillingTypeScalars
  }
}
    ${ProjectBillingTypeScalarsFragmentDoc}`;

/**
 * __useSingleProjectBillingTypeQuery__
 *
 * To run a query within a React component, call `useSingleProjectBillingTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectBillingTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectBillingTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectBillingTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectBillingTypeQuery, SingleProjectBillingTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectBillingTypeQuery, SingleProjectBillingTypeQueryVariables>(SingleProjectBillingTypeDocument, options);
      }
export function useSingleProjectBillingTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectBillingTypeQuery, SingleProjectBillingTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectBillingTypeQuery, SingleProjectBillingTypeQueryVariables>(SingleProjectBillingTypeDocument, options);
        }
export type SingleProjectBillingTypeQueryHookResult = ReturnType<typeof useSingleProjectBillingTypeQuery>;
export type SingleProjectBillingTypeLazyQueryHookResult = ReturnType<typeof useSingleProjectBillingTypeLazyQuery>;
export type SingleProjectBillingTypeQueryResult = Apollo.QueryResult<SingleProjectBillingTypeQuery, SingleProjectBillingTypeQueryVariables>;
export const SingleProjectBillingTypeFullDocument = gql`
    query SingleProjectBillingTypeFull($ID: Int!) {
  ProjectBillingType(ID: $ID) {
    ...ProjectBillingTypeScalars
  }
}
    ${ProjectBillingTypeScalarsFragmentDoc}`;

/**
 * __useSingleProjectBillingTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleProjectBillingTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectBillingTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectBillingTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleProjectBillingTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectBillingTypeFullQuery, SingleProjectBillingTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectBillingTypeFullQuery, SingleProjectBillingTypeFullQueryVariables>(SingleProjectBillingTypeFullDocument, options);
      }
export function useSingleProjectBillingTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectBillingTypeFullQuery, SingleProjectBillingTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectBillingTypeFullQuery, SingleProjectBillingTypeFullQueryVariables>(SingleProjectBillingTypeFullDocument, options);
        }
export type SingleProjectBillingTypeFullQueryHookResult = ReturnType<typeof useSingleProjectBillingTypeFullQuery>;
export type SingleProjectBillingTypeFullLazyQueryHookResult = ReturnType<typeof useSingleProjectBillingTypeFullLazyQuery>;
export type SingleProjectBillingTypeFullQueryResult = Apollo.QueryResult<SingleProjectBillingTypeFullQuery, SingleProjectBillingTypeFullQueryVariables>;
export const UpdateProjectBillingTypeDocument = gql`
    mutation UpdateProjectBillingType($input: UpdateProjectBillingTypeInput!) {
  UpdateProjectBillingType(input: $input) {
    ...ProjectBillingTypeScalars
  }
}
    ${ProjectBillingTypeScalarsFragmentDoc}`;
export type UpdateProjectBillingTypeMutationFn = Apollo.MutationFunction<UpdateProjectBillingTypeMutation, UpdateProjectBillingTypeMutationVariables>;

/**
 * __useUpdateProjectBillingTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectBillingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectBillingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectBillingTypeMutation, { data, loading, error }] = useUpdateProjectBillingTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectBillingTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectBillingTypeMutation, UpdateProjectBillingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectBillingTypeMutation, UpdateProjectBillingTypeMutationVariables>(UpdateProjectBillingTypeDocument, options);
      }
export type UpdateProjectBillingTypeMutationHookResult = ReturnType<typeof useUpdateProjectBillingTypeMutation>;
export type UpdateProjectBillingTypeMutationResult = Apollo.MutationResult<UpdateProjectBillingTypeMutation>;
export type UpdateProjectBillingTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProjectBillingTypeMutation, UpdateProjectBillingTypeMutationVariables>;
export const SingleListDocument = gql`
    query SingleList($ID: Int!) {
  List(ID: $ID) {
    ...ListScalars
  }
}
    ${ListScalarsFragmentDoc}`;

/**
 * __useSingleListQuery__
 *
 * To run a query within a React component, call `useSingleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleListQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleListQuery(baseOptions: Apollo.QueryHookOptions<SingleListQuery, SingleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleListQuery, SingleListQueryVariables>(SingleListDocument, options);
      }
export function useSingleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleListQuery, SingleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleListQuery, SingleListQueryVariables>(SingleListDocument, options);
        }
export type SingleListQueryHookResult = ReturnType<typeof useSingleListQuery>;
export type SingleListLazyQueryHookResult = ReturnType<typeof useSingleListLazyQuery>;
export type SingleListQueryResult = Apollo.QueryResult<SingleListQuery, SingleListQueryVariables>;
export const SingleListFullDocument = gql`
    query SingleListFull($ID: Int!) {
  List(ID: $ID) {
    ...ListScalars
    ListDetails {
      ...ListDetailScalars
    }
  }
}
    ${ListScalarsFragmentDoc}
${ListDetailScalarsFragmentDoc}`;

/**
 * __useSingleListFullQuery__
 *
 * To run a query within a React component, call `useSingleListFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleListFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleListFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleListFullQuery(baseOptions: Apollo.QueryHookOptions<SingleListFullQuery, SingleListFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleListFullQuery, SingleListFullQueryVariables>(SingleListFullDocument, options);
      }
export function useSingleListFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleListFullQuery, SingleListFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleListFullQuery, SingleListFullQueryVariables>(SingleListFullDocument, options);
        }
export type SingleListFullQueryHookResult = ReturnType<typeof useSingleListFullQuery>;
export type SingleListFullLazyQueryHookResult = ReturnType<typeof useSingleListFullLazyQuery>;
export type SingleListFullQueryResult = Apollo.QueryResult<SingleListFullQuery, SingleListFullQueryVariables>;
export const CreateListDocument = gql`
    mutation CreateList($input: CreateListInput!) {
  CreateList(input: $input) {
    ...ListScalars
  }
}
    ${ListScalarsFragmentDoc}`;
export type CreateListMutationFn = Apollo.MutationFunction<CreateListMutation, CreateListMutationVariables>;

/**
 * __useCreateListMutation__
 *
 * To run a mutation, you first call `useCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListMutation, { data, loading, error }] = useCreateListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListMutation(baseOptions?: Apollo.MutationHookOptions<CreateListMutation, CreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListMutation, CreateListMutationVariables>(CreateListDocument, options);
      }
export type CreateListMutationHookResult = ReturnType<typeof useCreateListMutation>;
export type CreateListMutationResult = Apollo.MutationResult<CreateListMutation>;
export type CreateListMutationOptions = Apollo.BaseMutationOptions<CreateListMutation, CreateListMutationVariables>;
export const UpdateListDocument = gql`
    mutation UpdateList($input: UpdateListInput!) {
  UpdateList(input: $input) {
    ...ListScalars
  }
}
    ${ListScalarsFragmentDoc}`;
export type UpdateListMutationFn = Apollo.MutationFunction<UpdateListMutation, UpdateListMutationVariables>;

/**
 * __useUpdateListMutation__
 *
 * To run a mutation, you first call `useUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListMutation, { data, loading, error }] = useUpdateListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListMutation, UpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListMutation, UpdateListMutationVariables>(UpdateListDocument, options);
      }
export type UpdateListMutationHookResult = ReturnType<typeof useUpdateListMutation>;
export type UpdateListMutationResult = Apollo.MutationResult<UpdateListMutation>;
export type UpdateListMutationOptions = Apollo.BaseMutationOptions<UpdateListMutation, UpdateListMutationVariables>;
export const DeleteListDocument = gql`
    mutation DeleteList($ID: Int!) {
  DeleteList(ID: $ID)
}
    `;
export type DeleteListMutationFn = Apollo.MutationFunction<DeleteListMutation, DeleteListMutationVariables>;

/**
 * __useDeleteListMutation__
 *
 * To run a mutation, you first call `useDeleteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListMutation, { data, loading, error }] = useDeleteListMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListMutation, DeleteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListMutation, DeleteListMutationVariables>(DeleteListDocument, options);
      }
export type DeleteListMutationHookResult = ReturnType<typeof useDeleteListMutation>;
export type DeleteListMutationResult = Apollo.MutationResult<DeleteListMutation>;
export type DeleteListMutationOptions = Apollo.BaseMutationOptions<DeleteListMutation, DeleteListMutationVariables>;
export const SingleListDetailDocument = gql`
    query SingleListDetail($ID: Int!) {
  ListDetail(ID: $ID) {
    ...ListDetailScalars
  }
}
    ${ListDetailScalarsFragmentDoc}`;

/**
 * __useSingleListDetailQuery__
 *
 * To run a query within a React component, call `useSingleListDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleListDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleListDetailQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleListDetailQuery(baseOptions: Apollo.QueryHookOptions<SingleListDetailQuery, SingleListDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleListDetailQuery, SingleListDetailQueryVariables>(SingleListDetailDocument, options);
      }
export function useSingleListDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleListDetailQuery, SingleListDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleListDetailQuery, SingleListDetailQueryVariables>(SingleListDetailDocument, options);
        }
export type SingleListDetailQueryHookResult = ReturnType<typeof useSingleListDetailQuery>;
export type SingleListDetailLazyQueryHookResult = ReturnType<typeof useSingleListDetailLazyQuery>;
export type SingleListDetailQueryResult = Apollo.QueryResult<SingleListDetailQuery, SingleListDetailQueryVariables>;
export const SingleListDetailFullDocument = gql`
    query SingleListDetailFull($ID: Int!) {
  ListDetail(ID: $ID) {
    ...ListDetailScalars
  }
}
    ${ListDetailScalarsFragmentDoc}`;

/**
 * __useSingleListDetailFullQuery__
 *
 * To run a query within a React component, call `useSingleListDetailFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleListDetailFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleListDetailFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleListDetailFullQuery(baseOptions: Apollo.QueryHookOptions<SingleListDetailFullQuery, SingleListDetailFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleListDetailFullQuery, SingleListDetailFullQueryVariables>(SingleListDetailFullDocument, options);
      }
export function useSingleListDetailFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleListDetailFullQuery, SingleListDetailFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleListDetailFullQuery, SingleListDetailFullQueryVariables>(SingleListDetailFullDocument, options);
        }
export type SingleListDetailFullQueryHookResult = ReturnType<typeof useSingleListDetailFullQuery>;
export type SingleListDetailFullLazyQueryHookResult = ReturnType<typeof useSingleListDetailFullLazyQuery>;
export type SingleListDetailFullQueryResult = Apollo.QueryResult<SingleListDetailFullQuery, SingleListDetailFullQueryVariables>;
export const CreateListDetailDocument = gql`
    mutation CreateListDetail($input: CreateListDetailInput!) {
  CreateListDetail(input: $input) {
    ...ListDetailScalars
  }
}
    ${ListDetailScalarsFragmentDoc}`;
export type CreateListDetailMutationFn = Apollo.MutationFunction<CreateListDetailMutation, CreateListDetailMutationVariables>;

/**
 * __useCreateListDetailMutation__
 *
 * To run a mutation, you first call `useCreateListDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListDetailMutation, { data, loading, error }] = useCreateListDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateListDetailMutation, CreateListDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListDetailMutation, CreateListDetailMutationVariables>(CreateListDetailDocument, options);
      }
export type CreateListDetailMutationHookResult = ReturnType<typeof useCreateListDetailMutation>;
export type CreateListDetailMutationResult = Apollo.MutationResult<CreateListDetailMutation>;
export type CreateListDetailMutationOptions = Apollo.BaseMutationOptions<CreateListDetailMutation, CreateListDetailMutationVariables>;
export const UpdateListDetailDocument = gql`
    mutation UpdateListDetail($input: UpdateListDetailInput!) {
  UpdateListDetail(input: $input) {
    ...ListDetailScalars
  }
}
    ${ListDetailScalarsFragmentDoc}`;
export type UpdateListDetailMutationFn = Apollo.MutationFunction<UpdateListDetailMutation, UpdateListDetailMutationVariables>;

/**
 * __useUpdateListDetailMutation__
 *
 * To run a mutation, you first call `useUpdateListDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListDetailMutation, { data, loading, error }] = useUpdateListDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListDetailMutation, UpdateListDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListDetailMutation, UpdateListDetailMutationVariables>(UpdateListDetailDocument, options);
      }
export type UpdateListDetailMutationHookResult = ReturnType<typeof useUpdateListDetailMutation>;
export type UpdateListDetailMutationResult = Apollo.MutationResult<UpdateListDetailMutation>;
export type UpdateListDetailMutationOptions = Apollo.BaseMutationOptions<UpdateListDetailMutation, UpdateListDetailMutationVariables>;
export const DeleteListDetailDocument = gql`
    mutation DeleteListDetail($ID: Int!) {
  DeleteListDetail(ID: $ID)
}
    `;
export type DeleteListDetailMutationFn = Apollo.MutationFunction<DeleteListDetailMutation, DeleteListDetailMutationVariables>;

/**
 * __useDeleteListDetailMutation__
 *
 * To run a mutation, you first call `useDeleteListDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListDetailMutation, { data, loading, error }] = useDeleteListDetailMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteListDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListDetailMutation, DeleteListDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListDetailMutation, DeleteListDetailMutationVariables>(DeleteListDetailDocument, options);
      }
export type DeleteListDetailMutationHookResult = ReturnType<typeof useDeleteListDetailMutation>;
export type DeleteListDetailMutationResult = Apollo.MutationResult<DeleteListDetailMutation>;
export type DeleteListDetailMutationOptions = Apollo.BaseMutationOptions<DeleteListDetailMutation, DeleteListDetailMutationVariables>;
export const SingleUserViewRunDocument = gql`
    query SingleUserViewRun($ID: Int!) {
  UserViewRun(ID: $ID) {
    ...UserViewRunScalars
  }
}
    ${UserViewRunScalarsFragmentDoc}`;

/**
 * __useSingleUserViewRunQuery__
 *
 * To run a query within a React component, call `useSingleUserViewRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserViewRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserViewRunQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserViewRunQuery(baseOptions: Apollo.QueryHookOptions<SingleUserViewRunQuery, SingleUserViewRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserViewRunQuery, SingleUserViewRunQueryVariables>(SingleUserViewRunDocument, options);
      }
export function useSingleUserViewRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserViewRunQuery, SingleUserViewRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserViewRunQuery, SingleUserViewRunQueryVariables>(SingleUserViewRunDocument, options);
        }
export type SingleUserViewRunQueryHookResult = ReturnType<typeof useSingleUserViewRunQuery>;
export type SingleUserViewRunLazyQueryHookResult = ReturnType<typeof useSingleUserViewRunLazyQuery>;
export type SingleUserViewRunQueryResult = Apollo.QueryResult<SingleUserViewRunQuery, SingleUserViewRunQueryVariables>;
export const SingleUserViewRunFullDocument = gql`
    query SingleUserViewRunFull($ID: Int!) {
  UserViewRun(ID: $ID) {
    ...UserViewRunScalars
    UserViewRunDetails {
      ...UserViewRunDetailScalars
    }
  }
}
    ${UserViewRunScalarsFragmentDoc}
${UserViewRunDetailScalarsFragmentDoc}`;

/**
 * __useSingleUserViewRunFullQuery__
 *
 * To run a query within a React component, call `useSingleUserViewRunFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserViewRunFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserViewRunFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserViewRunFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserViewRunFullQuery, SingleUserViewRunFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserViewRunFullQuery, SingleUserViewRunFullQueryVariables>(SingleUserViewRunFullDocument, options);
      }
export function useSingleUserViewRunFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserViewRunFullQuery, SingleUserViewRunFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserViewRunFullQuery, SingleUserViewRunFullQueryVariables>(SingleUserViewRunFullDocument, options);
        }
export type SingleUserViewRunFullQueryHookResult = ReturnType<typeof useSingleUserViewRunFullQuery>;
export type SingleUserViewRunFullLazyQueryHookResult = ReturnType<typeof useSingleUserViewRunFullLazyQuery>;
export type SingleUserViewRunFullQueryResult = Apollo.QueryResult<SingleUserViewRunFullQuery, SingleUserViewRunFullQueryVariables>;
export const CreateUserViewRunDocument = gql`
    mutation CreateUserViewRun($input: CreateUserViewRunInput!) {
  CreateUserViewRun(input: $input) {
    ...UserViewRunScalars
  }
}
    ${UserViewRunScalarsFragmentDoc}`;
export type CreateUserViewRunMutationFn = Apollo.MutationFunction<CreateUserViewRunMutation, CreateUserViewRunMutationVariables>;

/**
 * __useCreateUserViewRunMutation__
 *
 * To run a mutation, you first call `useCreateUserViewRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserViewRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserViewRunMutation, { data, loading, error }] = useCreateUserViewRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserViewRunMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserViewRunMutation, CreateUserViewRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserViewRunMutation, CreateUserViewRunMutationVariables>(CreateUserViewRunDocument, options);
      }
export type CreateUserViewRunMutationHookResult = ReturnType<typeof useCreateUserViewRunMutation>;
export type CreateUserViewRunMutationResult = Apollo.MutationResult<CreateUserViewRunMutation>;
export type CreateUserViewRunMutationOptions = Apollo.BaseMutationOptions<CreateUserViewRunMutation, CreateUserViewRunMutationVariables>;
export const UpdateUserViewRunDocument = gql`
    mutation UpdateUserViewRun($input: UpdateUserViewRunInput!) {
  UpdateUserViewRun(input: $input) {
    ...UserViewRunScalars
  }
}
    ${UserViewRunScalarsFragmentDoc}`;
export type UpdateUserViewRunMutationFn = Apollo.MutationFunction<UpdateUserViewRunMutation, UpdateUserViewRunMutationVariables>;

/**
 * __useUpdateUserViewRunMutation__
 *
 * To run a mutation, you first call `useUpdateUserViewRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserViewRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserViewRunMutation, { data, loading, error }] = useUpdateUserViewRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserViewRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserViewRunMutation, UpdateUserViewRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserViewRunMutation, UpdateUserViewRunMutationVariables>(UpdateUserViewRunDocument, options);
      }
export type UpdateUserViewRunMutationHookResult = ReturnType<typeof useUpdateUserViewRunMutation>;
export type UpdateUserViewRunMutationResult = Apollo.MutationResult<UpdateUserViewRunMutation>;
export type UpdateUserViewRunMutationOptions = Apollo.BaseMutationOptions<UpdateUserViewRunMutation, UpdateUserViewRunMutationVariables>;
export const SingleUserViewRunDetailDocument = gql`
    query SingleUserViewRunDetail($ID: Int!) {
  UserViewRunDetail(ID: $ID) {
    ...UserViewRunDetailScalars
  }
}
    ${UserViewRunDetailScalarsFragmentDoc}`;

/**
 * __useSingleUserViewRunDetailQuery__
 *
 * To run a query within a React component, call `useSingleUserViewRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserViewRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserViewRunDetailQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserViewRunDetailQuery(baseOptions: Apollo.QueryHookOptions<SingleUserViewRunDetailQuery, SingleUserViewRunDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserViewRunDetailQuery, SingleUserViewRunDetailQueryVariables>(SingleUserViewRunDetailDocument, options);
      }
export function useSingleUserViewRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserViewRunDetailQuery, SingleUserViewRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserViewRunDetailQuery, SingleUserViewRunDetailQueryVariables>(SingleUserViewRunDetailDocument, options);
        }
export type SingleUserViewRunDetailQueryHookResult = ReturnType<typeof useSingleUserViewRunDetailQuery>;
export type SingleUserViewRunDetailLazyQueryHookResult = ReturnType<typeof useSingleUserViewRunDetailLazyQuery>;
export type SingleUserViewRunDetailQueryResult = Apollo.QueryResult<SingleUserViewRunDetailQuery, SingleUserViewRunDetailQueryVariables>;
export const SingleUserViewRunDetailFullDocument = gql`
    query SingleUserViewRunDetailFull($ID: Int!) {
  UserViewRunDetail(ID: $ID) {
    ...UserViewRunDetailScalars
  }
}
    ${UserViewRunDetailScalarsFragmentDoc}`;

/**
 * __useSingleUserViewRunDetailFullQuery__
 *
 * To run a query within a React component, call `useSingleUserViewRunDetailFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserViewRunDetailFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserViewRunDetailFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserViewRunDetailFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserViewRunDetailFullQuery, SingleUserViewRunDetailFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserViewRunDetailFullQuery, SingleUserViewRunDetailFullQueryVariables>(SingleUserViewRunDetailFullDocument, options);
      }
export function useSingleUserViewRunDetailFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserViewRunDetailFullQuery, SingleUserViewRunDetailFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserViewRunDetailFullQuery, SingleUserViewRunDetailFullQueryVariables>(SingleUserViewRunDetailFullDocument, options);
        }
export type SingleUserViewRunDetailFullQueryHookResult = ReturnType<typeof useSingleUserViewRunDetailFullQuery>;
export type SingleUserViewRunDetailFullLazyQueryHookResult = ReturnType<typeof useSingleUserViewRunDetailFullLazyQuery>;
export type SingleUserViewRunDetailFullQueryResult = Apollo.QueryResult<SingleUserViewRunDetailFullQuery, SingleUserViewRunDetailFullQueryVariables>;
export const CreateUserViewRunDetailDocument = gql`
    mutation CreateUserViewRunDetail($input: CreateUserViewRunDetailInput!) {
  CreateUserViewRunDetail(input: $input) {
    ...UserViewRunDetailScalars
  }
}
    ${UserViewRunDetailScalarsFragmentDoc}`;
export type CreateUserViewRunDetailMutationFn = Apollo.MutationFunction<CreateUserViewRunDetailMutation, CreateUserViewRunDetailMutationVariables>;

/**
 * __useCreateUserViewRunDetailMutation__
 *
 * To run a mutation, you first call `useCreateUserViewRunDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserViewRunDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserViewRunDetailMutation, { data, loading, error }] = useCreateUserViewRunDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserViewRunDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserViewRunDetailMutation, CreateUserViewRunDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserViewRunDetailMutation, CreateUserViewRunDetailMutationVariables>(CreateUserViewRunDetailDocument, options);
      }
export type CreateUserViewRunDetailMutationHookResult = ReturnType<typeof useCreateUserViewRunDetailMutation>;
export type CreateUserViewRunDetailMutationResult = Apollo.MutationResult<CreateUserViewRunDetailMutation>;
export type CreateUserViewRunDetailMutationOptions = Apollo.BaseMutationOptions<CreateUserViewRunDetailMutation, CreateUserViewRunDetailMutationVariables>;
export const UpdateUserViewRunDetailDocument = gql`
    mutation UpdateUserViewRunDetail($input: UpdateUserViewRunDetailInput!) {
  UpdateUserViewRunDetail(input: $input) {
    ...UserViewRunDetailScalars
  }
}
    ${UserViewRunDetailScalarsFragmentDoc}`;
export type UpdateUserViewRunDetailMutationFn = Apollo.MutationFunction<UpdateUserViewRunDetailMutation, UpdateUserViewRunDetailMutationVariables>;

/**
 * __useUpdateUserViewRunDetailMutation__
 *
 * To run a mutation, you first call `useUpdateUserViewRunDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserViewRunDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserViewRunDetailMutation, { data, loading, error }] = useUpdateUserViewRunDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserViewRunDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserViewRunDetailMutation, UpdateUserViewRunDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserViewRunDetailMutation, UpdateUserViewRunDetailMutationVariables>(UpdateUserViewRunDetailDocument, options);
      }
export type UpdateUserViewRunDetailMutationHookResult = ReturnType<typeof useUpdateUserViewRunDetailMutation>;
export type UpdateUserViewRunDetailMutationResult = Apollo.MutationResult<UpdateUserViewRunDetailMutation>;
export type UpdateUserViewRunDetailMutationOptions = Apollo.BaseMutationOptions<UpdateUserViewRunDetailMutation, UpdateUserViewRunDetailMutationVariables>;
export const SingleWorkflowRunDocument = gql`
    query SingleWorkflowRun($ID: Int!) {
  WorkflowRun(ID: $ID) {
    ...WorkflowRunScalars
  }
}
    ${WorkflowRunScalarsFragmentDoc}`;

/**
 * __useSingleWorkflowRunQuery__
 *
 * To run a query within a React component, call `useSingleWorkflowRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleWorkflowRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleWorkflowRunQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleWorkflowRunQuery(baseOptions: Apollo.QueryHookOptions<SingleWorkflowRunQuery, SingleWorkflowRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleWorkflowRunQuery, SingleWorkflowRunQueryVariables>(SingleWorkflowRunDocument, options);
      }
export function useSingleWorkflowRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleWorkflowRunQuery, SingleWorkflowRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleWorkflowRunQuery, SingleWorkflowRunQueryVariables>(SingleWorkflowRunDocument, options);
        }
export type SingleWorkflowRunQueryHookResult = ReturnType<typeof useSingleWorkflowRunQuery>;
export type SingleWorkflowRunLazyQueryHookResult = ReturnType<typeof useSingleWorkflowRunLazyQuery>;
export type SingleWorkflowRunQueryResult = Apollo.QueryResult<SingleWorkflowRunQuery, SingleWorkflowRunQueryVariables>;
export const SingleWorkflowRunFullDocument = gql`
    query SingleWorkflowRunFull($ID: Int!) {
  WorkflowRun(ID: $ID) {
    ...WorkflowRunScalars
  }
}
    ${WorkflowRunScalarsFragmentDoc}`;

/**
 * __useSingleWorkflowRunFullQuery__
 *
 * To run a query within a React component, call `useSingleWorkflowRunFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleWorkflowRunFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleWorkflowRunFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleWorkflowRunFullQuery(baseOptions: Apollo.QueryHookOptions<SingleWorkflowRunFullQuery, SingleWorkflowRunFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleWorkflowRunFullQuery, SingleWorkflowRunFullQueryVariables>(SingleWorkflowRunFullDocument, options);
      }
export function useSingleWorkflowRunFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleWorkflowRunFullQuery, SingleWorkflowRunFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleWorkflowRunFullQuery, SingleWorkflowRunFullQueryVariables>(SingleWorkflowRunFullDocument, options);
        }
export type SingleWorkflowRunFullQueryHookResult = ReturnType<typeof useSingleWorkflowRunFullQuery>;
export type SingleWorkflowRunFullLazyQueryHookResult = ReturnType<typeof useSingleWorkflowRunFullLazyQuery>;
export type SingleWorkflowRunFullQueryResult = Apollo.QueryResult<SingleWorkflowRunFullQuery, SingleWorkflowRunFullQueryVariables>;
export const UpdateWorkflowRunDocument = gql`
    mutation UpdateWorkflowRun($input: UpdateWorkflowRunInput!) {
  UpdateWorkflowRun(input: $input) {
    ...WorkflowRunScalars
  }
}
    ${WorkflowRunScalarsFragmentDoc}`;
export type UpdateWorkflowRunMutationFn = Apollo.MutationFunction<UpdateWorkflowRunMutation, UpdateWorkflowRunMutationVariables>;

/**
 * __useUpdateWorkflowRunMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowRunMutation, { data, loading, error }] = useUpdateWorkflowRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowRunMutation, UpdateWorkflowRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowRunMutation, UpdateWorkflowRunMutationVariables>(UpdateWorkflowRunDocument, options);
      }
export type UpdateWorkflowRunMutationHookResult = ReturnType<typeof useUpdateWorkflowRunMutation>;
export type UpdateWorkflowRunMutationResult = Apollo.MutationResult<UpdateWorkflowRunMutation>;
export type UpdateWorkflowRunMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowRunMutation, UpdateWorkflowRunMutationVariables>;
export const SingleWorkflowDocument = gql`
    query SingleWorkflow($ID: Int!) {
  Workflow(ID: $ID) {
    ...WorkflowScalars
  }
}
    ${WorkflowScalarsFragmentDoc}`;

/**
 * __useSingleWorkflowQuery__
 *
 * To run a query within a React component, call `useSingleWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleWorkflowQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleWorkflowQuery(baseOptions: Apollo.QueryHookOptions<SingleWorkflowQuery, SingleWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleWorkflowQuery, SingleWorkflowQueryVariables>(SingleWorkflowDocument, options);
      }
export function useSingleWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleWorkflowQuery, SingleWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleWorkflowQuery, SingleWorkflowQueryVariables>(SingleWorkflowDocument, options);
        }
export type SingleWorkflowQueryHookResult = ReturnType<typeof useSingleWorkflowQuery>;
export type SingleWorkflowLazyQueryHookResult = ReturnType<typeof useSingleWorkflowLazyQuery>;
export type SingleWorkflowQueryResult = Apollo.QueryResult<SingleWorkflowQuery, SingleWorkflowQueryVariables>;
export const SingleWorkflowFullDocument = gql`
    query SingleWorkflowFull($ID: Int!) {
  Workflow(ID: $ID) {
    ...WorkflowScalars
  }
}
    ${WorkflowScalarsFragmentDoc}`;

/**
 * __useSingleWorkflowFullQuery__
 *
 * To run a query within a React component, call `useSingleWorkflowFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleWorkflowFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleWorkflowFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleWorkflowFullQuery(baseOptions: Apollo.QueryHookOptions<SingleWorkflowFullQuery, SingleWorkflowFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleWorkflowFullQuery, SingleWorkflowFullQueryVariables>(SingleWorkflowFullDocument, options);
      }
export function useSingleWorkflowFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleWorkflowFullQuery, SingleWorkflowFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleWorkflowFullQuery, SingleWorkflowFullQueryVariables>(SingleWorkflowFullDocument, options);
        }
export type SingleWorkflowFullQueryHookResult = ReturnType<typeof useSingleWorkflowFullQuery>;
export type SingleWorkflowFullLazyQueryHookResult = ReturnType<typeof useSingleWorkflowFullLazyQuery>;
export type SingleWorkflowFullQueryResult = Apollo.QueryResult<SingleWorkflowFullQuery, SingleWorkflowFullQueryVariables>;
export const UpdateWorkflowDocument = gql`
    mutation UpdateWorkflow($input: UpdateWorkflowInput!) {
  UpdateWorkflow(input: $input) {
    ...WorkflowScalars
  }
}
    ${WorkflowScalarsFragmentDoc}`;
export type UpdateWorkflowMutationFn = Apollo.MutationFunction<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;

/**
 * __useUpdateWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowMutation, { data, loading, error }] = useUpdateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
      }
export type UpdateWorkflowMutationHookResult = ReturnType<typeof useUpdateWorkflowMutation>;
export type UpdateWorkflowMutationResult = Apollo.MutationResult<UpdateWorkflowMutation>;
export type UpdateWorkflowMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const SingleCampaignDocument = gql`
    query SingleCampaign($ID: Int!) {
  Campaign(ID: $ID) {
    ...CampaignScalars
  }
}
    ${CampaignScalarsFragmentDoc}`;

/**
 * __useSingleCampaignQuery__
 *
 * To run a query within a React component, call `useSingleCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCampaignQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCampaignQuery(baseOptions: Apollo.QueryHookOptions<SingleCampaignQuery, SingleCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCampaignQuery, SingleCampaignQueryVariables>(SingleCampaignDocument, options);
      }
export function useSingleCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCampaignQuery, SingleCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCampaignQuery, SingleCampaignQueryVariables>(SingleCampaignDocument, options);
        }
export type SingleCampaignQueryHookResult = ReturnType<typeof useSingleCampaignQuery>;
export type SingleCampaignLazyQueryHookResult = ReturnType<typeof useSingleCampaignLazyQuery>;
export type SingleCampaignQueryResult = Apollo.QueryResult<SingleCampaignQuery, SingleCampaignQueryVariables>;
export const SingleCampaignFullDocument = gql`
    query SingleCampaignFull($ID: Int!) {
  Campaign(ID: $ID) {
    ...CampaignScalars
  }
}
    ${CampaignScalarsFragmentDoc}`;

/**
 * __useSingleCampaignFullQuery__
 *
 * To run a query within a React component, call `useSingleCampaignFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCampaignFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCampaignFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCampaignFullQuery(baseOptions: Apollo.QueryHookOptions<SingleCampaignFullQuery, SingleCampaignFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCampaignFullQuery, SingleCampaignFullQueryVariables>(SingleCampaignFullDocument, options);
      }
export function useSingleCampaignFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCampaignFullQuery, SingleCampaignFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCampaignFullQuery, SingleCampaignFullQueryVariables>(SingleCampaignFullDocument, options);
        }
export type SingleCampaignFullQueryHookResult = ReturnType<typeof useSingleCampaignFullQuery>;
export type SingleCampaignFullLazyQueryHookResult = ReturnType<typeof useSingleCampaignFullLazyQuery>;
export type SingleCampaignFullQueryResult = Apollo.QueryResult<SingleCampaignFullQuery, SingleCampaignFullQueryVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($input: UpdateCampaignInput!) {
  UpdateCampaign(input: $input) {
    ...CampaignScalars
  }
}
    ${CampaignScalarsFragmentDoc}`;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const SingleCampaignStepDocument = gql`
    query SingleCampaignStep($ID: Int!) {
  CampaignStep(ID: $ID) {
    ...CampaignStepScalars
  }
}
    ${CampaignStepScalarsFragmentDoc}`;

/**
 * __useSingleCampaignStepQuery__
 *
 * To run a query within a React component, call `useSingleCampaignStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCampaignStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCampaignStepQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCampaignStepQuery(baseOptions: Apollo.QueryHookOptions<SingleCampaignStepQuery, SingleCampaignStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCampaignStepQuery, SingleCampaignStepQueryVariables>(SingleCampaignStepDocument, options);
      }
export function useSingleCampaignStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCampaignStepQuery, SingleCampaignStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCampaignStepQuery, SingleCampaignStepQueryVariables>(SingleCampaignStepDocument, options);
        }
export type SingleCampaignStepQueryHookResult = ReturnType<typeof useSingleCampaignStepQuery>;
export type SingleCampaignStepLazyQueryHookResult = ReturnType<typeof useSingleCampaignStepLazyQuery>;
export type SingleCampaignStepQueryResult = Apollo.QueryResult<SingleCampaignStepQuery, SingleCampaignStepQueryVariables>;
export const SingleCampaignStepFullDocument = gql`
    query SingleCampaignStepFull($ID: Int!) {
  CampaignStep(ID: $ID) {
    ...CampaignStepScalars
  }
}
    ${CampaignStepScalarsFragmentDoc}`;

/**
 * __useSingleCampaignStepFullQuery__
 *
 * To run a query within a React component, call `useSingleCampaignStepFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCampaignStepFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCampaignStepFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleCampaignStepFullQuery(baseOptions: Apollo.QueryHookOptions<SingleCampaignStepFullQuery, SingleCampaignStepFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCampaignStepFullQuery, SingleCampaignStepFullQueryVariables>(SingleCampaignStepFullDocument, options);
      }
export function useSingleCampaignStepFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCampaignStepFullQuery, SingleCampaignStepFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCampaignStepFullQuery, SingleCampaignStepFullQueryVariables>(SingleCampaignStepFullDocument, options);
        }
export type SingleCampaignStepFullQueryHookResult = ReturnType<typeof useSingleCampaignStepFullQuery>;
export type SingleCampaignStepFullLazyQueryHookResult = ReturnType<typeof useSingleCampaignStepFullLazyQuery>;
export type SingleCampaignStepFullQueryResult = Apollo.QueryResult<SingleCampaignStepFullQuery, SingleCampaignStepFullQueryVariables>;
export const UpdateCampaignStepDocument = gql`
    mutation UpdateCampaignStep($input: UpdateCampaignStepInput!) {
  UpdateCampaignStep(input: $input) {
    ...CampaignStepScalars
  }
}
    ${CampaignStepScalarsFragmentDoc}`;
export type UpdateCampaignStepMutationFn = Apollo.MutationFunction<UpdateCampaignStepMutation, UpdateCampaignStepMutationVariables>;

/**
 * __useUpdateCampaignStepMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignStepMutation, { data, loading, error }] = useUpdateCampaignStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignStepMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignStepMutation, UpdateCampaignStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignStepMutation, UpdateCampaignStepMutationVariables>(UpdateCampaignStepDocument, options);
      }
export type UpdateCampaignStepMutationHookResult = ReturnType<typeof useUpdateCampaignStepMutation>;
export type UpdateCampaignStepMutationResult = Apollo.MutationResult<UpdateCampaignStepMutation>;
export type UpdateCampaignStepMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignStepMutation, UpdateCampaignStepMutationVariables>;
export const SingleWorkflowEngineDocument = gql`
    query SingleWorkflowEngine($ID: Int!) {
  WorkflowEngine(ID: $ID) {
    ...WorkflowEngineScalars
  }
}
    ${WorkflowEngineScalarsFragmentDoc}`;

/**
 * __useSingleWorkflowEngineQuery__
 *
 * To run a query within a React component, call `useSingleWorkflowEngineQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleWorkflowEngineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleWorkflowEngineQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleWorkflowEngineQuery(baseOptions: Apollo.QueryHookOptions<SingleWorkflowEngineQuery, SingleWorkflowEngineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleWorkflowEngineQuery, SingleWorkflowEngineQueryVariables>(SingleWorkflowEngineDocument, options);
      }
export function useSingleWorkflowEngineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleWorkflowEngineQuery, SingleWorkflowEngineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleWorkflowEngineQuery, SingleWorkflowEngineQueryVariables>(SingleWorkflowEngineDocument, options);
        }
export type SingleWorkflowEngineQueryHookResult = ReturnType<typeof useSingleWorkflowEngineQuery>;
export type SingleWorkflowEngineLazyQueryHookResult = ReturnType<typeof useSingleWorkflowEngineLazyQuery>;
export type SingleWorkflowEngineQueryResult = Apollo.QueryResult<SingleWorkflowEngineQuery, SingleWorkflowEngineQueryVariables>;
export const SingleWorkflowEngineFullDocument = gql`
    query SingleWorkflowEngineFull($ID: Int!) {
  WorkflowEngine(ID: $ID) {
    ...WorkflowEngineScalars
  }
}
    ${WorkflowEngineScalarsFragmentDoc}`;

/**
 * __useSingleWorkflowEngineFullQuery__
 *
 * To run a query within a React component, call `useSingleWorkflowEngineFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleWorkflowEngineFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleWorkflowEngineFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleWorkflowEngineFullQuery(baseOptions: Apollo.QueryHookOptions<SingleWorkflowEngineFullQuery, SingleWorkflowEngineFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleWorkflowEngineFullQuery, SingleWorkflowEngineFullQueryVariables>(SingleWorkflowEngineFullDocument, options);
      }
export function useSingleWorkflowEngineFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleWorkflowEngineFullQuery, SingleWorkflowEngineFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleWorkflowEngineFullQuery, SingleWorkflowEngineFullQueryVariables>(SingleWorkflowEngineFullDocument, options);
        }
export type SingleWorkflowEngineFullQueryHookResult = ReturnType<typeof useSingleWorkflowEngineFullQuery>;
export type SingleWorkflowEngineFullLazyQueryHookResult = ReturnType<typeof useSingleWorkflowEngineFullLazyQuery>;
export type SingleWorkflowEngineFullQueryResult = Apollo.QueryResult<SingleWorkflowEngineFullQuery, SingleWorkflowEngineFullQueryVariables>;
export const UpdateWorkflowEngineDocument = gql`
    mutation UpdateWorkflowEngine($input: UpdateWorkflowEngineInput!) {
  UpdateWorkflowEngine(input: $input) {
    ...WorkflowEngineScalars
  }
}
    ${WorkflowEngineScalarsFragmentDoc}`;
export type UpdateWorkflowEngineMutationFn = Apollo.MutationFunction<UpdateWorkflowEngineMutation, UpdateWorkflowEngineMutationVariables>;

/**
 * __useUpdateWorkflowEngineMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowEngineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowEngineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowEngineMutation, { data, loading, error }] = useUpdateWorkflowEngineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowEngineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowEngineMutation, UpdateWorkflowEngineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowEngineMutation, UpdateWorkflowEngineMutationVariables>(UpdateWorkflowEngineDocument, options);
      }
export type UpdateWorkflowEngineMutationHookResult = ReturnType<typeof useUpdateWorkflowEngineMutation>;
export type UpdateWorkflowEngineMutationResult = Apollo.MutationResult<UpdateWorkflowEngineMutation>;
export type UpdateWorkflowEngineMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowEngineMutation, UpdateWorkflowEngineMutationVariables>;
export const SingleRecordChangeDocument = gql`
    query SingleRecordChange($ID: Int!) {
  RecordChange(ID: $ID) {
    ...RecordChangeScalars
  }
}
    ${RecordChangeScalarsFragmentDoc}`;

/**
 * __useSingleRecordChangeQuery__
 *
 * To run a query within a React component, call `useSingleRecordChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRecordChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRecordChangeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleRecordChangeQuery(baseOptions: Apollo.QueryHookOptions<SingleRecordChangeQuery, SingleRecordChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRecordChangeQuery, SingleRecordChangeQueryVariables>(SingleRecordChangeDocument, options);
      }
export function useSingleRecordChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRecordChangeQuery, SingleRecordChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRecordChangeQuery, SingleRecordChangeQueryVariables>(SingleRecordChangeDocument, options);
        }
export type SingleRecordChangeQueryHookResult = ReturnType<typeof useSingleRecordChangeQuery>;
export type SingleRecordChangeLazyQueryHookResult = ReturnType<typeof useSingleRecordChangeLazyQuery>;
export type SingleRecordChangeQueryResult = Apollo.QueryResult<SingleRecordChangeQuery, SingleRecordChangeQueryVariables>;
export const SingleRecordChangeFullDocument = gql`
    query SingleRecordChangeFull($ID: Int!) {
  RecordChange(ID: $ID) {
    ...RecordChangeScalars
  }
}
    ${RecordChangeScalarsFragmentDoc}`;

/**
 * __useSingleRecordChangeFullQuery__
 *
 * To run a query within a React component, call `useSingleRecordChangeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRecordChangeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRecordChangeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleRecordChangeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleRecordChangeFullQuery, SingleRecordChangeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRecordChangeFullQuery, SingleRecordChangeFullQueryVariables>(SingleRecordChangeFullDocument, options);
      }
export function useSingleRecordChangeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRecordChangeFullQuery, SingleRecordChangeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRecordChangeFullQuery, SingleRecordChangeFullQueryVariables>(SingleRecordChangeFullDocument, options);
        }
export type SingleRecordChangeFullQueryHookResult = ReturnType<typeof useSingleRecordChangeFullQuery>;
export type SingleRecordChangeFullLazyQueryHookResult = ReturnType<typeof useSingleRecordChangeFullLazyQuery>;
export type SingleRecordChangeFullQueryResult = Apollo.QueryResult<SingleRecordChangeFullQuery, SingleRecordChangeFullQueryVariables>;
export const CreateRecordChangeDocument = gql`
    mutation CreateRecordChange($input: CreateRecordChangeInput!) {
  CreateRecordChange(input: $input) {
    ...RecordChangeScalars
  }
}
    ${RecordChangeScalarsFragmentDoc}`;
export type CreateRecordChangeMutationFn = Apollo.MutationFunction<CreateRecordChangeMutation, CreateRecordChangeMutationVariables>;

/**
 * __useCreateRecordChangeMutation__
 *
 * To run a mutation, you first call `useCreateRecordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordChangeMutation, { data, loading, error }] = useCreateRecordChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecordChangeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecordChangeMutation, CreateRecordChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecordChangeMutation, CreateRecordChangeMutationVariables>(CreateRecordChangeDocument, options);
      }
export type CreateRecordChangeMutationHookResult = ReturnType<typeof useCreateRecordChangeMutation>;
export type CreateRecordChangeMutationResult = Apollo.MutationResult<CreateRecordChangeMutation>;
export type CreateRecordChangeMutationOptions = Apollo.BaseMutationOptions<CreateRecordChangeMutation, CreateRecordChangeMutationVariables>;
export const SingleTeamDocument = gql`
    query SingleTeam($ID: Int!) {
  Team(ID: $ID) {
    ...TeamScalars
  }
}
    ${TeamScalarsFragmentDoc}`;

/**
 * __useSingleTeamQuery__
 *
 * To run a query within a React component, call `useSingleTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTeamQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTeamQuery(baseOptions: Apollo.QueryHookOptions<SingleTeamQuery, SingleTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTeamQuery, SingleTeamQueryVariables>(SingleTeamDocument, options);
      }
export function useSingleTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTeamQuery, SingleTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTeamQuery, SingleTeamQueryVariables>(SingleTeamDocument, options);
        }
export type SingleTeamQueryHookResult = ReturnType<typeof useSingleTeamQuery>;
export type SingleTeamLazyQueryHookResult = ReturnType<typeof useSingleTeamLazyQuery>;
export type SingleTeamQueryResult = Apollo.QueryResult<SingleTeamQuery, SingleTeamQueryVariables>;
export const SingleTeamFullDocument = gql`
    query SingleTeamFull($ID: Int!) {
  Team(ID: $ID) {
    ...TeamScalars
  }
}
    ${TeamScalarsFragmentDoc}`;

/**
 * __useSingleTeamFullQuery__
 *
 * To run a query within a React component, call `useSingleTeamFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTeamFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTeamFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTeamFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTeamFullQuery, SingleTeamFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTeamFullQuery, SingleTeamFullQueryVariables>(SingleTeamFullDocument, options);
      }
export function useSingleTeamFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTeamFullQuery, SingleTeamFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTeamFullQuery, SingleTeamFullQueryVariables>(SingleTeamFullDocument, options);
        }
export type SingleTeamFullQueryHookResult = ReturnType<typeof useSingleTeamFullQuery>;
export type SingleTeamFullLazyQueryHookResult = ReturnType<typeof useSingleTeamFullLazyQuery>;
export type SingleTeamFullQueryResult = Apollo.QueryResult<SingleTeamFullQuery, SingleTeamFullQueryVariables>;
export const AllLatestMetadataUpdatesDocument = gql`
    query AllLatestMetadataUpdates {
  AllLatestMetadataUpdates {
    ...TeamScalars
  }
}
    ${TeamScalarsFragmentDoc}`;

/**
 * __useAllLatestMetadataUpdatesQuery__
 *
 * To run a query within a React component, call `useAllLatestMetadataUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLatestMetadataUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLatestMetadataUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLatestMetadataUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<AllLatestMetadataUpdatesQuery, AllLatestMetadataUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLatestMetadataUpdatesQuery, AllLatestMetadataUpdatesQueryVariables>(AllLatestMetadataUpdatesDocument, options);
      }
export function useAllLatestMetadataUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLatestMetadataUpdatesQuery, AllLatestMetadataUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLatestMetadataUpdatesQuery, AllLatestMetadataUpdatesQueryVariables>(AllLatestMetadataUpdatesDocument, options);
        }
export type AllLatestMetadataUpdatesQueryHookResult = ReturnType<typeof useAllLatestMetadataUpdatesQuery>;
export type AllLatestMetadataUpdatesLazyQueryHookResult = ReturnType<typeof useAllLatestMetadataUpdatesLazyQuery>;
export type AllLatestMetadataUpdatesQueryResult = Apollo.QueryResult<AllLatestMetadataUpdatesQuery, AllLatestMetadataUpdatesQueryVariables>;
export const SingleUserRoleDocument = gql`
    query SingleUserRole($ID: Int!) {
  UserRole(ID: $ID) {
    ...UserRoleScalars
  }
}
    ${UserRoleScalarsFragmentDoc}`;

/**
 * __useSingleUserRoleQuery__
 *
 * To run a query within a React component, call `useSingleUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserRoleQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserRoleQuery(baseOptions: Apollo.QueryHookOptions<SingleUserRoleQuery, SingleUserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserRoleQuery, SingleUserRoleQueryVariables>(SingleUserRoleDocument, options);
      }
export function useSingleUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserRoleQuery, SingleUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserRoleQuery, SingleUserRoleQueryVariables>(SingleUserRoleDocument, options);
        }
export type SingleUserRoleQueryHookResult = ReturnType<typeof useSingleUserRoleQuery>;
export type SingleUserRoleLazyQueryHookResult = ReturnType<typeof useSingleUserRoleLazyQuery>;
export type SingleUserRoleQueryResult = Apollo.QueryResult<SingleUserRoleQuery, SingleUserRoleQueryVariables>;
export const SingleUserRoleFullDocument = gql`
    query SingleUserRoleFull($ID: Int!) {
  UserRole(ID: $ID) {
    ...UserRoleScalars
  }
}
    ${UserRoleScalarsFragmentDoc}`;

/**
 * __useSingleUserRoleFullQuery__
 *
 * To run a query within a React component, call `useSingleUserRoleFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleUserRoleFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleUserRoleFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleUserRoleFullQuery(baseOptions: Apollo.QueryHookOptions<SingleUserRoleFullQuery, SingleUserRoleFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleUserRoleFullQuery, SingleUserRoleFullQueryVariables>(SingleUserRoleFullDocument, options);
      }
export function useSingleUserRoleFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleUserRoleFullQuery, SingleUserRoleFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleUserRoleFullQuery, SingleUserRoleFullQueryVariables>(SingleUserRoleFullDocument, options);
        }
export type SingleUserRoleFullQueryHookResult = ReturnType<typeof useSingleUserRoleFullQuery>;
export type SingleUserRoleFullLazyQueryHookResult = ReturnType<typeof useSingleUserRoleFullLazyQuery>;
export type SingleUserRoleFullQueryResult = Apollo.QueryResult<SingleUserRoleFullQuery, SingleUserRoleFullQueryVariables>;
export const AllUserRolesDocument = gql`
    query AllUserRoles {
  AllUserRoles {
    ...UserRoleScalars
  }
}
    ${UserRoleScalarsFragmentDoc}`;

/**
 * __useAllUserRolesQuery__
 *
 * To run a query within a React component, call `useAllUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllUserRolesQuery, AllUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserRolesQuery, AllUserRolesQueryVariables>(AllUserRolesDocument, options);
      }
export function useAllUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserRolesQuery, AllUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserRolesQuery, AllUserRolesQueryVariables>(AllUserRolesDocument, options);
        }
export type AllUserRolesQueryHookResult = ReturnType<typeof useAllUserRolesQuery>;
export type AllUserRolesLazyQueryHookResult = ReturnType<typeof useAllUserRolesLazyQuery>;
export type AllUserRolesQueryResult = Apollo.QueryResult<AllUserRolesQuery, AllUserRolesQueryVariables>;
export const SingleRowLevelSecurityFilterDocument = gql`
    query SingleRowLevelSecurityFilter($ID: Int!) {
  RowLevelSecurityFilter(ID: $ID) {
    ...RowLevelSecurityFilterScalars
  }
}
    ${RowLevelSecurityFilterScalarsFragmentDoc}`;

/**
 * __useSingleRowLevelSecurityFilterQuery__
 *
 * To run a query within a React component, call `useSingleRowLevelSecurityFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRowLevelSecurityFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRowLevelSecurityFilterQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleRowLevelSecurityFilterQuery(baseOptions: Apollo.QueryHookOptions<SingleRowLevelSecurityFilterQuery, SingleRowLevelSecurityFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRowLevelSecurityFilterQuery, SingleRowLevelSecurityFilterQueryVariables>(SingleRowLevelSecurityFilterDocument, options);
      }
export function useSingleRowLevelSecurityFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRowLevelSecurityFilterQuery, SingleRowLevelSecurityFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRowLevelSecurityFilterQuery, SingleRowLevelSecurityFilterQueryVariables>(SingleRowLevelSecurityFilterDocument, options);
        }
export type SingleRowLevelSecurityFilterQueryHookResult = ReturnType<typeof useSingleRowLevelSecurityFilterQuery>;
export type SingleRowLevelSecurityFilterLazyQueryHookResult = ReturnType<typeof useSingleRowLevelSecurityFilterLazyQuery>;
export type SingleRowLevelSecurityFilterQueryResult = Apollo.QueryResult<SingleRowLevelSecurityFilterQuery, SingleRowLevelSecurityFilterQueryVariables>;
export const SingleRowLevelSecurityFilterFullDocument = gql`
    query SingleRowLevelSecurityFilterFull($ID: Int!) {
  RowLevelSecurityFilter(ID: $ID) {
    ...RowLevelSecurityFilterScalars
  }
}
    ${RowLevelSecurityFilterScalarsFragmentDoc}`;

/**
 * __useSingleRowLevelSecurityFilterFullQuery__
 *
 * To run a query within a React component, call `useSingleRowLevelSecurityFilterFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRowLevelSecurityFilterFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRowLevelSecurityFilterFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleRowLevelSecurityFilterFullQuery(baseOptions: Apollo.QueryHookOptions<SingleRowLevelSecurityFilterFullQuery, SingleRowLevelSecurityFilterFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRowLevelSecurityFilterFullQuery, SingleRowLevelSecurityFilterFullQueryVariables>(SingleRowLevelSecurityFilterFullDocument, options);
      }
export function useSingleRowLevelSecurityFilterFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRowLevelSecurityFilterFullQuery, SingleRowLevelSecurityFilterFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRowLevelSecurityFilterFullQuery, SingleRowLevelSecurityFilterFullQueryVariables>(SingleRowLevelSecurityFilterFullDocument, options);
        }
export type SingleRowLevelSecurityFilterFullQueryHookResult = ReturnType<typeof useSingleRowLevelSecurityFilterFullQuery>;
export type SingleRowLevelSecurityFilterFullLazyQueryHookResult = ReturnType<typeof useSingleRowLevelSecurityFilterFullLazyQuery>;
export type SingleRowLevelSecurityFilterFullQueryResult = Apollo.QueryResult<SingleRowLevelSecurityFilterFullQuery, SingleRowLevelSecurityFilterFullQueryVariables>;
export const AllRowLevelSecurityFiltersDocument = gql`
    query AllRowLevelSecurityFilters {
  AllRowLevelSecurityFilters {
    ...RowLevelSecurityFilterScalars
  }
}
    ${RowLevelSecurityFilterScalarsFragmentDoc}`;

/**
 * __useAllRowLevelSecurityFiltersQuery__
 *
 * To run a query within a React component, call `useAllRowLevelSecurityFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRowLevelSecurityFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRowLevelSecurityFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRowLevelSecurityFiltersQuery(baseOptions?: Apollo.QueryHookOptions<AllRowLevelSecurityFiltersQuery, AllRowLevelSecurityFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRowLevelSecurityFiltersQuery, AllRowLevelSecurityFiltersQueryVariables>(AllRowLevelSecurityFiltersDocument, options);
      }
export function useAllRowLevelSecurityFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRowLevelSecurityFiltersQuery, AllRowLevelSecurityFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRowLevelSecurityFiltersQuery, AllRowLevelSecurityFiltersQueryVariables>(AllRowLevelSecurityFiltersDocument, options);
        }
export type AllRowLevelSecurityFiltersQueryHookResult = ReturnType<typeof useAllRowLevelSecurityFiltersQuery>;
export type AllRowLevelSecurityFiltersLazyQueryHookResult = ReturnType<typeof useAllRowLevelSecurityFiltersLazyQuery>;
export type AllRowLevelSecurityFiltersQueryResult = Apollo.QueryResult<AllRowLevelSecurityFiltersQuery, AllRowLevelSecurityFiltersQueryVariables>;
export const SingleAuditLogDocument = gql`
    query SingleAuditLog($ID: Int!) {
  AuditLog(ID: $ID) {
    ...AuditLogScalars
  }
}
    ${AuditLogScalarsFragmentDoc}`;

/**
 * __useSingleAuditLogQuery__
 *
 * To run a query within a React component, call `useSingleAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuditLogQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuditLogQuery(baseOptions: Apollo.QueryHookOptions<SingleAuditLogQuery, SingleAuditLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuditLogQuery, SingleAuditLogQueryVariables>(SingleAuditLogDocument, options);
      }
export function useSingleAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuditLogQuery, SingleAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuditLogQuery, SingleAuditLogQueryVariables>(SingleAuditLogDocument, options);
        }
export type SingleAuditLogQueryHookResult = ReturnType<typeof useSingleAuditLogQuery>;
export type SingleAuditLogLazyQueryHookResult = ReturnType<typeof useSingleAuditLogLazyQuery>;
export type SingleAuditLogQueryResult = Apollo.QueryResult<SingleAuditLogQuery, SingleAuditLogQueryVariables>;
export const SingleAuditLogFullDocument = gql`
    query SingleAuditLogFull($ID: Int!) {
  AuditLog(ID: $ID) {
    ...AuditLogScalars
  }
}
    ${AuditLogScalarsFragmentDoc}`;

/**
 * __useSingleAuditLogFullQuery__
 *
 * To run a query within a React component, call `useSingleAuditLogFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuditLogFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuditLogFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuditLogFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAuditLogFullQuery, SingleAuditLogFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuditLogFullQuery, SingleAuditLogFullQueryVariables>(SingleAuditLogFullDocument, options);
      }
export function useSingleAuditLogFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuditLogFullQuery, SingleAuditLogFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuditLogFullQuery, SingleAuditLogFullQueryVariables>(SingleAuditLogFullDocument, options);
        }
export type SingleAuditLogFullQueryHookResult = ReturnType<typeof useSingleAuditLogFullQuery>;
export type SingleAuditLogFullLazyQueryHookResult = ReturnType<typeof useSingleAuditLogFullLazyQuery>;
export type SingleAuditLogFullQueryResult = Apollo.QueryResult<SingleAuditLogFullQuery, SingleAuditLogFullQueryVariables>;
export const CreateAuditLogDocument = gql`
    mutation CreateAuditLog($input: CreateAuditLogInput!) {
  CreateAuditLog(input: $input) {
    ...AuditLogScalars
  }
}
    ${AuditLogScalarsFragmentDoc}`;
export type CreateAuditLogMutationFn = Apollo.MutationFunction<CreateAuditLogMutation, CreateAuditLogMutationVariables>;

/**
 * __useCreateAuditLogMutation__
 *
 * To run a mutation, you first call `useCreateAuditLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuditLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuditLogMutation, { data, loading, error }] = useCreateAuditLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuditLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuditLogMutation, CreateAuditLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuditLogMutation, CreateAuditLogMutationVariables>(CreateAuditLogDocument, options);
      }
export type CreateAuditLogMutationHookResult = ReturnType<typeof useCreateAuditLogMutation>;
export type CreateAuditLogMutationResult = Apollo.MutationResult<CreateAuditLogMutation>;
export type CreateAuditLogMutationOptions = Apollo.BaseMutationOptions<CreateAuditLogMutation, CreateAuditLogMutationVariables>;
export const UpdateAuditLogDocument = gql`
    mutation UpdateAuditLog($input: UpdateAuditLogInput!) {
  UpdateAuditLog(input: $input) {
    ...AuditLogScalars
  }
}
    ${AuditLogScalarsFragmentDoc}`;
export type UpdateAuditLogMutationFn = Apollo.MutationFunction<UpdateAuditLogMutation, UpdateAuditLogMutationVariables>;

/**
 * __useUpdateAuditLogMutation__
 *
 * To run a mutation, you first call `useUpdateAuditLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuditLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuditLogMutation, { data, loading, error }] = useUpdateAuditLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuditLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuditLogMutation, UpdateAuditLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuditLogMutation, UpdateAuditLogMutationVariables>(UpdateAuditLogDocument, options);
      }
export type UpdateAuditLogMutationHookResult = ReturnType<typeof useUpdateAuditLogMutation>;
export type UpdateAuditLogMutationResult = Apollo.MutationResult<UpdateAuditLogMutation>;
export type UpdateAuditLogMutationOptions = Apollo.BaseMutationOptions<UpdateAuditLogMutation, UpdateAuditLogMutationVariables>;
export const SingleAuthorizationDocument = gql`
    query SingleAuthorization($ID: Int!) {
  Authorization(ID: $ID) {
    ...AuthorizationScalars
  }
}
    ${AuthorizationScalarsFragmentDoc}`;

/**
 * __useSingleAuthorizationQuery__
 *
 * To run a query within a React component, call `useSingleAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuthorizationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<SingleAuthorizationQuery, SingleAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuthorizationQuery, SingleAuthorizationQueryVariables>(SingleAuthorizationDocument, options);
      }
export function useSingleAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuthorizationQuery, SingleAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuthorizationQuery, SingleAuthorizationQueryVariables>(SingleAuthorizationDocument, options);
        }
export type SingleAuthorizationQueryHookResult = ReturnType<typeof useSingleAuthorizationQuery>;
export type SingleAuthorizationLazyQueryHookResult = ReturnType<typeof useSingleAuthorizationLazyQuery>;
export type SingleAuthorizationQueryResult = Apollo.QueryResult<SingleAuthorizationQuery, SingleAuthorizationQueryVariables>;
export const SingleAuthorizationFullDocument = gql`
    query SingleAuthorizationFull($ID: Int!) {
  Authorization(ID: $ID) {
    ...AuthorizationScalars
    AuthorizationRoles {
      ...AuthorizationRoleScalars
    }
  }
}
    ${AuthorizationScalarsFragmentDoc}
${AuthorizationRoleScalarsFragmentDoc}`;

/**
 * __useSingleAuthorizationFullQuery__
 *
 * To run a query within a React component, call `useSingleAuthorizationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuthorizationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuthorizationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuthorizationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAuthorizationFullQuery, SingleAuthorizationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuthorizationFullQuery, SingleAuthorizationFullQueryVariables>(SingleAuthorizationFullDocument, options);
      }
export function useSingleAuthorizationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuthorizationFullQuery, SingleAuthorizationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuthorizationFullQuery, SingleAuthorizationFullQueryVariables>(SingleAuthorizationFullDocument, options);
        }
export type SingleAuthorizationFullQueryHookResult = ReturnType<typeof useSingleAuthorizationFullQuery>;
export type SingleAuthorizationFullLazyQueryHookResult = ReturnType<typeof useSingleAuthorizationFullLazyQuery>;
export type SingleAuthorizationFullQueryResult = Apollo.QueryResult<SingleAuthorizationFullQuery, SingleAuthorizationFullQueryVariables>;
export const AllAuthorizationsDocument = gql`
    query AllAuthorizations {
  AllAuthorizations {
    ...AuthorizationScalars
  }
}
    ${AuthorizationScalarsFragmentDoc}`;

/**
 * __useAllAuthorizationsQuery__
 *
 * To run a query within a React component, call `useAllAuthorizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuthorizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuthorizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAuthorizationsQuery(baseOptions?: Apollo.QueryHookOptions<AllAuthorizationsQuery, AllAuthorizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAuthorizationsQuery, AllAuthorizationsQueryVariables>(AllAuthorizationsDocument, options);
      }
export function useAllAuthorizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAuthorizationsQuery, AllAuthorizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAuthorizationsQuery, AllAuthorizationsQueryVariables>(AllAuthorizationsDocument, options);
        }
export type AllAuthorizationsQueryHookResult = ReturnType<typeof useAllAuthorizationsQuery>;
export type AllAuthorizationsLazyQueryHookResult = ReturnType<typeof useAllAuthorizationsLazyQuery>;
export type AllAuthorizationsQueryResult = Apollo.QueryResult<AllAuthorizationsQuery, AllAuthorizationsQueryVariables>;
export const SingleAuthorizationRoleDocument = gql`
    query SingleAuthorizationRole($ID: Int!) {
  AuthorizationRole(ID: $ID) {
    ...AuthorizationRoleScalars
  }
}
    ${AuthorizationRoleScalarsFragmentDoc}`;

/**
 * __useSingleAuthorizationRoleQuery__
 *
 * To run a query within a React component, call `useSingleAuthorizationRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuthorizationRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuthorizationRoleQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuthorizationRoleQuery(baseOptions: Apollo.QueryHookOptions<SingleAuthorizationRoleQuery, SingleAuthorizationRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuthorizationRoleQuery, SingleAuthorizationRoleQueryVariables>(SingleAuthorizationRoleDocument, options);
      }
export function useSingleAuthorizationRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuthorizationRoleQuery, SingleAuthorizationRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuthorizationRoleQuery, SingleAuthorizationRoleQueryVariables>(SingleAuthorizationRoleDocument, options);
        }
export type SingleAuthorizationRoleQueryHookResult = ReturnType<typeof useSingleAuthorizationRoleQuery>;
export type SingleAuthorizationRoleLazyQueryHookResult = ReturnType<typeof useSingleAuthorizationRoleLazyQuery>;
export type SingleAuthorizationRoleQueryResult = Apollo.QueryResult<SingleAuthorizationRoleQuery, SingleAuthorizationRoleQueryVariables>;
export const SingleAuthorizationRoleFullDocument = gql`
    query SingleAuthorizationRoleFull($ID: Int!) {
  AuthorizationRole(ID: $ID) {
    ...AuthorizationRoleScalars
  }
}
    ${AuthorizationRoleScalarsFragmentDoc}`;

/**
 * __useSingleAuthorizationRoleFullQuery__
 *
 * To run a query within a React component, call `useSingleAuthorizationRoleFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuthorizationRoleFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuthorizationRoleFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuthorizationRoleFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAuthorizationRoleFullQuery, SingleAuthorizationRoleFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuthorizationRoleFullQuery, SingleAuthorizationRoleFullQueryVariables>(SingleAuthorizationRoleFullDocument, options);
      }
export function useSingleAuthorizationRoleFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuthorizationRoleFullQuery, SingleAuthorizationRoleFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuthorizationRoleFullQuery, SingleAuthorizationRoleFullQueryVariables>(SingleAuthorizationRoleFullDocument, options);
        }
export type SingleAuthorizationRoleFullQueryHookResult = ReturnType<typeof useSingleAuthorizationRoleFullQuery>;
export type SingleAuthorizationRoleFullLazyQueryHookResult = ReturnType<typeof useSingleAuthorizationRoleFullLazyQuery>;
export type SingleAuthorizationRoleFullQueryResult = Apollo.QueryResult<SingleAuthorizationRoleFullQuery, SingleAuthorizationRoleFullQueryVariables>;
export const AllAuthorizationRolesDocument = gql`
    query AllAuthorizationRoles {
  AllAuthorizationRoles {
    ...AuthorizationRoleScalars
  }
}
    ${AuthorizationRoleScalarsFragmentDoc}`;

/**
 * __useAllAuthorizationRolesQuery__
 *
 * To run a query within a React component, call `useAllAuthorizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuthorizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuthorizationRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAuthorizationRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllAuthorizationRolesQuery, AllAuthorizationRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAuthorizationRolesQuery, AllAuthorizationRolesQueryVariables>(AllAuthorizationRolesDocument, options);
      }
export function useAllAuthorizationRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAuthorizationRolesQuery, AllAuthorizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAuthorizationRolesQuery, AllAuthorizationRolesQueryVariables>(AllAuthorizationRolesDocument, options);
        }
export type AllAuthorizationRolesQueryHookResult = ReturnType<typeof useAllAuthorizationRolesQuery>;
export type AllAuthorizationRolesLazyQueryHookResult = ReturnType<typeof useAllAuthorizationRolesLazyQuery>;
export type AllAuthorizationRolesQueryResult = Apollo.QueryResult<AllAuthorizationRolesQuery, AllAuthorizationRolesQueryVariables>;
export const SingleAuditLogTypeDocument = gql`
    query SingleAuditLogType($ID: Int!) {
  AuditLogType(ID: $ID) {
    ...AuditLogTypeScalars
  }
}
    ${AuditLogTypeScalarsFragmentDoc}`;

/**
 * __useSingleAuditLogTypeQuery__
 *
 * To run a query within a React component, call `useSingleAuditLogTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuditLogTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuditLogTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuditLogTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleAuditLogTypeQuery, SingleAuditLogTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuditLogTypeQuery, SingleAuditLogTypeQueryVariables>(SingleAuditLogTypeDocument, options);
      }
export function useSingleAuditLogTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuditLogTypeQuery, SingleAuditLogTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuditLogTypeQuery, SingleAuditLogTypeQueryVariables>(SingleAuditLogTypeDocument, options);
        }
export type SingleAuditLogTypeQueryHookResult = ReturnType<typeof useSingleAuditLogTypeQuery>;
export type SingleAuditLogTypeLazyQueryHookResult = ReturnType<typeof useSingleAuditLogTypeLazyQuery>;
export type SingleAuditLogTypeQueryResult = Apollo.QueryResult<SingleAuditLogTypeQuery, SingleAuditLogTypeQueryVariables>;
export const SingleAuditLogTypeFullDocument = gql`
    query SingleAuditLogTypeFull($ID: Int!) {
  AuditLogType(ID: $ID) {
    ...AuditLogTypeScalars
  }
}
    ${AuditLogTypeScalarsFragmentDoc}`;

/**
 * __useSingleAuditLogTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleAuditLogTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAuditLogTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAuditLogTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAuditLogTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAuditLogTypeFullQuery, SingleAuditLogTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAuditLogTypeFullQuery, SingleAuditLogTypeFullQueryVariables>(SingleAuditLogTypeFullDocument, options);
      }
export function useSingleAuditLogTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAuditLogTypeFullQuery, SingleAuditLogTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAuditLogTypeFullQuery, SingleAuditLogTypeFullQueryVariables>(SingleAuditLogTypeFullDocument, options);
        }
export type SingleAuditLogTypeFullQueryHookResult = ReturnType<typeof useSingleAuditLogTypeFullQuery>;
export type SingleAuditLogTypeFullLazyQueryHookResult = ReturnType<typeof useSingleAuditLogTypeFullLazyQuery>;
export type SingleAuditLogTypeFullQueryResult = Apollo.QueryResult<SingleAuditLogTypeFullQuery, SingleAuditLogTypeFullQueryVariables>;
export const AllAuditLogTypesDocument = gql`
    query AllAuditLogTypes {
  AllAuditLogTypes {
    ...AuditLogTypeScalars
  }
}
    ${AuditLogTypeScalarsFragmentDoc}`;

/**
 * __useAllAuditLogTypesQuery__
 *
 * To run a query within a React component, call `useAllAuditLogTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuditLogTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuditLogTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAuditLogTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllAuditLogTypesQuery, AllAuditLogTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAuditLogTypesQuery, AllAuditLogTypesQueryVariables>(AllAuditLogTypesDocument, options);
      }
export function useAllAuditLogTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAuditLogTypesQuery, AllAuditLogTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAuditLogTypesQuery, AllAuditLogTypesQueryVariables>(AllAuditLogTypesDocument, options);
        }
export type AllAuditLogTypesQueryHookResult = ReturnType<typeof useAllAuditLogTypesQuery>;
export type AllAuditLogTypesLazyQueryHookResult = ReturnType<typeof useAllAuditLogTypesLazyQuery>;
export type AllAuditLogTypesQueryResult = Apollo.QueryResult<AllAuditLogTypesQuery, AllAuditLogTypesQueryVariables>;
export const SingleEntityFieldValueDocument = gql`
    query SingleEntityFieldValue($ID: Int!) {
  EntityFieldValue(ID: $ID) {
    ...EntityFieldValueScalars
  }
}
    ${EntityFieldValueScalarsFragmentDoc}`;

/**
 * __useSingleEntityFieldValueQuery__
 *
 * To run a query within a React component, call `useSingleEntityFieldValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityFieldValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityFieldValueQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityFieldValueQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityFieldValueQuery, SingleEntityFieldValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityFieldValueQuery, SingleEntityFieldValueQueryVariables>(SingleEntityFieldValueDocument, options);
      }
export function useSingleEntityFieldValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityFieldValueQuery, SingleEntityFieldValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityFieldValueQuery, SingleEntityFieldValueQueryVariables>(SingleEntityFieldValueDocument, options);
        }
export type SingleEntityFieldValueQueryHookResult = ReturnType<typeof useSingleEntityFieldValueQuery>;
export type SingleEntityFieldValueLazyQueryHookResult = ReturnType<typeof useSingleEntityFieldValueLazyQuery>;
export type SingleEntityFieldValueQueryResult = Apollo.QueryResult<SingleEntityFieldValueQuery, SingleEntityFieldValueQueryVariables>;
export const SingleEntityFieldValueFullDocument = gql`
    query SingleEntityFieldValueFull($ID: Int!) {
  EntityFieldValue(ID: $ID) {
    ...EntityFieldValueScalars
  }
}
    ${EntityFieldValueScalarsFragmentDoc}`;

/**
 * __useSingleEntityFieldValueFullQuery__
 *
 * To run a query within a React component, call `useSingleEntityFieldValueFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityFieldValueFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityFieldValueFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityFieldValueFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityFieldValueFullQuery, SingleEntityFieldValueFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityFieldValueFullQuery, SingleEntityFieldValueFullQueryVariables>(SingleEntityFieldValueFullDocument, options);
      }
export function useSingleEntityFieldValueFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityFieldValueFullQuery, SingleEntityFieldValueFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityFieldValueFullQuery, SingleEntityFieldValueFullQueryVariables>(SingleEntityFieldValueFullDocument, options);
        }
export type SingleEntityFieldValueFullQueryHookResult = ReturnType<typeof useSingleEntityFieldValueFullQuery>;
export type SingleEntityFieldValueFullLazyQueryHookResult = ReturnType<typeof useSingleEntityFieldValueFullLazyQuery>;
export type SingleEntityFieldValueFullQueryResult = Apollo.QueryResult<SingleEntityFieldValueFullQuery, SingleEntityFieldValueFullQueryVariables>;
export const SingleTaxReturnDocument = gql`
    query SingleTaxReturn($ID: Int!) {
  TaxReturn(ID: $ID) {
    ...TaxReturnScalars
  }
}
    ${TaxReturnScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnQuery, SingleTaxReturnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnQuery, SingleTaxReturnQueryVariables>(SingleTaxReturnDocument, options);
      }
export function useSingleTaxReturnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnQuery, SingleTaxReturnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnQuery, SingleTaxReturnQueryVariables>(SingleTaxReturnDocument, options);
        }
export type SingleTaxReturnQueryHookResult = ReturnType<typeof useSingleTaxReturnQuery>;
export type SingleTaxReturnLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnLazyQuery>;
export type SingleTaxReturnQueryResult = Apollo.QueryResult<SingleTaxReturnQuery, SingleTaxReturnQueryVariables>;
export const SingleTaxReturnFullDocument = gql`
    query SingleTaxReturnFull($ID: Int!) {
  TaxReturn(ID: $ID) {
    ...TaxReturnScalars
    TaxReturnDetails {
      ...TaxReturnDetailScalars
    }
    TaxReturnCompensation {
      ...TaxReturnCompensationScalars
    }
    TaxReturnContractors {
      ...TaxReturnContractorScalars
    }
  }
}
    ${TaxReturnScalarsFragmentDoc}
${TaxReturnDetailScalarsFragmentDoc}
${TaxReturnCompensationScalarsFragmentDoc}
${TaxReturnContractorScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnFullQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnFullQuery, SingleTaxReturnFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnFullQuery, SingleTaxReturnFullQueryVariables>(SingleTaxReturnFullDocument, options);
      }
export function useSingleTaxReturnFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnFullQuery, SingleTaxReturnFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnFullQuery, SingleTaxReturnFullQueryVariables>(SingleTaxReturnFullDocument, options);
        }
export type SingleTaxReturnFullQueryHookResult = ReturnType<typeof useSingleTaxReturnFullQuery>;
export type SingleTaxReturnFullLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnFullLazyQuery>;
export type SingleTaxReturnFullQueryResult = Apollo.QueryResult<SingleTaxReturnFullQuery, SingleTaxReturnFullQueryVariables>;
export const CreateTaxReturnDocument = gql`
    mutation CreateTaxReturn($input: CreateTaxReturnInput!) {
  CreateTaxReturn(input: $input) {
    ...TaxReturnScalars
  }
}
    ${TaxReturnScalarsFragmentDoc}`;
export type CreateTaxReturnMutationFn = Apollo.MutationFunction<CreateTaxReturnMutation, CreateTaxReturnMutationVariables>;

/**
 * __useCreateTaxReturnMutation__
 *
 * To run a mutation, you first call `useCreateTaxReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxReturnMutation, { data, loading, error }] = useCreateTaxReturnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaxReturnMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxReturnMutation, CreateTaxReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxReturnMutation, CreateTaxReturnMutationVariables>(CreateTaxReturnDocument, options);
      }
export type CreateTaxReturnMutationHookResult = ReturnType<typeof useCreateTaxReturnMutation>;
export type CreateTaxReturnMutationResult = Apollo.MutationResult<CreateTaxReturnMutation>;
export type CreateTaxReturnMutationOptions = Apollo.BaseMutationOptions<CreateTaxReturnMutation, CreateTaxReturnMutationVariables>;
export const UpdateTaxReturnDocument = gql`
    mutation UpdateTaxReturn($input: UpdateTaxReturnInput!) {
  UpdateTaxReturn(input: $input) {
    ...TaxReturnScalars
  }
}
    ${TaxReturnScalarsFragmentDoc}`;
export type UpdateTaxReturnMutationFn = Apollo.MutationFunction<UpdateTaxReturnMutation, UpdateTaxReturnMutationVariables>;

/**
 * __useUpdateTaxReturnMutation__
 *
 * To run a mutation, you first call `useUpdateTaxReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxReturnMutation, { data, loading, error }] = useUpdateTaxReturnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaxReturnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxReturnMutation, UpdateTaxReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxReturnMutation, UpdateTaxReturnMutationVariables>(UpdateTaxReturnDocument, options);
      }
export type UpdateTaxReturnMutationHookResult = ReturnType<typeof useUpdateTaxReturnMutation>;
export type UpdateTaxReturnMutationResult = Apollo.MutationResult<UpdateTaxReturnMutation>;
export type UpdateTaxReturnMutationOptions = Apollo.BaseMutationOptions<UpdateTaxReturnMutation, UpdateTaxReturnMutationVariables>;
export const SingleTaxReturnDetailDocument = gql`
    query SingleTaxReturnDetail($ID: Int!) {
  TaxReturnDetail(ID: $ID) {
    ...TaxReturnDetailScalars
  }
}
    ${TaxReturnDetailScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnDetailQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnDetailQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnDetailQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnDetailQuery, SingleTaxReturnDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnDetailQuery, SingleTaxReturnDetailQueryVariables>(SingleTaxReturnDetailDocument, options);
      }
export function useSingleTaxReturnDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnDetailQuery, SingleTaxReturnDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnDetailQuery, SingleTaxReturnDetailQueryVariables>(SingleTaxReturnDetailDocument, options);
        }
export type SingleTaxReturnDetailQueryHookResult = ReturnType<typeof useSingleTaxReturnDetailQuery>;
export type SingleTaxReturnDetailLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnDetailLazyQuery>;
export type SingleTaxReturnDetailQueryResult = Apollo.QueryResult<SingleTaxReturnDetailQuery, SingleTaxReturnDetailQueryVariables>;
export const SingleTaxReturnDetailFullDocument = gql`
    query SingleTaxReturnDetailFull($ID: Int!) {
  TaxReturnDetail(ID: $ID) {
    ...TaxReturnDetailScalars
  }
}
    ${TaxReturnDetailScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnDetailFullQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnDetailFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnDetailFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnDetailFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnDetailFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnDetailFullQuery, SingleTaxReturnDetailFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnDetailFullQuery, SingleTaxReturnDetailFullQueryVariables>(SingleTaxReturnDetailFullDocument, options);
      }
export function useSingleTaxReturnDetailFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnDetailFullQuery, SingleTaxReturnDetailFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnDetailFullQuery, SingleTaxReturnDetailFullQueryVariables>(SingleTaxReturnDetailFullDocument, options);
        }
export type SingleTaxReturnDetailFullQueryHookResult = ReturnType<typeof useSingleTaxReturnDetailFullQuery>;
export type SingleTaxReturnDetailFullLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnDetailFullLazyQuery>;
export type SingleTaxReturnDetailFullQueryResult = Apollo.QueryResult<SingleTaxReturnDetailFullQuery, SingleTaxReturnDetailFullQueryVariables>;
export const CreateTaxReturnDetailDocument = gql`
    mutation CreateTaxReturnDetail($input: CreateTaxReturnDetailInput!) {
  CreateTaxReturnDetail(input: $input) {
    ...TaxReturnDetailScalars
  }
}
    ${TaxReturnDetailScalarsFragmentDoc}`;
export type CreateTaxReturnDetailMutationFn = Apollo.MutationFunction<CreateTaxReturnDetailMutation, CreateTaxReturnDetailMutationVariables>;

/**
 * __useCreateTaxReturnDetailMutation__
 *
 * To run a mutation, you first call `useCreateTaxReturnDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxReturnDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxReturnDetailMutation, { data, loading, error }] = useCreateTaxReturnDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaxReturnDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxReturnDetailMutation, CreateTaxReturnDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxReturnDetailMutation, CreateTaxReturnDetailMutationVariables>(CreateTaxReturnDetailDocument, options);
      }
export type CreateTaxReturnDetailMutationHookResult = ReturnType<typeof useCreateTaxReturnDetailMutation>;
export type CreateTaxReturnDetailMutationResult = Apollo.MutationResult<CreateTaxReturnDetailMutation>;
export type CreateTaxReturnDetailMutationOptions = Apollo.BaseMutationOptions<CreateTaxReturnDetailMutation, CreateTaxReturnDetailMutationVariables>;
export const SingleTaxReturnCompensationDocument = gql`
    query SingleTaxReturnCompensation($ID: Int!) {
  TaxReturnCompensation(ID: $ID) {
    ...TaxReturnCompensationScalars
  }
}
    ${TaxReturnCompensationScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnCompensationQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnCompensationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnCompensationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnCompensationQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnCompensationQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnCompensationQuery, SingleTaxReturnCompensationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnCompensationQuery, SingleTaxReturnCompensationQueryVariables>(SingleTaxReturnCompensationDocument, options);
      }
export function useSingleTaxReturnCompensationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnCompensationQuery, SingleTaxReturnCompensationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnCompensationQuery, SingleTaxReturnCompensationQueryVariables>(SingleTaxReturnCompensationDocument, options);
        }
export type SingleTaxReturnCompensationQueryHookResult = ReturnType<typeof useSingleTaxReturnCompensationQuery>;
export type SingleTaxReturnCompensationLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnCompensationLazyQuery>;
export type SingleTaxReturnCompensationQueryResult = Apollo.QueryResult<SingleTaxReturnCompensationQuery, SingleTaxReturnCompensationQueryVariables>;
export const SingleTaxReturnCompensationFullDocument = gql`
    query SingleTaxReturnCompensationFull($ID: Int!) {
  TaxReturnCompensation(ID: $ID) {
    ...TaxReturnCompensationScalars
  }
}
    ${TaxReturnCompensationScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnCompensationFullQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnCompensationFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnCompensationFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnCompensationFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnCompensationFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnCompensationFullQuery, SingleTaxReturnCompensationFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnCompensationFullQuery, SingleTaxReturnCompensationFullQueryVariables>(SingleTaxReturnCompensationFullDocument, options);
      }
export function useSingleTaxReturnCompensationFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnCompensationFullQuery, SingleTaxReturnCompensationFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnCompensationFullQuery, SingleTaxReturnCompensationFullQueryVariables>(SingleTaxReturnCompensationFullDocument, options);
        }
export type SingleTaxReturnCompensationFullQueryHookResult = ReturnType<typeof useSingleTaxReturnCompensationFullQuery>;
export type SingleTaxReturnCompensationFullLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnCompensationFullLazyQuery>;
export type SingleTaxReturnCompensationFullQueryResult = Apollo.QueryResult<SingleTaxReturnCompensationFullQuery, SingleTaxReturnCompensationFullQueryVariables>;
export const CreateTaxReturnCompensationDocument = gql`
    mutation CreateTaxReturnCompensation($input: CreateTaxReturnCompensationInput!) {
  CreateTaxReturnCompensation(input: $input) {
    ...TaxReturnCompensationScalars
  }
}
    ${TaxReturnCompensationScalarsFragmentDoc}`;
export type CreateTaxReturnCompensationMutationFn = Apollo.MutationFunction<CreateTaxReturnCompensationMutation, CreateTaxReturnCompensationMutationVariables>;

/**
 * __useCreateTaxReturnCompensationMutation__
 *
 * To run a mutation, you first call `useCreateTaxReturnCompensationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxReturnCompensationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxReturnCompensationMutation, { data, loading, error }] = useCreateTaxReturnCompensationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaxReturnCompensationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxReturnCompensationMutation, CreateTaxReturnCompensationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxReturnCompensationMutation, CreateTaxReturnCompensationMutationVariables>(CreateTaxReturnCompensationDocument, options);
      }
export type CreateTaxReturnCompensationMutationHookResult = ReturnType<typeof useCreateTaxReturnCompensationMutation>;
export type CreateTaxReturnCompensationMutationResult = Apollo.MutationResult<CreateTaxReturnCompensationMutation>;
export type CreateTaxReturnCompensationMutationOptions = Apollo.BaseMutationOptions<CreateTaxReturnCompensationMutation, CreateTaxReturnCompensationMutationVariables>;
export const SingleTaxReturnContractorDocument = gql`
    query SingleTaxReturnContractor($ID: Int!) {
  TaxReturnContractor(ID: $ID) {
    ...TaxReturnContractorScalars
  }
}
    ${TaxReturnContractorScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnContractorQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnContractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnContractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnContractorQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnContractorQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnContractorQuery, SingleTaxReturnContractorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnContractorQuery, SingleTaxReturnContractorQueryVariables>(SingleTaxReturnContractorDocument, options);
      }
export function useSingleTaxReturnContractorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnContractorQuery, SingleTaxReturnContractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnContractorQuery, SingleTaxReturnContractorQueryVariables>(SingleTaxReturnContractorDocument, options);
        }
export type SingleTaxReturnContractorQueryHookResult = ReturnType<typeof useSingleTaxReturnContractorQuery>;
export type SingleTaxReturnContractorLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnContractorLazyQuery>;
export type SingleTaxReturnContractorQueryResult = Apollo.QueryResult<SingleTaxReturnContractorQuery, SingleTaxReturnContractorQueryVariables>;
export const SingleTaxReturnContractorFullDocument = gql`
    query SingleTaxReturnContractorFull($ID: Int!) {
  TaxReturnContractor(ID: $ID) {
    ...TaxReturnContractorScalars
  }
}
    ${TaxReturnContractorScalarsFragmentDoc}`;

/**
 * __useSingleTaxReturnContractorFullQuery__
 *
 * To run a query within a React component, call `useSingleTaxReturnContractorFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxReturnContractorFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxReturnContractorFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleTaxReturnContractorFullQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxReturnContractorFullQuery, SingleTaxReturnContractorFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxReturnContractorFullQuery, SingleTaxReturnContractorFullQueryVariables>(SingleTaxReturnContractorFullDocument, options);
      }
export function useSingleTaxReturnContractorFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxReturnContractorFullQuery, SingleTaxReturnContractorFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxReturnContractorFullQuery, SingleTaxReturnContractorFullQueryVariables>(SingleTaxReturnContractorFullDocument, options);
        }
export type SingleTaxReturnContractorFullQueryHookResult = ReturnType<typeof useSingleTaxReturnContractorFullQuery>;
export type SingleTaxReturnContractorFullLazyQueryHookResult = ReturnType<typeof useSingleTaxReturnContractorFullLazyQuery>;
export type SingleTaxReturnContractorFullQueryResult = Apollo.QueryResult<SingleTaxReturnContractorFullQuery, SingleTaxReturnContractorFullQueryVariables>;
export const CreateTaxReturnContractorDocument = gql`
    mutation CreateTaxReturnContractor($input: CreateTaxReturnContractorInput!) {
  CreateTaxReturnContractor(input: $input) {
    ...TaxReturnContractorScalars
  }
}
    ${TaxReturnContractorScalarsFragmentDoc}`;
export type CreateTaxReturnContractorMutationFn = Apollo.MutationFunction<CreateTaxReturnContractorMutation, CreateTaxReturnContractorMutationVariables>;

/**
 * __useCreateTaxReturnContractorMutation__
 *
 * To run a mutation, you first call `useCreateTaxReturnContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxReturnContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxReturnContractorMutation, { data, loading, error }] = useCreateTaxReturnContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaxReturnContractorMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxReturnContractorMutation, CreateTaxReturnContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxReturnContractorMutation, CreateTaxReturnContractorMutationVariables>(CreateTaxReturnContractorDocument, options);
      }
export type CreateTaxReturnContractorMutationHookResult = ReturnType<typeof useCreateTaxReturnContractorMutation>;
export type CreateTaxReturnContractorMutationResult = Apollo.MutationResult<CreateTaxReturnContractorMutation>;
export type CreateTaxReturnContractorMutationOptions = Apollo.BaseMutationOptions<CreateTaxReturnContractorMutation, CreateTaxReturnContractorMutationVariables>;
export const SingleAIModelDocument = gql`
    query SingleAIModel($ID: Int!) {
  AIModel(ID: $ID) {
    ...AIModelScalars
  }
}
    ${AIModelScalarsFragmentDoc}`;

/**
 * __useSingleAIModelQuery__
 *
 * To run a query within a React component, call `useSingleAIModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIModelQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIModelQuery(baseOptions: Apollo.QueryHookOptions<SingleAIModelQuery, SingleAIModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIModelQuery, SingleAIModelQueryVariables>(SingleAIModelDocument, options);
      }
export function useSingleAIModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIModelQuery, SingleAIModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIModelQuery, SingleAIModelQueryVariables>(SingleAIModelDocument, options);
        }
export type SingleAIModelQueryHookResult = ReturnType<typeof useSingleAIModelQuery>;
export type SingleAIModelLazyQueryHookResult = ReturnType<typeof useSingleAIModelLazyQuery>;
export type SingleAIModelQueryResult = Apollo.QueryResult<SingleAIModelQuery, SingleAIModelQueryVariables>;
export const SingleAIModelFullDocument = gql`
    query SingleAIModelFull($ID: Int!) {
  AIModel(ID: $ID) {
    ...AIModelScalars
  }
}
    ${AIModelScalarsFragmentDoc}`;

/**
 * __useSingleAIModelFullQuery__
 *
 * To run a query within a React component, call `useSingleAIModelFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIModelFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIModelFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIModelFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAIModelFullQuery, SingleAIModelFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIModelFullQuery, SingleAIModelFullQueryVariables>(SingleAIModelFullDocument, options);
      }
export function useSingleAIModelFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIModelFullQuery, SingleAIModelFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIModelFullQuery, SingleAIModelFullQueryVariables>(SingleAIModelFullDocument, options);
        }
export type SingleAIModelFullQueryHookResult = ReturnType<typeof useSingleAIModelFullQuery>;
export type SingleAIModelFullLazyQueryHookResult = ReturnType<typeof useSingleAIModelFullLazyQuery>;
export type SingleAIModelFullQueryResult = Apollo.QueryResult<SingleAIModelFullQuery, SingleAIModelFullQueryVariables>;
export const AllAIModelsDocument = gql`
    query AllAIModels {
  AllAIModels {
    ...AIModelScalars
  }
}
    ${AIModelScalarsFragmentDoc}`;

/**
 * __useAllAIModelsQuery__
 *
 * To run a query within a React component, call `useAllAIModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAIModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAIModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAIModelsQuery(baseOptions?: Apollo.QueryHookOptions<AllAIModelsQuery, AllAIModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAIModelsQuery, AllAIModelsQueryVariables>(AllAIModelsDocument, options);
      }
export function useAllAIModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAIModelsQuery, AllAIModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAIModelsQuery, AllAIModelsQueryVariables>(AllAIModelsDocument, options);
        }
export type AllAIModelsQueryHookResult = ReturnType<typeof useAllAIModelsQuery>;
export type AllAIModelsLazyQueryHookResult = ReturnType<typeof useAllAIModelsLazyQuery>;
export type AllAIModelsQueryResult = Apollo.QueryResult<AllAIModelsQuery, AllAIModelsQueryVariables>;
export const UpdateAIModelDocument = gql`
    mutation UpdateAIModel($input: UpdateAIModelInput!) {
  UpdateAIModel(input: $input) {
    ...AIModelScalars
  }
}
    ${AIModelScalarsFragmentDoc}`;
export type UpdateAIModelMutationFn = Apollo.MutationFunction<UpdateAIModelMutation, UpdateAIModelMutationVariables>;

/**
 * __useUpdateAIModelMutation__
 *
 * To run a mutation, you first call `useUpdateAIModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAIModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiModelMutation, { data, loading, error }] = useUpdateAIModelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAIModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAIModelMutation, UpdateAIModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAIModelMutation, UpdateAIModelMutationVariables>(UpdateAIModelDocument, options);
      }
export type UpdateAIModelMutationHookResult = ReturnType<typeof useUpdateAIModelMutation>;
export type UpdateAIModelMutationResult = Apollo.MutationResult<UpdateAIModelMutation>;
export type UpdateAIModelMutationOptions = Apollo.BaseMutationOptions<UpdateAIModelMutation, UpdateAIModelMutationVariables>;
export const SingleAIActionDocument = gql`
    query SingleAIAction($ID: Int!) {
  AIAction(ID: $ID) {
    ...AIActionScalars
  }
}
    ${AIActionScalarsFragmentDoc}`;

/**
 * __useSingleAIActionQuery__
 *
 * To run a query within a React component, call `useSingleAIActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIActionQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIActionQuery(baseOptions: Apollo.QueryHookOptions<SingleAIActionQuery, SingleAIActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIActionQuery, SingleAIActionQueryVariables>(SingleAIActionDocument, options);
      }
export function useSingleAIActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIActionQuery, SingleAIActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIActionQuery, SingleAIActionQueryVariables>(SingleAIActionDocument, options);
        }
export type SingleAIActionQueryHookResult = ReturnType<typeof useSingleAIActionQuery>;
export type SingleAIActionLazyQueryHookResult = ReturnType<typeof useSingleAIActionLazyQuery>;
export type SingleAIActionQueryResult = Apollo.QueryResult<SingleAIActionQuery, SingleAIActionQueryVariables>;
export const SingleAIActionFullDocument = gql`
    query SingleAIActionFull($ID: Int!) {
  AIAction(ID: $ID) {
    ...AIActionScalars
  }
}
    ${AIActionScalarsFragmentDoc}`;

/**
 * __useSingleAIActionFullQuery__
 *
 * To run a query within a React component, call `useSingleAIActionFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIActionFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIActionFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIActionFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAIActionFullQuery, SingleAIActionFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIActionFullQuery, SingleAIActionFullQueryVariables>(SingleAIActionFullDocument, options);
      }
export function useSingleAIActionFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIActionFullQuery, SingleAIActionFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIActionFullQuery, SingleAIActionFullQueryVariables>(SingleAIActionFullDocument, options);
        }
export type SingleAIActionFullQueryHookResult = ReturnType<typeof useSingleAIActionFullQuery>;
export type SingleAIActionFullLazyQueryHookResult = ReturnType<typeof useSingleAIActionFullLazyQuery>;
export type SingleAIActionFullQueryResult = Apollo.QueryResult<SingleAIActionFullQuery, SingleAIActionFullQueryVariables>;
export const AllAIActionsDocument = gql`
    query AllAIActions {
  AllAIActions {
    ...AIActionScalars
  }
}
    ${AIActionScalarsFragmentDoc}`;

/**
 * __useAllAIActionsQuery__
 *
 * To run a query within a React component, call `useAllAIActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAIActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAIActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAIActionsQuery(baseOptions?: Apollo.QueryHookOptions<AllAIActionsQuery, AllAIActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAIActionsQuery, AllAIActionsQueryVariables>(AllAIActionsDocument, options);
      }
export function useAllAIActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAIActionsQuery, AllAIActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAIActionsQuery, AllAIActionsQueryVariables>(AllAIActionsDocument, options);
        }
export type AllAIActionsQueryHookResult = ReturnType<typeof useAllAIActionsQuery>;
export type AllAIActionsLazyQueryHookResult = ReturnType<typeof useAllAIActionsLazyQuery>;
export type AllAIActionsQueryResult = Apollo.QueryResult<AllAIActionsQuery, AllAIActionsQueryVariables>;
export const UpdateAIActionDocument = gql`
    mutation UpdateAIAction($input: UpdateAIActionInput!) {
  UpdateAIAction(input: $input) {
    ...AIActionScalars
  }
}
    ${AIActionScalarsFragmentDoc}`;
export type UpdateAIActionMutationFn = Apollo.MutationFunction<UpdateAIActionMutation, UpdateAIActionMutationVariables>;

/**
 * __useUpdateAIActionMutation__
 *
 * To run a mutation, you first call `useUpdateAIActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAIActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiActionMutation, { data, loading, error }] = useUpdateAIActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAIActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAIActionMutation, UpdateAIActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAIActionMutation, UpdateAIActionMutationVariables>(UpdateAIActionDocument, options);
      }
export type UpdateAIActionMutationHookResult = ReturnType<typeof useUpdateAIActionMutation>;
export type UpdateAIActionMutationResult = Apollo.MutationResult<UpdateAIActionMutation>;
export type UpdateAIActionMutationOptions = Apollo.BaseMutationOptions<UpdateAIActionMutation, UpdateAIActionMutationVariables>;
export const SingleAIModelActionDocument = gql`
    query SingleAIModelAction($ID: Int!) {
  AIModelAction(ID: $ID) {
    ...AIModelActionScalars
  }
}
    ${AIModelActionScalarsFragmentDoc}`;

/**
 * __useSingleAIModelActionQuery__
 *
 * To run a query within a React component, call `useSingleAIModelActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIModelActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIModelActionQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIModelActionQuery(baseOptions: Apollo.QueryHookOptions<SingleAIModelActionQuery, SingleAIModelActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIModelActionQuery, SingleAIModelActionQueryVariables>(SingleAIModelActionDocument, options);
      }
export function useSingleAIModelActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIModelActionQuery, SingleAIModelActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIModelActionQuery, SingleAIModelActionQueryVariables>(SingleAIModelActionDocument, options);
        }
export type SingleAIModelActionQueryHookResult = ReturnType<typeof useSingleAIModelActionQuery>;
export type SingleAIModelActionLazyQueryHookResult = ReturnType<typeof useSingleAIModelActionLazyQuery>;
export type SingleAIModelActionQueryResult = Apollo.QueryResult<SingleAIModelActionQuery, SingleAIModelActionQueryVariables>;
export const SingleAIModelActionFullDocument = gql`
    query SingleAIModelActionFull($ID: Int!) {
  AIModelAction(ID: $ID) {
    ...AIModelActionScalars
  }
}
    ${AIModelActionScalarsFragmentDoc}`;

/**
 * __useSingleAIModelActionFullQuery__
 *
 * To run a query within a React component, call `useSingleAIModelActionFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIModelActionFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIModelActionFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIModelActionFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAIModelActionFullQuery, SingleAIModelActionFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIModelActionFullQuery, SingleAIModelActionFullQueryVariables>(SingleAIModelActionFullDocument, options);
      }
export function useSingleAIModelActionFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIModelActionFullQuery, SingleAIModelActionFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIModelActionFullQuery, SingleAIModelActionFullQueryVariables>(SingleAIModelActionFullDocument, options);
        }
export type SingleAIModelActionFullQueryHookResult = ReturnType<typeof useSingleAIModelActionFullQuery>;
export type SingleAIModelActionFullLazyQueryHookResult = ReturnType<typeof useSingleAIModelActionFullLazyQuery>;
export type SingleAIModelActionFullQueryResult = Apollo.QueryResult<SingleAIModelActionFullQuery, SingleAIModelActionFullQueryVariables>;
export const AllAIModelActionsDocument = gql`
    query AllAIModelActions {
  AllAIModelActions {
    ...AIModelActionScalars
  }
}
    ${AIModelActionScalarsFragmentDoc}`;

/**
 * __useAllAIModelActionsQuery__
 *
 * To run a query within a React component, call `useAllAIModelActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAIModelActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAIModelActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAIModelActionsQuery(baseOptions?: Apollo.QueryHookOptions<AllAIModelActionsQuery, AllAIModelActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAIModelActionsQuery, AllAIModelActionsQueryVariables>(AllAIModelActionsDocument, options);
      }
export function useAllAIModelActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAIModelActionsQuery, AllAIModelActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAIModelActionsQuery, AllAIModelActionsQueryVariables>(AllAIModelActionsDocument, options);
        }
export type AllAIModelActionsQueryHookResult = ReturnType<typeof useAllAIModelActionsQuery>;
export type AllAIModelActionsLazyQueryHookResult = ReturnType<typeof useAllAIModelActionsLazyQuery>;
export type AllAIModelActionsQueryResult = Apollo.QueryResult<AllAIModelActionsQuery, AllAIModelActionsQueryVariables>;
export const UpdateAIModelActionDocument = gql`
    mutation UpdateAIModelAction($input: UpdateAIModelActionInput!) {
  UpdateAIModelAction(input: $input) {
    ...AIModelActionScalars
  }
}
    ${AIModelActionScalarsFragmentDoc}`;
export type UpdateAIModelActionMutationFn = Apollo.MutationFunction<UpdateAIModelActionMutation, UpdateAIModelActionMutationVariables>;

/**
 * __useUpdateAIModelActionMutation__
 *
 * To run a mutation, you first call `useUpdateAIModelActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAIModelActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiModelActionMutation, { data, loading, error }] = useUpdateAIModelActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAIModelActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAIModelActionMutation, UpdateAIModelActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAIModelActionMutation, UpdateAIModelActionMutationVariables>(UpdateAIModelActionDocument, options);
      }
export type UpdateAIModelActionMutationHookResult = ReturnType<typeof useUpdateAIModelActionMutation>;
export type UpdateAIModelActionMutationResult = Apollo.MutationResult<UpdateAIModelActionMutation>;
export type UpdateAIModelActionMutationOptions = Apollo.BaseMutationOptions<UpdateAIModelActionMutation, UpdateAIModelActionMutationVariables>;
export const SingleEntityAIActionDocument = gql`
    query SingleEntityAIAction($ID: Int!) {
  EntityAIAction(ID: $ID) {
    ...EntityAIActionScalars
  }
}
    ${EntityAIActionScalarsFragmentDoc}`;

/**
 * __useSingleEntityAIActionQuery__
 *
 * To run a query within a React component, call `useSingleEntityAIActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityAIActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityAIActionQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityAIActionQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityAIActionQuery, SingleEntityAIActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityAIActionQuery, SingleEntityAIActionQueryVariables>(SingleEntityAIActionDocument, options);
      }
export function useSingleEntityAIActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityAIActionQuery, SingleEntityAIActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityAIActionQuery, SingleEntityAIActionQueryVariables>(SingleEntityAIActionDocument, options);
        }
export type SingleEntityAIActionQueryHookResult = ReturnType<typeof useSingleEntityAIActionQuery>;
export type SingleEntityAIActionLazyQueryHookResult = ReturnType<typeof useSingleEntityAIActionLazyQuery>;
export type SingleEntityAIActionQueryResult = Apollo.QueryResult<SingleEntityAIActionQuery, SingleEntityAIActionQueryVariables>;
export const SingleEntityAIActionFullDocument = gql`
    query SingleEntityAIActionFull($ID: Int!) {
  EntityAIAction(ID: $ID) {
    ...EntityAIActionScalars
  }
}
    ${EntityAIActionScalarsFragmentDoc}`;

/**
 * __useSingleEntityAIActionFullQuery__
 *
 * To run a query within a React component, call `useSingleEntityAIActionFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleEntityAIActionFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleEntityAIActionFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleEntityAIActionFullQuery(baseOptions: Apollo.QueryHookOptions<SingleEntityAIActionFullQuery, SingleEntityAIActionFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleEntityAIActionFullQuery, SingleEntityAIActionFullQueryVariables>(SingleEntityAIActionFullDocument, options);
      }
export function useSingleEntityAIActionFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleEntityAIActionFullQuery, SingleEntityAIActionFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleEntityAIActionFullQuery, SingleEntityAIActionFullQueryVariables>(SingleEntityAIActionFullDocument, options);
        }
export type SingleEntityAIActionFullQueryHookResult = ReturnType<typeof useSingleEntityAIActionFullQuery>;
export type SingleEntityAIActionFullLazyQueryHookResult = ReturnType<typeof useSingleEntityAIActionFullLazyQuery>;
export type SingleEntityAIActionFullQueryResult = Apollo.QueryResult<SingleEntityAIActionFullQuery, SingleEntityAIActionFullQueryVariables>;
export const UpdateEntityAIActionDocument = gql`
    mutation UpdateEntityAIAction($input: UpdateEntityAIActionInput!) {
  UpdateEntityAIAction(input: $input) {
    ...EntityAIActionScalars
  }
}
    ${EntityAIActionScalarsFragmentDoc}`;
export type UpdateEntityAIActionMutationFn = Apollo.MutationFunction<UpdateEntityAIActionMutation, UpdateEntityAIActionMutationVariables>;

/**
 * __useUpdateEntityAIActionMutation__
 *
 * To run a mutation, you first call `useUpdateEntityAIActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityAIActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityAiActionMutation, { data, loading, error }] = useUpdateEntityAIActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityAIActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityAIActionMutation, UpdateEntityAIActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityAIActionMutation, UpdateEntityAIActionMutationVariables>(UpdateEntityAIActionDocument, options);
      }
export type UpdateEntityAIActionMutationHookResult = ReturnType<typeof useUpdateEntityAIActionMutation>;
export type UpdateEntityAIActionMutationResult = Apollo.MutationResult<UpdateEntityAIActionMutation>;
export type UpdateEntityAIActionMutationOptions = Apollo.BaseMutationOptions<UpdateEntityAIActionMutation, UpdateEntityAIActionMutationVariables>;
export const SingleAIModelTypeDocument = gql`
    query SingleAIModelType($ID: Int!) {
  AIModelType(ID: $ID) {
    ...AIModelTypeScalars
  }
}
    ${AIModelTypeScalarsFragmentDoc}`;

/**
 * __useSingleAIModelTypeQuery__
 *
 * To run a query within a React component, call `useSingleAIModelTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIModelTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIModelTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIModelTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleAIModelTypeQuery, SingleAIModelTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIModelTypeQuery, SingleAIModelTypeQueryVariables>(SingleAIModelTypeDocument, options);
      }
export function useSingleAIModelTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIModelTypeQuery, SingleAIModelTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIModelTypeQuery, SingleAIModelTypeQueryVariables>(SingleAIModelTypeDocument, options);
        }
export type SingleAIModelTypeQueryHookResult = ReturnType<typeof useSingleAIModelTypeQuery>;
export type SingleAIModelTypeLazyQueryHookResult = ReturnType<typeof useSingleAIModelTypeLazyQuery>;
export type SingleAIModelTypeQueryResult = Apollo.QueryResult<SingleAIModelTypeQuery, SingleAIModelTypeQueryVariables>;
export const SingleAIModelTypeFullDocument = gql`
    query SingleAIModelTypeFull($ID: Int!) {
  AIModelType(ID: $ID) {
    ...AIModelTypeScalars
  }
}
    ${AIModelTypeScalarsFragmentDoc}`;

/**
 * __useSingleAIModelTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleAIModelTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAIModelTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAIModelTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleAIModelTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleAIModelTypeFullQuery, SingleAIModelTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAIModelTypeFullQuery, SingleAIModelTypeFullQueryVariables>(SingleAIModelTypeFullDocument, options);
      }
export function useSingleAIModelTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAIModelTypeFullQuery, SingleAIModelTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAIModelTypeFullQuery, SingleAIModelTypeFullQueryVariables>(SingleAIModelTypeFullDocument, options);
        }
export type SingleAIModelTypeFullQueryHookResult = ReturnType<typeof useSingleAIModelTypeFullQuery>;
export type SingleAIModelTypeFullLazyQueryHookResult = ReturnType<typeof useSingleAIModelTypeFullLazyQuery>;
export type SingleAIModelTypeFullQueryResult = Apollo.QueryResult<SingleAIModelTypeFullQuery, SingleAIModelTypeFullQueryVariables>;
export const AllAIModelTypesDocument = gql`
    query AllAIModelTypes {
  AllAIModelTypes {
    ...AIModelTypeScalars
  }
}
    ${AIModelTypeScalarsFragmentDoc}`;

/**
 * __useAllAIModelTypesQuery__
 *
 * To run a query within a React component, call `useAllAIModelTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAIModelTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAIModelTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAIModelTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllAIModelTypesQuery, AllAIModelTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAIModelTypesQuery, AllAIModelTypesQueryVariables>(AllAIModelTypesDocument, options);
      }
export function useAllAIModelTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAIModelTypesQuery, AllAIModelTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAIModelTypesQuery, AllAIModelTypesQueryVariables>(AllAIModelTypesDocument, options);
        }
export type AllAIModelTypesQueryHookResult = ReturnType<typeof useAllAIModelTypesQuery>;
export type AllAIModelTypesLazyQueryHookResult = ReturnType<typeof useAllAIModelTypesLazyQuery>;
export type AllAIModelTypesQueryResult = Apollo.QueryResult<AllAIModelTypesQuery, AllAIModelTypesQueryVariables>;
export const UpdateAIModelTypeDocument = gql`
    mutation UpdateAIModelType($input: UpdateAIModelTypeInput!) {
  UpdateAIModelType(input: $input) {
    ...AIModelTypeScalars
  }
}
    ${AIModelTypeScalarsFragmentDoc}`;
export type UpdateAIModelTypeMutationFn = Apollo.MutationFunction<UpdateAIModelTypeMutation, UpdateAIModelTypeMutationVariables>;

/**
 * __useUpdateAIModelTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAIModelTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAIModelTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiModelTypeMutation, { data, loading, error }] = useUpdateAIModelTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAIModelTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAIModelTypeMutation, UpdateAIModelTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAIModelTypeMutation, UpdateAIModelTypeMutationVariables>(UpdateAIModelTypeDocument, options);
      }
export type UpdateAIModelTypeMutationHookResult = ReturnType<typeof useUpdateAIModelTypeMutation>;
export type UpdateAIModelTypeMutationResult = Apollo.MutationResult<UpdateAIModelTypeMutation>;
export type UpdateAIModelTypeMutationOptions = Apollo.BaseMutationOptions<UpdateAIModelTypeMutation, UpdateAIModelTypeMutationVariables>;
export const SingleContactRoleDocument = gql`
    query SingleContactRole($ID: Int!) {
  ContactRole(ID: $ID) {
    ...ContactRoleScalars
  }
}
    ${ContactRoleScalarsFragmentDoc}`;

/**
 * __useSingleContactRoleQuery__
 *
 * To run a query within a React component, call `useSingleContactRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactRoleQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactRoleQuery(baseOptions: Apollo.QueryHookOptions<SingleContactRoleQuery, SingleContactRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactRoleQuery, SingleContactRoleQueryVariables>(SingleContactRoleDocument, options);
      }
export function useSingleContactRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactRoleQuery, SingleContactRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactRoleQuery, SingleContactRoleQueryVariables>(SingleContactRoleDocument, options);
        }
export type SingleContactRoleQueryHookResult = ReturnType<typeof useSingleContactRoleQuery>;
export type SingleContactRoleLazyQueryHookResult = ReturnType<typeof useSingleContactRoleLazyQuery>;
export type SingleContactRoleQueryResult = Apollo.QueryResult<SingleContactRoleQuery, SingleContactRoleQueryVariables>;
export const SingleContactRoleFullDocument = gql`
    query SingleContactRoleFull($ID: Int!) {
  ContactRole(ID: $ID) {
    ...ContactRoleScalars
  }
}
    ${ContactRoleScalarsFragmentDoc}`;

/**
 * __useSingleContactRoleFullQuery__
 *
 * To run a query within a React component, call `useSingleContactRoleFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactRoleFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactRoleFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactRoleFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactRoleFullQuery, SingleContactRoleFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactRoleFullQuery, SingleContactRoleFullQueryVariables>(SingleContactRoleFullDocument, options);
      }
export function useSingleContactRoleFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactRoleFullQuery, SingleContactRoleFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactRoleFullQuery, SingleContactRoleFullQueryVariables>(SingleContactRoleFullDocument, options);
        }
export type SingleContactRoleFullQueryHookResult = ReturnType<typeof useSingleContactRoleFullQuery>;
export type SingleContactRoleFullLazyQueryHookResult = ReturnType<typeof useSingleContactRoleFullLazyQuery>;
export type SingleContactRoleFullQueryResult = Apollo.QueryResult<SingleContactRoleFullQuery, SingleContactRoleFullQueryVariables>;
export const SingleContactLevelDocument = gql`
    query SingleContactLevel($ID: Int!) {
  ContactLevel(ID: $ID) {
    ...ContactLevelScalars
  }
}
    ${ContactLevelScalarsFragmentDoc}`;

/**
 * __useSingleContactLevelQuery__
 *
 * To run a query within a React component, call `useSingleContactLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactLevelQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactLevelQuery(baseOptions: Apollo.QueryHookOptions<SingleContactLevelQuery, SingleContactLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactLevelQuery, SingleContactLevelQueryVariables>(SingleContactLevelDocument, options);
      }
export function useSingleContactLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactLevelQuery, SingleContactLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactLevelQuery, SingleContactLevelQueryVariables>(SingleContactLevelDocument, options);
        }
export type SingleContactLevelQueryHookResult = ReturnType<typeof useSingleContactLevelQuery>;
export type SingleContactLevelLazyQueryHookResult = ReturnType<typeof useSingleContactLevelLazyQuery>;
export type SingleContactLevelQueryResult = Apollo.QueryResult<SingleContactLevelQuery, SingleContactLevelQueryVariables>;
export const SingleContactLevelFullDocument = gql`
    query SingleContactLevelFull($ID: Int!) {
  ContactLevel(ID: $ID) {
    ...ContactLevelScalars
  }
}
    ${ContactLevelScalarsFragmentDoc}`;

/**
 * __useSingleContactLevelFullQuery__
 *
 * To run a query within a React component, call `useSingleContactLevelFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleContactLevelFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleContactLevelFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleContactLevelFullQuery(baseOptions: Apollo.QueryHookOptions<SingleContactLevelFullQuery, SingleContactLevelFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleContactLevelFullQuery, SingleContactLevelFullQueryVariables>(SingleContactLevelFullDocument, options);
      }
export function useSingleContactLevelFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleContactLevelFullQuery, SingleContactLevelFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleContactLevelFullQuery, SingleContactLevelFullQueryVariables>(SingleContactLevelFullDocument, options);
        }
export type SingleContactLevelFullQueryHookResult = ReturnType<typeof useSingleContactLevelFullQuery>;
export type SingleContactLevelFullLazyQueryHookResult = ReturnType<typeof useSingleContactLevelFullLazyQuery>;
export type SingleContactLevelFullQueryResult = Apollo.QueryResult<SingleContactLevelFullQuery, SingleContactLevelFullQueryVariables>;
export const SingleQueueTypeDocument = gql`
    query SingleQueueType($ID: Int!) {
  QueueType(ID: $ID) {
    ...QueueTypeScalars
  }
}
    ${QueueTypeScalarsFragmentDoc}`;

/**
 * __useSingleQueueTypeQuery__
 *
 * To run a query within a React component, call `useSingleQueueTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQueueTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQueueTypeQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleQueueTypeQuery(baseOptions: Apollo.QueryHookOptions<SingleQueueTypeQuery, SingleQueueTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleQueueTypeQuery, SingleQueueTypeQueryVariables>(SingleQueueTypeDocument, options);
      }
export function useSingleQueueTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleQueueTypeQuery, SingleQueueTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleQueueTypeQuery, SingleQueueTypeQueryVariables>(SingleQueueTypeDocument, options);
        }
export type SingleQueueTypeQueryHookResult = ReturnType<typeof useSingleQueueTypeQuery>;
export type SingleQueueTypeLazyQueryHookResult = ReturnType<typeof useSingleQueueTypeLazyQuery>;
export type SingleQueueTypeQueryResult = Apollo.QueryResult<SingleQueueTypeQuery, SingleQueueTypeQueryVariables>;
export const SingleQueueTypeFullDocument = gql`
    query SingleQueueTypeFull($ID: Int!) {
  QueueType(ID: $ID) {
    ...QueueTypeScalars
  }
}
    ${QueueTypeScalarsFragmentDoc}`;

/**
 * __useSingleQueueTypeFullQuery__
 *
 * To run a query within a React component, call `useSingleQueueTypeFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQueueTypeFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQueueTypeFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleQueueTypeFullQuery(baseOptions: Apollo.QueryHookOptions<SingleQueueTypeFullQuery, SingleQueueTypeFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleQueueTypeFullQuery, SingleQueueTypeFullQueryVariables>(SingleQueueTypeFullDocument, options);
      }
export function useSingleQueueTypeFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleQueueTypeFullQuery, SingleQueueTypeFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleQueueTypeFullQuery, SingleQueueTypeFullQueryVariables>(SingleQueueTypeFullDocument, options);
        }
export type SingleQueueTypeFullQueryHookResult = ReturnType<typeof useSingleQueueTypeFullQuery>;
export type SingleQueueTypeFullLazyQueryHookResult = ReturnType<typeof useSingleQueueTypeFullLazyQuery>;
export type SingleQueueTypeFullQueryResult = Apollo.QueryResult<SingleQueueTypeFullQuery, SingleQueueTypeFullQueryVariables>;
export const SingleQueueDocument = gql`
    query SingleQueue($ID: Int!) {
  Queue(ID: $ID) {
    ...QueueScalars
  }
}
    ${QueueScalarsFragmentDoc}`;

/**
 * __useSingleQueueQuery__
 *
 * To run a query within a React component, call `useSingleQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQueueQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleQueueQuery(baseOptions: Apollo.QueryHookOptions<SingleQueueQuery, SingleQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleQueueQuery, SingleQueueQueryVariables>(SingleQueueDocument, options);
      }
export function useSingleQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleQueueQuery, SingleQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleQueueQuery, SingleQueueQueryVariables>(SingleQueueDocument, options);
        }
export type SingleQueueQueryHookResult = ReturnType<typeof useSingleQueueQuery>;
export type SingleQueueLazyQueryHookResult = ReturnType<typeof useSingleQueueLazyQuery>;
export type SingleQueueQueryResult = Apollo.QueryResult<SingleQueueQuery, SingleQueueQueryVariables>;
export const SingleQueueFullDocument = gql`
    query SingleQueueFull($ID: Int!) {
  Queue(ID: $ID) {
    ...QueueScalars
  }
}
    ${QueueScalarsFragmentDoc}`;

/**
 * __useSingleQueueFullQuery__
 *
 * To run a query within a React component, call `useSingleQueueFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQueueFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQueueFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleQueueFullQuery(baseOptions: Apollo.QueryHookOptions<SingleQueueFullQuery, SingleQueueFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleQueueFullQuery, SingleQueueFullQueryVariables>(SingleQueueFullDocument, options);
      }
export function useSingleQueueFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleQueueFullQuery, SingleQueueFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleQueueFullQuery, SingleQueueFullQueryVariables>(SingleQueueFullDocument, options);
        }
export type SingleQueueFullQueryHookResult = ReturnType<typeof useSingleQueueFullQuery>;
export type SingleQueueFullLazyQueryHookResult = ReturnType<typeof useSingleQueueFullLazyQuery>;
export type SingleQueueFullQueryResult = Apollo.QueryResult<SingleQueueFullQuery, SingleQueueFullQueryVariables>;
export const SingleQueueTaskDocument = gql`
    query SingleQueueTask($ID: Int!) {
  QueueTask(ID: $ID) {
    ...QueueTaskScalars
  }
}
    ${QueueTaskScalarsFragmentDoc}`;

/**
 * __useSingleQueueTaskQuery__
 *
 * To run a query within a React component, call `useSingleQueueTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQueueTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQueueTaskQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleQueueTaskQuery(baseOptions: Apollo.QueryHookOptions<SingleQueueTaskQuery, SingleQueueTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleQueueTaskQuery, SingleQueueTaskQueryVariables>(SingleQueueTaskDocument, options);
      }
export function useSingleQueueTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleQueueTaskQuery, SingleQueueTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleQueueTaskQuery, SingleQueueTaskQueryVariables>(SingleQueueTaskDocument, options);
        }
export type SingleQueueTaskQueryHookResult = ReturnType<typeof useSingleQueueTaskQuery>;
export type SingleQueueTaskLazyQueryHookResult = ReturnType<typeof useSingleQueueTaskLazyQuery>;
export type SingleQueueTaskQueryResult = Apollo.QueryResult<SingleQueueTaskQuery, SingleQueueTaskQueryVariables>;
export const SingleQueueTaskFullDocument = gql`
    query SingleQueueTaskFull($ID: Int!) {
  QueueTask(ID: $ID) {
    ...QueueTaskScalars
  }
}
    ${QueueTaskScalarsFragmentDoc}`;

/**
 * __useSingleQueueTaskFullQuery__
 *
 * To run a query within a React component, call `useSingleQueueTaskFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQueueTaskFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQueueTaskFullQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useSingleQueueTaskFullQuery(baseOptions: Apollo.QueryHookOptions<SingleQueueTaskFullQuery, SingleQueueTaskFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleQueueTaskFullQuery, SingleQueueTaskFullQueryVariables>(SingleQueueTaskFullDocument, options);
      }
export function useSingleQueueTaskFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleQueueTaskFullQuery, SingleQueueTaskFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleQueueTaskFullQuery, SingleQueueTaskFullQueryVariables>(SingleQueueTaskFullDocument, options);
        }
export type SingleQueueTaskFullQueryHookResult = ReturnType<typeof useSingleQueueTaskFullQuery>;
export type SingleQueueTaskFullLazyQueryHookResult = ReturnType<typeof useSingleQueueTaskFullLazyQuery>;
export type SingleQueueTaskFullQueryResult = Apollo.QueryResult<SingleQueueTaskFullQuery, SingleQueueTaskFullQueryVariables>;
export type AIActionKeySpecifier = ('CreatedAt' | 'DefaultModel' | 'DefaultModelID' | 'DefaultPrompt' | 'Description' | 'ID' | 'IsActive' | 'Name' | 'UpdatedAt' | AIActionKeySpecifier)[];
export type AIActionFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultModel?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultModelID?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultPrompt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AIModelKeySpecifier = ('AIModelTypeID' | 'CreatedAt' | 'Description' | 'DriverClass' | 'DriverImportPath' | 'ID' | 'IsActive' | 'Name' | 'UpdatedAt' | 'Vendor' | AIModelKeySpecifier)[];
export type AIModelFieldPolicy = {
	AIModelTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverClass?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverImportPath?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AIModelActionKeySpecifier = ('AIAction' | 'AIActionID' | 'AIModel' | 'AIModelID' | 'CreatedAt' | 'ID' | 'IsActive' | 'UpdatedAt' | AIModelActionKeySpecifier)[];
export type AIModelActionFieldPolicy = {
	AIAction?: FieldPolicy<any> | FieldReadFunction<any>,
	AIActionID?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModel?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModelID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AIModelTypeKeySpecifier = ('Description' | 'ID' | 'Name' | AIModelTypeKeySpecifier)[];
export type AIModelTypeFieldPolicy = {
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountKeySpecifier = ('AccountCompanyIntegrations' | 'AccountingFees' | 'Acronym' | 'Activities' | 'ActivityCount' | 'AddressLine1' | 'AddressLine2' | 'AddressLine3' | 'AdvertisingExpense' | 'BCMID' | 'City' | 'Companies' | 'Contacts' | 'Country' | 'CreatedAt' | 'Deals' | 'Description' | 'DisplayName' | 'Domain' | 'EarliestActivityDate' | 'Facebook' | 'ID' | 'ISOCountryCode' | 'InformationTechnologyExpense' | 'Invoices' | 'LastReviewedDate' | 'Latest990ID' | 'LatestActivityDate' | 'LeadershipPageURL' | 'LegalFees' | 'LinkedIn' | 'Logo' | 'LogoURL' | 'ManagementFees' | 'Name' | 'NumberEmployees' | 'OperatingName' | 'PhoneNumber' | 'PostalCode' | 'ProgramServiceRevenueA' | 'ProgramServiceRevenueB' | 'ProgramServiceRevenueC' | 'ProgramServiceRevenueD' | 'ProgramServiceRevenueE' | 'ProgramServiceRevenueNameA' | 'ProgramServiceRevenueNameB' | 'ProgramServiceRevenueNameC' | 'ProgramServiceRevenueNameD' | 'ProgramServiceRevenueNameE' | 'StateProvince' | 'Subsection' | 'TaxID' | 'TaxMonth' | 'TaxYear' | 'TotalAssets' | 'TotalRevenue' | 'UpdatedAt' | 'Website' | '_990Full' | AccountKeySpecifier)[];
export type AccountFieldPolicy = {
	AccountCompanyIntegrations?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	Acronym?: FieldPolicy<any> | FieldReadFunction<any>,
	Activities?: FieldPolicy<any> | FieldReadFunction<any>,
	ActivityCount?: FieldPolicy<any> | FieldReadFunction<any>,
	AddressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	AddressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	AddressLine3?: FieldPolicy<any> | FieldReadFunction<any>,
	AdvertisingExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	City?: FieldPolicy<any> | FieldReadFunction<any>,
	Companies?: FieldPolicy<any> | FieldReadFunction<any>,
	Contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	Country?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Deals?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	Domain?: FieldPolicy<any> | FieldReadFunction<any>,
	EarliestActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Facebook?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	ISOCountryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	InformationTechnologyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Invoices?: FieldPolicy<any> | FieldReadFunction<any>,
	LastReviewedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Latest990ID?: FieldPolicy<any> | FieldReadFunction<any>,
	LatestActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LeadershipPageURL?: FieldPolicy<any> | FieldReadFunction<any>,
	LegalFees?: FieldPolicy<any> | FieldReadFunction<any>,
	LinkedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	Logo?: FieldPolicy<any> | FieldReadFunction<any>,
	LogoURL?: FieldPolicy<any> | FieldReadFunction<any>,
	ManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	NumberEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	OperatingName?: FieldPolicy<any> | FieldReadFunction<any>,
	PhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	PostalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueE?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameE?: FieldPolicy<any> | FieldReadFunction<any>,
	StateProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	Subsection?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxID?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxYear?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Website?: FieldPolicy<any> | FieldReadFunction<any>,
	_990Full?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountCompanyIntegrationKeySpecifier = ('Account' | 'AccountID' | 'AccountType' | 'AccountTypeID' | 'CompanyID' | 'CompanyIntegrationID' | 'CompanyName' | 'CreatedAt' | 'ExternalSystemRecordID' | 'ID' | 'UpdatedAt' | AccountCompanyIntegrationKeySpecifier)[];
export type AccountCompanyIntegrationFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountType?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyName?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountTypeKeySpecifier = ('CreatedAt' | 'Description' | 'ID' | 'Name' | 'UpdatedAt' | AccountTypeKeySpecifier)[];
export type AccountTypeFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityKeySpecifier = ('Account' | 'AccountID' | 'AccountWebsite' | 'ActivityDate' | 'Attachment' | 'AttachmentID' | 'BCMID' | 'Company' | 'CompanyID' | 'CompanyIntegrationID' | 'ContactEmail' | 'ContactFirstName' | 'ContactID' | 'ContactLastName' | 'CreatedAt' | 'Deal' | 'DealID' | 'Description' | 'EmployeeEmail' | 'EmployeeFirstName' | 'EmployeeID' | 'EmployeeLastName' | 'EmployeeSupervisor' | 'EmployeeSupervisorEmail' | 'EmployeeSupervisorFirstName' | 'EmployeeSupervisorLastName' | 'ExternalSystemRecordID' | 'ID' | 'Integration' | 'IsActive' | 'IsBounced' | 'IsOpened' | 'IsReplied' | 'Summary' | 'Title' | 'Type' | 'UpdatedAt' | ActivityKeySpecifier)[];
export type ActivityFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountWebsite?: FieldPolicy<any> | FieldReadFunction<any>,
	ActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Attachment?: FieldPolicy<any> | FieldReadFunction<any>,
	AttachmentID?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	Company?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Deal?: FieldPolicy<any> | FieldReadFunction<any>,
	DealID?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeSupervisor?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeSupervisorEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeSupervisorFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeSupervisorLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Integration?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	IsBounced?: FieldPolicy<any> | FieldReadFunction<any>,
	IsOpened?: FieldPolicy<any> | FieldReadFunction<any>,
	IsReplied?: FieldPolicy<any> | FieldReadFunction<any>,
	Summary?: FieldPolicy<any> | FieldReadFunction<any>,
	Title?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityAttachmentKeySpecifier = ('Attachments' | 'CreatedAt' | 'ID' | 'UpdatedAt' | ActivityAttachmentKeySpecifier)[];
export type ActivityAttachmentFieldPolicy = {
	Attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApplicationKeySpecifier = ('ApplicationEntities' | 'ApplicationPermissions' | 'CreatedAt' | 'Description' | 'ID' | 'Name' | 'UpdatedAt' | ApplicationKeySpecifier)[];
export type ApplicationFieldPolicy = {
	ApplicationEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	ApplicationPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApplicationEntityKeySpecifier = ('Application' | 'ApplicationID' | 'CreatedAt' | 'DefaultForNewUser' | 'Entity' | 'EntityBaseTable' | 'EntityBaseTableCodeName' | 'EntityClassName' | 'EntityCodeName' | 'EntityID' | 'ID' | 'Sequence' | 'UpdatedAt' | ApplicationEntityKeySpecifier)[];
export type ApplicationEntityFieldPolicy = {
	Application?: FieldPolicy<any> | FieldReadFunction<any>,
	ApplicationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultForNewUser?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseTableCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApplicationPermissionKeySpecifier = ('Application' | 'ApplicationID' | 'CreatedAt' | 'ID' | 'Role' | 'RoleID' | 'UpdatedAt' | ApplicationPermissionKeySpecifier)[];
export type ApplicationPermissionFieldPolicy = {
	Application?: FieldPolicy<any> | FieldReadFunction<any>,
	ApplicationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	RoleID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AskSkipResultTypeKeySpecifier = ('Result' | 'Status' | 'Success' | AskSkipResultTypeKeySpecifier)[];
export type AskSkipResultTypeFieldPolicy = {
	Result?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogKeySpecifier = ('AuditLogType' | 'AuditLogTypeID' | 'AuthorizationID' | 'CreatedAt' | 'Details' | 'Entity' | 'EntityID' | 'ID' | 'RecordID' | 'Status' | 'UpdatedAt' | 'User' | 'UserID' | AuditLogKeySpecifier)[];
export type AuditLogFieldPolicy = {
	AuditLogType?: FieldPolicy<any> | FieldReadFunction<any>,
	AuditLogTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	AuthorizationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Details?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogTypeKeySpecifier = ('AuthorizationID' | 'CreatedAt' | 'Description' | 'ID' | 'Name' | 'Parent' | 'ParentID' | 'UpdatedAt' | AuditLogTypeKeySpecifier)[];
export type AuditLogTypeFieldPolicy = {
	AuthorizationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	Parent?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthorizationKeySpecifier = ('AuthorizationRoles' | 'CreatedAt' | 'Description' | 'ID' | 'IsActive' | 'Name' | 'ParentID' | 'UpdatedAt' | 'UseAuditLog' | AuthorizationKeySpecifier)[];
export type AuthorizationFieldPolicy = {
	AuthorizationRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	UseAuditLog?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthorizationRoleKeySpecifier = ('AuthorizationID' | 'CreatedAt' | 'ID' | 'Role' | 'RoleID' | 'Type' | 'UpdatedAt' | AuthorizationRoleKeySpecifier)[];
export type AuthorizationRoleFieldPolicy = {
	AuthorizationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	RoleID?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CampaignKeySpecifier = ('BCMID' | 'CompanyIntegrationID' | 'CreatedAt' | 'Employee' | 'EmployeeID' | 'ExternalSystemCreatedAt' | 'ExternalSystemRecordID' | 'ID' | 'Name' | 'StatusID' | 'UpdatedAt' | CampaignKeySpecifier)[];
export type CampaignFieldPolicy = {
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Employee?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemCreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	StatusID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CampaignStepKeySpecifier = ('Body' | 'CampaignID' | 'CreatedAt' | 'ExternalSystemRecordID' | 'ID' | 'Sequence' | 'Subject' | 'UpdatedAt' | CampaignStepKeySpecifier)[];
export type CampaignStepFieldPolicy = {
	Body?: FieldPolicy<any> | FieldReadFunction<any>,
	CampaignID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	Subject?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompanyKeySpecifier = ('AccountCompanyIntegrations' | 'Accounts' | 'Contacts' | 'CreatedAt' | 'Deals' | 'Description' | 'Domain' | 'Employees' | 'ID' | 'Invoices' | 'LogoURL' | 'Name' | 'UpdatedAt' | 'Website' | CompanyKeySpecifier)[];
export type CompanyFieldPolicy = {
	AccountCompanyIntegrations?: FieldPolicy<any> | FieldReadFunction<any>,
	Accounts?: FieldPolicy<any> | FieldReadFunction<any>,
	Contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Deals?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	Domain?: FieldPolicy<any> | FieldReadFunction<any>,
	Employees?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Invoices?: FieldPolicy<any> | FieldReadFunction<any>,
	LogoURL?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompanyIntegrationKeySpecifier = ('APIKey' | 'AccessToken' | 'ClientID' | 'ClientSecret' | 'Company' | 'CompanyID' | 'CreatedAt' | 'CustomAttribute1' | 'DriverClassName' | 'DriverImportPath' | 'ExternalSystemID' | 'ID' | 'Integration' | 'IntegrationID' | 'IsActive' | 'IsExternalSystemReadOnly' | 'LastRunEndedAt' | 'LastRunID' | 'LastRunStartedAt' | 'RefreshToken' | 'TokenExpirationDate' | 'UpdatedAt' | CompanyIntegrationKeySpecifier)[];
export type CompanyIntegrationFieldPolicy = {
	APIKey?: FieldPolicy<any> | FieldReadFunction<any>,
	AccessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	ClientID?: FieldPolicy<any> | FieldReadFunction<any>,
	ClientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	Company?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	CustomAttribute1?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverImportPath?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Integration?: FieldPolicy<any> | FieldReadFunction<any>,
	IntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	IsExternalSystemReadOnly?: FieldPolicy<any> | FieldReadFunction<any>,
	LastRunEndedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	LastRunID?: FieldPolicy<any> | FieldReadFunction<any>,
	LastRunStartedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	RefreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	TokenExpirationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactKeySpecifier = ('Account' | 'AccountID' | 'Activities' | 'ActivityCount' | 'BCMID' | 'Companies' | 'ContactAccounts' | 'ContactEmails' | 'ContactTopics' | 'CreatedAt' | 'Deals' | 'Domain' | 'EarliestActivityDate' | 'Email1' | 'Email2' | 'EmailDomain' | 'EmailSource' | 'EmailStatus' | 'Facebook' | 'FirstLast' | 'FirstName' | 'ID' | 'Instagram' | 'Invoices' | 'LastName' | 'LastReviewedDate' | 'LatestActivityDate' | 'Level' | 'LevelID' | 'LinkedIn' | 'NickName' | 'PhoneNumber' | 'Prefix' | 'ProfilePictureURL' | 'Role' | 'RoleID' | 'Status' | 'Suffix' | 'Tags' | 'Title' | 'Twitter' | 'UpdatedAt' | 'Website' | ContactKeySpecifier)[];
export type ContactFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	Activities?: FieldPolicy<any> | FieldReadFunction<any>,
	ActivityCount?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	Companies?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactTopics?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Deals?: FieldPolicy<any> | FieldReadFunction<any>,
	Domain?: FieldPolicy<any> | FieldReadFunction<any>,
	EarliestActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Email1?: FieldPolicy<any> | FieldReadFunction<any>,
	Email2?: FieldPolicy<any> | FieldReadFunction<any>,
	EmailDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	EmailSource?: FieldPolicy<any> | FieldReadFunction<any>,
	EmailStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	Facebook?: FieldPolicy<any> | FieldReadFunction<any>,
	FirstLast?: FieldPolicy<any> | FieldReadFunction<any>,
	FirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Instagram?: FieldPolicy<any> | FieldReadFunction<any>,
	Invoices?: FieldPolicy<any> | FieldReadFunction<any>,
	LastName?: FieldPolicy<any> | FieldReadFunction<any>,
	LastReviewedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LatestActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Level?: FieldPolicy<any> | FieldReadFunction<any>,
	LevelID?: FieldPolicy<any> | FieldReadFunction<any>,
	LinkedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	NickName?: FieldPolicy<any> | FieldReadFunction<any>,
	PhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	Prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	ProfilePictureURL?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	RoleID?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	Suffix?: FieldPolicy<any> | FieldReadFunction<any>,
	Tags?: FieldPolicy<any> | FieldReadFunction<any>,
	Title?: FieldPolicy<any> | FieldReadFunction<any>,
	Twitter?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactAccountKeySpecifier = ('Account' | 'AccountID' | 'Contact' | 'ContactID' | 'EndedAt' | 'ID' | 'IsPrimary' | 'Sequence' | 'StartedAt' | ContactAccountKeySpecifier)[];
export type ContactAccountFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	EndedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsPrimary?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	StartedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactCompanyIntegrationKeySpecifier = ('CompanyID' | 'CompanyIntegrationID' | 'CompanyName' | 'ContactID' | 'CreatedAt' | 'ExternalSystemRecordID' | 'ID' | 'UpdatedAt' | ContactCompanyIntegrationKeySpecifier)[];
export type ContactCompanyIntegrationFieldPolicy = {
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyName?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactEmailKeySpecifier = ('Account' | 'AccountID' | 'Contact' | 'ContactID' | 'Email' | 'EmailDomain' | 'ID' | 'IsActive' | ContactEmailKeySpecifier)[];
export type ContactEmailFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	Email?: FieldPolicy<any> | FieldReadFunction<any>,
	EmailDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactLevelKeySpecifier = ('Description' | 'ExcludeKeywords' | 'ID' | 'Keywords' | 'Name' | 'Rank' | ContactLevelKeySpecifier)[];
export type ContactLevelFieldPolicy = {
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ExcludeKeywords?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	Rank?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactRoleKeySpecifier = ('Description' | 'ID' | 'Keywords' | 'Name' | ContactRoleKeySpecifier)[];
export type ContactRoleFieldPolicy = {
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Keywords?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactTopicKeySpecifier = ('Account' | 'Contact' | 'ContactID' | 'Domain' | 'EarliestDate' | 'ID' | 'LatestDate' | 'Topic' | 'TotalCount' | 'Website' | ContactTopicKeySpecifier)[];
export type ContactTopicFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	Domain?: FieldPolicy<any> | FieldReadFunction<any>,
	EarliestDate?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	LatestDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Topic?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealKeySpecifier = ('Account' | 'AccountID' | 'Activities' | 'BCMID' | 'CloseDate' | 'Company' | 'CompanyID' | 'CompanyIntegrationID' | 'CompanyLogoURL' | 'ContactEmail1' | 'ContactFirstName' | 'ContactID' | 'ContactLastName' | 'ContactPhoneNumber' | 'ContactTitle' | 'ContractTermMonths' | 'CreatedAt' | 'DealForecastCategoryID' | 'DealStageID' | 'DealTypeID' | 'Description' | 'EmployeeEmail' | 'EmployeeFirstName' | 'EmployeeID' | 'EmployeeLastName' | 'EmployeeSupervisor' | 'EmployeeSupervisorEmail' | 'EmployeeTitle' | 'ExternalSystemCreatedAt' | 'ExternalSystemRecordID' | 'ExternalSystemUpdatedAt' | 'ForecastNotes' | 'ID' | 'IncludeInForecast' | 'LeadSource' | 'LeadSourceDetail' | 'MRR' | 'OneTimeFees' | 'Pipeline' | 'Probability' | 'Title' | 'UpdatedAt' | 'Value' | DealKeySpecifier)[];
export type DealFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	Activities?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	CloseDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Company?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyLogoURL?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactEmail1?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	ContractTermMonths?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DealForecastCategoryID?: FieldPolicy<any> | FieldReadFunction<any>,
	DealStageID?: FieldPolicy<any> | FieldReadFunction<any>,
	DealTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeSupervisor?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeSupervisorEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemCreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ForecastNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IncludeInForecast?: FieldPolicy<any> | FieldReadFunction<any>,
	LeadSource?: FieldPolicy<any> | FieldReadFunction<any>,
	LeadSourceDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	MRR?: FieldPolicy<any> | FieldReadFunction<any>,
	OneTimeFees?: FieldPolicy<any> | FieldReadFunction<any>,
	Pipeline?: FieldPolicy<any> | FieldReadFunction<any>,
	Probability?: FieldPolicy<any> | FieldReadFunction<any>,
	Title?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealStageKeySpecifier = ('CreatedAt' | 'Description' | 'ID' | 'Name' | 'UpdatedAt' | DealStageKeySpecifier)[];
export type DealStageFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealTypeKeySpecifier = ('CreatedAt' | 'Description' | 'DisplayName' | 'ID' | 'Name' | 'UpdatedAt' | DealTypeKeySpecifier)[];
export type DealTypeFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailServiceProvidersKeySpecifier = ('Domain' | 'ID' | EmailServiceProvidersKeySpecifier)[];
export type EmailServiceProvidersFieldPolicy = {
	Domain?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmployeeKeySpecifier = ('Active' | 'BCMID' | 'CompanyID' | 'CreatedAt' | 'Email' | 'Employees' | 'FirstLast' | 'FirstName' | 'ID' | 'LastName' | 'Phone' | 'Supervisor' | 'SupervisorEmail' | 'SupervisorFirstName' | 'SupervisorID' | 'SupervisorLastName' | 'Title' | 'UpdatedAt' | EmployeeKeySpecifier)[];
export type EmployeeFieldPolicy = {
	Active?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Email?: FieldPolicy<any> | FieldReadFunction<any>,
	Employees?: FieldPolicy<any> | FieldReadFunction<any>,
	FirstLast?: FieldPolicy<any> | FieldReadFunction<any>,
	FirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	LastName?: FieldPolicy<any> | FieldReadFunction<any>,
	Phone?: FieldPolicy<any> | FieldReadFunction<any>,
	Supervisor?: FieldPolicy<any> | FieldReadFunction<any>,
	SupervisorEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	SupervisorFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	SupervisorID?: FieldPolicy<any> | FieldReadFunction<any>,
	SupervisorLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	Title?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityKeySpecifier = ('AllowAllRowsAPI' | 'AllowCreateAPI' | 'AllowDeleteAPI' | 'AllowUpdateAPI' | 'AllowUserSearchAPI' | 'AuditRecordAccess' | 'AuditViewRuns' | 'BaseTable' | 'BaseTableCodeName' | 'BaseView' | 'BaseViewGenerated' | 'ClassName' | 'CodeName' | 'CreatedAt' | 'CustomResolverAPI' | 'Description' | 'EntityAIActions' | 'EntityFields' | 'EntityObjectSubclassImportPath' | 'EntityObjectSubclassName' | 'EntityPermissions' | 'EntityRelationships' | 'ID' | 'IncludeInAPI' | 'Name' | 'ParentBaseTable' | 'ParentBaseView' | 'ParentEntity' | 'ParentID' | 'SchemaName' | 'TrackRecordChanges' | 'UpdatedAt' | 'UserFormClassName' | 'UserFormGenerated' | 'UserFormImportPath' | 'UserViewMaxRows' | 'spCreate' | 'spCreateGenerated' | 'spDelete' | 'spDeleteGenerated' | 'spUpdate' | 'spUpdateGenerated' | EntityKeySpecifier)[];
export type EntityFieldPolicy = {
	AllowAllRowsAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	AllowCreateAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	AllowDeleteAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	AllowUpdateAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	AllowUserSearchAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	AuditRecordAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	AuditViewRuns?: FieldPolicy<any> | FieldReadFunction<any>,
	BaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	BaseTableCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	BaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	BaseViewGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	ClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	CodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	CustomResolverAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityAIActions?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityFields?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityObjectSubclassImportPath?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityObjectSubclassName?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityRelationships?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IncludeInAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentBaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentID?: FieldPolicy<any> | FieldReadFunction<any>,
	SchemaName?: FieldPolicy<any> | FieldReadFunction<any>,
	TrackRecordChanges?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFormClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFormGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFormImportPath?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewMaxRows?: FieldPolicy<any> | FieldReadFunction<any>,
	spCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	spCreateGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	spDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	spDeleteGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	spUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	spUpdateGenerated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityAIActionKeySpecifier = ('AIAction' | 'AIActionID' | 'AIModel' | 'AIModelID' | 'Comments' | 'Entity' | 'EntityID' | 'ID' | 'OutputEntity' | 'OutputEntityID' | 'OutputField' | 'OutputType' | 'Prompt' | 'SkipIfOutputFieldNotEmpty' | 'TriggerEvent' | 'UserMessage' | EntityAIActionKeySpecifier)[];
export type EntityAIActionFieldPolicy = {
	AIAction?: FieldPolicy<any> | FieldReadFunction<any>,
	AIActionID?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModel?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModelID?: FieldPolicy<any> | FieldReadFunction<any>,
	Comments?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	OutputEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	OutputEntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	OutputField?: FieldPolicy<any> | FieldReadFunction<any>,
	OutputType?: FieldPolicy<any> | FieldReadFunction<any>,
	Prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	SkipIfOutputFieldNotEmpty?: FieldPolicy<any> | FieldReadFunction<any>,
	TriggerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	UserMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityFieldKeySpecifier = ('AllowUpdateAPI' | 'AllowUpdateInView' | 'AllowsNull' | 'AutoIncrement' | 'BaseTable' | 'BaseView' | 'Category' | 'CreatedAt' | 'DefaultColumnWidth' | 'DefaultInView' | 'DefaultValue' | 'Description' | 'DisplayName' | 'Entity' | 'EntityClassName' | 'EntityCodeName' | 'EntityFieldValues' | 'EntityID' | 'ExtendedType' | 'GeneratedFormSection' | 'ID' | 'IncludeInGeneratedForm' | 'IncludeInUserSearchAPI' | 'IncludeRelatedEntityNameFieldInBaseView' | 'IsNameField' | 'IsVirtual' | 'Length' | 'Name' | 'Precision' | 'RelatedEntity' | 'RelatedEntityBaseTable' | 'RelatedEntityBaseView' | 'RelatedEntityClassName' | 'RelatedEntityCodeName' | 'RelatedEntityFieldName' | 'RelatedEntityID' | 'RelatedEntityNameFieldMap' | 'RelatedEntitySchemaName' | 'Scale' | 'SchemaName' | 'Sequence' | 'Type' | 'UpdatedAt' | 'UserSearchParamFormatAPI' | 'ValueListType' | 'ViewCellTemplate' | EntityFieldKeySpecifier)[];
export type EntityFieldFieldPolicy = {
	AllowUpdateAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	AllowUpdateInView?: FieldPolicy<any> | FieldReadFunction<any>,
	AllowsNull?: FieldPolicy<any> | FieldReadFunction<any>,
	AutoIncrement?: FieldPolicy<any> | FieldReadFunction<any>,
	BaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	BaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	Category?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultColumnWidth?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultInView?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultValue?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityFieldValues?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ExtendedType?: FieldPolicy<any> | FieldReadFunction<any>,
	GeneratedFormSection?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IncludeInGeneratedForm?: FieldPolicy<any> | FieldReadFunction<any>,
	IncludeInUserSearchAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	IncludeRelatedEntityNameFieldInBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	IsNameField?: FieldPolicy<any> | FieldReadFunction<any>,
	IsVirtual?: FieldPolicy<any> | FieldReadFunction<any>,
	Length?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	Precision?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityBaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityFieldName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityNameFieldMap?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntitySchemaName?: FieldPolicy<any> | FieldReadFunction<any>,
	Scale?: FieldPolicy<any> | FieldReadFunction<any>,
	SchemaName?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	UserSearchParamFormatAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	ValueListType?: FieldPolicy<any> | FieldReadFunction<any>,
	ViewCellTemplate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityFieldValueKeySpecifier = ('Code' | 'CreatedAt' | 'Description' | 'EntityField' | 'EntityFieldID' | 'ID' | 'Sequence' | 'UpdatedAt' | 'Value' | EntityFieldValueKeySpecifier)[];
export type EntityFieldValueFieldPolicy = {
	Code?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityField?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityFieldID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityPermissionKeySpecifier = ('CanCreate' | 'CanDelete' | 'CanRead' | 'CanUpdate' | 'CreateRLSFilter' | 'CreateRLSFilterID' | 'CreatedAt' | 'DeleteRLSFilter' | 'DeleteRLSFilterID' | 'Entity' | 'EntityID' | 'ID' | 'ReadRLSFilter' | 'ReadRLSFilterID' | 'Role' | 'RoleID' | 'RoleSQLName' | 'UpdateRLSFilter' | 'UpdateRLSFilterID' | 'UpdatedAt' | EntityPermissionKeySpecifier)[];
export type EntityPermissionFieldPolicy = {
	CanCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	CanDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	CanRead?: FieldPolicy<any> | FieldReadFunction<any>,
	CanUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateRLSFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateRLSFilterID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteRLSFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteRLSFilterID?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	ReadRLSFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	ReadRLSFilterID?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	RoleID?: FieldPolicy<any> | FieldReadFunction<any>,
	RoleSQLName?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateRLSFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateRLSFilterID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntityRelationshipKeySpecifier = ('BundleInAPI' | 'CreatedAt' | 'DisplayInForm' | 'DisplayName' | 'DisplayUserViewID' | 'Entity' | 'EntityBaseTable' | 'EntityBaseView' | 'EntityID' | 'EntityKeyField' | 'ID' | 'IncludeInParentAllQuery' | 'JoinEntityInverseJoinField' | 'JoinEntityJoinField' | 'JoinView' | 'RelatedEntity' | 'RelatedEntityBaseTable' | 'RelatedEntityBaseTableCodeName' | 'RelatedEntityBaseView' | 'RelatedEntityClassName' | 'RelatedEntityCodeName' | 'RelatedEntityID' | 'RelatedEntityJoinField' | 'Type' | 'UpdatedAt' | EntityRelationshipKeySpecifier)[];
export type EntityRelationshipFieldPolicy = {
	BundleInAPI?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DisplayInForm?: FieldPolicy<any> | FieldReadFunction<any>,
	DisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	DisplayUserViewID?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityKeyField?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IncludeInParentAllQuery?: FieldPolicy<any> | FieldReadFunction<any>,
	JoinEntityInverseJoinField?: FieldPolicy<any> | FieldReadFunction<any>,
	JoinEntityJoinField?: FieldPolicy<any> | FieldReadFunction<any>,
	JoinView?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityBaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityBaseTableCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityCodeName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedEntityJoinField?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntegrationKeySpecifier = ('BatchMaxRequestCount' | 'BatchRequestWaitTime' | 'ClassName' | 'CreatedAt' | 'Description' | 'ID' | 'ImportPath' | 'IntegrationURLFormats' | 'Name' | 'NavigationBaseURL' | 'UpdatedAt' | IntegrationKeySpecifier)[];
export type IntegrationFieldPolicy = {
	BatchMaxRequestCount?: FieldPolicy<any> | FieldReadFunction<any>,
	BatchRequestWaitTime?: FieldPolicy<any> | FieldReadFunction<any>,
	ClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	ImportPath?: FieldPolicy<any> | FieldReadFunction<any>,
	IntegrationURLFormats?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	NavigationBaseURL?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntegrationURLFormatKeySpecifier = ('EntityID' | 'FullURLFormat' | 'ID' | 'IntegrationID' | 'NavigationBaseURL' | 'URLFormat' | IntegrationURLFormatKeySpecifier)[];
export type IntegrationURLFormatFieldPolicy = {
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	FullURLFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	NavigationBaseURL?: FieldPolicy<any> | FieldReadFunction<any>,
	URLFormat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceKeySpecifier = ('Account' | 'AccountID' | 'AccountWebsite' | 'BCMID' | 'Company' | 'CompanyID' | 'CompanyIntegrationID' | 'Contact' | 'ContactEmail' | 'ContactID' | 'CreatedAt' | 'DueDate' | 'ExternalSystemRecordID' | 'ID' | 'InvoiceDate' | 'InvoiceNumber' | 'PaymentTermsID' | 'Payments' | 'PostingDate' | 'StatusID' | 'SubTotal' | 'Tax' | 'Total' | 'UpdatedAt' | InvoiceKeySpecifier)[];
export type InvoiceFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountWebsite?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	Company?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	InvoiceDate?: FieldPolicy<any> | FieldReadFunction<any>,
	InvoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	PaymentTermsID?: FieldPolicy<any> | FieldReadFunction<any>,
	Payments?: FieldPolicy<any> | FieldReadFunction<any>,
	PostingDate?: FieldPolicy<any> | FieldReadFunction<any>,
	StatusID?: FieldPolicy<any> | FieldReadFunction<any>,
	SubTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	Tax?: FieldPolicy<any> | FieldReadFunction<any>,
	Total?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LifecycleStageKeySpecifier = ('CreatedAt' | 'Description' | 'ID' | 'Name' | 'UpdatedAt' | LifecycleStageKeySpecifier)[];
export type LifecycleStageFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListKeySpecifier = ('CreatedAt' | 'Description' | 'Entity' | 'EntityID' | 'ID' | 'ListDetails' | 'Name' | 'UpdatedAt' | 'User' | 'UserID' | ListKeySpecifier)[];
export type ListFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	ListDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListDetailKeySpecifier = ('ID' | 'ListID' | 'RecordID' | 'Sequence' | ListDetailKeySpecifier)[];
export type ListDetailFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	ListID?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('AddUserFavorite' | 'CreateAccount' | 'CreateApplicationEntity' | 'CreateAuditLog' | 'CreateCompany' | 'CreateContact' | 'CreateDeal' | 'CreateEmployee' | 'CreateEntity' | 'CreateEntityField' | 'CreateEntityPermission' | 'CreateEntityRelationship' | 'CreateList' | 'CreateListDetail' | 'CreateRecordChange' | 'CreateTaxReturn' | 'CreateTaxReturnCompensation' | 'CreateTaxReturnContractor' | 'CreateTaxReturnDetail' | 'CreateUserApplicationEntity' | 'CreateUserFavorite' | 'CreateUserView' | 'CreateUserViewRun' | 'CreateUserViewRunDetail' | 'DeleteAccount' | 'DeleteApplicationEntity' | 'DeleteCompany' | 'DeleteContact' | 'DeleteDeal' | 'DeleteEmployee' | 'DeleteEntity' | 'DeleteEntityField' | 'DeleteEntityPermission' | 'DeleteEntityRelationship' | 'DeleteList' | 'DeleteListDetail' | 'DeleteUserApplicationEntity' | 'DeleteUserFavorite' | 'DeleteUserView' | 'SetRecordFavoriteStatus' | 'UpdateAIAction' | 'UpdateAIModel' | 'UpdateAIModelAction' | 'UpdateAIModelType' | 'UpdateAccount' | 'UpdateAccountCompanyIntegration' | 'UpdateAccountType' | 'UpdateActivity' | 'UpdateActivityAttachment' | 'UpdateApplication' | 'UpdateApplicationEntity' | 'UpdateApplicationPermission' | 'UpdateAuditLog' | 'UpdateCampaign' | 'UpdateCampaignStep' | 'UpdateCompany' | 'UpdateCompanyIntegration' | 'UpdateContact' | 'UpdateContactAccount' | 'UpdateContactCompanyIntegration' | 'UpdateContactEmail' | 'UpdateContactTopic' | 'UpdateDeal' | 'UpdateDealStage' | 'UpdateDealType' | 'UpdateEmailServiceProviders' | 'UpdateEmployee' | 'UpdateEntity' | 'UpdateEntityAIAction' | 'UpdateEntityField' | 'UpdateEntityPermission' | 'UpdateEntityRelationship' | 'UpdateIntegration' | 'UpdateIntegrationURLFormat' | 'UpdateInvoice' | 'UpdateLifecycleStage' | 'UpdateList' | 'UpdateListDetail' | 'UpdatePayment' | 'UpdateProject' | 'UpdateProjectBillingType' | 'UpdateProjectRateType' | 'UpdateProjectStatusType' | 'UpdateRole' | 'UpdateTask' | 'UpdateTaskType' | 'UpdateTaxReturn' | 'UpdateTimeEntry' | 'UpdateUser' | 'UpdateUserApplication' | 'UpdateUserApplicationEntity' | 'UpdateUserFavorite' | 'UpdateUserRecordLog' | 'UpdateUserView' | 'UpdateUserViewRun' | 'UpdateUserViewRunDetail' | 'UpdateWorkflow' | 'UpdateWorkflowEngine' | 'UpdateWorkflowRun' | 'Update_990Full' | 'Update_990Latest' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	AddUserFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateAuditLog?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateDeal?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateEntityField?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateEntityPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateEntityRelationship?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateList?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateListDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateRecordChange?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateTaxReturn?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateTaxReturnCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateTaxReturnContractor?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateTaxReturnDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateUserApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateUserFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateUserView?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateUserViewRun?: FieldPolicy<any> | FieldReadFunction<any>,
	CreateUserViewRunDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteContact?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteDeal?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteEntityField?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteEntityPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteEntityRelationship?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteList?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteListDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteUserApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteUserFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	DeleteUserView?: FieldPolicy<any> | FieldReadFunction<any>,
	SetRecordFavoriteStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAIAction?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAIModel?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAIModelAction?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAIModelType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAccountCompanyIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAccountType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateActivityAttachment?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateApplication?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateApplicationPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateAuditLog?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateCampaign?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateCampaignStep?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateCompanyIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateContact?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateContactAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateContactCompanyIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateContactTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateDeal?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateDealStage?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateDealType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEmailServiceProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEntityAIAction?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEntityField?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEntityPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateEntityRelationship?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateIntegrationURLFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateLifecycleStage?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateList?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateListDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatePayment?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateProject?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateProjectBillingType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateProjectRateType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateProjectStatusType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateRole?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateTask?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateTaskType?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateTaxReturn?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateTimeEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserApplication?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserRecordLog?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserView?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserViewRun?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateUserViewRunDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateWorkflow?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateWorkflowEngine?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateWorkflowRun?: FieldPolicy<any> | FieldReadFunction<any>,
	Update_990Full?: FieldPolicy<any> | FieldReadFunction<any>,
	Update_990Latest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NAICSKeySpecifier = ('Code' | 'Description' | 'Name' | NAICSKeySpecifier)[];
export type NAICSFieldPolicy = {
	Code?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('Account' | 'AccountID' | 'AccountWebsite' | 'Amount' | 'BCMID' | 'Comments' | 'Company' | 'CompanyID' | 'CompanyIntegrationID' | 'Contact' | 'ContactEmail' | 'CreatedAt' | 'Description' | 'DocumentNumber' | 'ExternalSystemRecordID' | 'ID' | 'InvoiceID' | 'PaymentDate' | 'UpdatedAt' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountWebsite?: FieldPolicy<any> | FieldReadFunction<any>,
	Amount?: FieldPolicy<any> | FieldReadFunction<any>,
	BCMID?: FieldPolicy<any> | FieldReadFunction<any>,
	Comments?: FieldPolicy<any> | FieldReadFunction<any>,
	Company?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DocumentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	InvoiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	PaymentDate?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectKeySpecifier = ('AccountID' | 'BillingType' | 'BillingTypeID' | 'BudgetAmount' | 'CompanyIntegrationID' | 'CreatedAt' | 'DueDate' | 'Employee' | 'EmployeeID' | 'ExternalSystemRecordID' | 'FixedFee' | 'ID' | 'IsDeleted' | 'Name' | 'ProjectRate' | 'RateType' | 'RateTypeID' | 'StartDate' | 'Status' | 'StatusID' | 'UpdatedAt' | ProjectKeySpecifier)[];
export type ProjectFieldPolicy = {
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	BillingType?: FieldPolicy<any> | FieldReadFunction<any>,
	BillingTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	BudgetAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegrationID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	DueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Employee?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	FixedFee?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	ProjectRate?: FieldPolicy<any> | FieldReadFunction<any>,
	RateType?: FieldPolicy<any> | FieldReadFunction<any>,
	RateTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	StartDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	StatusID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectBillingTypeKeySpecifier = ('Code' | 'CreatedAt' | 'Description' | 'ID' | 'Name' | 'UpdatedAt' | ProjectBillingTypeKeySpecifier)[];
export type ProjectBillingTypeFieldPolicy = {
	Code?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectRateTypeKeySpecifier = ('Code' | 'CreatedAt' | 'Description' | 'ID' | 'Name' | 'UpdatedAt' | ProjectRateTypeKeySpecifier)[];
export type ProjectRateTypeFieldPolicy = {
	Code?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectStatusTypeKeySpecifier = ('Code' | 'CreatedAt' | 'Description' | 'ID' | 'IsClosed' | 'Name' | 'UpdatedAt' | ProjectStatusTypeKeySpecifier)[];
export type ProjectStatusTypeFieldPolicy = {
	Code?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('AIAction' | 'AIModel' | 'AIModelAction' | 'AIModelType' | 'Account' | 'AccountCompanyIntegration' | 'AccountType' | 'Activity' | 'ActivityAttachment' | 'AllAIActions' | 'AllAIModelActions' | 'AllAIModelTypes' | 'AllAIModels' | 'AllAccountTypes' | 'AllApplications' | 'AllAuditLogTypes' | 'AllAuthorizationRoles' | 'AllAuthorizations' | 'AllCompanies' | 'AllDealStages' | 'AllDealTypes' | 'AllDeals' | 'AllEmailServiceProviders' | 'AllEmployees' | 'AllEntities' | 'AllEntityFields' | 'AllEntityPermissions' | 'AllIntegrationURLFormats' | 'AllIntegrations' | 'AllLatestMetadataUpdates' | 'AllLifecycleStages' | 'AllRoles' | 'AllRowLevelSecurityFilters' | 'AllSkills' | 'AllTaskTypes' | 'AllUserRoles' | 'AllUserViews' | 'AllUsers' | 'Application' | 'ApplicationEntity' | 'ApplicationPermission' | 'AuditLog' | 'AuditLogType' | 'Authorization' | 'AuthorizationRole' | 'Campaign' | 'CampaignStep' | 'Company' | 'CompanyIntegration' | 'Contact' | 'ContactAccount' | 'ContactCompanyIntegration' | 'ContactEmail' | 'ContactLevel' | 'ContactRole' | 'ContactTopic' | 'CurrentUser' | 'CurrentUserDefaultViewByEntityID' | 'CurrentUserUserViewsByEntityID' | 'Deal' | 'DealStage' | 'DealType' | 'DefaultViewByUserAndEntity' | 'EmailServiceProviders' | 'Employee' | 'Entity' | 'EntityAIAction' | 'EntityField' | 'EntityFieldValue' | 'EntityPermission' | 'EntityRelationship' | 'ExecuteAskSkipQuery' | 'GetEntityRecordName' | 'GetRecordFavoriteStatus' | 'Integration' | 'IntegrationURLFormat' | 'Invoice' | 'LifecycleStage' | 'List' | 'ListDetail' | 'Payment' | 'Project' | 'ProjectBillingType' | 'ProjectRateType' | 'ProjectStatusType' | 'Queue' | 'QueueTask' | 'QueueType' | 'RecordChange' | 'Role' | 'RowLevelSecurityFilter' | 'RunAIActionUnsavedView' | 'RunAIActionViewByID' | 'RunAIActionViewByName' | 'RunAIModelActionUnsavedView' | 'RunAIModelActionViewByID' | 'RunAIModelActionViewByName' | 'RunAIModelTypeUnsavedView' | 'RunAIModelTypeViewByID' | 'RunAIModelTypeViewByName' | 'RunAIModelUnsavedView' | 'RunAIModelViewByID' | 'RunAIModelViewByName' | 'RunAccountCompanyIntegrationUnsavedView' | 'RunAccountCompanyIntegrationViewByID' | 'RunAccountCompanyIntegrationViewByName' | 'RunAccountTypeUnsavedView' | 'RunAccountTypeViewByID' | 'RunAccountTypeViewByName' | 'RunAccountUnsavedView' | 'RunAccountViewByID' | 'RunAccountViewByName' | 'RunActivityAttachmentUnsavedView' | 'RunActivityAttachmentViewByID' | 'RunActivityAttachmentViewByName' | 'RunActivityUnsavedView' | 'RunActivityViewByID' | 'RunActivityViewByName' | 'RunApplicationEntityUnsavedView' | 'RunApplicationEntityViewByID' | 'RunApplicationEntityViewByName' | 'RunApplicationPermissionUnsavedView' | 'RunApplicationPermissionViewByID' | 'RunApplicationPermissionViewByName' | 'RunApplicationUnsavedView' | 'RunApplicationViewByID' | 'RunApplicationViewByName' | 'RunAuditLogTypeUnsavedView' | 'RunAuditLogTypeViewByID' | 'RunAuditLogTypeViewByName' | 'RunAuditLogUnsavedView' | 'RunAuditLogViewByID' | 'RunAuditLogViewByName' | 'RunAuthorizationRoleUnsavedView' | 'RunAuthorizationRoleViewByID' | 'RunAuthorizationRoleViewByName' | 'RunAuthorizationUnsavedView' | 'RunAuthorizationViewByID' | 'RunAuthorizationViewByName' | 'RunCampaignStepUnsavedView' | 'RunCampaignStepViewByID' | 'RunCampaignStepViewByName' | 'RunCampaignUnsavedView' | 'RunCampaignViewByID' | 'RunCampaignViewByName' | 'RunCompanyIntegrationUnsavedView' | 'RunCompanyIntegrationViewByID' | 'RunCompanyIntegrationViewByName' | 'RunCompanyUnsavedView' | 'RunCompanyViewByID' | 'RunCompanyViewByName' | 'RunContactAccountUnsavedView' | 'RunContactAccountViewByID' | 'RunContactAccountViewByName' | 'RunContactCompanyIntegrationUnsavedView' | 'RunContactCompanyIntegrationViewByID' | 'RunContactCompanyIntegrationViewByName' | 'RunContactEmailUnsavedView' | 'RunContactEmailViewByID' | 'RunContactEmailViewByName' | 'RunContactLevelUnsavedView' | 'RunContactLevelViewByID' | 'RunContactLevelViewByName' | 'RunContactRoleUnsavedView' | 'RunContactRoleViewByID' | 'RunContactRoleViewByName' | 'RunContactTopicUnsavedView' | 'RunContactTopicViewByID' | 'RunContactTopicViewByName' | 'RunContactUnsavedView' | 'RunContactViewByID' | 'RunContactViewByName' | 'RunDealStageUnsavedView' | 'RunDealStageViewByID' | 'RunDealStageViewByName' | 'RunDealTypeUnsavedView' | 'RunDealTypeViewByID' | 'RunDealTypeViewByName' | 'RunDealUnsavedView' | 'RunDealViewByID' | 'RunDealViewByName' | 'RunEmailServiceProvidersUnsavedView' | 'RunEmailServiceProvidersViewByID' | 'RunEmailServiceProvidersViewByName' | 'RunEmployeeUnsavedView' | 'RunEmployeeViewByID' | 'RunEmployeeViewByName' | 'RunEntityAIActionUnsavedView' | 'RunEntityAIActionViewByID' | 'RunEntityAIActionViewByName' | 'RunEntityFieldUnsavedView' | 'RunEntityFieldValueUnsavedView' | 'RunEntityFieldValueViewByID' | 'RunEntityFieldValueViewByName' | 'RunEntityFieldViewByID' | 'RunEntityFieldViewByName' | 'RunEntityPermissionUnsavedView' | 'RunEntityPermissionViewByID' | 'RunEntityPermissionViewByName' | 'RunEntityRelationshipUnsavedView' | 'RunEntityRelationshipViewByID' | 'RunEntityRelationshipViewByName' | 'RunEntityUnsavedView' | 'RunEntityViewByID' | 'RunEntityViewByName' | 'RunIntegrationURLFormatUnsavedView' | 'RunIntegrationURLFormatViewByID' | 'RunIntegrationURLFormatViewByName' | 'RunIntegrationUnsavedView' | 'RunIntegrationViewByID' | 'RunIntegrationViewByName' | 'RunInvoiceUnsavedView' | 'RunInvoiceViewByID' | 'RunInvoiceViewByName' | 'RunLifecycleStageUnsavedView' | 'RunLifecycleStageViewByID' | 'RunLifecycleStageViewByName' | 'RunListDetailUnsavedView' | 'RunListDetailViewByID' | 'RunListDetailViewByName' | 'RunListUnsavedView' | 'RunListViewByID' | 'RunListViewByName' | 'RunPaymentUnsavedView' | 'RunPaymentViewByID' | 'RunPaymentViewByName' | 'RunProjectBillingTypeUnsavedView' | 'RunProjectBillingTypeViewByID' | 'RunProjectBillingTypeViewByName' | 'RunProjectRateTypeUnsavedView' | 'RunProjectRateTypeViewByID' | 'RunProjectRateTypeViewByName' | 'RunProjectStatusTypeUnsavedView' | 'RunProjectStatusTypeViewByID' | 'RunProjectStatusTypeViewByName' | 'RunProjectUnsavedView' | 'RunProjectViewByID' | 'RunProjectViewByName' | 'RunQueueTaskUnsavedView' | 'RunQueueTaskViewByID' | 'RunQueueTaskViewByName' | 'RunQueueTypeUnsavedView' | 'RunQueueTypeViewByID' | 'RunQueueTypeViewByName' | 'RunQueueUnsavedView' | 'RunQueueViewByID' | 'RunQueueViewByName' | 'RunRecordChangeUnsavedView' | 'RunRecordChangeViewByID' | 'RunRecordChangeViewByName' | 'RunRoleUnsavedView' | 'RunRoleViewByID' | 'RunRoleViewByName' | 'RunRowLevelSecurityFilterUnsavedView' | 'RunRowLevelSecurityFilterViewByID' | 'RunRowLevelSecurityFilterViewByName' | 'RunSkillUnsavedView' | 'RunSkillViewByID' | 'RunSkillViewByName' | 'RunTaskTypeUnsavedView' | 'RunTaskTypeViewByID' | 'RunTaskTypeViewByName' | 'RunTaskUnsavedView' | 'RunTaskViewByID' | 'RunTaskViewByName' | 'RunTaxReturnCompensationUnsavedView' | 'RunTaxReturnCompensationViewByID' | 'RunTaxReturnCompensationViewByName' | 'RunTaxReturnContractorUnsavedView' | 'RunTaxReturnContractorViewByID' | 'RunTaxReturnContractorViewByName' | 'RunTaxReturnDetailUnsavedView' | 'RunTaxReturnDetailViewByID' | 'RunTaxReturnDetailViewByName' | 'RunTaxReturnUnsavedView' | 'RunTaxReturnViewByID' | 'RunTaxReturnViewByName' | 'RunTeamUnsavedView' | 'RunTeamViewByID' | 'RunTeamViewByName' | 'RunTimeEntryUnsavedView' | 'RunTimeEntryViewByID' | 'RunTimeEntryViewByName' | 'RunUnsavedView' | 'RunUserApplicationEntityUnsavedView' | 'RunUserApplicationEntityViewByID' | 'RunUserApplicationEntityViewByName' | 'RunUserApplicationUnsavedView' | 'RunUserApplicationViewByID' | 'RunUserApplicationViewByName' | 'RunUserFavoriteUnsavedView' | 'RunUserFavoriteViewByID' | 'RunUserFavoriteViewByName' | 'RunUserRecordLogUnsavedView' | 'RunUserRecordLogViewByID' | 'RunUserRecordLogViewByName' | 'RunUserRoleUnsavedView' | 'RunUserRoleViewByID' | 'RunUserRoleViewByName' | 'RunUserUnsavedView' | 'RunUserViewByID' | 'RunUserViewByName' | 'RunUserViewRunDetailUnsavedView' | 'RunUserViewRunDetailViewByID' | 'RunUserViewRunDetailViewByName' | 'RunUserViewRunUnsavedView' | 'RunUserViewRunViewByID' | 'RunUserViewRunViewByName' | 'RunUserViewUnsavedView' | 'RunUserViewViewByID' | 'RunUserViewViewByName' | 'RunViewByID' | 'RunViewByName' | 'RunWorkflowEngineUnsavedView' | 'RunWorkflowEngineViewByID' | 'RunWorkflowEngineViewByName' | 'RunWorkflowRunUnsavedView' | 'RunWorkflowRunViewByID' | 'RunWorkflowRunViewByName' | 'RunWorkflowUnsavedView' | 'RunWorkflowViewByID' | 'RunWorkflowViewByName' | 'Run_990FullUnsavedView' | 'Run_990FullViewByID' | 'Run_990FullViewByName' | 'Run_990LatestUnsavedView' | 'Run_990LatestViewByID' | 'Run_990LatestViewByName' | 'Skill' | 'Task' | 'TaskType' | 'TaxReturn' | 'TaxReturnCompensation' | 'TaxReturnContractor' | 'TaxReturnDetail' | 'Team' | 'TimeEntry' | 'UpdateWhereClause' | 'User' | 'UserApplication' | 'UserApplicationEntity' | 'UserByEmail' | 'UserByEmployeeID' | 'UserByID' | 'UserFavorite' | 'UserFavoriteSearchByParams' | 'UserFavoritesByUserID' | 'UserRecordLog' | 'UserRole' | 'UserView' | 'UserViewRun' | 'UserViewRunDetail' | 'UserViewsByUserID' | 'Workflow' | 'WorkflowEngine' | 'WorkflowRun' | '_990Full' | '_990Latest' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	AIAction?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModel?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModelAction?: FieldPolicy<any> | FieldReadFunction<any>,
	AIModelType?: FieldPolicy<any> | FieldReadFunction<any>,
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountCompanyIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountType?: FieldPolicy<any> | FieldReadFunction<any>,
	Activity?: FieldPolicy<any> | FieldReadFunction<any>,
	ActivityAttachment?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAIActions?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAIModelActions?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAIModelTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAIModels?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAccountTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	AllApplications?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAuditLogTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAuthorizationRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	AllAuthorizations?: FieldPolicy<any> | FieldReadFunction<any>,
	AllCompanies?: FieldPolicy<any> | FieldReadFunction<any>,
	AllDealStages?: FieldPolicy<any> | FieldReadFunction<any>,
	AllDealTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	AllDeals?: FieldPolicy<any> | FieldReadFunction<any>,
	AllEmailServiceProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	AllEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	AllEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	AllEntityFields?: FieldPolicy<any> | FieldReadFunction<any>,
	AllEntityPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	AllIntegrationURLFormats?: FieldPolicy<any> | FieldReadFunction<any>,
	AllIntegrations?: FieldPolicy<any> | FieldReadFunction<any>,
	AllLatestMetadataUpdates?: FieldPolicy<any> | FieldReadFunction<any>,
	AllLifecycleStages?: FieldPolicy<any> | FieldReadFunction<any>,
	AllRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	AllRowLevelSecurityFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	AllSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	AllTaskTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	AllUserRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	AllUserViews?: FieldPolicy<any> | FieldReadFunction<any>,
	AllUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	Application?: FieldPolicy<any> | FieldReadFunction<any>,
	ApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	ApplicationPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	AuditLog?: FieldPolicy<any> | FieldReadFunction<any>,
	AuditLogType?: FieldPolicy<any> | FieldReadFunction<any>,
	Authorization?: FieldPolicy<any> | FieldReadFunction<any>,
	AuthorizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	Campaign?: FieldPolicy<any> | FieldReadFunction<any>,
	CampaignStep?: FieldPolicy<any> | FieldReadFunction<any>,
	Company?: FieldPolicy<any> | FieldReadFunction<any>,
	CompanyIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactCompanyIntegration?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactRole?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	CurrentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	CurrentUserDefaultViewByEntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	CurrentUserUserViewsByEntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	Deal?: FieldPolicy<any> | FieldReadFunction<any>,
	DealStage?: FieldPolicy<any> | FieldReadFunction<any>,
	DealType?: FieldPolicy<any> | FieldReadFunction<any>,
	DefaultViewByUserAndEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	EmailServiceProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	Employee?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityAIAction?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityField?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityFieldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityPermission?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityRelationship?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecuteAskSkipQuery?: FieldPolicy<any> | FieldReadFunction<any>,
	GetEntityRecordName?: FieldPolicy<any> | FieldReadFunction<any>,
	GetRecordFavoriteStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	Integration?: FieldPolicy<any> | FieldReadFunction<any>,
	IntegrationURLFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	Invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	LifecycleStage?: FieldPolicy<any> | FieldReadFunction<any>,
	List?: FieldPolicy<any> | FieldReadFunction<any>,
	ListDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	Payment?: FieldPolicy<any> | FieldReadFunction<any>,
	Project?: FieldPolicy<any> | FieldReadFunction<any>,
	ProjectBillingType?: FieldPolicy<any> | FieldReadFunction<any>,
	ProjectRateType?: FieldPolicy<any> | FieldReadFunction<any>,
	ProjectStatusType?: FieldPolicy<any> | FieldReadFunction<any>,
	Queue?: FieldPolicy<any> | FieldReadFunction<any>,
	QueueTask?: FieldPolicy<any> | FieldReadFunction<any>,
	QueueType?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordChange?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	RowLevelSecurityFilter?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIActionUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIActionViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIActionViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelActionUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelActionViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelActionViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAIModelViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountCompanyIntegrationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountCompanyIntegrationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountCompanyIntegrationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAccountViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunActivityAttachmentUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunActivityAttachmentViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunActivityAttachmentViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunActivityUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunActivityViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunActivityViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationEntityUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationEntityViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationEntityViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationPermissionUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationPermissionViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationPermissionViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunApplicationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuditLogTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuditLogTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuditLogTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuditLogUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuditLogViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuditLogViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuthorizationRoleUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuthorizationRoleViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuthorizationRoleViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuthorizationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuthorizationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAuthorizationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCampaignStepUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCampaignStepViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCampaignStepViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCampaignUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCampaignViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCampaignViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCompanyIntegrationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCompanyIntegrationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCompanyIntegrationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCompanyUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCompanyViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunCompanyViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactAccountUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactAccountViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactAccountViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactCompanyIntegrationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactCompanyIntegrationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactCompanyIntegrationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactEmailUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactEmailViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactEmailViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactLevelUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactLevelViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactLevelViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactRoleUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactRoleViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactRoleViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactTopicUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactTopicViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactTopicViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunContactViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealStageUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealStageViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealStageViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunDealViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEmailServiceProvidersUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEmailServiceProvidersViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEmailServiceProvidersViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEmployeeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEmployeeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEmployeeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityAIActionUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityAIActionViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityAIActionViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityFieldUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityFieldValueUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityFieldValueViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityFieldValueViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityFieldViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityFieldViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityPermissionUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityPermissionViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityPermissionViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityRelationshipUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityRelationshipViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityRelationshipViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunEntityViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunIntegrationURLFormatUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunIntegrationURLFormatViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunIntegrationURLFormatViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunIntegrationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunIntegrationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunIntegrationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunInvoiceUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunInvoiceViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunInvoiceViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunLifecycleStageUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunLifecycleStageViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunLifecycleStageViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunListDetailUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunListDetailViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunListDetailViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunListUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunListViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunListViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunPaymentUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunPaymentViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunPaymentViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectBillingTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectBillingTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectBillingTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectRateTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectRateTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectRateTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectStatusTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectStatusTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectStatusTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunProjectViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueTaskUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueTaskViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueTaskViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunQueueViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRecordChangeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRecordChangeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRecordChangeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRoleUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRoleViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRoleViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRowLevelSecurityFilterUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRowLevelSecurityFilterViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunRowLevelSecurityFilterViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunSkillUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunSkillViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunSkillViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaskTypeUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaskTypeViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaskTypeViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaskUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaskViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaskViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnCompensationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnCompensationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnCompensationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnContractorUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnContractorViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnContractorViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnDetailUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnDetailViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnDetailViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTaxReturnViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTeamUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTeamViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTeamViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTimeEntryUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTimeEntryViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunTimeEntryViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserApplicationEntityUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserApplicationEntityViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserApplicationEntityViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserApplicationUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserApplicationViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserApplicationViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserFavoriteUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserFavoriteViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserFavoriteViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserRecordLogUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserRecordLogViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserRecordLogViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserRoleUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserRoleViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserRoleViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewRunDetailUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewRunDetailViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewRunDetailViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewRunUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewRunViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewRunViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunUserViewViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowEngineUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowEngineViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowEngineViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowRunUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowRunViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowRunViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunWorkflowViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	Run_990FullUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	Run_990FullViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	Run_990FullViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	Run_990LatestUnsavedView?: FieldPolicy<any> | FieldReadFunction<any>,
	Run_990LatestViewByID?: FieldPolicy<any> | FieldReadFunction<any>,
	Run_990LatestViewByName?: FieldPolicy<any> | FieldReadFunction<any>,
	Skill?: FieldPolicy<any> | FieldReadFunction<any>,
	Task?: FieldPolicy<any> | FieldReadFunction<any>,
	TaskType?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturn?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnContractor?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	Team?: FieldPolicy<any> | FieldReadFunction<any>,
	TimeEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdateWhereClause?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserApplication?: FieldPolicy<any> | FieldReadFunction<any>,
	UserApplicationEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	UserByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	UserByEmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserByID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFavoriteSearchByParams?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFavoritesByUserID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserRecordLog?: FieldPolicy<any> | FieldReadFunction<any>,
	UserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	UserView?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRun?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewsByUserID?: FieldPolicy<any> | FieldReadFunction<any>,
	Workflow?: FieldPolicy<any> | FieldReadFunction<any>,
	WorkflowEngine?: FieldPolicy<any> | FieldReadFunction<any>,
	WorkflowRun?: FieldPolicy<any> | FieldReadFunction<any>,
	_990Full?: FieldPolicy<any> | FieldReadFunction<any>,
	_990Latest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueueKeySpecifier = ('Description' | 'ID' | 'IsActive' | 'Name' | 'QueueType' | 'QueueTypeID' | QueueKeySpecifier)[];
export type QueueFieldPolicy = {
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	QueueType?: FieldPolicy<any> | FieldReadFunction<any>,
	QueueTypeID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueueTaskKeySpecifier = ('Comments' | 'EndedAt' | 'ErrorMessage' | 'ID' | 'Output' | 'QueueID' | 'StartedAt' | 'Status' | QueueTaskKeySpecifier)[];
export type QueueTaskFieldPolicy = {
	Comments?: FieldPolicy<any> | FieldReadFunction<any>,
	EndedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Output?: FieldPolicy<any> | FieldReadFunction<any>,
	QueueID?: FieldPolicy<any> | FieldReadFunction<any>,
	StartedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueueTypeKeySpecifier = ('Description' | 'DriverClass' | 'DriverImportPath' | 'ID' | 'Name' | QueueTypeKeySpecifier)[];
export type QueueTypeFieldPolicy = {
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverClass?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverImportPath?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecordChangeKeySpecifier = ('ChangedAt' | 'ChangesDescription' | 'ChangesJSON' | 'Comments' | 'Entity' | 'EntityID' | 'FullRecordJSON' | 'ID' | 'RecordID' | 'Status' | 'User' | 'UserID' | RecordChangeKeySpecifier)[];
export type RecordChangeFieldPolicy = {
	ChangedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ChangesDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	ChangesJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	Comments?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	FullRecordJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('AzureID' | 'CreatedAt' | 'Description' | 'ID' | 'Name' | 'SQLName' | 'UpdatedAt' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	AzureID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	SQLName?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RowLevelSecurityFilterKeySpecifier = ('CreatedAt' | 'Description' | 'FilterText' | 'ID' | 'Name' | 'UpdatedAt' | RowLevelSecurityFilterKeySpecifier)[];
export type RowLevelSecurityFilterFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	FilterText?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAIActionViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAIActionViewResultKeySpecifier)[];
export type RunAIActionViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAIModelActionViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAIModelActionViewResultKeySpecifier)[];
export type RunAIModelActionViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAIModelTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAIModelTypeViewResultKeySpecifier)[];
export type RunAIModelTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAIModelViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAIModelViewResultKeySpecifier)[];
export type RunAIModelViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAccountCompanyIntegrationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAccountCompanyIntegrationViewResultKeySpecifier)[];
export type RunAccountCompanyIntegrationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAccountTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAccountTypeViewResultKeySpecifier)[];
export type RunAccountTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAccountViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAccountViewResultKeySpecifier)[];
export type RunAccountViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunActivityAttachmentViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunActivityAttachmentViewResultKeySpecifier)[];
export type RunActivityAttachmentViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunActivityViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunActivityViewResultKeySpecifier)[];
export type RunActivityViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunApplicationEntityViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunApplicationEntityViewResultKeySpecifier)[];
export type RunApplicationEntityViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunApplicationPermissionViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunApplicationPermissionViewResultKeySpecifier)[];
export type RunApplicationPermissionViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunApplicationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunApplicationViewResultKeySpecifier)[];
export type RunApplicationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAuditLogTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAuditLogTypeViewResultKeySpecifier)[];
export type RunAuditLogTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAuditLogViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAuditLogViewResultKeySpecifier)[];
export type RunAuditLogViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAuthorizationRoleViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAuthorizationRoleViewResultKeySpecifier)[];
export type RunAuthorizationRoleViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunAuthorizationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunAuthorizationViewResultKeySpecifier)[];
export type RunAuthorizationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunCampaignStepViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunCampaignStepViewResultKeySpecifier)[];
export type RunCampaignStepViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunCampaignViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunCampaignViewResultKeySpecifier)[];
export type RunCampaignViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunCompanyIntegrationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunCompanyIntegrationViewResultKeySpecifier)[];
export type RunCompanyIntegrationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunCompanyViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunCompanyViewResultKeySpecifier)[];
export type RunCompanyViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactAccountViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactAccountViewResultKeySpecifier)[];
export type RunContactAccountViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactCompanyIntegrationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactCompanyIntegrationViewResultKeySpecifier)[];
export type RunContactCompanyIntegrationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactEmailViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactEmailViewResultKeySpecifier)[];
export type RunContactEmailViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactLevelViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactLevelViewResultKeySpecifier)[];
export type RunContactLevelViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactRoleViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactRoleViewResultKeySpecifier)[];
export type RunContactRoleViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactTopicViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactTopicViewResultKeySpecifier)[];
export type RunContactTopicViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunContactViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunContactViewResultKeySpecifier)[];
export type RunContactViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunDealStageViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunDealStageViewResultKeySpecifier)[];
export type RunDealStageViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunDealTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunDealTypeViewResultKeySpecifier)[];
export type RunDealTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunDealViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunDealViewResultKeySpecifier)[];
export type RunDealViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEmailServiceProvidersViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEmailServiceProvidersViewResultKeySpecifier)[];
export type RunEmailServiceProvidersViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEmployeeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEmployeeViewResultKeySpecifier)[];
export type RunEmployeeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEntityAIActionViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEntityAIActionViewResultKeySpecifier)[];
export type RunEntityAIActionViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEntityFieldValueViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEntityFieldValueViewResultKeySpecifier)[];
export type RunEntityFieldValueViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEntityFieldViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEntityFieldViewResultKeySpecifier)[];
export type RunEntityFieldViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEntityPermissionViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEntityPermissionViewResultKeySpecifier)[];
export type RunEntityPermissionViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEntityRelationshipViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEntityRelationshipViewResultKeySpecifier)[];
export type RunEntityRelationshipViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunEntityViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunEntityViewResultKeySpecifier)[];
export type RunEntityViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunIntegrationURLFormatViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunIntegrationURLFormatViewResultKeySpecifier)[];
export type RunIntegrationURLFormatViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunIntegrationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunIntegrationViewResultKeySpecifier)[];
export type RunIntegrationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunInvoiceViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunInvoiceViewResultKeySpecifier)[];
export type RunInvoiceViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunLifecycleStageViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunLifecycleStageViewResultKeySpecifier)[];
export type RunLifecycleStageViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunListDetailViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunListDetailViewResultKeySpecifier)[];
export type RunListDetailViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunListViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunListViewResultKeySpecifier)[];
export type RunListViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunPaymentViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunPaymentViewResultKeySpecifier)[];
export type RunPaymentViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunProjectBillingTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunProjectBillingTypeViewResultKeySpecifier)[];
export type RunProjectBillingTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunProjectRateTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunProjectRateTypeViewResultKeySpecifier)[];
export type RunProjectRateTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunProjectStatusTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunProjectStatusTypeViewResultKeySpecifier)[];
export type RunProjectStatusTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunProjectViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunProjectViewResultKeySpecifier)[];
export type RunProjectViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunQueueTaskViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunQueueTaskViewResultKeySpecifier)[];
export type RunQueueTaskViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunQueueTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunQueueTypeViewResultKeySpecifier)[];
export type RunQueueTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunQueueViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunQueueViewResultKeySpecifier)[];
export type RunQueueViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunRecordChangeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunRecordChangeViewResultKeySpecifier)[];
export type RunRecordChangeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunRoleViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunRoleViewResultKeySpecifier)[];
export type RunRoleViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunRowLevelSecurityFilterViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunRowLevelSecurityFilterViewResultKeySpecifier)[];
export type RunRowLevelSecurityFilterViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunSkillViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunSkillViewResultKeySpecifier)[];
export type RunSkillViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTaskTypeViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTaskTypeViewResultKeySpecifier)[];
export type RunTaskTypeViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTaskViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTaskViewResultKeySpecifier)[];
export type RunTaskViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTaxReturnCompensationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTaxReturnCompensationViewResultKeySpecifier)[];
export type RunTaxReturnCompensationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTaxReturnContractorViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTaxReturnContractorViewResultKeySpecifier)[];
export type RunTaxReturnContractorViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTaxReturnDetailViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTaxReturnDetailViewResultKeySpecifier)[];
export type RunTaxReturnDetailViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTaxReturnViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTaxReturnViewResultKeySpecifier)[];
export type RunTaxReturnViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTeamViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTeamViewResultKeySpecifier)[];
export type RunTeamViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunTimeEntryViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunTimeEntryViewResultKeySpecifier)[];
export type RunTimeEntryViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserApplicationEntityViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserApplicationEntityViewResultKeySpecifier)[];
export type RunUserApplicationEntityViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserApplicationViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserApplicationViewResultKeySpecifier)[];
export type RunUserApplicationViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserFavoriteViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserFavoriteViewResultKeySpecifier)[];
export type RunUserFavoriteViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserRecordLogViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserRecordLogViewResultKeySpecifier)[];
export type RunUserRecordLogViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserRoleViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserRoleViewResultKeySpecifier)[];
export type RunUserRoleViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserViewResultKeySpecifier)[];
export type RunUserViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserViewRunDetailViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserViewRunDetailViewResultKeySpecifier)[];
export type RunUserViewRunDetailViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserViewRunViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserViewRunViewResultKeySpecifier)[];
export type RunUserViewRunViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunUserViewViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunUserViewViewResultKeySpecifier)[];
export type RunUserViewViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunViewResultKeySpecifier)[];
export type RunViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunViewResultRowKeySpecifier = ('Data' | 'EntityID' | 'ID' | RunViewResultRowKeySpecifier)[];
export type RunViewResultRowFieldPolicy = {
	Data?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunWorkflowEngineViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunWorkflowEngineViewResultKeySpecifier)[];
export type RunWorkflowEngineViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunWorkflowRunViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunWorkflowRunViewResultKeySpecifier)[];
export type RunWorkflowRunViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunWorkflowViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | RunWorkflowViewResultKeySpecifier)[];
export type RunWorkflowViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Run_990FullViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | Run_990FullViewResultKeySpecifier)[];
export type Run_990FullViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Run_990LatestViewResultKeySpecifier = ('ErrorMessage' | 'ExecutionTime' | 'Results' | 'RowCount' | 'Success' | 'UserViewRunID' | Run_990LatestViewResultKeySpecifier)[];
export type Run_990LatestViewResultFieldPolicy = {
	ErrorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	ExecutionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	RowCount?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SkillKeySpecifier = ('CreatedAt' | 'ID' | 'Name' | 'ParentID' | 'UpdatedAt' | SkillKeySpecifier)[];
export type SkillFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('ActualEffort' | 'ActualVariance' | 'AssignedEmployee' | 'AssignedEmployeeID' | 'BudgetedEffort' | 'CalculatedActual' | 'CreatedAt' | 'EndDate' | 'EstimateToComplete' | 'ExternalSystemRecordID' | 'ForecastedEffort' | 'ForecastedVariance' | 'ID' | 'IsCompleted' | 'IsDeleted' | 'Name' | 'Parent' | 'ParentID' | 'Project' | 'ProjectID' | 'Role' | 'Section' | 'Skills' | 'StartDate' | 'Status' | 'TaskTypeID' | 'UpdatedAt' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	ActualEffort?: FieldPolicy<any> | FieldReadFunction<any>,
	ActualVariance?: FieldPolicy<any> | FieldReadFunction<any>,
	AssignedEmployee?: FieldPolicy<any> | FieldReadFunction<any>,
	AssignedEmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	BudgetedEffort?: FieldPolicy<any> | FieldReadFunction<any>,
	CalculatedActual?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	EndDate?: FieldPolicy<any> | FieldReadFunction<any>,
	EstimateToComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ForecastedEffort?: FieldPolicy<any> | FieldReadFunction<any>,
	ForecastedVariance?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	IsDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	Parent?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentID?: FieldPolicy<any> | FieldReadFunction<any>,
	Project?: FieldPolicy<any> | FieldReadFunction<any>,
	ProjectID?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	Section?: FieldPolicy<any> | FieldReadFunction<any>,
	Skills?: FieldPolicy<any> | FieldReadFunction<any>,
	StartDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	TaskTypeID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskTypeKeySpecifier = ('CreatedAt' | 'ID' | 'IsActive' | 'Name' | 'ParentID' | 'UpdatedAt' | TaskTypeKeySpecifier)[];
export type TaskTypeFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxReturnKeySpecifier = ('Account' | 'AccountID' | 'AccountingFees' | 'AccountsPayable' | 'AccountsReceivable' | 'ActivityDescription' | 'AddressLine1' | 'AddressLine2' | 'AdvertisingExpense' | 'AffiliatePaymentExpense' | 'Affiliation' | 'BODVotingMembers' | 'CapitalStockPrincipal' | 'Cash' | 'City' | 'ConferenceExpense' | 'CostBasisSecurities' | 'DeferredRevenue' | 'DepreciationExpense' | 'DisqualifiedPersonCompensation' | 'EscrowAccountLiability' | 'FinancialStrength' | 'FundraisingExpenses' | 'FundraisingNetIncome' | 'GrantsPayable' | 'GrantsToIndividuals' | 'GrantsToOrgs' | 'GrossFundraisingReceipts' | 'GrossRentsFromRealEstate' | 'GrossSalesSecurities' | 'HasForeignBankAcct' | 'HasInvestmentIncome' | 'ID' | 'InformationTechnologyExpense' | 'InsuranceExpense' | 'IntangibleAssetValue' | 'InterestExpense' | 'InventoryAssetValue' | 'InvestmentManagementFees' | 'IsHospital' | 'LegalFees' | 'LobbyingFees' | 'ManagementFees' | 'MissionDescription' | 'MortgagesNotesPayable' | 'Name' | 'NetGainSecurities' | 'NetRentRealEstate' | 'NotesReceivable' | 'NumberEmployees' | 'NumberVolunteers' | 'OccupancyExpense' | 'OfficeExpense' | 'OfficerCompensation' | 'OtherAssets' | 'OtherEmployeeBenefits' | 'OtherFees' | 'OtherLiabilities' | 'OtherSalaries' | 'OtherSecuritiesAssetValue' | 'PaidInCapitalSurplus' | 'PayablesToOfficers' | 'PayrollTaxes' | 'PensionContributions' | 'PermanentlyRestrictedNetAssets' | 'PledgesGrantsReceivable' | 'PostalCode' | 'PrepaidExpenseAssetValue' | 'PreparerFirm' | 'PreparerFirmAddressLine1' | 'PreparerFirmAddressLine2' | 'PreparerFirmCity' | 'PreparerFirmPostalCode' | 'PreparerFirmStateProvince' | 'PreparerFirmTaxID' | 'PreparerPerson' | 'PreparerPersonPhone' | 'PreparerPersonTaxID' | 'ProfessionalFundraisingFees' | 'ProgramInvestmentsAssetValue' | 'PublicSecuritiesAssetValue' | 'RealEstateAssetValue' | 'ReceivablesFromDisqualifiedPersons' | 'ReceivablesFromOfficers' | 'RentalExpenseRealEstate' | 'RetainedEarnings' | 'ReturnType' | 'RoyaltyExpense' | 'Savings' | 'SourceJSON' | 'StateProvince' | 'Subsection' | 'SummaryText' | 'TaxExemptBondLiability' | 'TaxID' | 'TaxMonth' | 'TaxPeriodEnd' | 'TaxPeriodStart' | 'TaxReturnCompensation' | 'TaxReturnContractors' | 'TaxReturnDetails' | 'TaxYear' | 'TemporarilyRestrictedNetAssets' | 'TotalAssets' | 'TotalGrossReceipts' | 'TotalInvestmentIncome' | 'TotalLiabilities' | 'TotalMemberIncome' | 'TotalNetAssets' | 'TotalNetAssetsPlusLiabilities' | 'TotalProgramServiceRevenue' | 'TotalRevenue' | 'TravelExpense' | 'TravelExpensePublicOfficials' | 'UnrestrictedNetAssets' | 'UnsecuredNotesPayable' | 'Website' | 'YearFormed' | TaxReturnKeySpecifier)[];
export type TaxReturnFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountsPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountsReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	ActivityDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	AddressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	AddressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	AdvertisingExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	AffiliatePaymentExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Affiliation?: FieldPolicy<any> | FieldReadFunction<any>,
	BODVotingMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	CapitalStockPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	Cash?: FieldPolicy<any> | FieldReadFunction<any>,
	City?: FieldPolicy<any> | FieldReadFunction<any>,
	ConferenceExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	CostBasisSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	DeferredRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	DepreciationExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	DisqualifiedPersonCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	EscrowAccountLiability?: FieldPolicy<any> | FieldReadFunction<any>,
	FinancialStrength?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingExpenses?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingNetIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsToIndividuals?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsToOrgs?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossFundraisingReceipts?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossRentsFromRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossSalesSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	HasForeignBankAcct?: FieldPolicy<any> | FieldReadFunction<any>,
	HasInvestmentIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	InformationTechnologyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	InsuranceExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	IntangibleAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	InterestExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	InventoryAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	InvestmentManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	IsHospital?: FieldPolicy<any> | FieldReadFunction<any>,
	LegalFees?: FieldPolicy<any> | FieldReadFunction<any>,
	LobbyingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	ManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	MissionDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	MortgagesNotesPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	NetGainSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	NetRentRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	NotesReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	NumberEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	NumberVolunteers?: FieldPolicy<any> | FieldReadFunction<any>,
	OccupancyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	OfficeExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	OfficerCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherEmployeeBenefits?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherFees?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherSalaries?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherSecuritiesAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	PaidInCapitalSurplus?: FieldPolicy<any> | FieldReadFunction<any>,
	PayablesToOfficers?: FieldPolicy<any> | FieldReadFunction<any>,
	PayrollTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	PensionContributions?: FieldPolicy<any> | FieldReadFunction<any>,
	PermanentlyRestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	PledgesGrantsReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	PostalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	PrepaidExpenseAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirm?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirmAddressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirmAddressLine2?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirmCity?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirmPostalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirmStateProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerFirmTaxID?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerPerson?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerPersonPhone?: FieldPolicy<any> | FieldReadFunction<any>,
	PreparerPersonTaxID?: FieldPolicy<any> | FieldReadFunction<any>,
	ProfessionalFundraisingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramInvestmentsAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	PublicSecuritiesAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	RealEstateAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ReceivablesFromDisqualifiedPersons?: FieldPolicy<any> | FieldReadFunction<any>,
	ReceivablesFromOfficers?: FieldPolicy<any> | FieldReadFunction<any>,
	RentalExpenseRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	RetainedEarnings?: FieldPolicy<any> | FieldReadFunction<any>,
	ReturnType?: FieldPolicy<any> | FieldReadFunction<any>,
	RoyaltyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Savings?: FieldPolicy<any> | FieldReadFunction<any>,
	SourceJSON?: FieldPolicy<any> | FieldReadFunction<any>,
	StateProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	Subsection?: FieldPolicy<any> | FieldReadFunction<any>,
	SummaryText?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxExemptBondLiability?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxID?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxPeriodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxPeriodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnContractors?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxYear?: FieldPolicy<any> | FieldReadFunction<any>,
	TemporarilyRestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalGrossReceipts?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalInvestmentIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalMemberIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalNetAssetsPlusLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalProgramServiceRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	TravelExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	TravelExpensePublicOfficials?: FieldPolicy<any> | FieldReadFunction<any>,
	UnrestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	UnsecuredNotesPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	Website?: FieldPolicy<any> | FieldReadFunction<any>,
	YearFormed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxReturnCompensationKeySpecifier = ('AnnualizedTotalCompensation' | 'AverageHoursPerWeek' | 'Compensation' | 'Contact' | 'ContactID' | 'EndDate' | 'ID' | 'IsOfficer' | 'OtherCompensation' | 'PartialYear' | 'PersonName' | 'RelatedOrgCompensation' | 'StartDate' | 'TaxReturnID' | 'Title' | 'TotalCompensation' | TaxReturnCompensationKeySpecifier)[];
export type TaxReturnCompensationFieldPolicy = {
	AnnualizedTotalCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	AverageHoursPerWeek?: FieldPolicy<any> | FieldReadFunction<any>,
	Compensation?: FieldPolicy<any> | FieldReadFunction<any>,
	Contact?: FieldPolicy<any> | FieldReadFunction<any>,
	ContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	EndDate?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsOfficer?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	PartialYear?: FieldPolicy<any> | FieldReadFunction<any>,
	PersonName?: FieldPolicy<any> | FieldReadFunction<any>,
	RelatedOrgCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	StartDate?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnID?: FieldPolicy<any> | FieldReadFunction<any>,
	Title?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalCompensation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxReturnContractorKeySpecifier = ('Account' | 'AccountID' | 'AddressLine1' | 'Amount' | 'City' | 'ID' | 'Name' | 'PostalCode' | 'StateProvince' | 'TaxReturnID' | 'Type' | TaxReturnContractorKeySpecifier)[];
export type TaxReturnContractorFieldPolicy = {
	Account?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AddressLine1?: FieldPolicy<any> | FieldReadFunction<any>,
	Amount?: FieldPolicy<any> | FieldReadFunction<any>,
	City?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	PostalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	StateProvince?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnID?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxReturnDetailKeySpecifier = ('Code' | 'EndingAmount' | 'ID' | 'Name' | 'StartingAmount' | 'TaxReturnID' | 'Type' | TaxReturnDetailKeySpecifier)[];
export type TaxReturnDetailFieldPolicy = {
	Code?: FieldPolicy<any> | FieldReadFunction<any>,
	EndingAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	StartingAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxReturnID?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TeamKeySpecifier = ('ID' | 'Type' | 'UpdatedAt' | TeamKeySpecifier)[];
export type TeamFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimeEntryKeySpecifier = ('Comment' | 'CreatedAt' | 'Date' | 'Effort' | 'Employee' | 'EmployeeID' | 'ExternalSystemRecordID' | 'ID' | 'IsDeleted' | 'IsInvoiced' | 'IsLocked' | 'Task' | 'TaskID' | 'UpdatedAt' | TimeEntryKeySpecifier)[];
export type TimeEntryFieldPolicy = {
	Comment?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Date?: FieldPolicy<any> | FieldReadFunction<any>,
	Effort?: FieldPolicy<any> | FieldReadFunction<any>,
	Employee?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	IsInvoiced?: FieldPolicy<any> | FieldReadFunction<any>,
	IsLocked?: FieldPolicy<any> | FieldReadFunction<any>,
	Task?: FieldPolicy<any> | FieldReadFunction<any>,
	TaskID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('CreatedAt' | 'Email' | 'EmployeeID' | 'FirstLast' | 'ID' | 'IsActive' | 'Name' | 'Supervisor' | 'SupervisorEmail' | 'Type' | 'UpdatedAt' | 'UserApplications' | 'UserRoles' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Email?: FieldPolicy<any> | FieldReadFunction<any>,
	EmployeeID?: FieldPolicy<any> | FieldReadFunction<any>,
	FirstLast?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	Supervisor?: FieldPolicy<any> | FieldReadFunction<any>,
	SupervisorEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	Type?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	UserApplications?: FieldPolicy<any> | FieldReadFunction<any>,
	UserRoles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserApplicationKeySpecifier = ('Application' | 'ApplicationID' | 'ID' | 'IsActive' | 'Sequence' | 'User' | 'UserApplicationEntities' | 'UserID' | UserApplicationKeySpecifier)[];
export type UserApplicationFieldPolicy = {
	Application?: FieldPolicy<any> | FieldReadFunction<any>,
	ApplicationID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsActive?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserApplicationEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserApplicationEntityKeySpecifier = ('Application' | 'Entity' | 'EntityID' | 'ID' | 'Sequence' | 'User' | 'UserApplicationID' | UserApplicationEntityKeySpecifier)[];
export type UserApplicationEntityFieldPolicy = {
	Application?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserApplicationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserFavoriteKeySpecifier = ('CreatedAt' | 'Entity' | 'EntityBaseTable' | 'EntityBaseView' | 'EntityID' | 'ID' | 'RecordID' | 'UpdatedAt' | 'UserID' | UserFavoriteKeySpecifier)[];
export type UserFavoriteFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseTable?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserFavoriteResultKeySpecifier = ('EntityID' | 'IsFavorite' | 'RecordID' | 'Success' | 'UserID' | UserFavoriteResultKeySpecifier)[];
export type UserFavoriteResultFieldPolicy = {
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsFavorite?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	Success?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserRecordLogKeySpecifier = ('EarliestAt' | 'Entity' | 'EntityID' | 'ID' | 'LatestAt' | 'RecordID' | 'TotalCount' | 'UserEmail' | 'UserFirstLast' | 'UserID' | 'UserName' | 'UserSupervisor' | 'UserSupervisorEmail' | UserRecordLogKeySpecifier)[];
export type UserRecordLogFieldPolicy = {
	EarliestAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	LatestAt?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	UserEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFirstLast?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserName?: FieldPolicy<any> | FieldReadFunction<any>,
	UserSupervisor?: FieldPolicy<any> | FieldReadFunction<any>,
	UserSupervisorEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserRoleKeySpecifier = ('CreatedAt' | 'ID' | 'Role' | 'RoleID' | 'UpdatedAt' | 'User' | 'UserID' | UserRoleKeySpecifier)[];
export type UserRoleFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Role?: FieldPolicy<any> | FieldReadFunction<any>,
	RoleID?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	User?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserViewKeySpecifier = ('CreatedAt' | 'CustomFilterState' | 'CustomWhereClause' | 'Description' | 'Entity' | 'EntityBaseView' | 'EntityID' | 'FilterState' | 'GridState' | 'ID' | 'IsDefault' | 'IsShared' | 'Name' | 'UpdatedAt' | 'UserEmail' | 'UserFirstLast' | 'UserID' | 'UserName' | 'UserType' | 'WhereClause' | UserViewKeySpecifier)[];
export type UserViewFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	CustomFilterState?: FieldPolicy<any> | FieldReadFunction<any>,
	CustomWhereClause?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	Entity?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityBaseView?: FieldPolicy<any> | FieldReadFunction<any>,
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	FilterState?: FieldPolicy<any> | FieldReadFunction<any>,
	GridState?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IsDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	IsShared?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	UserEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	UserFirstLast?: FieldPolicy<any> | FieldReadFunction<any>,
	UserID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserName?: FieldPolicy<any> | FieldReadFunction<any>,
	UserType?: FieldPolicy<any> | FieldReadFunction<any>,
	WhereClause?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserViewRunKeySpecifier = ('ID' | 'RunAt' | 'RunByUser' | 'RunByUserID' | 'UserView' | 'UserViewID' | 'UserViewRunDetails' | UserViewRunKeySpecifier)[];
export type UserViewRunFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	RunAt?: FieldPolicy<any> | FieldReadFunction<any>,
	RunByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	RunByUserID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserView?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserViewRunDetailKeySpecifier = ('EntityID' | 'ID' | 'RecordID' | 'UserViewID' | 'UserViewRunID' | UserViewRunDetailKeySpecifier)[];
export type UserViewRunDetailFieldPolicy = {
	EntityID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	RecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewID?: FieldPolicy<any> | FieldReadFunction<any>,
	UserViewRunID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UtilityResultTypeKeySpecifier = ('Result' | 'Status' | UtilityResultTypeKeySpecifier)[];
export type UtilityResultTypeFieldPolicy = {
	Result?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkflowKeySpecifier = ('CompanyID' | 'CreatedAt' | 'Description' | 'ExternalSystemRecordID' | 'ID' | 'Name' | 'UpdatedAt' | 'WorkflowEngine' | 'WorkflowEngineID' | WorkflowKeySpecifier)[];
export type WorkflowFieldPolicy = {
	CompanyID?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	WorkflowEngine?: FieldPolicy<any> | FieldReadFunction<any>,
	WorkflowEngineID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkflowEngineKeySpecifier = ('CreatedAt' | 'Description' | 'DriverClass' | 'DriverPath' | 'ID' | 'Name' | 'UpdatedAt' | WorkflowEngineKeySpecifier)[];
export type WorkflowEngineFieldPolicy = {
	CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Description?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverClass?: FieldPolicy<any> | FieldReadFunction<any>,
	DriverPath?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	UpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkflowRunKeySpecifier = ('EndedAt' | 'ExternalSystemRecordID' | 'ID' | 'Results' | 'StartedAt' | 'Status' | 'Workflow' | 'WorkflowEngine' | 'WorkflowID' | WorkflowRunKeySpecifier)[];
export type WorkflowRunFieldPolicy = {
	EndedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ExternalSystemRecordID?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	Results?: FieldPolicy<any> | FieldReadFunction<any>,
	StartedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	Workflow?: FieldPolicy<any> | FieldReadFunction<any>,
	WorkflowEngine?: FieldPolicy<any> | FieldReadFunction<any>,
	WorkflowID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type _990FullKeySpecifier = ('AccountID' | 'AccountingFees' | 'AccountsPayable' | 'AccountsReceivable' | 'Activity' | 'AdvertisingExpense' | 'AffiliatePaymentExpense' | 'Affiliation' | 'AssetCode' | 'CapitalStockPrincipal' | 'Cash' | 'City' | 'Classification' | 'ConferenceExpense' | 'CostBasisSecurities' | 'Deductibility' | 'DeferredRevenue' | 'DepreciationExpense' | 'DisqualifiedPersonCompensation' | 'EIN' | 'EscrowAccountLiability' | 'FilingRequirementCode' | 'Foundation' | 'FundraisingActivities' | 'FundraisingExpenses' | 'FundraisingNetIncome' | 'GrantsPayable' | 'GrantsToIndividuals' | 'GrantsToOrgs' | 'GrossFundraisingReceipts' | 'GrossRentsFromRealEstate' | 'GrossSalesSecurities' | 'Group' | 'HasForeignBankAcct' | 'HasInvestmentIncome' | 'ICO' | 'ID' | 'IncomeCode' | 'InformationTechnologyExpense' | 'InsuranceExpense' | 'IntangibleAssetValue' | 'InterestExpense' | 'InventoryAssetValue' | 'InvestmentManagementFees' | 'IsHospital' | 'LegalFees' | 'LobbyingActivities' | 'LobbyingFees' | 'ManagementFees' | 'MortgagesNotesPayable' | 'Name' | 'NetGainSecurities' | 'NetRentRealEstate' | 'NotesReceivable' | 'NumberEmployees' | 'OccupancyExpense' | 'OfficeExpense' | 'OfficerCompensation' | 'Organization' | 'OtherAssets' | 'OtherEmployeeBenefits' | 'OtherFees' | 'OtherLiabilities' | 'OtherSalaries' | 'OtherSecuritiesAssetValue' | 'PaidInCapitalSurplus' | 'PayablesToOfficers' | 'PayrollTaxes' | 'PensionContributions' | 'PermanentlyRestrictedNetAssets' | 'PledgesGrantsReceivable' | 'PoliticalActivities' | 'PrepaidExpenseAssetValue' | 'ProfessionalFundraisingFees' | 'ProgramInvestmentsAssetValue' | 'ProgramServiceRevenueA' | 'ProgramServiceRevenueB' | 'ProgramServiceRevenueC' | 'ProgramServiceRevenueCodeA' | 'ProgramServiceRevenueCodeB' | 'ProgramServiceRevenueCodeC' | 'ProgramServiceRevenueCodeD' | 'ProgramServiceRevenueCodeE' | 'ProgramServiceRevenueD' | 'ProgramServiceRevenueE' | 'ProgramServiceRevenueNameA' | 'ProgramServiceRevenueNameB' | 'ProgramServiceRevenueNameC' | 'ProgramServiceRevenueNameD' | 'ProgramServiceRevenueNameE' | 'PublicSecuritiesAssetValue' | 'RealEstateAssetValue' | 'ReceivablesFromDisqualifiedPersons' | 'ReceivablesFromOfficers' | 'RentalExpenseRealEstate' | 'RetainedEarnings' | 'RoyaltyExpense' | 'Ruling' | 'Savings' | 'SortName' | 'State' | 'Status' | 'Street' | 'Subsection' | 'TaxExemptBondLiability' | 'TaxMonth' | 'TaxPeriod' | 'TaxYear' | 'TemporarilyRestrictedNetAssets' | 'TotalAssets' | 'TotalGrossReceipts' | 'TotalInvestmentIncome' | 'TotalLiabilities' | 'TotalMemberIncome' | 'TotalNetAssets' | 'TotalNetAssetsPlusLiabilities' | 'TotalProgramServiceRevenue' | 'TotalRevenue' | 'TravelExpense' | 'TravelExpensePublicOfficials' | 'UnrestrictedNetAssets' | 'UnsecuredNotesPayable' | 'Zip' | _990FullKeySpecifier)[];
export type _990FullFieldPolicy = {
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountsPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountsReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	Activity?: FieldPolicy<any> | FieldReadFunction<any>,
	AdvertisingExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	AffiliatePaymentExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Affiliation?: FieldPolicy<any> | FieldReadFunction<any>,
	AssetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	CapitalStockPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	Cash?: FieldPolicy<any> | FieldReadFunction<any>,
	City?: FieldPolicy<any> | FieldReadFunction<any>,
	Classification?: FieldPolicy<any> | FieldReadFunction<any>,
	ConferenceExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	CostBasisSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	Deductibility?: FieldPolicy<any> | FieldReadFunction<any>,
	DeferredRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	DepreciationExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	DisqualifiedPersonCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	EIN?: FieldPolicy<any> | FieldReadFunction<any>,
	EscrowAccountLiability?: FieldPolicy<any> | FieldReadFunction<any>,
	FilingRequirementCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Foundation?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingExpenses?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingNetIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsToIndividuals?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsToOrgs?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossFundraisingReceipts?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossRentsFromRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossSalesSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	Group?: FieldPolicy<any> | FieldReadFunction<any>,
	HasForeignBankAcct?: FieldPolicy<any> | FieldReadFunction<any>,
	HasInvestmentIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	ICO?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IncomeCode?: FieldPolicy<any> | FieldReadFunction<any>,
	InformationTechnologyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	InsuranceExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	IntangibleAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	InterestExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	InventoryAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	InvestmentManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	IsHospital?: FieldPolicy<any> | FieldReadFunction<any>,
	LegalFees?: FieldPolicy<any> | FieldReadFunction<any>,
	LobbyingActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	LobbyingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	ManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	MortgagesNotesPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	NetGainSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	NetRentRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	NotesReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	NumberEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	OccupancyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	OfficeExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	OfficerCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	Organization?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherEmployeeBenefits?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherFees?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherSalaries?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherSecuritiesAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	PaidInCapitalSurplus?: FieldPolicy<any> | FieldReadFunction<any>,
	PayablesToOfficers?: FieldPolicy<any> | FieldReadFunction<any>,
	PayrollTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	PensionContributions?: FieldPolicy<any> | FieldReadFunction<any>,
	PermanentlyRestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	PledgesGrantsReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	PoliticalActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	PrepaidExpenseAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ProfessionalFundraisingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramInvestmentsAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeE?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueE?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameE?: FieldPolicy<any> | FieldReadFunction<any>,
	PublicSecuritiesAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	RealEstateAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ReceivablesFromDisqualifiedPersons?: FieldPolicy<any> | FieldReadFunction<any>,
	ReceivablesFromOfficers?: FieldPolicy<any> | FieldReadFunction<any>,
	RentalExpenseRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	RetainedEarnings?: FieldPolicy<any> | FieldReadFunction<any>,
	RoyaltyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Ruling?: FieldPolicy<any> | FieldReadFunction<any>,
	Savings?: FieldPolicy<any> | FieldReadFunction<any>,
	SortName?: FieldPolicy<any> | FieldReadFunction<any>,
	State?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	Street?: FieldPolicy<any> | FieldReadFunction<any>,
	Subsection?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxExemptBondLiability?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxYear?: FieldPolicy<any> | FieldReadFunction<any>,
	TemporarilyRestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalGrossReceipts?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalInvestmentIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalMemberIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalNetAssetsPlusLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalProgramServiceRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	TravelExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	TravelExpensePublicOfficials?: FieldPolicy<any> | FieldReadFunction<any>,
	UnrestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	UnsecuredNotesPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	Zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type _990LatestKeySpecifier = ('AccountID' | 'AccountingFees' | 'AccountsPayable' | 'AccountsReceivable' | 'Activity' | 'AdvertisingExpense' | 'AffiliatePaymentExpense' | 'Affiliation' | 'AssetCode' | 'CapitalStockPrincipal' | 'Cash' | 'City' | 'Classification' | 'ConferenceExpense' | 'CostBasisSecurities' | 'Deductibility' | 'DeferredRevenue' | 'DepreciationExpense' | 'DisqualifiedPersonCompensation' | 'EIN' | 'EscrowAccountLiability' | 'FilingRequirementCode' | 'Foundation' | 'FundraisingActivities' | 'FundraisingExpenses' | 'FundraisingNetIncome' | 'GrantsPayable' | 'GrantsToIndividuals' | 'GrantsToOrgs' | 'GrossFundraisingReceipts' | 'GrossRentsFromRealEstate' | 'GrossSalesSecurities' | 'Group' | 'HasForeignBankAcct' | 'HasInvestmentIncome' | 'ICO' | 'ID' | 'IncomeCode' | 'InformationTechnologyExpense' | 'InsuranceExpense' | 'IntangibleAssetValue' | 'InterestExpense' | 'InventoryAssetValue' | 'InvestmentManagementFees' | 'IsHospital' | 'LegalFees' | 'LobbyingActivities' | 'LobbyingFees' | 'ManagementFees' | 'MortgagesNotesPayable' | 'Name' | 'NetGainSecurities' | 'NetRentRealEstate' | 'NotesReceivable' | 'NumberEmployees' | 'OccupancyExpense' | 'OfficeExpense' | 'OfficerCompensation' | 'Organization' | 'OtherAssets' | 'OtherEmployeeBenefits' | 'OtherFees' | 'OtherLiabilities' | 'OtherSalaries' | 'OtherSecuritiesAssetValue' | 'PaidInCapitalSurplus' | 'PayablesToOfficers' | 'PayrollTaxes' | 'PensionContributions' | 'PermanentlyRestrictedNetAssets' | 'PledgesGrantsReceivable' | 'PoliticalActivities' | 'PrepaidExpenseAssetValue' | 'ProfessionalFundraisingFees' | 'ProgramInvestmentsAssetValue' | 'ProgramServiceRevenueA' | 'ProgramServiceRevenueB' | 'ProgramServiceRevenueC' | 'ProgramServiceRevenueCodeA' | 'ProgramServiceRevenueCodeB' | 'ProgramServiceRevenueCodeC' | 'ProgramServiceRevenueCodeD' | 'ProgramServiceRevenueCodeE' | 'ProgramServiceRevenueD' | 'ProgramServiceRevenueE' | 'ProgramServiceRevenueNameA' | 'ProgramServiceRevenueNameB' | 'ProgramServiceRevenueNameC' | 'ProgramServiceRevenueNameD' | 'ProgramServiceRevenueNameE' | 'PublicSecuritiesAssetValue' | 'RealEstateAssetValue' | 'ReceivablesFromDisqualifiedPersons' | 'ReceivablesFromOfficers' | 'RentalExpenseRealEstate' | 'RetainedEarnings' | 'RoyaltyExpense' | 'Ruling' | 'Savings' | 'SortName' | 'State' | 'Status' | 'Street' | 'Subsection' | 'TaxExemptBondLiability' | 'TaxMonth' | 'TaxPeriod' | 'TaxYear' | 'TemporarilyRestrictedNetAssets' | 'TotalAssets' | 'TotalGrossReceipts' | 'TotalInvestmentIncome' | 'TotalLiabilities' | 'TotalMemberIncome' | 'TotalNetAssets' | 'TotalNetAssetsPlusLiabilities' | 'TotalProgramServiceRevenue' | 'TotalRevenue' | 'TravelExpense' | 'TravelExpensePublicOfficials' | 'UnrestrictedNetAssets' | 'UnsecuredNotesPayable' | 'Zip' | _990LatestKeySpecifier)[];
export type _990LatestFieldPolicy = {
	AccountID?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountsPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	AccountsReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	Activity?: FieldPolicy<any> | FieldReadFunction<any>,
	AdvertisingExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	AffiliatePaymentExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Affiliation?: FieldPolicy<any> | FieldReadFunction<any>,
	AssetCode?: FieldPolicy<any> | FieldReadFunction<any>,
	CapitalStockPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	Cash?: FieldPolicy<any> | FieldReadFunction<any>,
	City?: FieldPolicy<any> | FieldReadFunction<any>,
	Classification?: FieldPolicy<any> | FieldReadFunction<any>,
	ConferenceExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	CostBasisSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	Deductibility?: FieldPolicy<any> | FieldReadFunction<any>,
	DeferredRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	DepreciationExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	DisqualifiedPersonCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	EIN?: FieldPolicy<any> | FieldReadFunction<any>,
	EscrowAccountLiability?: FieldPolicy<any> | FieldReadFunction<any>,
	FilingRequirementCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Foundation?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingExpenses?: FieldPolicy<any> | FieldReadFunction<any>,
	FundraisingNetIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsToIndividuals?: FieldPolicy<any> | FieldReadFunction<any>,
	GrantsToOrgs?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossFundraisingReceipts?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossRentsFromRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	GrossSalesSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	Group?: FieldPolicy<any> | FieldReadFunction<any>,
	HasForeignBankAcct?: FieldPolicy<any> | FieldReadFunction<any>,
	HasInvestmentIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	ICO?: FieldPolicy<any> | FieldReadFunction<any>,
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	IncomeCode?: FieldPolicy<any> | FieldReadFunction<any>,
	InformationTechnologyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	InsuranceExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	IntangibleAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	InterestExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	InventoryAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	InvestmentManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	IsHospital?: FieldPolicy<any> | FieldReadFunction<any>,
	LegalFees?: FieldPolicy<any> | FieldReadFunction<any>,
	LobbyingActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	LobbyingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	ManagementFees?: FieldPolicy<any> | FieldReadFunction<any>,
	MortgagesNotesPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	Name?: FieldPolicy<any> | FieldReadFunction<any>,
	NetGainSecurities?: FieldPolicy<any> | FieldReadFunction<any>,
	NetRentRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	NotesReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	NumberEmployees?: FieldPolicy<any> | FieldReadFunction<any>,
	OccupancyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	OfficeExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	OfficerCompensation?: FieldPolicy<any> | FieldReadFunction<any>,
	Organization?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherEmployeeBenefits?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherFees?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherSalaries?: FieldPolicy<any> | FieldReadFunction<any>,
	OtherSecuritiesAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	PaidInCapitalSurplus?: FieldPolicy<any> | FieldReadFunction<any>,
	PayablesToOfficers?: FieldPolicy<any> | FieldReadFunction<any>,
	PayrollTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	PensionContributions?: FieldPolicy<any> | FieldReadFunction<any>,
	PermanentlyRestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	PledgesGrantsReceivable?: FieldPolicy<any> | FieldReadFunction<any>,
	PoliticalActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	PrepaidExpenseAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ProfessionalFundraisingFees?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramInvestmentsAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueCodeE?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueE?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameA?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameB?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameC?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameD?: FieldPolicy<any> | FieldReadFunction<any>,
	ProgramServiceRevenueNameE?: FieldPolicy<any> | FieldReadFunction<any>,
	PublicSecuritiesAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	RealEstateAssetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	ReceivablesFromDisqualifiedPersons?: FieldPolicy<any> | FieldReadFunction<any>,
	ReceivablesFromOfficers?: FieldPolicy<any> | FieldReadFunction<any>,
	RentalExpenseRealEstate?: FieldPolicy<any> | FieldReadFunction<any>,
	RetainedEarnings?: FieldPolicy<any> | FieldReadFunction<any>,
	RoyaltyExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	Ruling?: FieldPolicy<any> | FieldReadFunction<any>,
	Savings?: FieldPolicy<any> | FieldReadFunction<any>,
	SortName?: FieldPolicy<any> | FieldReadFunction<any>,
	State?: FieldPolicy<any> | FieldReadFunction<any>,
	Status?: FieldPolicy<any> | FieldReadFunction<any>,
	Street?: FieldPolicy<any> | FieldReadFunction<any>,
	Subsection?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxExemptBondLiability?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	TaxYear?: FieldPolicy<any> | FieldReadFunction<any>,
	TemporarilyRestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalGrossReceipts?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalInvestmentIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalMemberIncome?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalNetAssetsPlusLiabilities?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalProgramServiceRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	TotalRevenue?: FieldPolicy<any> | FieldReadFunction<any>,
	TravelExpense?: FieldPolicy<any> | FieldReadFunction<any>,
	TravelExpensePublicOfficials?: FieldPolicy<any> | FieldReadFunction<any>,
	UnrestrictedNetAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	UnsecuredNotesPayable?: FieldPolicy<any> | FieldReadFunction<any>,
	Zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AIAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AIActionKeySpecifier | (() => undefined | AIActionKeySpecifier),
		fields?: AIActionFieldPolicy,
	},
	AIModel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AIModelKeySpecifier | (() => undefined | AIModelKeySpecifier),
		fields?: AIModelFieldPolicy,
	},
	AIModelAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AIModelActionKeySpecifier | (() => undefined | AIModelActionKeySpecifier),
		fields?: AIModelActionFieldPolicy,
	},
	AIModelType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AIModelTypeKeySpecifier | (() => undefined | AIModelTypeKeySpecifier),
		fields?: AIModelTypeFieldPolicy,
	},
	Account?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountKeySpecifier | (() => undefined | AccountKeySpecifier),
		fields?: AccountFieldPolicy,
	},
	AccountCompanyIntegration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountCompanyIntegrationKeySpecifier | (() => undefined | AccountCompanyIntegrationKeySpecifier),
		fields?: AccountCompanyIntegrationFieldPolicy,
	},
	AccountType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountTypeKeySpecifier | (() => undefined | AccountTypeKeySpecifier),
		fields?: AccountTypeFieldPolicy,
	},
	Activity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityKeySpecifier | (() => undefined | ActivityKeySpecifier),
		fields?: ActivityFieldPolicy,
	},
	ActivityAttachment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityAttachmentKeySpecifier | (() => undefined | ActivityAttachmentKeySpecifier),
		fields?: ActivityAttachmentFieldPolicy,
	},
	Application?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApplicationKeySpecifier | (() => undefined | ApplicationKeySpecifier),
		fields?: ApplicationFieldPolicy,
	},
	ApplicationEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApplicationEntityKeySpecifier | (() => undefined | ApplicationEntityKeySpecifier),
		fields?: ApplicationEntityFieldPolicy,
	},
	ApplicationPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApplicationPermissionKeySpecifier | (() => undefined | ApplicationPermissionKeySpecifier),
		fields?: ApplicationPermissionFieldPolicy,
	},
	AskSkipResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AskSkipResultTypeKeySpecifier | (() => undefined | AskSkipResultTypeKeySpecifier),
		fields?: AskSkipResultTypeFieldPolicy,
	},
	AuditLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogKeySpecifier | (() => undefined | AuditLogKeySpecifier),
		fields?: AuditLogFieldPolicy,
	},
	AuditLogType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogTypeKeySpecifier | (() => undefined | AuditLogTypeKeySpecifier),
		fields?: AuditLogTypeFieldPolicy,
	},
	Authorization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthorizationKeySpecifier | (() => undefined | AuthorizationKeySpecifier),
		fields?: AuthorizationFieldPolicy,
	},
	AuthorizationRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthorizationRoleKeySpecifier | (() => undefined | AuthorizationRoleKeySpecifier),
		fields?: AuthorizationRoleFieldPolicy,
	},
	Campaign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CampaignKeySpecifier | (() => undefined | CampaignKeySpecifier),
		fields?: CampaignFieldPolicy,
	},
	CampaignStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CampaignStepKeySpecifier | (() => undefined | CampaignStepKeySpecifier),
		fields?: CampaignStepFieldPolicy,
	},
	Company?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompanyKeySpecifier | (() => undefined | CompanyKeySpecifier),
		fields?: CompanyFieldPolicy,
	},
	CompanyIntegration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompanyIntegrationKeySpecifier | (() => undefined | CompanyIntegrationKeySpecifier),
		fields?: CompanyIntegrationFieldPolicy,
	},
	Contact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactKeySpecifier | (() => undefined | ContactKeySpecifier),
		fields?: ContactFieldPolicy,
	},
	ContactAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactAccountKeySpecifier | (() => undefined | ContactAccountKeySpecifier),
		fields?: ContactAccountFieldPolicy,
	},
	ContactCompanyIntegration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactCompanyIntegrationKeySpecifier | (() => undefined | ContactCompanyIntegrationKeySpecifier),
		fields?: ContactCompanyIntegrationFieldPolicy,
	},
	ContactEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactEmailKeySpecifier | (() => undefined | ContactEmailKeySpecifier),
		fields?: ContactEmailFieldPolicy,
	},
	ContactLevel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactLevelKeySpecifier | (() => undefined | ContactLevelKeySpecifier),
		fields?: ContactLevelFieldPolicy,
	},
	ContactRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactRoleKeySpecifier | (() => undefined | ContactRoleKeySpecifier),
		fields?: ContactRoleFieldPolicy,
	},
	ContactTopic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactTopicKeySpecifier | (() => undefined | ContactTopicKeySpecifier),
		fields?: ContactTopicFieldPolicy,
	},
	Deal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealKeySpecifier | (() => undefined | DealKeySpecifier),
		fields?: DealFieldPolicy,
	},
	DealStage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealStageKeySpecifier | (() => undefined | DealStageKeySpecifier),
		fields?: DealStageFieldPolicy,
	},
	DealType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealTypeKeySpecifier | (() => undefined | DealTypeKeySpecifier),
		fields?: DealTypeFieldPolicy,
	},
	EmailServiceProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailServiceProvidersKeySpecifier | (() => undefined | EmailServiceProvidersKeySpecifier),
		fields?: EmailServiceProvidersFieldPolicy,
	},
	Employee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmployeeKeySpecifier | (() => undefined | EmployeeKeySpecifier),
		fields?: EmployeeFieldPolicy,
	},
	Entity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityKeySpecifier | (() => undefined | EntityKeySpecifier),
		fields?: EntityFieldPolicy,
	},
	EntityAIAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityAIActionKeySpecifier | (() => undefined | EntityAIActionKeySpecifier),
		fields?: EntityAIActionFieldPolicy,
	},
	EntityField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityFieldKeySpecifier | (() => undefined | EntityFieldKeySpecifier),
		fields?: EntityFieldFieldPolicy,
	},
	EntityFieldValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityFieldValueKeySpecifier | (() => undefined | EntityFieldValueKeySpecifier),
		fields?: EntityFieldValueFieldPolicy,
	},
	EntityPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityPermissionKeySpecifier | (() => undefined | EntityPermissionKeySpecifier),
		fields?: EntityPermissionFieldPolicy,
	},
	EntityRelationship?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntityRelationshipKeySpecifier | (() => undefined | EntityRelationshipKeySpecifier),
		fields?: EntityRelationshipFieldPolicy,
	},
	Integration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntegrationKeySpecifier | (() => undefined | IntegrationKeySpecifier),
		fields?: IntegrationFieldPolicy,
	},
	IntegrationURLFormat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntegrationURLFormatKeySpecifier | (() => undefined | IntegrationURLFormatKeySpecifier),
		fields?: IntegrationURLFormatFieldPolicy,
	},
	Invoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceKeySpecifier | (() => undefined | InvoiceKeySpecifier),
		fields?: InvoiceFieldPolicy,
	},
	LifecycleStage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LifecycleStageKeySpecifier | (() => undefined | LifecycleStageKeySpecifier),
		fields?: LifecycleStageFieldPolicy,
	},
	List?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListKeySpecifier | (() => undefined | ListKeySpecifier),
		fields?: ListFieldPolicy,
	},
	ListDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListDetailKeySpecifier | (() => undefined | ListDetailKeySpecifier),
		fields?: ListDetailFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NAICS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NAICSKeySpecifier | (() => undefined | NAICSKeySpecifier),
		fields?: NAICSFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	Project?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectKeySpecifier | (() => undefined | ProjectKeySpecifier),
		fields?: ProjectFieldPolicy,
	},
	ProjectBillingType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectBillingTypeKeySpecifier | (() => undefined | ProjectBillingTypeKeySpecifier),
		fields?: ProjectBillingTypeFieldPolicy,
	},
	ProjectRateType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectRateTypeKeySpecifier | (() => undefined | ProjectRateTypeKeySpecifier),
		fields?: ProjectRateTypeFieldPolicy,
	},
	ProjectStatusType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectStatusTypeKeySpecifier | (() => undefined | ProjectStatusTypeKeySpecifier),
		fields?: ProjectStatusTypeFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	Queue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueueKeySpecifier | (() => undefined | QueueKeySpecifier),
		fields?: QueueFieldPolicy,
	},
	QueueTask?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueueTaskKeySpecifier | (() => undefined | QueueTaskKeySpecifier),
		fields?: QueueTaskFieldPolicy,
	},
	QueueType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueueTypeKeySpecifier | (() => undefined | QueueTypeKeySpecifier),
		fields?: QueueTypeFieldPolicy,
	},
	RecordChange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecordChangeKeySpecifier | (() => undefined | RecordChangeKeySpecifier),
		fields?: RecordChangeFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	RowLevelSecurityFilter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RowLevelSecurityFilterKeySpecifier | (() => undefined | RowLevelSecurityFilterKeySpecifier),
		fields?: RowLevelSecurityFilterFieldPolicy,
	},
	RunAIActionViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAIActionViewResultKeySpecifier | (() => undefined | RunAIActionViewResultKeySpecifier),
		fields?: RunAIActionViewResultFieldPolicy,
	},
	RunAIModelActionViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAIModelActionViewResultKeySpecifier | (() => undefined | RunAIModelActionViewResultKeySpecifier),
		fields?: RunAIModelActionViewResultFieldPolicy,
	},
	RunAIModelTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAIModelTypeViewResultKeySpecifier | (() => undefined | RunAIModelTypeViewResultKeySpecifier),
		fields?: RunAIModelTypeViewResultFieldPolicy,
	},
	RunAIModelViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAIModelViewResultKeySpecifier | (() => undefined | RunAIModelViewResultKeySpecifier),
		fields?: RunAIModelViewResultFieldPolicy,
	},
	RunAccountCompanyIntegrationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAccountCompanyIntegrationViewResultKeySpecifier | (() => undefined | RunAccountCompanyIntegrationViewResultKeySpecifier),
		fields?: RunAccountCompanyIntegrationViewResultFieldPolicy,
	},
	RunAccountTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAccountTypeViewResultKeySpecifier | (() => undefined | RunAccountTypeViewResultKeySpecifier),
		fields?: RunAccountTypeViewResultFieldPolicy,
	},
	RunAccountViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAccountViewResultKeySpecifier | (() => undefined | RunAccountViewResultKeySpecifier),
		fields?: RunAccountViewResultFieldPolicy,
	},
	RunActivityAttachmentViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunActivityAttachmentViewResultKeySpecifier | (() => undefined | RunActivityAttachmentViewResultKeySpecifier),
		fields?: RunActivityAttachmentViewResultFieldPolicy,
	},
	RunActivityViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunActivityViewResultKeySpecifier | (() => undefined | RunActivityViewResultKeySpecifier),
		fields?: RunActivityViewResultFieldPolicy,
	},
	RunApplicationEntityViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunApplicationEntityViewResultKeySpecifier | (() => undefined | RunApplicationEntityViewResultKeySpecifier),
		fields?: RunApplicationEntityViewResultFieldPolicy,
	},
	RunApplicationPermissionViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunApplicationPermissionViewResultKeySpecifier | (() => undefined | RunApplicationPermissionViewResultKeySpecifier),
		fields?: RunApplicationPermissionViewResultFieldPolicy,
	},
	RunApplicationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunApplicationViewResultKeySpecifier | (() => undefined | RunApplicationViewResultKeySpecifier),
		fields?: RunApplicationViewResultFieldPolicy,
	},
	RunAuditLogTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAuditLogTypeViewResultKeySpecifier | (() => undefined | RunAuditLogTypeViewResultKeySpecifier),
		fields?: RunAuditLogTypeViewResultFieldPolicy,
	},
	RunAuditLogViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAuditLogViewResultKeySpecifier | (() => undefined | RunAuditLogViewResultKeySpecifier),
		fields?: RunAuditLogViewResultFieldPolicy,
	},
	RunAuthorizationRoleViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAuthorizationRoleViewResultKeySpecifier | (() => undefined | RunAuthorizationRoleViewResultKeySpecifier),
		fields?: RunAuthorizationRoleViewResultFieldPolicy,
	},
	RunAuthorizationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunAuthorizationViewResultKeySpecifier | (() => undefined | RunAuthorizationViewResultKeySpecifier),
		fields?: RunAuthorizationViewResultFieldPolicy,
	},
	RunCampaignStepViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunCampaignStepViewResultKeySpecifier | (() => undefined | RunCampaignStepViewResultKeySpecifier),
		fields?: RunCampaignStepViewResultFieldPolicy,
	},
	RunCampaignViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunCampaignViewResultKeySpecifier | (() => undefined | RunCampaignViewResultKeySpecifier),
		fields?: RunCampaignViewResultFieldPolicy,
	},
	RunCompanyIntegrationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunCompanyIntegrationViewResultKeySpecifier | (() => undefined | RunCompanyIntegrationViewResultKeySpecifier),
		fields?: RunCompanyIntegrationViewResultFieldPolicy,
	},
	RunCompanyViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunCompanyViewResultKeySpecifier | (() => undefined | RunCompanyViewResultKeySpecifier),
		fields?: RunCompanyViewResultFieldPolicy,
	},
	RunContactAccountViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactAccountViewResultKeySpecifier | (() => undefined | RunContactAccountViewResultKeySpecifier),
		fields?: RunContactAccountViewResultFieldPolicy,
	},
	RunContactCompanyIntegrationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactCompanyIntegrationViewResultKeySpecifier | (() => undefined | RunContactCompanyIntegrationViewResultKeySpecifier),
		fields?: RunContactCompanyIntegrationViewResultFieldPolicy,
	},
	RunContactEmailViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactEmailViewResultKeySpecifier | (() => undefined | RunContactEmailViewResultKeySpecifier),
		fields?: RunContactEmailViewResultFieldPolicy,
	},
	RunContactLevelViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactLevelViewResultKeySpecifier | (() => undefined | RunContactLevelViewResultKeySpecifier),
		fields?: RunContactLevelViewResultFieldPolicy,
	},
	RunContactRoleViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactRoleViewResultKeySpecifier | (() => undefined | RunContactRoleViewResultKeySpecifier),
		fields?: RunContactRoleViewResultFieldPolicy,
	},
	RunContactTopicViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactTopicViewResultKeySpecifier | (() => undefined | RunContactTopicViewResultKeySpecifier),
		fields?: RunContactTopicViewResultFieldPolicy,
	},
	RunContactViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunContactViewResultKeySpecifier | (() => undefined | RunContactViewResultKeySpecifier),
		fields?: RunContactViewResultFieldPolicy,
	},
	RunDealStageViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunDealStageViewResultKeySpecifier | (() => undefined | RunDealStageViewResultKeySpecifier),
		fields?: RunDealStageViewResultFieldPolicy,
	},
	RunDealTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunDealTypeViewResultKeySpecifier | (() => undefined | RunDealTypeViewResultKeySpecifier),
		fields?: RunDealTypeViewResultFieldPolicy,
	},
	RunDealViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunDealViewResultKeySpecifier | (() => undefined | RunDealViewResultKeySpecifier),
		fields?: RunDealViewResultFieldPolicy,
	},
	RunEmailServiceProvidersViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEmailServiceProvidersViewResultKeySpecifier | (() => undefined | RunEmailServiceProvidersViewResultKeySpecifier),
		fields?: RunEmailServiceProvidersViewResultFieldPolicy,
	},
	RunEmployeeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEmployeeViewResultKeySpecifier | (() => undefined | RunEmployeeViewResultKeySpecifier),
		fields?: RunEmployeeViewResultFieldPolicy,
	},
	RunEntityAIActionViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEntityAIActionViewResultKeySpecifier | (() => undefined | RunEntityAIActionViewResultKeySpecifier),
		fields?: RunEntityAIActionViewResultFieldPolicy,
	},
	RunEntityFieldValueViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEntityFieldValueViewResultKeySpecifier | (() => undefined | RunEntityFieldValueViewResultKeySpecifier),
		fields?: RunEntityFieldValueViewResultFieldPolicy,
	},
	RunEntityFieldViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEntityFieldViewResultKeySpecifier | (() => undefined | RunEntityFieldViewResultKeySpecifier),
		fields?: RunEntityFieldViewResultFieldPolicy,
	},
	RunEntityPermissionViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEntityPermissionViewResultKeySpecifier | (() => undefined | RunEntityPermissionViewResultKeySpecifier),
		fields?: RunEntityPermissionViewResultFieldPolicy,
	},
	RunEntityRelationshipViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEntityRelationshipViewResultKeySpecifier | (() => undefined | RunEntityRelationshipViewResultKeySpecifier),
		fields?: RunEntityRelationshipViewResultFieldPolicy,
	},
	RunEntityViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunEntityViewResultKeySpecifier | (() => undefined | RunEntityViewResultKeySpecifier),
		fields?: RunEntityViewResultFieldPolicy,
	},
	RunIntegrationURLFormatViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunIntegrationURLFormatViewResultKeySpecifier | (() => undefined | RunIntegrationURLFormatViewResultKeySpecifier),
		fields?: RunIntegrationURLFormatViewResultFieldPolicy,
	},
	RunIntegrationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunIntegrationViewResultKeySpecifier | (() => undefined | RunIntegrationViewResultKeySpecifier),
		fields?: RunIntegrationViewResultFieldPolicy,
	},
	RunInvoiceViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunInvoiceViewResultKeySpecifier | (() => undefined | RunInvoiceViewResultKeySpecifier),
		fields?: RunInvoiceViewResultFieldPolicy,
	},
	RunLifecycleStageViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunLifecycleStageViewResultKeySpecifier | (() => undefined | RunLifecycleStageViewResultKeySpecifier),
		fields?: RunLifecycleStageViewResultFieldPolicy,
	},
	RunListDetailViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunListDetailViewResultKeySpecifier | (() => undefined | RunListDetailViewResultKeySpecifier),
		fields?: RunListDetailViewResultFieldPolicy,
	},
	RunListViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunListViewResultKeySpecifier | (() => undefined | RunListViewResultKeySpecifier),
		fields?: RunListViewResultFieldPolicy,
	},
	RunPaymentViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunPaymentViewResultKeySpecifier | (() => undefined | RunPaymentViewResultKeySpecifier),
		fields?: RunPaymentViewResultFieldPolicy,
	},
	RunProjectBillingTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunProjectBillingTypeViewResultKeySpecifier | (() => undefined | RunProjectBillingTypeViewResultKeySpecifier),
		fields?: RunProjectBillingTypeViewResultFieldPolicy,
	},
	RunProjectRateTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunProjectRateTypeViewResultKeySpecifier | (() => undefined | RunProjectRateTypeViewResultKeySpecifier),
		fields?: RunProjectRateTypeViewResultFieldPolicy,
	},
	RunProjectStatusTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunProjectStatusTypeViewResultKeySpecifier | (() => undefined | RunProjectStatusTypeViewResultKeySpecifier),
		fields?: RunProjectStatusTypeViewResultFieldPolicy,
	},
	RunProjectViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunProjectViewResultKeySpecifier | (() => undefined | RunProjectViewResultKeySpecifier),
		fields?: RunProjectViewResultFieldPolicy,
	},
	RunQueueTaskViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunQueueTaskViewResultKeySpecifier | (() => undefined | RunQueueTaskViewResultKeySpecifier),
		fields?: RunQueueTaskViewResultFieldPolicy,
	},
	RunQueueTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunQueueTypeViewResultKeySpecifier | (() => undefined | RunQueueTypeViewResultKeySpecifier),
		fields?: RunQueueTypeViewResultFieldPolicy,
	},
	RunQueueViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunQueueViewResultKeySpecifier | (() => undefined | RunQueueViewResultKeySpecifier),
		fields?: RunQueueViewResultFieldPolicy,
	},
	RunRecordChangeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunRecordChangeViewResultKeySpecifier | (() => undefined | RunRecordChangeViewResultKeySpecifier),
		fields?: RunRecordChangeViewResultFieldPolicy,
	},
	RunRoleViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunRoleViewResultKeySpecifier | (() => undefined | RunRoleViewResultKeySpecifier),
		fields?: RunRoleViewResultFieldPolicy,
	},
	RunRowLevelSecurityFilterViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunRowLevelSecurityFilterViewResultKeySpecifier | (() => undefined | RunRowLevelSecurityFilterViewResultKeySpecifier),
		fields?: RunRowLevelSecurityFilterViewResultFieldPolicy,
	},
	RunSkillViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunSkillViewResultKeySpecifier | (() => undefined | RunSkillViewResultKeySpecifier),
		fields?: RunSkillViewResultFieldPolicy,
	},
	RunTaskTypeViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTaskTypeViewResultKeySpecifier | (() => undefined | RunTaskTypeViewResultKeySpecifier),
		fields?: RunTaskTypeViewResultFieldPolicy,
	},
	RunTaskViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTaskViewResultKeySpecifier | (() => undefined | RunTaskViewResultKeySpecifier),
		fields?: RunTaskViewResultFieldPolicy,
	},
	RunTaxReturnCompensationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTaxReturnCompensationViewResultKeySpecifier | (() => undefined | RunTaxReturnCompensationViewResultKeySpecifier),
		fields?: RunTaxReturnCompensationViewResultFieldPolicy,
	},
	RunTaxReturnContractorViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTaxReturnContractorViewResultKeySpecifier | (() => undefined | RunTaxReturnContractorViewResultKeySpecifier),
		fields?: RunTaxReturnContractorViewResultFieldPolicy,
	},
	RunTaxReturnDetailViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTaxReturnDetailViewResultKeySpecifier | (() => undefined | RunTaxReturnDetailViewResultKeySpecifier),
		fields?: RunTaxReturnDetailViewResultFieldPolicy,
	},
	RunTaxReturnViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTaxReturnViewResultKeySpecifier | (() => undefined | RunTaxReturnViewResultKeySpecifier),
		fields?: RunTaxReturnViewResultFieldPolicy,
	},
	RunTeamViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTeamViewResultKeySpecifier | (() => undefined | RunTeamViewResultKeySpecifier),
		fields?: RunTeamViewResultFieldPolicy,
	},
	RunTimeEntryViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunTimeEntryViewResultKeySpecifier | (() => undefined | RunTimeEntryViewResultKeySpecifier),
		fields?: RunTimeEntryViewResultFieldPolicy,
	},
	RunUserApplicationEntityViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserApplicationEntityViewResultKeySpecifier | (() => undefined | RunUserApplicationEntityViewResultKeySpecifier),
		fields?: RunUserApplicationEntityViewResultFieldPolicy,
	},
	RunUserApplicationViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserApplicationViewResultKeySpecifier | (() => undefined | RunUserApplicationViewResultKeySpecifier),
		fields?: RunUserApplicationViewResultFieldPolicy,
	},
	RunUserFavoriteViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserFavoriteViewResultKeySpecifier | (() => undefined | RunUserFavoriteViewResultKeySpecifier),
		fields?: RunUserFavoriteViewResultFieldPolicy,
	},
	RunUserRecordLogViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserRecordLogViewResultKeySpecifier | (() => undefined | RunUserRecordLogViewResultKeySpecifier),
		fields?: RunUserRecordLogViewResultFieldPolicy,
	},
	RunUserRoleViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserRoleViewResultKeySpecifier | (() => undefined | RunUserRoleViewResultKeySpecifier),
		fields?: RunUserRoleViewResultFieldPolicy,
	},
	RunUserViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserViewResultKeySpecifier | (() => undefined | RunUserViewResultKeySpecifier),
		fields?: RunUserViewResultFieldPolicy,
	},
	RunUserViewRunDetailViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserViewRunDetailViewResultKeySpecifier | (() => undefined | RunUserViewRunDetailViewResultKeySpecifier),
		fields?: RunUserViewRunDetailViewResultFieldPolicy,
	},
	RunUserViewRunViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserViewRunViewResultKeySpecifier | (() => undefined | RunUserViewRunViewResultKeySpecifier),
		fields?: RunUserViewRunViewResultFieldPolicy,
	},
	RunUserViewViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunUserViewViewResultKeySpecifier | (() => undefined | RunUserViewViewResultKeySpecifier),
		fields?: RunUserViewViewResultFieldPolicy,
	},
	RunViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunViewResultKeySpecifier | (() => undefined | RunViewResultKeySpecifier),
		fields?: RunViewResultFieldPolicy,
	},
	RunViewResultRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunViewResultRowKeySpecifier | (() => undefined | RunViewResultRowKeySpecifier),
		fields?: RunViewResultRowFieldPolicy,
	},
	RunWorkflowEngineViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunWorkflowEngineViewResultKeySpecifier | (() => undefined | RunWorkflowEngineViewResultKeySpecifier),
		fields?: RunWorkflowEngineViewResultFieldPolicy,
	},
	RunWorkflowRunViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunWorkflowRunViewResultKeySpecifier | (() => undefined | RunWorkflowRunViewResultKeySpecifier),
		fields?: RunWorkflowRunViewResultFieldPolicy,
	},
	RunWorkflowViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunWorkflowViewResultKeySpecifier | (() => undefined | RunWorkflowViewResultKeySpecifier),
		fields?: RunWorkflowViewResultFieldPolicy,
	},
	Run_990FullViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Run_990FullViewResultKeySpecifier | (() => undefined | Run_990FullViewResultKeySpecifier),
		fields?: Run_990FullViewResultFieldPolicy,
	},
	Run_990LatestViewResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Run_990LatestViewResultKeySpecifier | (() => undefined | Run_990LatestViewResultKeySpecifier),
		fields?: Run_990LatestViewResultFieldPolicy,
	},
	Skill?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SkillKeySpecifier | (() => undefined | SkillKeySpecifier),
		fields?: SkillFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskTypeKeySpecifier | (() => undefined | TaskTypeKeySpecifier),
		fields?: TaskTypeFieldPolicy,
	},
	TaxReturn?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxReturnKeySpecifier | (() => undefined | TaxReturnKeySpecifier),
		fields?: TaxReturnFieldPolicy,
	},
	TaxReturnCompensation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxReturnCompensationKeySpecifier | (() => undefined | TaxReturnCompensationKeySpecifier),
		fields?: TaxReturnCompensationFieldPolicy,
	},
	TaxReturnContractor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxReturnContractorKeySpecifier | (() => undefined | TaxReturnContractorKeySpecifier),
		fields?: TaxReturnContractorFieldPolicy,
	},
	TaxReturnDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxReturnDetailKeySpecifier | (() => undefined | TaxReturnDetailKeySpecifier),
		fields?: TaxReturnDetailFieldPolicy,
	},
	Team?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TeamKeySpecifier | (() => undefined | TeamKeySpecifier),
		fields?: TeamFieldPolicy,
	},
	TimeEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimeEntryKeySpecifier | (() => undefined | TimeEntryKeySpecifier),
		fields?: TimeEntryFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserApplication?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserApplicationKeySpecifier | (() => undefined | UserApplicationKeySpecifier),
		fields?: UserApplicationFieldPolicy,
	},
	UserApplicationEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserApplicationEntityKeySpecifier | (() => undefined | UserApplicationEntityKeySpecifier),
		fields?: UserApplicationEntityFieldPolicy,
	},
	UserFavorite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserFavoriteKeySpecifier | (() => undefined | UserFavoriteKeySpecifier),
		fields?: UserFavoriteFieldPolicy,
	},
	UserFavoriteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserFavoriteResultKeySpecifier | (() => undefined | UserFavoriteResultKeySpecifier),
		fields?: UserFavoriteResultFieldPolicy,
	},
	UserRecordLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserRecordLogKeySpecifier | (() => undefined | UserRecordLogKeySpecifier),
		fields?: UserRecordLogFieldPolicy,
	},
	UserRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserRoleKeySpecifier | (() => undefined | UserRoleKeySpecifier),
		fields?: UserRoleFieldPolicy,
	},
	UserView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserViewKeySpecifier | (() => undefined | UserViewKeySpecifier),
		fields?: UserViewFieldPolicy,
	},
	UserViewRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserViewRunKeySpecifier | (() => undefined | UserViewRunKeySpecifier),
		fields?: UserViewRunFieldPolicy,
	},
	UserViewRunDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserViewRunDetailKeySpecifier | (() => undefined | UserViewRunDetailKeySpecifier),
		fields?: UserViewRunDetailFieldPolicy,
	},
	UtilityResultType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UtilityResultTypeKeySpecifier | (() => undefined | UtilityResultTypeKeySpecifier),
		fields?: UtilityResultTypeFieldPolicy,
	},
	Workflow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkflowKeySpecifier | (() => undefined | WorkflowKeySpecifier),
		fields?: WorkflowFieldPolicy,
	},
	WorkflowEngine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkflowEngineKeySpecifier | (() => undefined | WorkflowEngineKeySpecifier),
		fields?: WorkflowEngineFieldPolicy,
	},
	WorkflowRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkflowRunKeySpecifier | (() => undefined | WorkflowRunKeySpecifier),
		fields?: WorkflowRunFieldPolicy,
	},
	_990Full?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | _990FullKeySpecifier | (() => undefined | _990FullKeySpecifier),
		fields?: _990FullFieldPolicy,
	},
	_990Latest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | _990LatestKeySpecifier | (() => undefined | _990LatestKeySpecifier),
		fields?: _990LatestFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;